<app-headnav [user]="userName" (info)="onInfo($event)" [logOutFlag]="logOutFlag" (getLogo)="onSavedLogo($event)" >
</app-headnav>


<!-- <div class="example-box" cdkDrag [cdkDragFreeDragPosition]="dragPosition">
	<h6 *ngIf="!new"> What's New!</h6>
	<button (click)="op.toggle($event)">Open</button>
	<p-overlayPanel #op [appendTo]="'body'">


	</p-overlayPanel>
</div> -->
<!--div class="task-box" cdkDrag *ngIf="expanded" [style.right.px]="taskBoxRight">
	<div class="row" style="background-color: rgb(28 36 51);  border-radius: 3px; padding-top: 0.375rem;
    padding-right: 0.375rem;
    padding-bottom: 0.375rem;
    padding-left: 0.375rem;
	border-right: 1px solid white;
    border-top: 1px solid white;
    border-left: 1px solid white;"
	>
		<span>
			<a style="cursor: pointer; color: white;" (click)="expandcollapse();" title="Expand/Collapse">
				<i *ngIf="!expanded" style="margin-left: 5px;  margin-bottom: 2px; vertical-align: middle;" class="fas fa-chevron-right" size="lg"></i>
				<i *ngIf="expanded" style="margin-left: 5px; margin-bottom: 2px; vertical-align: middle" class="fas fa-chevron-down" size="lg"></i>
			</a>
		</span>

		<span *ngIf="!expanded" style="font-size: 16px; margin-left:10px; color: white;">News
				Alert</span>
		<span *ngIf="expanded" style="font-size: 16px; margin-left:32%; color: white;">News
				Alert</span>
	</div>
	<div *ngIf="expanded" class="row">
		<iframe width="800px" height="800px" src="https://www.erisinfo.com/ca/">

		</iframe>
	</div>
</div-->

<!--div class="task-box" *ngIf="!expanded" style="position:absolute; top: 10px" [style.right.px]="taskBoxRight"> 
	<div class="row" style="background-color: rgb(28 36 51);  border-radius: 3px; padding-top: 0.375rem;
    padding-right: 0.375rem;
    padding-bottom: 0.375rem;
    padding-left: 0.375rem;">
		<span>
			<a style="cursor: pointer; color: white;" (click)="expandcollapse();" title="Expand/Collapse">
				<i *ngIf="!expanded" style="margin-left: 5px;  margin-bottom: 2px; vertical-align: middle;" class="fas fa-chevron-right" size="lg"></i>
				<i *ngIf="expanded" style="margin-left: 5px; margin-bottom: 2px; vertical-align: middle;" class="fas fa-chevron-down" size="lg"></i>
			</a>
		</span>

		<span *ngIf="!expanded" style="font-size: 16px; margin-left:10px; color: white;">News
				Alert</span>
		<span *ngIf="expanded" style="font-size: 16px; margin-left:32%; color: white;">News
				Alert</span>
	</div>
	<div *ngIf="expanded" class="row">
		<iframe width="800px" height="800px" src="https://www.erisinfo.com/ca/">

		</iframe>
	</div>
</div-->

<div *ngIf="!userId" class="studio">
	<!--<div class="loading">
    <img src="assets/images/loader.gif" alt="spinner" width="64" height="64" />
    
  </div>-->
</div>
<div *ngIf="userId" class="studio">

	<!--<app-headnav [user]="userInfo">
</app-headnav>-->

	<section #datacontent class="content">
		<div class="sidenav flex-container" [style.width]="sideNavWidth">
			<a href="#" title="Dashboard" class="active">
			<!--span aria-hidden="true" data-icon="&#xe90a;" class="icon-dashboard" style="font-size:32px"></span-->
			<span aria-hidden="true" data-icon="&#xe90a;" class="icon-dashboard" style="font-size:32px">
			</span>
			<span *ngIf="toggleSideBarVar" style="position: absolute; left: 86px">Dashboard</span>

			</a>
			<!-- <a href="report" title="Report Writer" target=_blank><i class="far fa-edit"></i></a><i class="fas fa-tachometer-alt"></i> -->
			<a href="cover" title="Cover Page" target=_blank><i class="icon-Cover" style="font-size:32px"></i>
				<span *ngIf="toggleSideBarVar" style="position: absolute; left: 86px">Cover, Header & Footer</span>
			</a>
			<a href="template" title="Template" target=_blank><i class="icon-Template" style="font-size:32px"></i>
				<span *ngIf="toggleSideBarVar" style="position: absolute; left: 86px">Templates</span>

			</a>
			<a href="complete" title="Completed Reports" target=_blank>
				<i style="margin-left: 5px" class="far fa-list-alt"></i>
				<span *ngIf="toggleSideBarVar" style="position: absolute; left: 86px">Complete Reports</span>
			</a>
			<!--hr class="m-2" style="background:grey; z-index:9999999;"-->
			<a href="company" style="border-top: 1px solid #000000;" title="Company" target=_blank><i class="icon-property" style="font-size:32px"></i>
				<span *ngIf="toggleSideBarVar" style="position: absolute; left: 86px">Company Info</span>

			</a>
					
			<!--hr class="m-2" style="background:grey; z-index:9999999;"-->
			<a title="Libraries" href="resources" style="border-top: 1px solid #000000" target=_blank>
			<span aria-hidden="true" data-icon="&#xe90f;" class="icon-Libraries" style="font-size:32px; margin-left:5px"></span>
			<span *ngIf="toggleSideBarVar" style="position: absolute; left: 86px">Libraries</span>

			</a>
			<!--hr class="m-2" style="background:grey; z-index:9999999;"-->
			<a *ngIf="userInfo.ERIS_STAFF=='Y'" title="ERIS" href="erisonly" style="border-top: 1px solid #000000" target=_blank>
				<i  class="icon-eris" style="font-size: 32px;"></i>
				<span *ngIf="toggleSideBarVar" style="position: absolute; left: 86px">ERIS Only</span>

				</a>

			<a  (click)="toggleSideBar()"> 

				<i *ngIf="!toggleSideBarVar" class="pi pi-chevron-right" style="font-size: 24px;"></i>
				<i  *ngIf="toggleSideBarVar"class="pi pi-chevron-left" style="font-size: 24px;"></i>

			</a>

		</div>

		<div id="myTab" class="tableView">
			<ul class="nav nav-tabs  nav-justified" style="background-color: rgb(9 17 33)">
				<li class="nav-item">
					<a (click)="tabFrom('ACTIVE');setTable();"id="reporttab" class="nav-link active" data-toggle="tab" href="#Reports">Reports</a><!--(click)="setTableHeight()" -->
					
				</li>
				<li class="nav-item">
					<!--<div  *ngIf='loading7||(deliveryRate>0&&deliveryRate<100)' class="progress" title="Portfolio Delivery Progress" style="height:4px;margin-top:2px;background-color:#999">
						<div class="progress-bar" [ngStyle]="{'width': deliveryRate+'%'}" style="background:rgb(195,212,47)">
						</div>
					</div>-->
					<a (click)="getAllPortfolios();tabFrom('PORTFOLIO')" id="portfoliotab" class="nav-link" data-toggle="tab" href="#Portfolio">Portfolio <span *ngIf='loading7' style="color:#e27676; margin-left: 10px;font-size: 9pt;">(Portfolio Generation in Progress: {{this.deliverResults.length}} / {{deliverRpts.length}} )</span>
					</a>
				</li>
				<li class="nav-item">
					<a class="nav-link" (click)="getErisInfo();"data-toggle="tab" href="#menu2" id="lnk-erisorders">ERIS Orders</a>
				</li>
				<!--li class="nav-item">
					<a class="nav-link" (click)="setTable();" data-toggle="tab" href="#Reports2">Reports 2</a>
				</li-->
			</ul>
			<div class="tab-content">
				<div id="Reports2" class="tab-pane" style="display:none">

					<div style="padding:5px;">
						<p-table>
							<ng-template pTemplate="header">
								<tr>
									<th [ngStyle]="{'width': '3%'}">
										<button style="font-size:12px" class="statusbutton"
											(click)="resetTableFilters()">All</button>
									</th>

									<th *ngFor="let status of statusList; let i = index" style="font-weight:400; padding:4px">
										<button style="font-size:12px" *ngIf="status.STATUS!='Writing in Process'"
											class="statusbutton" id="btn-status{{i}}"
											(click)="resetTableFilters(); tt.filter(status.STATUS, 'STATUS', 'contains');">
											{{status.STATUS}}
										</button>
										<button style="font-size:12px" *ngIf="status.STATUS=='Writing in Process'"
											class="statusbutton" id="btn-status{{i}}"
											(click)="resetTableFilters(); tt.filter(status.STATUS, 'STATUS', 'contains');">
											Writing in Process
										</button>
										({{status.TOTAL}})
									</th>
									<th *ngFor="let protocol of protocolList; let i = index" style="font-weight:400; padding:4px">
										<button style="font-size:12px" class="statusbutton" id="btn-protocol{{i}}"
											(click)="resetTableFilters(); tt.filter(protocol.PROTOCOL, 'flat.PROTOCOL', 'contains');">
											{{protocol.PROTOCOL}}
										</button>
										({{protocol.TOTAL}})
									</th>
								</tr>
							</ng-template>
						</p-table>

					</div>

					<!-- <p-treeTable #tt [value]="reportTreeData" [columns]="selectedColumns" [scrollable]="true"  (onSort)="setExcel($event)" (onFilter)="setExcel($event)"
						scrollHeight="68vh" [globalFilterFields]="['PROPERTY_NAME', 'PROJECT_NUMBER', 'REPORT_TITLE', 'POSTALZIP', 'PROVSTATE', 'ADDRESS_LINE1' , 'ADDRESS_LINE2', 'COUNTRY', 'CITY', 'ASSESSOR_DUE_DATE', 'REVIEWER_DUE_DATE',
					 'REPORT_DUE_DATE', 'flat.ASSESSOR', 'flat.REVIEWER', 'flat.ASSIGNED_USERS', 'STATUS', 'ORDER_NUM', 'flat.TEMPLATE', 'flat.TRANSACTION_TYPE', 'flat.PROTOCOL']"
					 [rows]="40" [virtualScroll]="true" [virtualRowHeight]="20" (sortFunction)="tableSort($event)" [customSort]="true"> -->
					<p-treeTable #tt *ngIf="reportTreeData" [value]="reportTreeData" [columns]="selectedColumns" [scrollable]="true"  (onSort)="setExcel($event)" (onFilter)="setExcel($event)"
						scrollHeight="68vh" [globalFilterFields]="['PROPERTY_NAME', 'PROJECT_NUMBER', 'REPORT_TITLE', 'POSTALZIP', 'PROVSTATE', 'ADDRESS_LINE1' , 'ADDRESS_LINE2', 'COUNTRY', 'CITY', 'ASSESSOR_DUE_DATE', 'REVIEWER_DUE_DATE',
						'REPORT_DUE_DATE', 'flat.ASSESSOR', 'flat.REVIEWER', 'flat.ASSIGNED_USERS', 'STATUS', 'ORDER_NUM', 'flat.TEMPLATE', 'flat.TRANSACTION_TYPE', 'flat.PROTOCOL']"
						[rows]="40" [virtualScroll]="true" [virtualRowHeight]="20">
						<ng-template pTemplate="caption">

							
							<div class="table-header" style="width:auto; font-weight:normal;" >
							{{totalrecords}} Reports
							<i *ngIf="loading" class="pi pi-spin pi-spinner" style="font-size: 1.2rem; margin-left: 10px; color: #C2D63F;"></i>

							<label class="ml-3" >   Group By :</label>
						<a href="javascript:void(0)" id="btn-groupby" class="ml-1 btn btn-outline-dark" (click)="op301.toggle($event)" style="padding:2px 16px">{{groupkey.value}}<i class="fas fa-angle-down ml-2"></i></a>
							<p-overlayPanel #op301 [appendTo]="'body'" [dismissable]="true" [style]="{'width': '200px'}">
								<ng-template pTemplate>
									<ng-container *ngFor="let key of cateKey;">
										<a href="javascript:void(0)" id="btn-getallreports" class="btn btn-link" style="color:white; font-size:.8em; margin:2px;" (click)="groupkey=key; getAllReportByGroup(key); op301.hide()">{{key.value}}</a>
										<i class="fas fa-check" *ngIf="groupkey.label==key.label" style="color:rgb(195,212,47); float:right"></i><br>
									</ng-container>					
								</ng-template>
							</p-overlayPanel>					
								<a>
									<a href="javascript:void(0)" id="btn-getallportfolios" class="btn btn-outline-dark btn-sm pt-1 pb-1 pl-2 pr-2 ml-4" id="btn-startnewproject"
									title="Start New Project"  style=" background-color:rgb(195,212,47);"
									data-toggle="modal" data-target="#reportsModal" (click)="addRpt('ACTIVE'); show('collapse1'); consoleLog(allTypeRpt);
									hide('inner-collapse1'); hide('inner-collapse2');hide('inner-collapse3'); getAllPortfolios();tabFrom('ACTIVE');resetOriginalData();">
									<!-- <span
										style="font-weight:bold; color:rgb(195,212,47)">P</span> -->
									<span style="color: black"> Start New Project</span>
								</a>	
												
							<a href="javascript:void(0)" class="btn btn-outline-dark btn-sm pt-1 pb-1 pl-2 pr-2 ml-4" id="btn-uploadbatchprojects"
								title="Upload Batch Projects" 
								data-toggle="modal" data-target="#import" (click)="resetUpload('ACTIVE');uploadBatchProjectsPermission=false;checkUploadBatchProjectsPermission();">
								<!-- <span
								style="font-weight:bold; color:rgb(195,212,47)">P</span> -->
								<span>Upload Batch Projects</span>
							</a>
							<a href="javascript:void(0)" class="btn btn-outline-dark btn-sm pt-1 pb-1 pl-2 pr-2 ml-4" id="btn-exporttoexcel"
							title="Export to Excel" (click)="exportExcel()">
							<!-- <span
						style="font-weight:bold; color:rgb(195,212,47)">P</span> -->
							<span> Export to Excel</span>
						</a>	
								<span style="float: right;">
									<i class="pi pi-search" style="margin:4px 4px 0 0"></i>
									<input type="text" pInputText size="24" placeholder="Search This Page" id="txt-filterglobal"
										(input)="tt.filterGlobal($event.target.value, 'contains')" style="width:auto; background-color: rgb(28 36 51); border: 0px">
								</span>
								</a>
							</div>
						</ng-template>

						<ng-template pTemplate="header" let-columns let-rowNode style="width: 100%;">
							<tr [ttRow]="rowNode"  >
								<th style="padding:1px; font-size:12px; border: 2px solid rgb(9 17 33); background-color: rgb(28 36 51)" [ngStyle]="{'width': '180px'}">
									<a style="cursor: pointer; font-size: 16px;" (click)="expandAllReports()"
										title="Expand/Collapse All">
										<i *ngIf="!isExpanded" class="pi pi-plus"></i>
										<i *ngIf="isExpanded" class="pi pi-minus"></i>
									</a>
								</th>

								<th style="padding:1px; font-size:12px; border: 2px solid rgb(9 17 33)" [ttSortableColumn]="'PROJECT_NUMBER'" [ngStyle]="{'width': '180px'}" ttResizableColumn>
									Project Number<ng-container><p-treeTableSortIcon [field]="'PROJECT_NUMBER'"></p-treeTableSortIcon></ng-container>
								</th>

								<th style="padding:1px; font-size:12px; border: 2px solid rgb(9 17 33); background-color:rgb(195,212,47); color: black" [ttSortableColumn]="'REPORT_TITLE'" [ngStyle]="{'width': '180px'}" ttResizableColumn>
									Access Report(s)<ng-container><p-treeTableSortIcon [field]="'REPORT_TITLE'" ></p-treeTableSortIcon></ng-container>
								</th>

								<th *ngFor="let col of columns | slice:3:19; let i=index"
									[ttSortableColumn]="col.searchfield" [ngStyle]="{'width': col.width}" 
									style="padding:1px; font-size:12px; border: 2px solid rgb(9 17 33)"  ttResizableColumn>
									<!--span *ngIf="col.header!='Access Report(s)'">{{col.header}}</span>
									<span *ngIf="col.header=='Access Report(s)'" style='color: black'> {{col.header}} </span-->
									{{col.header}}
									<ng-container  *ngIf="i!=05&&i!=6&&i!=7&&i!=8&&i!=16"><p-treeTableSortIcon [field]="col.field"></p-treeTableSortIcon></ng-container>
								</th>
							</tr>
							<tr>
								<th style="padding:1px; font-size:12px; border: 2px solid rgb(9 17 33); background-color: rgb(28 36 51)"></th>
								<th *ngFor="let col of columns | slice:1:19; let i=index" style="padding:2px;border: 2px solid rgb(9 17 33); background-color: rgb(28 36 51)">
									<input *ngIf="i!=3 && i!=11&&i!=05&&i!=6&&i!=7&&i!=8&&i!=16" pInputText type="text" id="txt-filter{{i}}"
										(input)="tt.filter($event.target.value, col.searchfield, col.filterMatchMode)"
										style="margin:0 2px; font-size:12px; width:98%; background-color: rgb(9 17 33); border: 0px">
									<!-- <input *ngIf="i==0" pInputText type="text"
										(input)="tt.filter($event.target.value, 'flat', 'projectnumname')"
										style="margin:0 2px; font-size:12px; width:98%;"> -->
									<input *ngIf="i==3" pInputText type="text" id="txt-filter{{i}}"
										(input)="tt.filter($event.target.value, 'flat', 'address')"
										style="margin:0 2px; font-size:12px; width:98%; background-color: rgb(9 17 33); border: 0px">
										<!-- <input *ngIf="i==9 || i==10 ||i==8" pInputText type="text"
										(input)="tt.filter($event.target.value, col.searchfield, 'user')"
										style="margin:0 2px; font-size:12px; width:98%;"> -->
									<input *ngIf="i==11" pInputText type="text" id="txt-filter{{i}}"
										(input)="tt.filter($event.target.value, 'flat', 'transaction')"
										style="margin:0 2px; font-size:12px; width:98%; background-color: rgb(9 17 33); border: 0px">
								</th>
							</tr>
						</ng-template>
<!--flag-->
						<ng-template pTemplate="body" let-rowNode let-rowData="rowData" let-columns="columns">
							<tr style="font-size:12px; line-height:1.3"
								[ngStyle]="{'background': rowData.highlight? '#4c4c4c' :'#323232'}">

								<td *ngFor="let col of columns | slice:0:19; let i = index; trackBy: trackByFuntion" (click)="consoleLog(rowData)"
							 [ngStyle]="{'width': col.width}" style="padding:4px; font-size:12px; border: 2px solid rgb(9 17 33); background-color: rgb(28 36 51)">
									<!-- <p-treeTableToggler [rowNode]="rowNode" *ngIf="i == 0" style="width:10px; height:10px"></p-treeTableToggler> -->
									<span *ngIf="!rowData.project && i==0 && rowData.size!=0">
										
										<!--<button style="background: transparent; border: none;  background-repeat:no-repeat;" *ngIf="rowData.REVIEWER_PROGRESS>=180" title="Click to View" (click)="op1.toggle($event); getWriterReviewerStatus(rowData)">
											<i class="pieblue tenblue" [style]="{'background-image':'linear-gradient(0deg, transparent 50%, rgb(195,212,47) 50%), linear-gradient('+ (360-(rowData.REVIEWER_PROGRESS*3.6))
											 +'deg, rgb(195,212,47) 50%, transparent 50%)'}"
					
											></i>
										</button>
										<button style="background: transparent; border: none;  background-repeat:no-repeat;" *ngIf="rowData.REVIEWER_PROGRESS && rowData.REVIEWER_PROGRESS<180" title="Click to View" (click)="op1.toggle($event); getWriterReviewerStatus(rowData)">
											
											<i class="pieblue tenblue " [style]="{'background-image':'linear-gradient('+ (360-(rowData.REVIEWER_PROGRESS*3.6))+'deg, transparent 50%, white 50%), linear-gradient(180deg, rgb(195,212,47) 50%, transparent 50%)'}"
					
											></i>
										</button>
										<button style="background: transparent; border: none;  background-repeat:no-repeat;" *ngIf="!rowData.REVIEWER_PROGRESS" title="Click to View" (click)="op1.toggle($event); getWriterReviewerStatus(rowData)" >
											<i class="pieblue  tenblue "  [style]="{'background-image':'linear-gradient(0deg, transparent 50%, white 50%), linear-gradient(180deg, white 50%, transparent 50%)'}"
											></i>
										</button>
										<p-overlayPanel #op1 [appendTo]="'body'">
											<ng-template pTemplate>
													<a *ngIf="rowData.REVIEWER_PROGRESS" href="javascript:void(0)"
														style="font-size:.8em;"
														>Reviewer Progress: {{rowData.REVIEWER_PROGRESS}}%</a>
													<a *ngIf="!rowData.REVIEWER_PROGRESS" href="javascript:void(0)"
														style="font-size:.8em;"
														>Reviewer Progress: 0%</a>
													<br>
											</ng-template>
										</p-overlayPanel>-->
										<div class="row mb-1">
										<div style="width:20%">
										<span class="col-md-12 m-0" style="font-size:.8em; ">W</span><br>
										<span class="col-md-12 m-0" style="font-size:.8em">R</span>
										</div>
										<div style="width:60%">
											<div class="progress" [title]="rowData.PERCENT_COMPLETE  + '%'" style="height:6px;margin-top:4px;background-color:#999">
												<div class="progress-bar" [ngStyle]="{'width': rowData.PERCENT_COMPLETE+'%'}" style="background:white"><!-- [ngStyle]="{'width': rowData.REVIEWER_PROGRESS + '%'}"-->
												</div>
											</div><div style="height:10px"></div>
											<div class="progress" [title]="rowData.REVIEWER_PROGRESS + '%'" style="height:6px;background-color:#999">
											<div class="progress-bar" [ngStyle]="{'width': rowData.REVIEWER_PROGRESS+'%'}" style="background:rgb(195,212,47)"><!-- [ngStyle]="{'width': rowData.REVIEWER_PROGRESS + '%'}"-->
											</div>
											</div>
										</div>
										
										
										</div>
										
										<!--<button style="background: transparent; border: none;  background-repeat:no-repeat;" *ngIf="rowData.PERCENT_COMPLETE>=180" title="Click to View" (click)="op2.toggle($event); getWriterReviewerStatus(rowData)">
											<i class="pie ten" [style]="{'background-image':'linear-gradient(0deg, transparent 50%, green 50%), linear-gradient('+ (360-(rowData.PERCENT_COMPLETE*3.6))
											 +'deg, green 50%, transparent 50%)'}"
					
											></i>
										</button>
										
										<button style="background: transparent; border: none;  background-repeat:no-repeat;" *ngIf="rowData.PERCENT_COMPLETE && rowData.PERCENT_COMPLETE<180" title="Click to View" (click)="op2.toggle($event); getWriterReviewerStatus(rowData)">
											
											<i class="pie ten" [style]="{'background-image':'linear-gradient('+ (360-(rowData.PERCENT_COMPLETE*3.6))+'deg, transparent 50%, white 50%), linear-gradient(180deg, green 50%, transparent 50%)'}"
					
											></i>
										</button>
										
										<button style="background: transparent; border: none;  background-repeat:no-repeat;" *ngIf="!rowData.PERCENT_COMPLETE" title="Click to View" (click)="op2.toggle($event); getWriterReviewerStatus(rowData)">
											<i class="pie ten"  [style]="{'background-image':'linear-gradient(0deg, transparent 50%, white 50%), linear-gradient(180deg, white 50%, transparent 50%)'}"
											></i>
										</button>
										<p-overlayPanel #op2 [appendTo]="'body'">
											<ng-template pTemplate>
													<a *ngIf="rowData.PERCENT_COMPLETE" href="javascript:void(0)"
														style="font-size:.8em;"
														>Writing Progress: {{rowData.PERCENT_COMPLETE}}%</a>
													<a *ngIf="!rowData.PERCENT_COMPLETE" href="javascript:void(0)"
														style="font-size:.8em;"
														>Writing Progress: 0%</a>
													<br>
											</ng-template>
										</p-overlayPanel>-->

										<!-- <a *ngIf="rowData.size!=0" style="cursor:pointer; float:right" class="m-1"	(click)= "getPCA(rowData.REPORT_ID); idToSave= rowData.REPORT_ID; saveAnswers=true; saveRow=rowData" data-toggle="modal" data-target="#PCA" >

											<i style="font-size:15px" [class.erisGreen]="rowData.PCA_QUESTIONS=='Y'" class="fas fa-search-dollar"></i>
										</a> -->
										<a   *ngIf="rowData.size!=0" title="Project Documents" id="btn-projectdocuments" style="cursor:pointer;" class="m-1"  data-toggle="modal" data-target="#fileModal" (click)='uploadType="FILE"; currentRowData=rowData; getAllBk(rowData.PROJECT_ID, rowData.REPORT_ID)'>

											<i style="font-size:15px; color: rgb(201 218 251)"  class="fas fa-file-upload"></i> 
										</a>
										<a  title="Share Report by Email" *ngIf="rowData.REPORT_ID" id="btn-sharereportbyemail" [ngClass]="{'disable':!noPrint}" style="cursor:pointer;" class="m-1" (click)="op5.toggle($event);resetEmailForm()">

											<i style="font-size:15px; color: rgb(201 218 251)"  class="fas fa-envelope"></i>
										</a>
										<i class="fas fa-info-circle erisIconColor" *ngIf='noPrint' style="color:#F78181" title="Other report sharing in progress!"></i>
										<input id="{{rowData.REPORT_ID}}" type="file" style="display: none;"  multiple (change)="uploadImage(rowData);"  accept='.png,.PNG,.jpg,.JPG, .jpeg,.JPEG'/>
										
										<input  id="{{rowData.REPORT_ID}}x"  type="file" style="display: none;" multiple (change)="uploadFile2(rowData)" accept=".jpg,.png,.jpeg,.xlsx,.csv,.txt,.docx,.doc, .pdf, .ppt,.pptx,.kml,.dwg">
											
										<!--got to here-->

										<p-overlayPanel #op5 [appendTo]="'body'"  [dismissable]="false" [showCloseIcon]="true">

											<ng-template pTemplate> 

												Email: <br>
												<input class="rptInfo" id="txt-email" type='text' [(ngModel)]="shareEmail" > 	
												<a  title="Send to Email" style="cursor:pointer;" class="m-1" (click)="shareByEmail(rowData.REPORT_ID);">

													<i *ngIf="!noPrint" style="font-size:15px"  class="erisIconColor fas fa-paper-plane"></i>
												</a>
												<i *ngIf="noPrint" class="pi pi-spin pi-spinner" style="font-size: 1.2rem; margin-left: 10px; color: #C2D63F;"></i> 
											</ng-template> 
										
										</p-overlayPanel>
										<a	(click)="op13.toggle($event);getProM()"	title="Project Manager"	style="cursor: pointer; text-decoration: underline;"><i	style="color: rgb(201 218 251)" class="fas fa-user"></i></a>
										<p-overlayPanel #op13 [style]="{'width':'480px'}" [dismissable]="false" [showCloseIcon]="true" [appendTo]="'body'">
												<ng-template pTemplate>
													<ng-container>
														<div class="row">
														<label style="margin-top:10px" class="col-md-4 inputLabel">Project Manager</label>
															<ng-select *ngIf="!rowData.PROJECT_MANAGER[0]"															
																[clearable]="false"
																[items]="pmList"
																notFoundText="Not Found"
																class="col-md-7 p-1 rptInfo" 
																style="margin:4px; color: grey"
																[(ngModel)]="rowData.PROJECT_MANAGER[0]"
																[ngModelOptions]="{standalone: true}"
																placeholder="Select User"																
																>
																<ng-template ng-label-tmp
																							let-item="item">
																							<span style="color: black;"
																								*ngIf="item.FIRST_NAME">{{
																								item.FIRST_NAME + ', ' +
																								item.FULL_NAME + ', ' +
																								'(' + item.USER_EMAIL + ')'}}</span>
																							<span style="color: black;"
																								*ngIf="!item.FIRST_NAME">{{item.USER_EMAIL}}</span>
																						</ng-template>
																						<ng-template ng-option-tmp
																							let-item="item"
																							let-search="searchTerm"
																							let-index="index">
																							<span style="color: black;"
																								*ngIf="item.FIRST_NAME">{{
																								item.FIRST_NAME + ', ' +
																								item.FULL_NAME + ', ' +
																								'(' + item.USER_EMAIL + ')'}}</span>
																							<span style="color: black;"
																								*ngIf="!item.FIRST_NAME">{{item.USER_EMAIL}}</span>
																						</ng-template>
															</ng-select>
															<ng-select	*ngIf="rowData.PROJECT_MANAGER[0]"															
																[clearable]="false"
																[items]="pmList"
																notFoundText="Not Found"
																class="col-md-7 p-1 rptInfo" 
																style="margin:4px; color: grey"
																[(ngModel)]="rowData.PROJECT_MANAGER[0]"
																[ngModelOptions]="{standalone: true}"
																>
																<ng-template ng-label-tmp
																							let-item="item">
																							<span style="color: black;"
																								*ngIf="item.FIRST_NAME">{{
																								item.FIRST_NAME + ', ' +
																								item.FULL_NAME + ', ' +
																								'(' + item.USER_EMAIL + ')'}}</span>
																							<span style="color: black;"
																								*ngIf="!item.FIRST_NAME">{{item.USER_EMAIL}}</span>
																						</ng-template>
																						<ng-template ng-option-tmp
																							let-item="item"
																							let-search="searchTerm"
																							let-index="index">
																							<span style="color: black;"
																								*ngIf="item.FIRST_NAME">{{
																								item.FIRST_NAME + ', ' +
																								item.FULL_NAME + ', ' +
																								'(' + item.USER_EMAIL + ')'}}</span>
																							<span style="color: black;"
																								*ngIf="!item.FIRST_NAME">{{item.USER_EMAIL}}</span>
																						</ng-template>
															</ng-select>															
																<button class="btn btn-sm pt-0 pb-0 pl-1 pr-1"
																style="padding: 3px; font-size: 11px;"
																title="Update Project Manager"><i class="fas fa-check erisIconColor" (click)="updatePM(rowData)"></i>
															</button>															
														</div>	
													</ng-container>
												</ng-template>
											</p-overlayPanel>
									</span>
									<!-- <span *ngIf="!rowData.project && col.field=='PCA_QUESTIONS'">

										
									</span> -->
									<span *ngIf="rowData.size!=0 && !rowData.project && col.field=='DATE_UPDATED'">
										<a (click)="getHistory(rowData); op1.toggle($event)"  style="cursor:pointer; color:rgb(228, 238, 138)"> {{rowData[col.field]}}</a>
										<p-overlayPanel #op1 [appendTo]="'body'" 		[style]="{'z-index':'9999999999999999', 'min-width':'300px'}">

											<ng-template pTemplate>
												<!-- <span *ngFor="let history of rowData.RW_REPORT_HISTORY">
													<a class="erisGreen" [title]="history.CHANGE_REASON_DESC"> {{history.DATE_UPDATED}} -- {{history.UPDATED_BY}}</a>
													<br>
												</span> -->
												<div style="padding:4px; height:300px; overflow:auto">
												<table  class="table2" style="width:90%; border: 1px solid black;  border-collapse: collapse;">
													<thead>
													  <tr style="color:rgb(195,212,47); font-size:12px">
									
													  <th class="table2">Edited By</th>
													  <th class="table2">Edit Date</th>
													  </tr>
													</thead>
													<tbody>
													  <ng-container *ngFor="let history of rowData.RW_REPORT_HISTORY; let i=index; trackBy: trackByFuntion">
														<tr style="color:white; font-size: 12px">
														<td class="table2">{{history.UPDATED_BY}}</td>
														<td class="table2">{{history.DATE_UPDATED}}</td>
														
														</tr>
													  </ng-container>
													</tbody>
													</table>
													</div>
											</ng-template>
										</p-overlayPanel>
									</span>
									<span *ngIf="rowData.size!=0 && !rowData.project && col.field=='DATE_CREATED'">
										<a (click)="consoleLog(rowData)"> 
											{{rowData[col.field]}}	
										</a>									
									</span>
									<span *ngIf="rowData.size!=0 && !rowData.project && col.field=='REPORT_COMPANY_NAME'">
										
										{{rowData[col.field]}}										
									</span>
									<span class="line-clamp1" *ngIf="(rowData.project) && i==0">
										<p-treeTableToggler [rowNode]="rowNode" style="width:10px; height:10px">
										</p-treeTableToggler> {{rowData[col.field]}}&nbsp; ({{rowData.size}})
									</span>
									<!-- <span *ngIf="(rowData.project) && i==0 && rowData.highlight">Highlight this&nbsp;</span> -->
									

									<span *ngIf="i==0 && rowData.SOW" style="float:right; margin-right:10px; ">
										<a style="color:rgb(195,212,47)" target="_blank" [href]="rowData.SOW">SOW</a>

									</span>
									<span *ngIf="!(rowData.project)">
										<span class="line-clamp2" *ngIf="i==3"> {{rowData["PROPERTY_NAME"]}}</span>
										<!-- <span
											*ngIf="(i!=0 && i!=1 && i!=4 && i!=2 && i!=12 && i!=3 && i!=4 && i!=5 && i!=6 && i!=7 &&i!=8 && i!=9 && i!=10 && i!=11 && i!=13)">{{rowData[col.field]}}
										</span> -->
										<div style="position:relative;" *ngIf="i==2" #reportInfo>
									
											<span *ngIf="rowData.size!=0"> 
												<a *ngIf="rowData.TEMPLATE && rowData.TEMPLATE[0] "class="line-clamp"
													style="color:#C2D63F; margin-right:19px; max-width:calc(100% - 18px);"
													target="_blank" [title]="rowData[col.field]"
													[attr.href]="'/report/' + rowData.PROJECT_ID +'/' + rowData.REPORT_ID">
													{{rowData[col.field]}} <br> &nbsp;
												</a>
												<span 	style="margin-right:19px; max-width:calc(100% - 18px);" *ngIf="!rowData.TEMPLATE || !rowData.TEMPLATE[0]"> 
													{{rowData[col.field]}} 
												</span>
												<a *ngIf="rowData[col.field]==''">
													&nbsp;
												</a>
											</span>
											<span *ngIf="rowData.size!=0">
												<!-- <a style="font-size:12px; position:absolute;right:18px;top:-2px; cursor: pointer;"
												(click)="op2.toggle($event);" title="Edit Name">
												<i class="fas fa-pen erisGreen" style="margin: 5px;"></i>
											</a> *ngIf="rowData.REPORT_URL!=''"-->
												<a *ngIf="rowData.REPORT_URL" [href]="rowData.REPORT_URL"
													target="_blank"
													style="font-size:12px; position:absolute;right:-1px;top:-3px; cursor: pointer;"
													title="PDF"><i class="far fa-file-pdf"
														style="margin:5px; color: rgb(201 218 251)"></i> </a>
												<a *ngIf="rowData.REPORT_URL"
													style="position:absolute;right:0;top:12px; cursor: pointer; font-size: 16px;"
													(click)="op1.toggle($event);" title="More Tools">
													<i class="pi pi-angle-down"
														tyle="margin-left:5px; margin-right:4px; ; color: rgb(201 218 251)"></i>
												</a>
												<a *ngIf="!rowData.REPORT_URL"
													style="position:absolute;right:0;top:6px; cursor: pointer; font-size: 16px;"
													(click)="op1.toggle($event);" title="More Tools">
													<i class="pi pi-angle-down"
														tyle="margin-left:5px; margin-right:4px; ; color: rgb(201 218 251)"></i>
												</a>
												<!-- <a href="javascript:void(0)" style="font-size:12px; position:absolute;right:0;top:-5px; cursor: pointer;"
													
												title="Add/Edit Reports" data-toggle="modal"
												data-target="#reportsModal"
												(click)="editProject(rowData, rowNode, true); show('collapse5');">
												<i 
													style="margin:7px" class="fas fa-file-medical erisGreen"></i> </a>

													<a style="position:absolute;right:0;top:12px; cursor: pointer; font-size: 16px;"
													(click)="op1.toggle($event);" title="More Tools">
													<i class="pi pi-angle-down" style="margin-left:5px; margin-right:4px;"></i>
												</a>										 -->
											</span>
											<p-overlayPanel #op3 [dismissable]="true" appendTo="reportInfo"
												[style]="{'z-index':'9999999999999999','width':'300px'} "
												[showCloseIcon]="true">

												<ng-template pTemplate>
													<ng-container>
														<!-- <div class="row">
															<label style="margin-top:10px"
																class="col-md-2 inputLabel">Email: </label>
															<input placeholder="Email"
																style="background:#E6E6E6; margin:4px" type="text"
																class="col-md-6 invuser p-1 rptInfo">
															<div class="col-md-auto" style="margin-top:5px">
																<a class="btn btn-outline-dark btn-sm pt-0 pb-0 pl-1 pr-1 ml-1"
																	title="Send link"> <i
																		class="erisGreen fas fa-paper-plane"></i> </a>
																<a (click)="copy(rowData)"
																	class="btn btn-outline-dark btn-sm pt-0 pb-0 pl-1 pr-1 ml-1"
																	title="Copy Link"><i
																		class="fas fa-link erisGreen"></i> </a>
															</div>
														</div> -->
														Email: <br>
														<input class="rptInfo" type='text' style="width:80%" [(ngModel)]="shareEmail"> 	
														<a  title="Send to Email" style="cursor:pointer;" class="m-1" (click)="shareByEmail(rowData.REPORT_ID);op1.toggle($event)">
		
															<i style="font-size:15px ; color: rgb(201 218 251)"  class="fas fa-paper-plane"></i>
														</a>
														<a  style="cursor:pointer;" (click)="copy(rowData)"
														class="m-1"
														title="Copy Link"><i style="color: rgb(201 218 251)"
															class="fas fa-link"></i> </a>

													</ng-container>

												</ng-template>
											</p-overlayPanel>
											<p-overlayPanel #op1 [appendTo]="'body'">

												<ng-template pTemplate>
													<button *ngIf="rowData.size!=0" 
													data-toggle="modal"
													data-target="#deleteReportModal"
													style="color: rgb(201 218 251)"
														class="btn btn-outline-dark btn-sm pt-0 pb-0 pl-1 pr-1 ml-1"
														title="Delete Report"><i class="far fa-trash-alt"
															(click)="reportToDelete= rowData;tabFrom('ACTIVE')"></i> </button>

													<!-- <a ref="javascript:void(0)"
														class="btn btn-outline-dark btn-sm pt-0 pb-0 pl-1 pr-1 ml-1"
														(click)="op2.toggle($event);" title="Edit Name">
														<i class="fas fa-pen erisGreen"></i>
													</a>

													<a *ngIf="rowData.REPORT_URL"
														(click)="op1.hide(); op3.toggle($event);"
														class="btn btn-outline-dark btn-sm pt-0 pb-0 pl-1 pr-1 ml-1"
														title="Share"><i class="far fa-share-square erisGreen"></i> </a> -->
												</ng-template>
											</p-overlayPanel>
											<p-overlayPanel #op2 [appendTo]="'body'">

												<ng-template pTemplate>
													<input class="rptInfo" type="text" [(ngModel)]="rowData[col.field]" 
													style="width: 250px;">
													<button (click)="changeReportTitle(rowData); op2.hide()"
													class="btn m-0 uploadBtn">Save</button>


												</ng-template>
											</p-overlayPanel>

										</div>
										<span *ngIf="(i==9 || i==7 || i==6 ||i==8) && rowData.size!=0"
										style="position:relative">

											<span *ngIf="rowData.CONSULTANT != 'Y'">
												<a *ngIf="(rowData.ASSESSOR_DUE_DATE==null || rowData.ASSESSOR_DUE_DATE=='') && i==6"
												style=" cursor: pointer;z-index:1;position: absolute; top:0; left:5px; pointer-events: none; color: rgb(201 218 251)">
												<i class="fas fa-calendar-plus"></i></a>
											<a *ngIf="(rowData.REPORT_RECEIVED_DATE==null || rowData.REPORT_RECEIVED_DATE=='') && i==7"
												style=" cursor: pointer;z-index:1;position: absolute; top:0; left:5px; pointer-events: none; color: rgb(201 218 251)">
												<i class="fas fa-calendar-plus"></i></a>
											<a *ngIf="(rowData.REVIEWER_DUE_DATE==null || rowData.REVIEWER_DUE_DATE=='') && i==8"
												style=" cursor: pointer;z-index:1;position: absolute; top:0; left:5px; pointer-events: none; color: rgb(201 218 251)">
												<i class="fas fa-calendar-plus "></i></a>
											<a *ngIf="(rowData.REPORT_DUE_DATE==null || rowData.REPORT_DUE_DATE=='') && i==9"
												style=" cursor: pointer;z-index:1;position: absolute; top:0; left:5px; pointer-events: none; color: rgb(201 218 251)">
												<i class="fas fa-calendar-plus "></i></a>
											</span>
											<!--
												<p-overlayPanel #op1 [style]="{'max-width':'130px'}" [appendTo]="'body'">
													<ng-template pTemplate>
														
														<p-calendar placeholder="dd-M-y" [(ngModel)]="rowData[col.field]" dateFormat="dd-M-y"op1.toggle($event);
												styleClass="calendarInput2" inputStyleClass="calendarInput2"
												(onSelect)="changeDate(rowData, rowData[col.field], col.field)" [showIcon]="true">
											</p-calendar>
														</ng-template>
												</p-overlayPanel>-->
											<p-calendar *ngIf="i==6"
											#op [appendTo]="'body'"
												[(ngModel)]="rowData.ASSESSOR_DUE_DATE" dateFormat="M dd, yy" 
												styleClass="calendarInput2" inputStyleClass="calendarInput2"
												[inputStyle]="{'padding':'2px','color': rowData[col.field+'_RED']? 'rgb(255 89 89)': '#ccc'}"
												[readonlyInput]="rowData.CONSULTANT == 'Y'"
												[showOnFocus]="rowData.CONSULTANT != 'Y'"
												(onSelect)="changeDate(rowData, rowData.ASSESSOR_DUE_DATE, col.field, col.sortfield)">
											</p-calendar>
											<!------------------------------->
											<p-calendar *ngIf="i==7"
											#op [appendTo]="'body'"
												[(ngModel)]="rowData.REPORT_RECEIVED_DATE" dateFormat="M dd, yy" 
												styleClass="calendarInput2" inputStyleClass="calendarInput2"
												[inputStyle]="{'padding':'2px','color': rowData[col.field+'_WHITE']? 'rgb(255 89 89)': '#ccc'}"
												[readonlyInput]="rowData.CONSULTANT == 'Y'"
												[showOnFocus]="rowData.CONSULTANT != 'Y'"
												(onSelect)="changeDate(rowData, rowData.REPORT_RECEIVED_DATE, col.field, col.sortfield)">
											</p-calendar>
											<!------------------------------->
											<p-calendar *ngIf="i==8"
											#op [appendTo]="'body'"
												[(ngModel)]="rowData.REVIEWER_DUE_DATE" dateFormat="M dd, yy" 
												styleClass="calendarInput2" inputStyleClass="calendarInput2"
												[inputStyle]="{'padding':'2px','color': rowData[col.field+'_RED']? 'rgb(255 89 89)': '#ccc'}"
												[readonlyInput]="rowData.CONSULTANT == 'Y'"
												[showOnFocus]="rowData.CONSULTANT != 'Y'"
												(onSelect)="changeDate(rowData, rowData.REVIEWER_DUE_DATE, col.field, col.sortfield)">
											</p-calendar>
											<p-calendar *ngIf="i==9"
											#op [appendTo]="'body'"
												[(ngModel)]="rowData.REPORT_DUE_DATE" dateFormat="M dd, yy" 
												styleClass="calendarInput2" inputStyleClass="calendarInput2"
												[inputStyle]="{'padding':'2px','color': rowData[col.field+'_RED']? 'rgb(255 89 89)': '#ccc'}"
												[readonlyInput]="rowData.CONSULTANT == 'Y'"
												[showOnFocus]="rowData.CONSULTANT != 'Y'"
												(onSelect)="changeDate(rowData, rowData.REPORT_DUE_DATE, col.field, col.sortfield)">
											</p-calendar>
										</span>
										<span *ngIf="(i==1)">
											<ng-container>
												<div>
													<div style="position:relative;">
														<span class="line-clamp ">
															<a  class="mr-1" style="cursor:pointer" (click)="selectedPortfolio=rowData.PORTFOLIO[0].PORTFOLIO_ID; portfolioDisplayName=rowData.PORTFOLIO[0].PORTFOLIO_NAME;getAllPortfoliosFromActive(); setTabs()"[title]=rowData.PORTFOLIO[0].PORTFOLIO_NAME *ngIf="rowData.PORTFOLIO.length!=0" >
																<i class="erisIconColor fas fa-folder"></i>
															</a>
															<a class="erisGreen mr-1"
															target="_blank"
																style="cursor: pointer; margin-right:19px; max-width:calc(80% - 20px); text-overflow: ellipsis; display: inline-block; color: rgb(195,212,47)
																"
																data-toggle="modal" (click)="editProject(rowData, rowNode, false); show('collapse1'); getAllPortfolios();
															hide('inner-collapse1'); hide('inner-collapse2'); hide('inner-collapse3');tabFrom('ACTIVE')" data-target="#reportsModal"
																[title]="'Project Num: '+ rowData.PROJECT_NUMBER"
																href="javascript:void(0)">{{rowData.PROJECT_NUMBER}} <br> &nbsp;</a>
														</span>
													
														

														<a href="javascript:void(0)"
															style="font-size:12px; position:absolute;right:0;top:-5px; cursor: pointer;"
															title="Add/Edit Reports" data-toggle="modal"
															data-target="#reportsModal"
															(click)="editProject(rowData, rowNode, true); show('collapse5');tabFrom('ACTIVE');">
															<i style="margin:4px; color: rgb(201 218 251)" 
																class="fas fa-edit"></i> </a>

														<a style="position:absolute;right:0;top:12px; cursor: pointer; font-size: 16px; ; color: rgb(201 218 251)"
															(click)="op1.toggle($event);" title="More Tools">
															<i class="pi pi-angle-down"
																style="margin-left:5px; margin-right:4px;"></i>
														</a>
													</div>
													<!-- <div class="col-sm-2">
														<a href="javascript:void(0)"
															class="btn btn-outline-dark btn-sm pt-0 pb-0 pl-1 pr-1 ml-1"
															title="Edit Project" data-toggle="modal"
															data-target="#reportsModal"
															(click)="editProject(rowData, rowNode, true);">
															<i 
																class="fas fa-file-medical erisGreen"></i> </a>

														<a style="cursor: pointer; font-size: 16px;"
															(click)="op1.toggle($event);" title="Edit Project">
															<i class="pi pi-angle-down" style="margin-left:5px; margin-right:5px;"></i>
														</a>
													</div> -->
												</div>
											</ng-container>

											<p-overlayPanel #op1 [appendTo]="'body'">

												<ng-template pTemplate>
													<button
													data-toggle="modal"
													data-target="#deleteModal"
														class="btn btn-outline-dark btn-sm pt-0 pb-0 pl-1 pr-1 ml-1"
														title="Delete Project"
														style="color: rgb(201 218 251)"
														(click)="projectToDelete=rowData.PROJECT_ID;tabFrom('ACTIVE')"><i
															class="far fa-trash-alt"></i>
												</button>

												</ng-template>
											</p-overlayPanel>
										</span>
										<!-- <span *ngIf="(i==13)">
											<ng-container>
												<ng-container *ngIf="rowData.ORDER_REPORTS?.length>0">
													<div class="row">
														<div class="col-sm-7" style="margin-top:3px">
															{{rowData.ORDER_NUM}}
														</div>
														<div #test class="col-sm-auto">
															<a style="cursor: pointer; font-size: 16px;" (click)="op2.toggle($event);"
															>
															<i class="pi pi-angle-down" style="margin: 5px;"></i>
														</a>
														</div>
														<p-overlayPanel #op2 [appendTo]="'body'" [dismissable]="true">
															<ng-template pTemplate>
																			<ng-container *ngFor="let item of rowData[col.field]">
																				<a style="font-size:12px" [href]="item.REPORT_URL"
																					target=_blank>{{item.REPORT_NAME}}</a><br>
																			</ng-container>
															</ng-template>
														</p-overlayPanel>
													</div>

												</ng-container> -->
										<span *ngIf="i==14 &&!rowData.project && rowData.size!=0">

											<ng-container>
												<div style="position:relative">
													<div style="max-width:calc(100% - 20px);">
														{{rowData.STATUS}}
													</div>
													<!-- <div class="col-sm-6" *ngIf="rowData.STATUS=='Writing in Process'" >  
												Writing
											</div>
											<div class="col-sm-7" *ngIf="rowData.STATUS=='In Senior Review'">
												Senior Review
											</div> -->
													<div>
														<a style="position:absolute;right:0;top:-5px; cursor: pointer; font-size: 16px;"
															(click)="getStatus(rowData.REPORT_ID);op1.toggle($event);" title="Edit Status">
															<i class="pi pi-angle-down" style="margin: 5px;"></i>
														</a>
													</div>
													<p-overlayPanel #op1 [appendTo]="'body'">
														<ng-template pTemplate>
															<ng-container *ngFor="let item of statusList2; trackBy: trackByFuntion">
																<a href="javascript:void(0)"
																	style="font-size:.8em; color: #C2D63F;"
																	(click)="op1.hide(); changeStatus1(rowData,item.STATUS)">{{item.STATUS}}</a>
																<br>
															</ng-container>
														</ng-template>
													</p-overlayPanel>
												</div>
											</ng-container>
										</span>
										<span *ngIf="(i==5)  && rowData.size!=0">

											<div *ngIf="!rowData.TEMPLATE || !rowData.TEMPLATE[0]"
												style="position:relative">

												<div>
													<a style="position:absolute;right:2px;top:-8px; cursor: pointer; font-size: 16px;"
														(click)="op1.toggle($event);findType(rowData);"
														title="Add Template">
														<i class="fas fa-plus erisGreen" style="margin: 4px;"></i>
													</a>
													<p-overlayPanel #op1 [appendTo]="'body'">
														<ng-template pTemplate>
															<label class="col-md-4 inputLabel">Template
																Identifier:</label>
															<select class="col-md-7 p-1 rptInfo" style="margin:4px;"
																[(ngModel)]="catToChange.selectedSubCat"
																[ngModelOptions]="{standalone: true}"
																(change)="setByTypeId(catToChange);">
																<option></option>
																<option
																	*ngFor="let subCat of catToChange.subCategories;"
																	[ngValue]="subCat">
																	{{subCat.subCategory}}</option>
															</select>

															<label class="col-md-4 inputLabel">Template: </label>
															<select class="col-md-7 p-1 rptInfo" style="margin:4px;"
																[(ngModel)]="catToChange.selectedTemplate"
																[ngModelOptions]="{standalone: true}"
																(change)="changeTemplate(rowData)">
																<option></option>
																<option
																	*ngFor="let template of catToChange.typeIdTemplates;"
																	[ngValue]="template">
																	{{template.TEMPLATE_TITLE}}</option>
															</select>

														</ng-template>
													</p-overlayPanel>

												</div>
											</div>
											<ng-container *ngIf="rowData.TEMPLATE && rowData.TEMPLATE[0]">
												<div  style="position:relative">

													<!-- <div class="row"> -->
													<!-- <div class="col-md-6"> -->
													<div style="max-width:calc(100% - 18px);" class="line-clamp">													
														<a class="erisIconColor" [href]="'template/'+rowData.TEMPLATE[0].TEMPLATE_ID" target=_blank title="{{rowData.TEMPLATE[0].TEMPLATE_TITLE}}">
														{{rowData.TEMPLATE[0].TEMPLATE_TITLE}}
														</a>
													</div>
													<ng-container *ngIf="rowData.TEMPLATE[0].TEMPLATE_VERSION_NO">
														<span style="font-size: 7pt;">({{rowData.TEMPLATE[0].TEMPLATE_VERSION_NO}})</span>
													</ng-container>
													<!--<div>
														<a style="position:absolute;right:0;top:-5px; cursor: pointer; font-size: 16px;"
															(click)="tableTemplates=[]; getTemplate(rowData.TEMPLATE[0].TEMPLATE_TYPE_ID); findType1(rowData);op11.toggle($event);"
															title="Choose Template">
															<i class="pi pi-angle-down" style="margin: 5px;"></i>
														</a>
													</div>
													<p-overlayPanel #op11 [appendTo]="'body'" [dismissable]="false" [showCloseIcon]="true">
														<ng-template pTemplate>
															<div style="padding:4px; height:400px; overflow:auto; width:400px">
																<ng-container *ngFor="let item of tableTemplates; trackBy:trackByFuntion">
															
																<a href="javascript:void(0)"
																	style="font-size:.8em; color: #C2D63F;"
																	(click)="rowData.TEMPLATE[0].TEMPLATE_TITLE=item.TEMPLATE_TITLE; updateTemplate(item, rowData); op11.hide()">
																	{{item.TEMPLATE_TITLE}}</a>
																<br>

															</ng-container>
															</div>
														</ng-template>
													</p-overlayPanel>-->
													<!-- </div> -->
													<!-- <div class="col-md-12">
													<div class="dropdown" style="display:inline; margin-left:4px">
														<button type="button"
															class="btn btn-success dropdown-toggle btn-sm p-0 m-0"
															style="width:16px; height:16px" data-toggle="dropdown"
															(click)="tableTemplates=[]; getTemplate(rowData.TEMPLATE[0].TEMPLATE_ID)"></button>
														<div class="dropdown-menu">
															<ng-container *ngFor="let item of tableTemplates">
																<a class="dropdown-item m-0 p-1"
																	href="javascript:void(0)"
																	(click)="updateTemplate(item, rowData);"
																	style="font-size:.9em; color:black; font-family:'Times New Roman', Times, serif;">{{item.TEMPLATE_TITLE}}</a>

															</ng-container>
														</div>
													</div>
												</div> -->
													<!-- </div> -->
												</div>
											</ng-container>
										</span>
										<!-- <span *ngIf="(i==0)">{{rowData["REPORT_TITLE"]}} </span> -->
										<span *ngIf="(i==4) && rowData.FULL_ADDRESS ">
											<a [title]="rowData.FULL_ADDRESS" class="link-light line-clamp"
												style="cursor:pointer; text-decoration: underline;"
												(click)="op1111.toggle($event);getCords(rowData)">
												<i class= "fas fa-map-marker-alt" style="float:right; margin:3px; color: rgb(201 218 251)"></i>
												{{rowData.FULL_ADDRESS}}
										
											</a>
											<p-overlayPanel #op1111 [appendTo]="'body'" [dismissable]="true" (onHide)="onHide()" [style]="{width: '550px', height: '550px'}">
												<span style="color:rgb(195,212,47)">
													{{rowData.FULL_ADDRESS}}
													<a *ngIf="!noLocation" style="color: red; display: inline-block;">
														(Address not valid)
													</a><br>
													<span *ngIf="rowData.PARCEL_ID">
														Parcel ID: {{rowData.PARCEL_ID}}
													</span>
													
												</span>
												<!--<agm-map id="test" class="googleMap2" controlSize=24 [latitude]="rowData.LATITUDE"
                              						[longitude]="rowData.LONGITUDE" [zoom]="zoomV" [disableDefaultUI]="false" [zoomControl]="false" [disableDoubleClickZoom]='true'>
                              						<agm-marker *ngIf="noLocation" [latitude]="rowData.LATITUDE" 
													  [longitude]="rowData.LONGITUDE">
														<agm-info-window>
															<strong>{{rowData.FULL_ADDRESS}}</strong>
														</agm-info-window>

													</agm-marker>
												</agm-map>-->
												<div id="googleMap2" class="googleMap2"></div>

											</p-overlayPanel>
										</span>
										<span *ngIf="(i==13) && rowData.size!=0 "
										style="position:relative">
											<span *ngIf='rowData[col.field]&&rowData[col.field][0]'>
											{{rowData[col.field][0].TRANSACTION_TYPE}} 
												<!--<a 
												class="line-clamp"
													style="margin-right:19px; max-width:calc(100% - 5px); text-overflow: ellipsis; display: inline-block;"
												[title]="rowData[col.field][0].TRANSACTION_TYPE">
												<br>	{{rowData[col.field][0].TRANSACTION_TYPE}} 
												</a>-->
											</span><br>
											<span *ngIf='rowData["PROTOCOL"]&&rowData["PROTOCOL"][0]'>
											{{rowData['PROTOCOL'][0]?.PROTOCOL}} 
												<!--<a 
												class="line-clamp"
													style="margin-right:19px; max-width:calc(100% - 5px); text-overflow: ellipsis; display: inline-block;"
												[title]="rowData['PROTOCOL'][0]?.PROTOCOL">
												<br>	{{rowData['PROTOCOL'][0]?.PROTOCOL}} 
												</a>-->
											</span>
										</span>
										<span *ngIf="(i==10 || i==11)  && rowData.size!=0 &&rowData.REPORT_CATEGORY" >
											<a *ngIf="rowData[col.field] && rowData[col.field][0] && rowData[col.field][0].LAST_NAME "
												(click)="op1.toggle($event); getCompanyRoles(); getAllReportUsers(-1, -1, ''); clearInvite1(rowData, rowData[col.field]); "
												style="cursor: pointer; text-decoration: underline;">
												{{rowData[col.field][0].FIRST_NAME
												+ " " + rowData[col.field][0].LAST_NAME}}
											</a>
											<a *ngIf="rowData[col.field] && rowData[col.field][0] && !rowData[col.field][0].LAST_NAME"
												(click)="op1.toggle($event); getCompanyRoles(); getAllReportUsers(-1, -1, ''); clearInvite1(rowData, rowData[col.field]); "
												style="cursor: pointer; text-decoration: underline; word-break:break-all">
												{{rowData[col.field][0].USER_EMAIL}}
											</a>
											<a *ngIf="!rowData[col.field] || !rowData[col.field][0]"
												(click)="op1.toggle($event); getCompanyRoles(); getAllReportUsers(-1, -1, ''); clearInvite1(rowData, rowData[col.field]); "
												title="Add User"
												style="cursor: pointer; margin-left:5px;"><i
												class="icon-AddUser fa-2x" style="color: rgb(201 218 251)"></i></a>
											<p-overlayPanel #op1 [style]="{'max-width':'580px'}" [appendTo]="'body'">
												<ng-template pTemplate>
													<ng-container>
														<!-- <div>
															{{rowData.ASSESSOR_TITLE[0]}}
														</div> -->
														<div class="row">
															<!-- <div class="col-md-12"> -->
															<!-- <div *ngIf="i==8"> -->
															<!--label *ngIf="i==10" style="margin-top:10px"
																class="col-md-3 inputLabel">
																Writer Title:</label>
															
																<ng-select  
																*ngIf="i==10 && !rowData.ASSESSOR_TITLE[0]"
																[compareWith]="compareFn" 
																class="col-md-7 p-1 rptInfo" 
																style="margin:4px; color: grey"
																(change)="changeTitle(true, rowData)"
																[(ngModel)]="rowData.ASSESSOR_TITLE[0]"
																[ngModelOptions]="{standalone: true}"
																placeholder="Select Title"
																>
																<ng-option [value]=title
																*ngFor="let title of assessortitles;">
																<span style="color: black;">
																	{{title.TITLE}}
																</span>	
															</ng-option>
															</ng-select>
															<ng-select  
																*ngIf="i==10 && rowData.ASSESSOR_TITLE[0]"
																[compareWith]="compareFn" 
																class="col-md-7 p-1 rptInfo" 
																style="margin:4px;"
																(change)="changeTitle(true, rowData)"
																[(ngModel)]="rowData.ASSESSOR_TITLE[0]"
																[ngModelOptions]="{standalone: true}"
																>
																<ng-option [value]=title 
																*ngFor="let title of assessortitles;">
																<span style="color: black;">
																	{{title.TITLE}}
																</span>	
															</ng-option>
															</ng-select--> <!--FLAG-->
															<!--
																<option value="" disabled selected>Test</option>
																<option [ngValue]="title"
																*ngFor="let title of assessortitles;">
																{{title.TITLE}}</option>
	
	
															<p-dropdown
															*ngIf="i==9"
															[options]="reviewertitles"
															class="col-md-7 p-1 rptInfo getTitles()"
															[(ngModel)]="rowData.ASSESSOR_TITLE[0]"
															style="margin:4px;"
															(change)="changeTitle(true, rowData)"
															placeholder="Test"
															>
															</p-dropdown>
															-->
															
															<!-- </div> -->
															<!-- <span *ngIf="i==9"> -->
															<!--label *ngIf="i==11" style="margin-top:10px"
																class="col-md-3 inputLabel">
																Reviewer Title:</label>
															<ng-select  
																*ngIf="i==11 && !rowData.REVIEWER_TITLE[0]"
																[compareWith]="compareFn" 
																class="col-md-7 p-1 rptInfo" 
																style="margin:4px; color: grey"
																(change)="changeTitle(false, rowData)"
																[(ngModel)]="rowData.REVIEWER_TITLE[0]"
																[ngModelOptions]="{standalone: true}"
																placeholder="Select Title"
																>
																<ng-option [value]=title 
																*ngFor="let title of reviewertitles; trackBy: trackByFuntion">
																<span style="color: black;">
																	{{title.TITLE}}
																</span>	
															</ng-option>
															</ng-select>
															<ng-select  
																*ngIf="i==11 && rowData.REVIEWER_TITLE[0]"
																[compareWith]="compareFn" 
																class="col-md-7 p-1 rptInfo" 
																style="margin:4px;"
																(change)="changeTitle(false, rowData)"
																[(ngModel)]="rowData.REVIEWER_TITLE[0]"
																[ngModelOptions]="{standalone: true}"
																>
																<ng-option [value]=title 
																*ngFor="let title of reviewertitles; trackBy: trackByFuntion">
																<span style="color: black;">
																	{{title.TITLE}}
																</span>	
															</ng-option>
															</ng-select-->
													
															<label *ngIf="i!=12" style="margin-top:10px"
																class="col-md-3 inputLabel">{{col.header}}: </label>
															<label *ngIf="i==12" style="margin-top:10px"
																class="col-md-3 inputLabel">Select User: </label>
															<ng-select *ngIf="!rowData[col.field][0]"
																id="writer reviewer dropdown"style="margin:4px; color: grey" class="col-md-7 p-1 rptInfo"
																[clearable]="false" [items]="allusersList"
																notFoundText="Not Found" bindLabel="USER_EMAIL"
																[(ngModel)]="rowData[col.field][0]"
																[ngModelOptions]="{standalone: true}"
																[searchFn]="customSearchFn"
																(change)="changeUser(rowData, rowData[col.field], col.field)"
																placeholder="Select Existing User"
																>
	
																
	
																<!-- <ng-option [value]="{'USER_ID':null}">test</ng-option> -->
																<ng-template ng-label-tmp let-item="item">
																	<span *ngIf="item.FULL_NAME" style="color: black;">{{
																		item.FULL_NAME + ', ' +
																		'('+item.USER_EMAIL+')'}}</span>
																	<span
																		*ngIf="!item.FULL_NAME">{{ '(' + item.USER_EMAIL + ')'}}</span>
																</ng-template>
																<ng-template ng-option-tmp let-item="item"
																	let-search="searchTerm" let-index="index" >
																	<span *ngIf="item.FULL_NAME" style="color: black;">{{
																		item.FULL_NAME + ', ' +
																		'(' + item.USER_EMAIL + ')'}}</span>
																	<span
																		*ngIf="!item.FULL_NAME" style="color: black;">{{'(' + item.USER_EMAIL + ')'}}</span>
																</ng-template>
															</ng-select>
															<ng-select *ngIf="rowData[col.field][0]"
																id="writer reviewer dropdown"style="margin:4px; color: grey" class="col-md-7 p-1 rptInfo"
																[clearable]="false" [items]="allusersList"
																notFoundText="Not Found" bindLabel="USER_EMAIL"
																[(ngModel)]="rowData[col.field][0]"
																[ngModelOptions]="{standalone: true}"
																[searchFn]="customSearchFn"
																(change)="changeUser(rowData, rowData[col.field], col.field)"
																>
																<!-- <ng-option [value]="{'USER_ID':null}">test</ng-option> -->
																<ng-template ng-label-tmp let-item="item">
																	<span *ngIf="item.FULL_NAME" style="color: black;">{{
																		item.FULL_NAME + ', ' +
																		'(' + item.USER_EMAIL + ')'}}</span>
																	<span
																		*ngIf="!item.FULL_NAME">{{item.USER_EMAIL}}</span>
																</ng-template>
																<ng-template ng-option-tmp let-item="item"
																	let-search="searchTerm" let-index="index" >
																	<span *ngIf="item.FULL_NAME" style="color: black;">{{
																		item.FULL_NAME + ', ' +
																		'(' + item.USER_EMAIL + ')'}}</span>
																	<span
																		*ngIf="!item.FULL_NAME" style="color: black;">{{'(' + item.USER_EMAIL + ')'}}</span>
																</ng-template>
															</ng-select>
	
															<button class="btn btn-sm pt-0 pb-0 pl-1 pr-1 col-md-1"
																style="margin-left: 5px; padding: 3px; font-size: 11px; margin:4px"
																title="Remove User"><i
																	class="far fa-trash-alt erisGreen"
																	(click)="rowData[col.field][0]={'USER_ID':null}; changeUser(rowData, rowData[col.field], col.field)"></i>
															</button>
															<hr style="color: white; width: 100%; background-color: white;">
																<!---->
															<div>
																<label style="margin-top:10px"
																class="col-md-10 inputLabel">Invite New Users
																&nbsp;
																
																<span style="float: right">External:
																	<input type="checkbox" [(ngModel)]="userExternal" (change)="changeRole()" [ngModelOptions]="{standalone: true}"></span></label>
	
															
	
																<label style="margin-top:10px"
																class="col-md-3 inputLabel">First Name:<span style="color:red"> * </span>
																&nbsp;</label>
	
															<input [(ngModel)]="firstname"
																[ngModelOptions]="{standalone: true}"
																style="background:#E6E6E6; margin:4px" type="text"
																class="col-md-7 invuser p-1 rptInfo"/>
	
																<label style="margin-top:10px"
																class="col-md-3 inputLabel">Last Name:<span style="color:red"> * </span>
																&nbsp;</label>
	
															<input [(ngModel)]="lastname"
																[ngModelOptions]="{standalone: true}"
																style="background:#E6E6E6; margin:4px" type="text"
																class="col-md-7 invuser p-1 rptInfo"/>
		<!---->
															<label style="margin-top:10px"
																class="col-md-3 inputLabel">Email:<span style="color:red"> * </span>
																&nbsp;</label>
	
															<input [(ngModel)]="userToAdd"
																[ngModelOptions]="{standalone: true}"
																style="background:#E6E6E6; margin:4px" type="text"
																class="col-md-7 invuser p-1 rptInfo" placeholder="Enter Email to Invite User"/>
														
															<!--button type="button"
																title="Invite User"
																class="btn btn-sm pt-0 pb-0 pl-1 pr-1 col-md-1"
																(click)="inviteUser2(rowData, col.field); op1.hide()"
																style="margin-left: 5px; padding: 3px; font-size: 11px; margin:4px">
																<i class="fas fa-user-plus erisGreen"></i></button-->
	
															<!-- <button *ngIf="i==10" type="button" class="btn btn-sm pt-0 pb-0 pl-1 pr-1 col-md-1"
																		(click)="inviteUser2(rowData, col.field); op1.hide()"
																		style="margin-left: 5px; padding: 3px; font-size: 11px; margin:4px"> <i class="fas fa-user-plus erisGreen"></i></button> -->
															<!-- </div> -->
	
																<label style="margin-top:10px"
																	class="col-md-3 inputLabel">User Role:<span style="color:red"> * </span></label>
																	<select style="margin:4px;" class="col-md-7 p-1 rptInfo" [(ngModel)]="role"
																	[ngModelOptions]="{standalone: true}" >
																  <option [value]="type.ROLE_ID" *ngFor="let type of roles">
																	{{type.ROLE_NAME}} </option>
													  
																</select>
	
																<label class="col-md-10 inputLabel"><button (click)="inviteUser3(rowData, col.field, op1, $event); " [disabled]="inviteUserLoading" title="Invite User" class="btn btn-default btn-outline-dark" style="color: white; border-color: white; margin-top: 10px;" >Invite User</button>
																	<i *ngIf="inviteUserLoading" class="pi pi-spin pi-spinner" style="font-size: 1.2rem; margin-left: 10px; color: #C2D63F;"></i>
																	<span></span><span *ngIf="inviteUserErrorMessage" style="margin-left:30px;color: red"> {{inviteUserErrorMessage}} </span></label>
																</div>
												
												
														</div>
													</ng-container>
												</ng-template>
											</p-overlayPanel>
	
										</span>
										<span *ngIf="(i==12)  && rowData.size!=0 &&rowData.REPORT_CATEGORY">
											<a  [class.assignedUser]="rowData[col.field].length>1"  *ngIf="rowData[col.field] && rowData[col.field][0] && rowData[col.field][0].LAST_NAME && rowData[col.field][1] && rowData[col.field][1].LAST_NAME"
												(click)="op1.toggle($event); getCompanyRoles(); getAllReportUsers(-1, -1, ''); clearInvite1(rowData, rowData[col.field]); "
												style="cursor: pointer; text-decoration: underline;">
												{{rowData[col.field][0].FIRST_NAME
												+ " " + rowData[col.field][0].LAST_NAME}}
												{{rowData[col.field][1].FIRST_NAME
													+ " " + rowData[col.field][1].LAST_NAME}}
											</a>
											<a  [class.assignedUser]="rowData[col.field].length>1" *ngIf="rowData[col.field] && rowData[col.field][0] && !rowData[col.field][0].LAST_NAME && rowData[col.field][1] && !rowData[col.field][1].LAST_NAME"
												(click)="op1.toggle($event); getCompanyRoles(); getAllReportUsers(-1, -1, ''); clearInvite1(rowData, rowData[col.field]); "
												style="cursor: pointer; text-decoration: underline; word-break:break-all">
												{{rowData[col.field][0].USER_EMAIL}}
												{{rowData[col.field][1].USER_EMAIL}}
	
											</a>
	
											<a  [class.assignedUser]="rowData[col.field].length>1"  *ngIf="rowData[col.field] && rowData[col.field][0] && rowData[col.field][0].LAST_NAME"
												(click)="op1.toggle($event); getCompanyRoles(); getAllReportUsers(-1, -1, ''); clearInvite1(rowData, rowData[col.field]); "
												style="cursor: pointer; text-decoration: underline;">
												{{rowData[col.field][0].FIRST_NAME
												+ " " + rowData[col.field][0].LAST_NAME}}
											</a>
											<a  [class.assignedUser]="rowData[col.field].length>1" *ngIf="rowData[col.field] && rowData[col.field][0] && !rowData[col.field][0].LAST_NAME"
												(click)="op1.toggle($event); getCompanyRoles(); getAllReportUsers(-1, -1, ''); clearInvite1(rowData, rowData[col.field]); "
												style="cursor: pointer; text-decoration: underline; word-break:break-all">
												{{rowData[col.field][0].USER_EMAIL}}
											</a>
	
	
											<a [class.assignedUser]="rowData[col.field]?.length>1"  *ngIf="!rowData[col.field] || !(rowData[col.field]&&rowData[col.field][0])"
												(click)="op1.toggle($event); getCompanyRoles(); clearInvite1(rowData, rowData[col.field]); getAllReportUsers(-1, -1, '')"
												title="Add User"
												style="cursor: pointer; margin-left:5px;"><i
												class="icon-AddUser fa-2x" style="color: rgb(201 218 251)"></i></a>
											<p-overlayPanel #op1 [style]="{'max-width':'580px'}" [dismissable]="false" [appendTo]="'body'" (onShow)="getCompanyRoles(); clearInvite()">
												<ng-template pTemplate>
													<ng-container>
														<!-- <div>
															{{rowData.ASSESSOR_TITLE[0]}}
														</div> -->
														<div class="row">
	
															<div *ngFor="let user of rowData.ASSIGNED_USERS" class="col-md-12">
	
															
																<label class="tag"> <i class="fas fa-times iconBtn erisGreen" style="margin-left:5px" (click)='removeAssignedUser(rowData, user)'></i> {{user.FULL_NAME? user.FULL_NAME:user.USER_EMAIL}}</label>
															</div>
															<label *ngIf="i==12" style="margin-top:10px"
																class="col-md-4 inputLabel">Add New User: </label>
	
																<select class="col-md-6 p-1 rptInfo" style="margin:4px; color: grey;" [(ngModel)]="rowData['USER_TO_ADD']">
																	<option></option>
																	<option *ngFor="let item of allusersList" [ngValue]='item'>
																	{{item.FULL_NAME}} ({{item.USER_EMAIL}})
																
																	</option>
																</select>
																
									
															<button *ngIf="rowData['USER_TO_ADD']" class="btn btn-sm pt-0 pb-0 pl-1 pr-1 col-md-1 btn-outline-light"
															style="margin-left: 5px; padding: 3px;  margin:4px;" (click)="addAssignedUser(rowData, rowData['USER_TO_ADD']);"
															title="Add User">Add</button>
	
															<hr style="color: white; width: 100%; background-color: white;">
	
															<!--label style="margin-top:10px"
																class="col-md-4 inputLabel">Invite New User:
																&nbsp;</label>
	
															<input [(ngModel)]="userToAdd"
																[ngModelOptions]="{standalone: true}"
																style="background:#E6E6E6; margin:4px" type="text"
																class="col-md-6 invuser p-1 rptInfo" placeholder="Enter Email to Invite User"/>
	
															<button type="button"
																title="Invite User"
																class="btn btn-sm pt-0 pb-0 pl-1 pr-1 col-md-1"
																(click)="inviteUser2(rowData, col.field);"
																style="margin-left: 5px; padding: 3px; font-size: 11px; margin:4px">
																<i class="fas fa-user-plus erisGreen"></i></button>
														
															
																<label style="margin-top:10px"
																class="col-md-4 inputLabel">User Role:</label>
																<select style="margin:4px;" class="col-md-6 p-1 rptInfo" [(ngModel)]="role"
																[ngModelOptions]="{standalone: true}" >
																  <option [value]="type.ROLE_ID" *ngFor="let type of roles">
																	{{type.ROLE_NAME}} </option>
													  
																</select-->
												
																<label style="margin-top:10px"
																class="col-md-10 inputLabel">Invite New Users
																&nbsp;<span style="float: right">External:
																	<input type="checkbox" [(ngModel)]="userExternal" (change)="changeRole()" [ngModelOptions]="{standalone: true}"></span></label>
	
															
	
																<label style="margin-top:10px"
																class="col-md-3 inputLabel">First Name:<span style="color:red"> * </span>
																&nbsp;</label>
	
															<input [(ngModel)]="firstname"
																[ngModelOptions]="{standalone: true}"
																style="background:#E6E6E6; margin:4px" type="text"
																class="col-md-7 invuser p-1 rptInfo"/>
	
																<label style="margin-top:10px"
																class="col-md-3 inputLabel">Last Name:<span style="color:red"> * </span>
																&nbsp;</label>
	
															<input [(ngModel)]="lastname"
																[ngModelOptions]="{standalone: true}"
																style="background:#E6E6E6; margin:4px" type="text"
																class="col-md-7 invuser p-1 rptInfo"/>
		<!---->
															<label style="margin-top:10px"
																class="col-md-3 inputLabel">Email:<span style="color:red"> * </span>
																&nbsp;</label>
	
															<input [(ngModel)]="userToAdd"
																[ngModelOptions]="{standalone: true}"
																style="background:#E6E6E6; margin:4px" type="text"
																class="col-md-7 invuser p-1 rptInfo" placeholder="Enter Email to Invite User"/>
	
																<label style="margin-top:10px"
																class="col-md-3 inputLabel">User Role:<span style="color:red"> * </span></label>
																<select style="margin:4px;" class="col-md-7 p-1 rptInfo" [(ngModel)]="role"
																[ngModelOptions]="{standalone: true}" >
																  <option [value]="type.ROLE_ID" *ngFor="let type of roles">
																	{{type.ROLE_NAME}} </option>
													  
																</select>
	
																<label class="col-md-10 inputLabel"><button (click)="inviteUser3(rowData, col.field, op1, $event); " [disabled]="inviteUserLoading" title="Invite User" class="btn btn-default btn-outline-dark" style="color: white; border-color: white; margin-top: 10px;" >Invite User</button>
																<i *ngIf="inviteUserLoading" class="pi pi-spin pi-spinner" style="font-size: 1.2rem; margin-left: 10px; color: #C2D63F;"></i>
																	<span></span><span *ngIf="inviteUserErrorMessage" style="margin-left:30px;color: red"> {{inviteUserErrorMessage}} </span></label>
												
															  
														</div>
													</ng-container>
												</ng-template>
											</p-overlayPanel>
	
										</span>

										<span *ngIf="(i==15)  && rowData.size!=0">
											<ng-container>
												<ng-container *ngIf="rowData.ORDER_NUM!=''">
													<div>
														<div style=" white-space: nowrap;
														overflow: hidden;
														text-overflow: ellipsis;
														 cursor: pointer; font-size: 12px; margin-top:3px; color:rgb(195,212,47)"  *ngIf="rowData.ORDER_REPORTS?.length>0">
															<a 
																(click)="op2.toggle($event);">
																{{rowData.ORDER_NUM}}
															</a>
														</div>
														<div style="  white-space: nowrap;
														overflow: hidden;
														text-overflow: ellipsis; margin-top:3px;" *ngIf="rowData.ORDER_REPORTS?.length==0">
										
																{{rowData.ORDER_NUM}}
														
														</div>
														<!-- <div #test class="col-sm-auto">
															<a style="cursor: pointer; font-size: 16px;"
																(click)="op2.toggle($event);">
																<i class="pi pi-angle-down" style="margin: 5px;"></i>
															</a>
														</div> -->
														<p-overlayPanel #op2 [styleClass]="'fixedoverlay'"
															[appendTo]="'body'" [dismissable]="true">
															<ng-template pTemplate>
																<ng-container *ngFor="let item of rowData[col.field]">
																	<a style="font-size:12px; color:rgb(195,212,47)"
																		[href]="item.REPORT_URL"
																		target=_blank>{{item.REPORT_NAME}}</a><br>
																</ng-container>
															</ng-template>
														</p-overlayPanel>
													</div>

												</ng-container>
												<ng-container *ngIf="rowData.ORDER_NUM==''">

												<span *ngIf="userInfo.ERIS_CUSTOMER_ID">
												<a class="btn btn-sm pt-0 pb-0 pl-1 pr-1 ml-1"
														(click)="op1.toggle($event);consoleLog(userInfo);checkErisData()"
														title="Add/Change Order Number">
														<i class="erisIcon erisGreen"></i>
													</a>
												</span>
												<span *ngIf="!userInfo.ERIS_CUSTOMER_ID">
													<a class="btn btn-sm pt-0 pb-0 pl-1 pr-1 ml-1"
															(click)="op2.toggle($event);consoleLog(userInfo)"
															title="Add/Change Order Number">
															<i class="erisIcon erisGreen"></i>
														</a>
													</span>
												</ng-container>

												

												<p-overlayPanel #op1 [appendTo]="'body'" [style]="{'z-index':'9999999999999999', 'min-width':'400px', 'max-width':'700px'}" [dismissable]="false" [showCloseIcon]="false">
													<ng-template pTemplate>
														<!-- <span *ngFor="let history of rowData.RW_REPORT_HISTORY">
															<a class="erisGreen" [title]="history.CHANGE_REASON_DESC"> {{history.DATE_UPDATED}} -- {{history.UPDATED_BY}}</a>
															<br>
														</span> -->
														<!--table  class="table2" style="width:90%; border: 1px solid black;  border-collapse: collapse;">
															<thead>
																<tr style="color:rgb(195,212,47); font-size:12px">
											
																<th class="table2">Edited By</th>
																<th class="table2">Edit Date</th>
																</tr>
															</thead>
															<tbody>
																<ng-container *ngFor="let history of rowData.RW_REPORT_HISTORY; let i=index">
																<tr style="color:rgb(195,212,47); font-size:12px">
																<td class="table2">{{history.UPDATED_BY}}</td>
																<td class="table2">{{history.DATE_UPDATED}}</td>
																
																</tr>
																</ng-container>
															</tbody>
															</table-->
															<p-table #pt2 styleClass="p-datatable-sm" [value]="erisData" [columns]="erisColsDashboard" [scrollable]="true"
															scrollHeight="30vh"			[globalFilterFields]="erisCols2">
															<!--ng-template pTemplate="caption">
													
																<div class="table-header">
																	&nbsp;
																	<i *ngIf="erisDataLoading" class="pi pi-spin pi-spinner" style="font-size: 1.2rem; margin-left: 10px; color: #C2D63F;"></i>
										
																<span style="float: right;">
																	<i class="pi pi-search" style="margin:4px 4px 0 0"></i>
																	<input type="text" pInputText size="50" placeholder="Search This Page"
																		(input)="pt2.filterGlobal($event.target.value, 'contains')" style="width:auto" style="background-color: rgb(28 36 51); border:0px">
																</span>
																</div>
															</ng-template-->
															<ng-template pTemplate="header" let-columns let-i>
													
																<tr style="font-size:12px">
																<th *ngFor="let col of columns|slice:0:6" [ngStyle]="{'width': col.width}" [pSortableColumn]="col.field" >
																	<span>{{col.header}}</span>
																	<span *ngIf="col.field!='CHECKBOX'"><p-sortIcon  [field]="col.field"></p-sortIcon></span>
																</th>
																
																</tr>
										
																<tr>
																<th *ngFor="let col of columns|slice:0:6" style="padding:2px;border: 2px solid rgb(9 17 33); background-color: rgb(28 36 51)">
																<span *ngIf="col.field!='CHECKBOX'">
																<input  pInputText type="text"
																	(input)="pt2.filter($event.target.value, col.searchfield, col.filterMatchMode);consoleLog($event.target.value);consoleLog(col.searchfield);consoleLog(col.filterMatchMode)"
																	style="margin:0 2px; font-size:12px; width:98%; background-color: rgb(9 17 33); border: 0px">
																</span>
																</th>
																	</tr>
															</ng-template>
															<ng-template pTemplate="body" let-user let-j="rowIndex" let-columns="columns">
																<tr style="font-size:12px;">
																<td  style="padding:4px; font-size:12px; border: solid 2px rgb(9 17 33); background-color: rgb(28 36 51); border-collapse: collapse;"*ngFor="let col of columns let i = index" [ngStyle]="{'width': col.width}">
																	<!--span *ngIf="col.field!='ADDRESS1'&&col.field!='ORDER_NUM'&&col.field!='CHECKBOX'"
																	>{{user[col.field]}}{{j}}
																	</span-->
																	<span *ngIf="col.field!='ADDRESS1'&&col.field!='ORDER_NUM'&&col.field!='CHECKBOX'"
																	>{{user[col.field]}}
																	</span>
																	<span *ngIf="col.field=='ADDRESS1'"
																	>{{user[col.field]}}, {{user.CITY}}
																</span>
																<span *ngIf="col.field=='ORDER_NUM'" style="color:rgb(228, 238, 138)">{{user[col.field]}}</span>
																<span *ngIf="col.field=='CHECKBOX'">
																	<input
																		type="checkbox"
																		id="erisDataCheckBox{{j}}"
																		(change)="erisDataChange(user, j)"/>
																</span>
																</td>
																</tr>
															</ng-template>
															</p-table>
															<button title="Close" class="btn btn-outline-dark btn-sm pt-0 pb-0 pl-1 pr-1 ml-1" 
																	style="float: right; color: black; background-color: #C2D63F; border-color:black; margin-bottom: 10px; margin-top: 10px" 
																	(click)='op1.hide()'>Close</button>
															<button title="Add Order" class="btn btn-outline-dark btn-sm pt-0 pb-0 pl-1 pr-1 ml-1" 
																	style="float: right; color: black; background-color: #C2D63F; border-color:black; margin-bottom: 10px; margin-top: 10px" 
																	(click)='addOrder1(rowData);op1.hide()'>Add ERIS Data</button>
													</ng-template>
												</p-overlayPanel>
												<p-overlayPanel #op2 [appendTo]="'body'" [style]="{'z-index':'9999999999999999', 'max-width':'500px'}" [dismissable]="false" [showCloseIcon]="false">
													<ng-template pTemplate>
														<div class="col-md-12">
															<label class=col-md-4 style="font-weight:normal;margin-top: 10px;">
															Username:
															</label><input class="col-md-5" style="padding:0px; background-color: rgb(28 36 51)" type="text" [(ngModel)]="ERIS_USERNAME">
														</div>
														<div class="col-md-12">

															<label style="font-weight:normal" class=col-md-4>
															Password:
															</label>
															<input class="col-md-5" type="password" style="padding:0px; background-color: rgb(28 36 51);" [(ngModel)]="ERIS_PASSWORD">
															<button class="btn btn-outline-dark btn-sm pt-0 pb-0 pl-1 pr-1 ml-1" style="float: right; color: black; background-color: #C2D63F; border-color:black; margin-bottom: 10px; margin-top: 10px"(click)="verifyEris($event, op2);">Verify ERIS Account</button>
															<button title="Close" class="btn btn-outline-dark btn-sm pt-0 pb-0 pl-1 pr-1 ml-1" style="float: right; color: black; background-color: #C2D63F; border-color:black; margin-bottom: 10px; margin-top: 10px" (click)='op2.hide()'>Close</button>
															<!--span>
																<i *ngIf="verifyErisLoading" class="pi pi-spin pi-spinner" style="font-size: 1.2rem; margin-left: 10px; color: #C2D63F; float: right"></i>
															</span-->

														</div>
														<div class="col-md-12" *ngIf="incorrect" style="color:red">
															Incorrect ERIS Login Information
														</div>

													</ng-template>
												</p-overlayPanel>
													<!--p-overlayPanel [styleClass]="'fixedoverlay'" #op1 
														[appendTo]="'body'">
														<ng-template pTemplate>
															<input style="min-width:150px" class="tableInput"
																[(ngModel)]="rowData.ORDER_NUM" type='text'>
															<button type="button"
																class="btn btn-outline-dark btn-sm pt-0 pb-0 pl-1 pr-1 ml-1"
																title="Add Order" (click)='addOrder(rowData,$event)'><i
																	class="fas fa-check erisIconColor"></i></button>

														</ng-template>
													</p-overlayPanel-->
												<ng-container
													*ngIf="rowData.ORDER_NUM==''">													

													<!-- <a href="http://testorder.erisinfo.com" target=_blank
														class="btn btn-outline-dark btn-sm pt-0 pb-0 pl-1 pr-1 ml-1 erisGreen"
														title="Order ERIS Data"><span
															style="font-weight:bold;">E</span></a> -->
													<a [href]="erisOrderURL" target=_blank
														class="btn btn-outline-dark btn-sm pt-0 pb-0 pl-1 pr-1 ml-1 erisGreen"
														title="Order ERIS Data"><span
															style="font-weight:bold;">E</span></a>
												</ng-container>

											</ng-container>
										</span>
									</span>
								</td>
							</tr>
						</ng-template>
					</p-treeTable>


				</div>
				<div id="menu2" class="tab-pane fade">
					<div style="padding:0px;">
					<p-table #pt2 styleClass="p-datatable-sm" [value]="erisData" [columns]="erisCols" [scrollable]="true"
					scrollHeight="82vh"	[globalFilterFields]="erisCols2">
					<ng-template pTemplate="caption">
			
						<div class="table-header">
							{{numErisOrders}} Orders
							
							<i *ngIf="erisDataLoading" class="pi pi-spin pi-spinner" style="font-size: 1.2rem; margin-left: 10px; color: #C2D63F;"></i>

						<span style="float: right;">
							<i class="pi pi-search" style="margin:4px 4px 0 0"></i>
							<input type="text" pInputText size="50" placeholder="Search This Page"
								(input)="pt2.filterGlobal($event.target.value, 'contains')" style="width:auto" style="background-color: rgb(28 36 51); border:0px">
						</span>
			
			
					  </div>
					</ng-template>
					<ng-template pTemplate="header" let-columns>
			
					  <tr style="font-size:12px">
						<th *ngFor="let col of columns" [ngStyle]="{'width': col.width}" [pSortableColumn]="col.field" >
						  <span>{{col.header}}</span>
						  <p-sortIcon [field]="col.field"></p-sortIcon>
						</th>
						
					  </tr>

					  <tr>
					  <th *ngFor="let col of columns" style="padding:2px;border: 2px solid rgb(9 17 33); background-color: rgb(28 36 51)">
						<input pInputText type="text"
							(input)="pt2.filter($event.target.value, col.searchfield, col.filterMatchMode)"
							style="margin:0 2px; font-size:12px; width:98%; background-color: rgb(9 17 33); border: 0px">
					  </th>
							</tr>
					</ng-template>
					<ng-template pTemplate="body" let-user let-i="rowIndex" let-columns="columns">
					  <tr style="font-size:12px;">
						<td style="padding:4px; font-size:12px; border: 2px solid rgb(9 17 33); background-color: rgb(28 36 51)"*ngFor="let col of columns" [ngStyle]="{'width': col.width}">
						  <span *ngIf="col.field!='ADDRESS1' &&col.field!='PRODUCTS'"class="line-clamp1"
							>{{user[col.field]}}
						  </span>
						  <span *ngIf="col.field=='ADDRESS1'"class="line-clamp1"
						  >{{user[col.field]}}, {{user.CITY}}
						</span>
						<span *ngIf="col.field=='PRODUCTS'"
						>
						<span *ngFor="let product of user[col.field]">
							<a target="_blank"*ngIf="product.PRODUCT_LINK[0]"  style="cursor:pointer; text-decoration:underline; color:rgb(195,212,47)" [href]='product.PRODUCT_LINK[0][1]'>
								{{product.PRODUCT_TYPE}}
							</a>
							<br>
						</span>
					
					  </span>
						</td>
					  </tr>
					</ng-template>
				  </p-table>
				  </div>
				</div>

				<div #tableView id="Reports" class="tab-pane active">
					<!-- Status Filters Header: -->
					<div style="padding:5px;">
						<p-table>
							<ng-template pTemplate="header">
								<tr>
									<!-- <th [ngStyle]="{'width': '3%'}">
										<button style="font-size:12px" class="statusbutton"
											(click)="resetTableFilters1()">All</button>
									</th> -->
									<th *ngFor="let status of statusList" style="font-weight:400; padding:4px; background: #1D365E;"
										[ngStyle]="statusModel==status.STATUS? {'border-bottom': '2px solid #C2D63F'} : {'border-bottom': '2px solid #1D365E'}">
										<button style="font-size:12px;"
											(click)="statusModel=status.STATUS;resetTableFilters1();"
											class="statusbutton">
											{{status.STATUS}}
										</button>
										<span *ngIf="status.STATUS!='All'">
											({{status.TOTAL}})
										</span>
									</th>
								</tr>
							</ng-template>
						</p-table>

					</div>
			
					<p-table *ngIf="table" #activeTable2 [value]="activeData" [columns]="selectedColumns" [scrollable]="true" 
						[scrollHeight]="rowHeight" scrollDirection="both" [virtualScroll]="true" [virtualScrollItemSize]="20"
						[globalFilterFields]="portfolioFilterCols" (onFilter)="onFilterReports($event)" [tableStyle]="{'min-height': '200px'}">
						<ng-template pTemplate="caption">
							<div class="table-header">

								<!-- this search bar needs to come first in the html, otherwise it messes the table up on smaller displays: -->
								<span style="float: right;">
									<i class="pi pi-search" style="margin:4px 4px 0 0"></i>
									<input class="pt-1 pb-1 pl-2 pr-2" type="text" pInputText size="12" placeholder="Search This Page" 
										(input)="activeTable2.filterGlobal($event.target.value, 'contains')"
										style="width:auto; background-color: rgb(28 36 51); border: 0px; font-size: 12px;">
								</span>

								<span style="font-size: 12px"> {{numActiveReports}} Reports</span>
								<i *ngIf="loading" class="pi pi-spin pi-spinner" style="font-size: 1.2rem; margin-left: 10px; color: #C2D63F;"></i>
								<!-- <span>
									&nbsp;&nbsp;Filters:&nbsp;
									
									<select [(ngModel)]="statusModel" (change)="resetTableFilters1();" style="background-color: rgb(28 36 51); color: white; border: 0px" >
										<option  *ngFor="let status of statusList; let i=index">
						
											{{status.STATUS}}
											
										</option>
									</select>
								</span> -->
								<a href="javascript:void(0)" class="btn btn-outline-dark btn-sm pt-1 pb-1 pl-2 pr-2 ml-4"
									title="Start New Project"  style=" background-color:rgb(195,212,47);"
									data-toggle="modal" data-target="#reportsModal" (click)="addRpt('ACTIVE'); show('collapse1');
									hide('inner-collapse1'); hide('inner-collapse2');hide('inner-collapse3'); tabFrom('ACTIVE');resetOriginalData();
									newReportPermission = false; checkNewReportPermission();">
									<span style="color: black;font-size: 12px"> Start New Project</span>
								</a>

								<a href="javascript:void(0)" class="btn btn-outline-dark btn-sm pt-1 pb-1 pl-2 pr-2 ml-4"
									title="Upload Batch Projects" data-toggle="modal" data-target="#import"
									(click)="resetUpload('ACTIVE');uploadBatchProjectsPermission = false;checkUploadBatchProjectsPermission();">
									<span style="font-size: 12px">Upload Batch Projects</span>
								</a>
								<a href="javascript:void(0)" class="btn btn-outline-dark btn-sm pt-1 pb-1 pl-2 pr-2 ml-4 mr-0" 
									title="Export to Excel" (click)="exportExcel3('A')">
									<span style="font-size: 12px">Export to Excel</span>
								</a>
								<a href="javascript:void(0)" class="btn btn-outline-dark btn-sm pt-1 pb-1 pl-2 pr-2 ml-0"
								(click)="proOnlya.toggle($event)">
								<i class="pi pi-angle-down" style="position:relative;top:2px"></i>
								</a>
								<p-overlayPanel #proOnlya [appendTo]="'body'"
									[dismissable]="true" [showCloseIcon]="false">
									<ng-template pTemplate>
										<a href="javascript:void(0)" class="btn btn-outline-dark btn-sm pt-1 pb-1 pl-2 pr-2" (click)="exportExcel3('A','Y');proOnlya.hide() "> Export to Project Only Excel</a>
									</ng-template>
								</p-overlayPanel>
								<!--<input type="checkbox" [(ngModel)]="proOnly1"><label class="tLabel ml-1" style="vertical-align: middle;line-height: 20px;">Project Only</label>-->
								<a href="javascript:void(0)" class="btn btn-outline-dark btn-sm pt-1 pb-1 pl-2 pr-2 ml-4" 
									title="Search All Reports" data-toggle="modal" data-target="#keySearchModal"  (click)="keyInput=''; keySearchReports = []">
									<span style="font-size: 12px">Search All Reports</span> <!-- aka complete search -->
								</a>
								<a href="javascript:void(0)" class="btn btn-outline-dark btn-sm pt-1 pb-1 pl-2 pr-2 ml-4" 
									title="Copy Project/Reports" (click)="resetCopyPR()">
									<span style="font-size: 12px">Copy Project/Reports</span>
								</a>
								<p-multiSelect styleClass="pt-1 pb-1 pl-2 pr-2 ml-4" [style]="{minWidth: '100px', maxWidth: '100px'}"
									[options]="selectedDisplayCols" [(ngModel)]="selectedColumns" optionLabel="header"
									placeholder="Choose Columns"  (onChange)="$event?.originalEvent?.originalEvent?.stopPropagation();"></p-multiSelect>
								<button class="btn btn-dark btn-sm ml-1" style="background-color: rgb(9 17 33);"
									(click)="saveSelectedColumns();" title="Save as Default Columns Display">
									<i class="fa fa-save"></i></button>

								<!-- <a href="javascript:void(0)" class="btn btn-outline-dark btn-sm pt-1 pb-1 pl-2 pr-2 ml-4"
									(click)="opContentMenu.toggle($event);">
									<span>Tools</span>
									<i class="pi pi-angle-down" style="position:relative;top:2px;margin-left:5px;"></i>
								</a>
								<p-overlayPanel #opContentMenu [appendTo]="'body'"
									[dismissable]="true" [showCloseIcon]="false">
									<ng-template pTemplate>
										
									</ng-template>
								</p-overlayPanel> -->
							</div>
						</ng-template>

						<!-- Reports Tab Header: -->
						<ng-template pTemplate="header" let-columns>

							<!-- Header Column Content: -->
							<th *ngFor="let col of columns"
								[ngStyle]="{'width': col.width,
											'background-color': col.field==='REPORT_TITLE'? 'rgb(195,212,47)' : null,
											'color': col.field==='REPORT_TITLE'? 'black' : 'white'}"
								style="padding:1px; font-size:12px; border: 2px solid rgb(9 17 33);" 
								[pSortableColumn]="col.sortfield"> 
								{{col.header}}
								<p-sortIcon *ngIf="col.field !== 'GROUP_LABEL'" [field]="col.searchfield"></p-sortIcon>
							</th>

							<!-- Reports Tab Columns Search Bars: -->
							<tr>
								<th *ngFor="let col of columns" style="padding:2px;border: 2px solid rgb(9 17 33); background-color: rgb(28 36 51)">
									<input 
										*ngIf="col.field !== 'GROUP_LABEL' &&
											   col.field !== 'FULL_ADDRESS' &&
											   col.field !== 'ASSESSOR_DATE' &&
											   col.field !== 'REPORT_RECEIVED_DATE_DATE' &&
											   col.field !== 'REVIEWER_DATE' &&
											   col.field !== 'REPORT_DATE' &&
											   col.field !== 'ASSIGNED_USERS' &&
											   col.field !== 'TRANSACTION_TYPE'"
										pInputText type="text"
										(input)="activeTable2.filter($event.target.value, col.searchfield, col.filterMatchMode)"
										style="margin:0 2px; font-size:12px; width:98%; background-color: rgb(9 17 33); border: 0px">
									<input *ngIf="col.field === 'FULL_ADDRESS'" pInputText type="text"
										(input)="activeTable2.filter($event.target.value, 'flat', 'address')"
										style="margin:0 2px; font-size:12px; width:98%; background-color: rgb(9 17 33); border: 0px">
									<input *ngIf="col.field === 'ASSIGNED_USERS'" pInputText type="text"
										(input)="activeTable2.filter($event.target.value, 'flat', 'additional_users')"
										style="margin:0 2px; font-size:12px; width:98%; background-color: rgb(9 17 33); border: 0px">
									<input *ngIf="col.field === 'TRANSACTION_TYPE'" pInputText type="text"
										(input)="activeTable2.filter($event.target.value, 'flat', 'transaction')"
										style="margin:0 2px; font-size:12px; width:98%; background-color: rgb(9 17 33); border: 0px">
								</th>
							</tr>
						</ng-template>

						<!-- Reports Tab Columns Data: -->
						<ng-template pTemplate="body" let-rowData let-columns="columns">
							<tr style="font-size:12px; line-height:1.3">
								<td *ngFor="let col of columns; trackBy: trackByFuntion" [ngStyle]="{'width': col.width}"
									style="padding:4px; font-size:12px; border: 2px solid rgb(9 17 33); background-color: rgb(28 36 51)" (click)="consoleLog(rowData)"> 
									<!--span (click)="consoleLog(rowData)">{{col.header}}{{i}}</span-->
									
									<span *ngIf="rowData.size!=0 && !rowData.project && col.field==='REPORT_GROUP'">
										<ng-container>
											<div style="position:relative">
												<div style="max-width:calc(100% - 20px);" [title]="rowData?.REPORT_GROUP?.GROUP_NAME || ''">
													{{rowData?.REPORT_GROUP?.GROUP_NAME || ''}}
												</div>
												<div>
													<a style="position:absolute;right:0;top:-5px; cursor: pointer; font-size: 16px;"
														(click)="toggleUserGroups($event, op1)" title="Edit Group">
														<i class="pi pi-angle-down" style="margin: 5px;"></i>
													</a>
												</div>
												<p-overlayPanel #op1 [appendTo]="'body'">
													<ng-template pTemplate>
														<div style="max-height: 400px; overflow-y: auto;">
															<ng-container *ngIf="userGroups.length > 0; else noGroups">
																<ng-container *ngFor="let group of userGroups; trackBy: trackByFuntion">
																	<a href="javascript:void(0)"
																		style="font-size:.8em; color: #C2D63F;"
																		(click)="op1.hide(); updateReportGroup(rowData,group)">
																		{{group.GROUP_NAME}}
																	</a>
																	<br>
																</ng-container>
															</ng-container>
															<ng-template #noGroups>
																<p style="font-size:.8em; color: #C2D63F;">No Groups Found</p>
															</ng-template>
														</div>
													</ng-template>
												</p-overlayPanel>
											</div>
										</ng-container>
									</span>

									<span *ngIf="rowData.size!=0 && !rowData.project && col.field==='GROUP_LABEL'">
										<div class="row mb-1">
											<div style="width:20%;margin-right:5px">
												<span class="col-md-12 m-0" style="font-size:.8em; ">W</span><br>
												<span class="col-md-12 m-0" style="font-size:.8em">R</span>
											</div>
											<div style="width:60%">
												<div class="progress" [title]="rowData.PERCENT_COMPLETE" style="height:6px;margin-top:4px;background-color:#999">
													<div class="progress-bar" [ngStyle]="{'width': rowData.PERCENT_COMPLETE}" style="background:rgb(195,212,47)"><!-- [ngStyle]="{'width': rowData.REVIEWER_PROGRESS + '%'}"-->
													</div>
												</div><div style="height:10px"></div>
												<div class="progress" [title]="rowData.REVIEWER_PROGRESS" style="height:6px;background-color:#999">
													<div class="progress-bar" [ngStyle]="{'width': rowData.REVIEWER_PROGRESS}" style="background:rgb(195,212,47)"><!-- [ngStyle]="{'width': rowData.REVIEWER_PROGRESS + '%'}"-->
													</div>
												</div>
											</div>										
										</div>
									
										<!-- Tools menu: -->
										<a *ngIf="rowData.CONSULTANT!='Y'" class="erisIconColor"
											style="cursor: pointer; "
											(click)="toolsOp.toggle($event);" title="Tools">
											Tools
											<i class="pi pi-angle-down" style="position:relative;top:2px;cursor:pointer;font-size:16px;margin-left:5px;"></i>
										</a>
										<a *ngIf="rowData.CONSULTANT=='Y'" class="erisIconColor"
											style="cursor: default; text-decoration:none; opacity:0.5; " title="Tools">
											Tools
										</a>
										<p-overlayPanel #toolsOp [appendTo]="'body'">
											<div>
												<a *ngIf="rowData.size!=0" title="Project Documents"  style="cursor:pointer;" class="m-1"  data-toggle="modal" data-target="#fileModal"
													(click)='uploadType="FILE"; currentRowData=rowData; getAllBk(rowData.PROJECT_ID, rowData.REPORT_ID)'>
													<i class="fas fa-file-upload erisIconColor"></i>
													Project Documents
												</a>
											</div>
											<div>
												<a *ngIf="rowData.REPORT_ID" title="Share Report by Email"  [ngClass]="{'disable':noPrint}" style="cursor:pointer;" class="m-1"
													(click)="resetEmailForm(); showEmail(rowData.REPORT_ID)"><!--op5.toggle($event);-->
													<i class="fas fa-envelope erisIconColor"></i>
													Share Report
												</a><i class="fas fa-info-circle erisIconColor" *ngIf='noPrint&&rowData.REPORT_ID&&rowData.REPORT_ID!=emailId' style="color:#F78181" title="Other report sharing in progress!"></i>
												<div *ngIf="rowData.REPORT_ID==emailId">Email:
													<input class="rptInfo" type='text' [(ngModel)]="shareEmail" >
													<a  title="Send to Email" style="cursor:pointer;" class="m-1" (click)="shareByEmail(rowData.REPORT_ID);">
														<i *ngIf="!noPrint"  style="font-size:15px; pointer-events: none;"  class="erisIconColor fas fa-paper-plane"></i>														
													</a>
													<i *ngIf="noPrint" class="pi pi-spin pi-spinner" style="font-size: 1.2rem; margin-left: 10px; color: #C2D63F;"></i>
												</div> 
											</div>
												
											<!-- <p-overlayPanel #op5 [style]="{'width':'480px'}" [appendTo]="'body'"> -->
											<p-overlayPanel #op5 [appendTo]="'body'" [dismissable]="false" [showCloseIcon]="true" styleClass="">
												<ng-template pTemplate> 
													Email: <br>
													<input class="rptInfo" type='text' [(ngModel)]="shareEmail" >
													<a  title="Send to Email" style="cursor:pointer;" class="m-1" (click)="shareByEmail(rowData.REPORT_ID);">
														<i *ngIf="!noPrint"  style="font-size:15px; pointer-events: none;"  class="erisIconColor fas fa-paper-plane"></i>														
													</a>
													<i *ngIf="noPrint" class="pi pi-spin pi-spinner" style="font-size: 1.2rem; margin-left: 10px; color: #C2D63F;"></i> 
												</ng-template> 
											</p-overlayPanel>

											<div>
												<a (click)="op13.toggle($event);getProM();checkAssignUserPermission(rowData.REPORT_ID);" class="m-1"
													title="Project Manager" style="cursor: pointer;">
													<i class="fas fa-user erisIconColor"></i>
													Project Manager
												</a>
											</div>
											<p-overlayPanel #op13 [style]="{'width':'480px'}" [dismissable]="false" [showCloseIcon]="true" [appendTo]="'body'">
												<ng-template pTemplate>
													<ng-container>
														<div class="row">
														<label style="margin-top:10px" class="col-md-4 inputLabel">Project Manager</label>
														<ng-select *ngIf="!rowData.PROJECT_MANAGER[0]"															
															[clearable]="false"
															[items]="pmList"
															notFoundText="Not Found"
															class="col-md-7 p-1 rptInfo" 
															style="margin:4px; color: grey"
															[(ngModel)]="rowData.PROJECT_MANAGER[0]"
															[ngModelOptions]="{standalone: true}"
															placeholder="Select User"
															[searchFn]="customSearchFn">
															<ng-template ng-label-tmp let-item="item">
																<span *ngIf="item.FULL_NAME" style="color: black;">
																	{{item.FULL_NAME + ' ' +'(' + item.USER_EMAIL + ')'}}
																</span>
																<span *ngIf="!item.FULL_NAME && item.USER_EMAIL" style="color: black;">
																	{{item.USER_EMAIL}}
																</span>
																<!-- for blank option: -->
																<span *ngIf="!item.FULL_NAME && !item.USER_EMAIL" style="color: black;">
																	&nbsp;
																</span>
															</ng-template>
															<ng-template ng-option-tmp
																let-item="item"
																let-search="searchTerm"
																let-index="index">
																<span *ngIf="item.FULL_NAME" style="color: black;">
																	{{item.FULL_NAME + ' ' +'(' + item.USER_EMAIL + ')'}}
																</span>
																<span *ngIf="!item.FULL_NAME && item.USER_EMAIL" style="color: black;">
																	{{item.USER_EMAIL}}
																</span>
																<!-- for blank option: -->
																<span *ngIf="!item.FULL_NAME && !item.USER_EMAIL" style="color: black;">
																	&nbsp;
																</span>
															</ng-template>
														</ng-select>
														<ng-select	*ngIf="rowData.PROJECT_MANAGER[0]"															
															[clearable]="false"
															[items]="pmList"
															notFoundText="Not Found"
															class="col-md-7 p-1 rptInfo" 
															style="margin:4px; color: grey"
															[(ngModel)]="rowData.PROJECT_MANAGER[0]"
															[ngModelOptions]="{standalone: true}"
															[searchFn]="customSearchFn"
															>
															<ng-template ng-label-tmp let-item="item">
																<span *ngIf="item.FULL_NAME" style="color: black;">
																	{{item.FULL_NAME + ' ' +'(' + item.USER_EMAIL + ')'}}
																</span>
																<span *ngIf="!item.FULL_NAME && item.USER_EMAIL" style="color: black;">
																	{{item.USER_EMAIL}}
																</span>
																<!-- for blank option: -->
																<span *ngIf="!item.FULL_NAME && !item.USER_EMAIL" style="color: black;">
																	&nbsp;
																</span>
															</ng-template>
															<ng-template ng-option-tmp
																let-item="item"
																let-search="searchTerm"
																let-index="index">
																<span *ngIf="item.FULL_NAME" style="color: black;">
																	{{item.FULL_NAME + ' ' +'(' + item.USER_EMAIL + ')'}}
																</span>
																<span *ngIf="!item.FULL_NAME && item.USER_EMAIL" style="color: black;">
																	{{item.USER_EMAIL}}
																</span>
																<!-- for blank option: -->
																<span *ngIf="!item.FULL_NAME && !item.USER_EMAIL" style="color: black;">
																	&nbsp;
																</span>
															</ng-template>
														</ng-select>															
														<button class="btn btn-sm pt-0 pb-0 pl-1 pr-1"
															style="padding: 3px; font-size: 11px;"
															title="Update Project Manager"
															[disabled]="!assignUserPermission">
															<i class="fas fa-check erisIconColor" (click)="updatePM(rowData);op13.hide();"></i>
														</button>															
														</div>	
													</ng-container>
												</ng-template>
											</p-overlayPanel>

											<div>
												<a (click)="op14.toggle($event);checkPM(rowData)" title="Project Information" style="cursor: pointer;" class="m-1">
													<i class="fas fa-info-circle erisIconColor"></i>
													Project Information
												</a>
											</div>
											<p-overlayPanel #op14 [style]="{'width':'480px'}" [appendTo]="'body'">
												<ng-template pTemplate>
													<div class="row">
														<label style="margin-top:10px" class="col-md-6 inputLabel">Project Manager: </label>
												
															<span style="margin-top:10px; color: #C2D63D" *ngIf="hasPM">	
															{{PMname}}
															</span>
													
														</div>	
		
														<div class="row">
														<label style="margin-top:10px" class="col-md-6 inputLabel">Client:</label>
														<span style="margin-top:10px; color: #C2D63D">	
															{{rowData.CLIENT_COMPANY_NAME}}
															</span>
														</div>
		
														<div class="row">
															<label style="margin-top:10px" class="col-md-6 inputLabel">Co-Client:</label>
															<span style="margin-top:10px; color: #C2D63D">	
															{{rowData.CO_CLIENT_COMPANY_NAME}}
															</span>
														</div>
		
														<div class="row">
															<label style="margin-top:10px" class="col-md-6 inputLabel">Consultant Company Name:</label>
															<span style="margin-top:10px; color: #C2D63D">	
																{{rowData.REPORT_COMPANY_NAME}}
																</span>
														</div>
		
														<div class="row">
															<label style="margin-top:10px" class="col-md-6 inputLabel">Report Received:</label>
															<span style="margin-top:10px; color: #C2D63D">	
																{{rowData.REPORT_RECEIVED_DATE}}
															</span>
														</div>
												</ng-template>
											</p-overlayPanel>

											<div>
												<span *ngIf="rowData.SOW">
													<a style="color:rgb(195,212,47)" target="_blank" [href]="rowData.SOW">Scope of Work</a>
												</span>
											</div>

										</p-overlayPanel>

										<!-- this is for uploading files to project documents: -->
										<input id="{{rowData.REPORT_ID}}" type="file" style="display: none;"  multiple (change)="uploadImage(rowData);"
											accept='.png,.PNG,.jpg,.JPG, .jpeg,.JPEG'/>
										<input id="{{rowData.REPORT_ID}}x"  type="file" style="display: none;" multiple (change)="uploadFile2(rowData)" accept=".jpg,.png,.jpeg,.xlsx,.csv,.txt,.docx,.doc, .pdf, .ppt,.pptx,.kml,.dwg">

									</span>
					
									<span *ngIf="rowData.size!=0 && !rowData.project && col.field=='DATE_UPDATED'">
										<a class="erisIconColor" (click)="getHistory(rowData); op1.toggle($event)"  style="cursor:pointer"
											[title]="rowData[col.field]"> {{rowData[col.field]}}</a>
										<p-overlayPanel #op1 [appendTo]="'body'" 		[style]="{'z-index':'9999999999999999', 'min-width':'300px'}">
					
											<ng-template pTemplate>
												<!-- <span *ngFor="let history of rowData.RW_REPORT_HISTORY">
													<a class="erisGreen" [title]="history.CHANGE_REASON_DESC"> {{history.DATE_UPDATED}} -- {{history.UPDATED_BY}}</a>
													<br>
												</span> -->
												<div style="padding:4px; height:300px; overflow:auto">
												<table  class="table2" style="width:90%; border: 1px solid black;  border-collapse: collapse;">
													<thead>
													  <tr style="color:rgb(195,212,47); font-size:12px">
									
													  <th class="table2">Edited By</th>
													  <th class="table2">Edit Date</th>
													  </tr>
													</thead>
													<tbody>
													  <ng-container *ngFor="let history of rowData.RW_REPORT_HISTORY; let i=index; trackBy: trackByFuntion">
														<tr style="color:white; font-size: 12px">
														<td class="table2">{{history.UPDATED_BY}}</td>
														<td class="table2">{{history.DATE_UPDATED}}</td>
														
														</tr>
													  </ng-container>
													</tbody>
													</table>
													</div>
											</ng-template>
										</p-overlayPanel>
									</span>
					
									<span *ngIf="rowData.size!=0 && !rowData.project && col.field=='DATE_CREATED'"
										[title]="rowData[col.field]">
										<a (click)="consoleLog(rowData)"> 
											{{rowData[col.field]}}	
										</a>									
									</span>
					
									<span *ngIf="rowData.size!=0 && !rowData.project && col.field=='CONSULTANT_LOCATION'"
										[title]="rowData[col.field].LOCATION_NAME">
										{{rowData[col.field].LOCATION_NAME}}
									</span>

									<!-- Has been removed: -->
									<span *ngIf="rowData.size!=0 && !rowData.project && col.field=='REPORT_COMPANY_NAME'">
										{{rowData[col.field]}}
									</span>
									<span *ngIf="rowData.size!=0 && !rowData.project && col.field=='CLIENT_COMPANY_NAME'">
										{{rowData[col.field]}}
									</span>
									<span *ngIf="!(rowData.project)">
										<span class="line-clamp2" *ngIf="col.field === 'PROPERTY_NAME'" [title]="rowData.PROPERTY_NAME"> {{rowData["PROPERTY_NAME"]}}</span>

										<div style="position:relative;" *ngIf="col.field === 'REPORT_TITLE'" #reportInfo>
									
											<span *ngIf="rowData.size!=0"> 
												<a *ngIf="rowData.TEMPLATE && rowData.TEMPLATE[0] && rowData.REPORT_URL"class="line-clamp"
													style="color:#aac400; margin-right:19px; max-width:calc(100% - 18px);"
													target="_blank" [title]="rowData[col.field]"
													[attr.href]="'/report/' + rowData.PROJECT_ID +'/' + rowData.REPORT_ID">
													{{rowData[col.field]}} <br> &nbsp;
												</a>
												<a *ngIf="rowData.TEMPLATE && rowData.TEMPLATE[0] && !(rowData.REPORT_URL)"class="line-clamp"
													style="color:#aac400; max-width:100%;"
													target="_blank" [title]="rowData[col.field]"
													[attr.href]="'/report/' + rowData.PROJECT_ID +'/' + rowData.REPORT_ID">
													{{rowData[col.field]}} <br> &nbsp;
												</a>
												<span style="max-width:calc(100% - 18px);" *ngIf="!rowData.TEMPLATE || !rowData.TEMPLATE[0]"> 
													{{rowData[col.field]}} 
												</span>
												<a *ngIf="rowData[col.field]==''">
													&nbsp;
												</a>
											</span>
											<span *ngIf="rowData.size!=0">
												<!-- <a style="font-size:12px; position:absolute;right:18px;top:-2px; cursor: pointer;"
												(click)="op2.toggle($event);" title="Edit Name">
												<i class="fas fa-pen erisGreen" style="margin: 5px;"></i>
											</a> *ngIf="rowData.REPORT_URL!=''"-->
												<a *ngIf="rowData.REPORT_URL" [href]="rowData.REPORT_URL"
													target="_blank"
													style="font-size:12px; position:absolute;right:-1px;top:-3px; cursor: pointer;"
													title="PDF"><i class="far fa-file-pdf"
														style="margin:5px; color: rgb(201 218 251)"></i> </a>
												<!--a *ngIf="rowData.REPORT_URL"
													style="position:absolute;right:0;top:12px; cursor: pointer; font-size: 16px;"
													(click)="op1.toggle($event);" title="More Tools">
													<i class="pi pi-angle-down"
														tyle="margin-left:5px; margin-right:4px; ; color: rgb(201 218 251)"></i>
												</a>
												<a *ngIf="!rowData.REPORT_URL"
													style="position:absolute;right:0;top:6px; cursor: pointer; font-size: 16px;"
													(click)="op1.toggle($event);" title="More Tools">
													<i class="pi pi-angle-down"
														tyle="margin-left:5px; margin-right:4px; ; color: rgb(201 218 251)"></i>
												</a-->
					
												
												<!-- <a href="javascript:void(0)" style="font-size:12px; position:absolute;right:0;top:-5px; cursor: pointer;"
													
												title="Add/Edit Reports" data-toggle="modal"
												data-target="#reportsModal"
												(click)="editProject(rowData, rowNode, true); show('collapse5');">
												<i 
													style="margin:7px" class="fas fa-file-medical erisGreen"></i> </a>
					
													<a style="position:absolute;right:0;top:12px; cursor: pointer; font-size: 16px;"
													(click)="op1.toggle($event);" title="More Tools">
													<i class="pi pi-angle-down" style="margin-left:5px; margin-right:4px;"></i>
												</a>										 -->
											</span>
											<p-overlayPanel #op3 [dismissable]="true" appendTo="reportInfo"
												[style]="{'z-index':'9999999999999999','width':'300px'} "
												[showCloseIcon]="true">
					
												<ng-template pTemplate>
													<ng-container>
														<!-- <div class="row">
															<label style="margin-top:10px"
																class="col-md-2 inputLabel">Email: </label>
															<input placeholder="Email"
																style="background:#E6E6E6; margin:4px" type="text"
																class="col-md-6 invuser p-1 rptInfo">
															<div class="col-md-auto" style="margin-top:5px">
																<a class="btn btn-outline-dark btn-sm pt-0 pb-0 pl-1 pr-1 ml-1"
																	title="Send link"> <i
																		class="erisGreen fas fa-paper-plane"></i> </a>
																<a (click)="copy(rowData)"
																	class="btn btn-outline-dark btn-sm pt-0 pb-0 pl-1 pr-1 ml-1"
																	title="Copy Link"><i
																		class="fas fa-link erisGreen"></i> </a>
															</div>
														</div> -->
														Email: <br>
														<input class="rptInfo" type='text' style="width:80%" [(ngModel)]="shareEmail"> 	
														<a  title="Send to Email" style="cursor:pointer;" class="m-1" (click)="shareByEmail(rowData.REPORT_ID);op1.toggle($event)">
															<i style="font-size:15px ; color: rgb(201 218 251)"  class="fas fa-paper-plane"></i>
														</a>
														<a style="cursor:pointer;" (click)="copy(rowData)"
															class="m-1"
															title="Copy Link">
															<i style="color: rgb(201 218 251)"
																class="fas fa-link"></i></a>
													</ng-container>
					
												</ng-template>
											</p-overlayPanel>

											<p-overlayPanel #op1 [appendTo]="'body'">
												<ng-template pTemplate>
													<button *ngIf="rowData.size!=0" 
													data-toggle="modal"
													data-target="#deleteReportModal"
													style="color: rgb(201 218 251)"
														class="btn btn-outline-dark btn-sm pt-0 pb-0 pl-1 pr-1 ml-1"
														title="Delete Report"><i class="far fa-trash-alt"
															(click)="reportToDelete= rowData;tabFrom('PORTFOLIO')"></i> </button>
					
													<!-- <a ref="javascript:void(0)"
														class="btn btn-outline-dark btn-sm pt-0 pb-0 pl-1 pr-1 ml-1"
														(click)="op2.toggle($event);" title="Edit Name">
														<i class="fas fa-pen erisGreen"></i>
													</a>
					
													<a *ngIf="rowData.REPORT_URL"
														(click)="op1.hide(); op3.toggle($event);"
														class="btn btn-outline-dark btn-sm pt-0 pb-0 pl-1 pr-1 ml-1"
														title="Share"><i class="far fa-share-square erisGreen"></i> </a> -->
												</ng-template>
											</p-overlayPanel>
											<p-overlayPanel #op2 [appendTo]="'body'">
					
												<ng-template pTemplate>
													<input class="rptInfo" type="text" [(ngModel)]="rowData[col.field]" 
													style="width: 250px;">
													<button (click)="changeReportTitle(rowData); op2.hide()"
													class="btn m-0 uploadBtn">Save</button>
					
					
												</ng-template>
											</p-overlayPanel>
					
										</div>
										<span *ngIf="(col.field === 'ASSESSOR_DATE' ||
														col.field === 'REPORT_RECEIVED_DATE_DATE' ||
														col.field === 'REVIEWER_DATE' ||
														col.field === 'REPORT_DATE')
														&& rowData.size!=0 && rowData.REPORT_CATEGORY"
											style="position:relative">

											<span *ngIf="rowData.CONSULTANT != 'Y'">
												<a *ngIf="(rowData.ASSESSOR_DUE_DATE==null || rowData.ASSESSOR_DUE_DATE=='') && col.field === 'ASSESSOR_DATE'"
													style=" cursor: pointer;z-index:1;position: absolute; top:0; left:5px; pointer-events: none; color: rgb(201 218 251)">
													<i class="fas fa-calendar-plus"></i></a>
												<a *ngIf="(rowData.REPORT_RECEIVED_DATE==null || rowData.REPORT_RECEIVED_DATE=='') && col.field === 'REPORT_RECEIVED_DATE_DATE'"
													style=" cursor: pointer;z-index:1;position: absolute; top:0; left:5px; pointer-events: none; color: rgb(201 218 251)">
													<i class="fas fa-calendar-plus"></i></a>
												<a *ngIf="(rowData.REVIEWER_DUE_DATE==null || rowData.REVIEWER_DUE_DATE=='') && col.field === 'REVIEWER_DATE'"
													style=" cursor: pointer;z-index:1;position: absolute; top:0; left:5px; pointer-events: none; color: rgb(201 218 251)">
													<i class="fas fa-calendar-plus "></i></a>
												<a *ngIf="(rowData.REPORT_DUE_DATE==null || rowData.REPORT_DUE_DATE=='') && col.field === 'REPORT_DATE'"
													style=" cursor: pointer;z-index:1;position: absolute; top:0; left:5px; pointer-events: none; color: rgb(201 218 251)">
													<i class="fas fa-calendar-plus "></i></a>
											</span>

											<p-calendar *ngIf="col.field === 'ASSESSOR_DATE'"
											#op [appendTo]="'body'"
												[(ngModel)]="rowData.ASSESSOR_DUE_DATE" dateFormat="M dd, yy" 
												[title]="rowData.ASSESSOR_DUE_DATE"
												styleClass="calendarInput2" inputStyleClass="calendarInput2"
												[inputStyle]="{'padding':'2px','color': rowData[col.field+'_RED']? 'rgb(255 89 89)': '#ccc'}"
												[readonlyInput]="true"
												[showOnFocus]="rowData.CONSULTANT != 'Y'"
												showButtonBar="true"
												(onSelect)="changeDate(rowData, rowData.ASSESSOR_DUE_DATE, col.field, col.sortfield)"
												(onClearClick)="changeDate(rowData, rowData.ASSESSOR_DUE_DATE, col.field, col.sortfield)">
											</p-calendar>
											<!------------------------------->
											<p-calendar *ngIf="col.field === 'REPORT_RECEIVED_DATE_DATE'"
											#op [appendTo]="'body'"
												[(ngModel)]="rowData.REPORT_RECEIVED_DATE" dateFormat="M dd, yy" 
												[title]="rowData.REPORT_RECEIVED_DATE"
												styleClass="calendarInput2" inputStyleClass="calendarInput2"
												[inputStyle]="{'padding':'2px','color': rowData[col.field+'_WHITE']? 'rgb(255 89 89)': '#ccc'}"
												[readonlyInput]="true"
												[showOnFocus]="rowData.CONSULTANT != 'Y'"
												showButtonBar="true"
												(onSelect)="changeDate(rowData, rowData.REPORT_RECEIVED_DATE, col.field, col.sortfield)"
												(onClearClick)="changeDate(rowData, rowData.REPORT_RECEIVED_DATE, col.field, col.sortfield)">
											</p-calendar>
											<!------------------------------->
											<p-calendar *ngIf="col.field === 'REVIEWER_DATE'"
											#op [appendTo]="'body'"
												[(ngModel)]="rowData.REVIEWER_DUE_DATE" dateFormat="M dd, yy"
												[title]="rowData.REVIEWER_DUE_DATE"
												styleClass="calendarInput2" inputStyleClass="calendarInput2"
												[inputStyle]="{'padding':'2px','color': rowData[col.field+'_RED']? 'rgb(255 89 89)': '#ccc'}"
												[readonlyInput]="true"
												[showOnFocus]="rowData.CONSULTANT != 'Y'"
												showButtonBar="true"
												(onSelect)="changeDate(rowData, rowData.REVIEWER_DUE_DATE, col.field, col.sortfield)"
												(onClearClick)="changeDate(rowData, rowData.REVIEWER_DUE_DATE, col.field, col.sortfield)">
											</p-calendar>
											<p-calendar *ngIf="col.field === 'REPORT_DATE'"
											#op [appendTo]="'body'"
												[(ngModel)]="rowData.REPORT_DUE_DATE" dateFormat="M dd, yy" 
												[title]="rowData.REPORT_DUE_DATE"
												styleClass="calendarInput2" inputStyleClass="calendarInput2"
												[inputStyle]="{'padding':'2px','color': rowData[col.field+'_RED']? 'rgb(255 89 89)': '#ccc'}"
												[readonlyInput]="true"
												[showOnFocus]="rowData.CONSULTANT != 'Y'"
												showButtonBar="true"
												(onSelect)="changeDate(rowData, rowData.REPORT_DUE_DATE, col.field, col.sortfield)"
												(onClearClick)="changeDate(rowData, rowData.REPORT_DUE_DATE, col.field, col.sortfield)">
											</p-calendar>
										</span>
										<span *ngIf="col.field === 'PROJECT_NUMBER'">
											<ng-container>
												<div>
													<div style="position:relative;">
														<span class="line-clamp ">
															<a *ngIf="rowData.PRIVATE_FLAG == 'Y'" class="mr-1" style="cursor:pointer"
																data-toggle="modal" (click)="editProject(rowData, '', false); show('collapse1'); hide('inner-collapse1');
																hide('inner-collapse2'); hide('inner-collapse3');tabFrom('ACTIVE');checkEditProjectPermission(rowData.PROJECT_ID)"
																data-target="#reportsModal"
																[title]="rowData.PROJECT_NUMBER"
																href="javascript:void(0)">
																<i class="erisIconColor fas fa-lock"></i>
															</a>
															<a *ngIf="rowData.PORTFOLIO.length!=0 && rowData.PORTFOLIO[0].PORTFOLIO_NAME != ''"
																class="mr-1" style="cursor:pointer" 
																(click)="getAllPortfolios1();tabFrom('PORTFOLIO');selectedPortfolio=rowData.PORTFOLIO[0].PORTFOLIO_ID; getProjectforPortfolioV2(); setTabs()"
																[title]=rowData.PORTFOLIO[0].PORTFOLIO_NAME>
																<i class="erisIconColor fas fa-folder"></i>
															</a>
															<!-- yoinked from reports2: -->
															<!-- <a  class="mr-1" style="cursor:pointer" (click)="selectedPortfolio=rowData.PORTFOLIO[0].PORTFOLIO_ID; portfolioDisplayName=rowData.PORTFOLIO[0].PORTFOLIO_NAME;getAllPortfoliosFromActive(); setTabs()"[title]=rowData.PORTFOLIO[0].PORTFOLIO_NAME *ngIf="rowData.PORTFOLIO.length!=0" >
																<i class="erisIconColor fas fa-folder"></i>
															</a> -->

															<!-- original colour of vv: erisGreen, color: rgb(195,212,47) just to keep for now -->
															<!-- now it is:
																.erisIconColor{
																color: rgb(201 218 251)
															  } -->
															  <!-- max-width:calc(80% - 20px);  -->
															<a class="erisIconColor mr-1"
															target="_blank"
																style="cursor: pointer; margin-right:19px; text-overflow: ellipsis; display: inline-block;"
																data-toggle="modal" (click)="editProject(rowData, '', false); show('collapse1'); hide('inner-collapse1');
																hide('inner-collapse2'); hide('inner-collapse3');tabFrom('ACTIVE');checkEditProjectPermission(rowData.PROJECT_ID)"
																data-target="#reportsModal"
																[title]="rowData.PROJECT_NUMBER"
																href="javascript:void(0)">{{rowData.PROJECT_NUMBER}}</a>
														</span>
													
														<!--a href="javascript:void(0)"
															style="font-size:12px; position:absolute;right:0;top:-5px; cursor: pointer;"
															title="Add/Edit Reports" data-toggle="modal"
															data-target="#reportsModal"
															(click)="editProject(rowData, '', false); show('collapse1');tabFrom('ACTIVE');getReports2()">
															<i style="margin:4px; color: rgb(201 218 251)" 
																class="fas fa-edit"></i> </a>
					
														<a style="position:absolute;right:0;top:12px; cursor: pointer; font-size: 16px; ; color: rgb(201 218 251)"
															(click)="op1.toggle($event);" title="More Tools">
															<i class="pi pi-angle-down"
																style="margin-left:5px; margin-right:4px;"></i>
														</a-->
													</div>
													<!-- <div class="col-sm-2">
														<a href="javascript:void(0)"
															class="btn btn-outline-dark btn-sm pt-0 pb-0 pl-1 pr-1 ml-1"
															title="Edit Project" data-toggle="modal"
															data-target="#reportsModal"
															(click)="editProject(rowData, rowNode, true);">
															<i 
																class="fas fa-file-medical erisGreen"></i> </a>
					
														<a style="cursor: pointer; font-size: 16px;"
															(click)="op1.toggle($event);" title="Edit Project">
															<i class="pi pi-angle-down" style="margin-left:5px; margin-right:5px;"></i>
														</a>
													</div> -->
												</div>
											</ng-container>

											<p-overlayPanel #op1 [appendTo]="'body'">
					
												<ng-template pTemplate>
													<button
													data-toggle="modal"
													data-target="#deleteModal"
														class="btn btn-outline-dark btn-sm pt-0 pb-0 pl-1 pr-1 ml-1"
														title="Delete Project"
														style="color: rgb(201 218 251)"
														(click)="projectToDelete=rowData.PROJECT_ID;tabFrom('ACTIVE')"><i
															class="far fa-trash-alt"></i>
												</button>
					
												</ng-template>
											</p-overlayPanel>
										</span>
										<!-- <span *ngIf="(i==13)">
											<ng-container>
												<ng-container *ngIf="rowData.ORDER_REPORTS?.length>0">
													<div class="row">
														<div class="col-sm-7" style="margin-top:3px">
															{{rowData.ORDER_NUM}}
														</div>
														<div #test class="col-sm-auto">
															<a style="cursor: pointer; font-size: 16px;" (click)="op2.toggle($event);"
															>
															<i class="pi pi-angle-down" style="margin: 5px;"></i>
														</a>
														</div>
														<p-overlayPanel #op2 [appendTo]="'body'" [dismissable]="true">
															<ng-template pTemplate>
																			<ng-container *ngFor="let item of rowData[col.field]">
																				<a style="font-size:12px" [href]="item.REPORT_URL"
																					target=_blank>{{item.REPORT_NAME}}</a><br>
																			</ng-container>
															</ng-template>
														</p-overlayPanel>
													</div>
					
												</ng-container> -->
										<span *ngIf="rowData.size!=0 && !rowData.project && col.field=='STATUS'">
											<ng-container>
												<div style="position:relative">
													<div style="max-width:calc(100% - 20px);" [title]="rowData.STATUS">
														{{rowData.STATUS}}
													</div>
													<div>
														<a style="position:absolute;right:0;top:-5px; cursor: pointer; font-size: 16px;"
															(click)="getStatus(rowData.REPORT_ID);op1.toggle($event);" title="Edit Status">
															<i class="pi pi-angle-down" style="margin: 5px;"></i>
														</a>
													</div>
													<p-overlayPanel #op1 [appendTo]="'body'">
														<ng-template pTemplate>
															<ng-container *ngFor="let item of statusList2; trackBy: trackByFuntion">
																<a href="javascript:void(0)"
																	style="font-size:.8em; color: #C2D63F;"
																	(click)="op1.hide(); changeStatus1(rowData,item.STATUS)">{{item.STATUS}}</a>
																<br>
															</ng-container>
														</ng-template>
													</p-overlayPanel>
												</div>
											</ng-container>
										</span>
										<span *ngIf="rowData.FULL_ADDRESS && col.field=='FULL_ADDRESS'">
											<a [title]="rowData.FULL_ADDRESS" class="link-light line-clamp"
												style="cursor:pointer; text-decoration: underline;"
												(click)="op.toggle($event);getCords(rowData)">
												<!-- <i class= "fas fa-map-marker-alt" style="float:right; margin:3px; color: rgb(201 218 251)"></i> -->
												{{rowData.FULL_ADDRESS}}
											</a>
											<p-overlayPanel #op [appendTo]="'body'" [dismissable]="true" (onHide)="onHide()"
												[style]="{width: '550px', height: '550px'}">
												<span style="color:rgb(195,212,47)">
													{{rowData.FULL_ADDRESS}}
													<a *ngIf="!noLocation" style="color: red; display: inline-block;">
														(Address not valid)
													</a><br>
													<span *ngIf="rowData.PARCEL_ID">
														Parcel ID: {{rowData.PARCEL_ID}}
													</span>
													
												</span>
												<!--<agm-map id="test" class="googleMap2" controlSize=24 [latitude]="rowData.LATITUDE"
													  [longitude]="rowData.LONGITUDE" [zoom]="zoomV" [disableDefaultUI]="false" [zoomControl]="false" [disableDoubleClickZoom]='true'>
													  <agm-marker *ngIf="noLocation" [latitude]="rowData.LATITUDE" 
													  [longitude]="rowData.LONGITUDE">
														<agm-info-window>
															<strong>{{rowData.FULL_ADDRESS}}</strong>
														</agm-info-window>
					
													</agm-marker>
												</agm-map>-->
												<div id="googleMap2" class="googleMap2"></div>
											</p-overlayPanel>
										</span>
										<span *ngIf="rowData.size!=0 && rowData.REPORT_CATEGORY && col.field=='TEMPLATE_ID'">
											<div *ngIf="!rowData.TEMPLATE || !rowData.TEMPLATE[0]"
												style="position:relative">
												<div>
													<a style="position:absolute;right:2px;top:-8px; cursor: pointer; font-size: 16px;"
														(click)="op1.toggle($event);findType(rowData);"
														title="Add Template">
														<i class="fas fa-plus erisIconColor" style="margin: 4px;"></i>
													</a>
													<p-overlayPanel #op1 [appendTo]="'body'">
														<ng-template pTemplate>
															<label class="col-md-4 inputLabel">
																Template Identifier:</label>
															<select class="col-md-7 p-1 rptInfo" style="margin:4px;"
																[(ngModel)]="catToChange.selectedSubCat"
																[ngModelOptions]="{standalone: true}"
																(change)="setByTypeId(catToChange);">
																<option></option>
																<option
																	*ngFor="let subCat of catToChange.subCategories;"
																	[ngValue]="subCat">
																	{{subCat.subCategory}}</option>
															</select>
															<label class="col-md-4 inputLabel">Template: </label>
															<select class="col-md-7 p-1 rptInfo" style="margin:4px;"
																[(ngModel)]="catToChange.selectedTemplate"
																[ngModelOptions]="{standalone: true}"
																(change)="changeTemplate(rowData)">
																<option></option>
																<option
																	*ngFor="let template of catToChange.typeIdTemplates;"
																	[ngValue]="template">
																	{{template.TEMPLATE_TITLE}}</option>
															</select>
														</ng-template>
													</p-overlayPanel>
												</div>
											</div>
											<ng-container *ngIf="rowData.TEMPLATE && rowData.TEMPLATE[0]">
												<div  style="position:relative">
													<!-- <div class="row"> -->
													<!-- <div class="col-md-6"> -->
													<div style="max-width:calc(100% - 18px);" class="line-clamp">													
														<a class="erisIconColor" [href]="'template/'+rowData.TEMPLATE[0].TEMPLATE_ID" target=_blank	title="{{rowData.TEMPLATE[0].TEMPLATE_TITLE}}">
														{{rowData.TEMPLATE[0].TEMPLATE_TITLE}}
														</a>														
													</div>
													<ng-container *ngIf="rowData.TEMPLATE[0].TEMPLATE_VERSION_NO">
														<span style="font-size: 7pt;">({{rowData.TEMPLATE[0].TEMPLATE_VERSION_NO}})</span>
													</ng-container>
													<!--<div>
														<a style="position:absolute;right:0;top:-5px; cursor: pointer; font-size: 16px;"
															(click)="tableTemplates=[]; getTemplate(rowData.TEMPLATE[0].TEMPLATE_TYPE_ID); findType1(rowData);op11.toggle($event);"
															title="Choose Template">
															<i class="pi pi-angle-down" style="margin: 5px;"></i>
														</a>
													</div>-->
													<!--<p-overlayPanel #op11 [appendTo]="'body'" [dismissable]="false" [showCloseIcon]="true">
														<ng-template pTemplate>
															<div style="padding:4px; height:400px; overflow:auto; width:400px">
													
															<ng-container *ngFor="let item of tableTemplates; trackBy:trackByFuntion">
															
																<a href="javascript:void(0)"
																	style="font-size:.8em; color: #C2D63F;"
																	(click)="updateTemplate(item, rowData); op11.hide()">
																	{{item.TEMPLATE_TITLE}}</a>
																<br>
					
															</ng-container>
															</div>
														</ng-template>
													</p-overlayPanel>-->
										
												</div>
											</ng-container>
										</span>
										<span *ngIf="rowData.size!=0 && col.field=='TRANSACTION_TYPE'"
											style="position:relative">
											<span *ngIf='rowData[col.field]&&rowData[col.field][0]'
											[title]="rowData[col.field][0].TRANSACTION_TYPE"
											style="overflow-wrap:break-word;">
												{{rowData[col.field][0].TRANSACTION_TYPE}}
											</span><br>
											<span *ngIf='rowData["PROTOCOL"]&&rowData["PROTOCOL"][0]'
											[title]="rowData['PROTOCOL'][0]?.PROTOCOL"
											style="overflow-wrap:break-word;">
												{{rowData['PROTOCOL'][0]?.PROTOCOL}}
											</span>
										</span>
										<span *ngIf="rowData.size!=0 &&rowData.REPORT_CATEGORY && (col.field==='ASSESSOR' || col.field==='REVIEWER')">
											<a *ngIf="rowData[col.field] && rowData[col.field][0] && rowData[col.field][0].LAST_NAME "
												(click)="op1.toggle($event); checkAssignUserPermission(rowData.REPORT_ID); getCompanyRoles(); getAllReportUsers(-1, -1, ''); clearInvite1(rowData, rowData[col.field]);"
												[title]="rowData[col.field][0].FIRST_NAME+ ' ' + rowData[col.field][0].LAST_NAME"
												style="cursor: pointer; text-decoration: underline; overflow-wrap: break-word;">
												{{rowData[col.field][0].FIRST_NAME
												+ " " + rowData[col.field][0].LAST_NAME}}
											</a>
											<a *ngIf="rowData[col.field] && rowData[col.field][0] && !rowData[col.field][0].LAST_NAME"
												(click)="op1.toggle($event); checkAssignUserPermission(rowData.REPORT_ID); getCompanyRoles(); getAllReportUsers(-1, -1, ''); clearInvite1(rowData, rowData[col.field]);"
												[title]="rowData[col.field][0].USER_MAME"
												style="cursor: pointer; text-decoration: underline; word-break:break-all">
												{{rowData[col.field][0].USER_EMAIL}}
											</a>
											<a *ngIf="!rowData[col.field] || !rowData[col.field][0]"
												(click)="op1.toggle($event); checkAssignUserPermission(rowData.REPORT_ID); getCompanyRoles(); getAllReportUsers(-1, -1, ''); clearInvite1(rowData, rowData[col.field]);"
												title="Add User"
												style="cursor: pointer; margin-left:5px;"><i
												class="icon-AddUser fa-2x" style="color: rgb(201 218 251)"></i></a>
											<p-overlayPanel #op1 [style]="{'max-width':'580px'}" [appendTo]="'body'">
												<ng-template pTemplate>
													<ng-container>
														<div class="row">
															<label style="margin-top:10px"
																class="col-md-3 inputLabel">
																{{col.header}}: </label>
															<ng-select *ngIf="!rowData[col.field][0]"
																id="writer reviewer dropdown"style="margin:4px; color: grey" class="col-md-7 p-1 rptInfo"
																[clearable]="false" [items]="allusersList"
																notFoundText="Not Found" bindLabel="USER_EMAIL"
																[(ngModel)]="rowData[col.field][0]"
																[ngModelOptions]="{standalone: true}"
																[searchFn]="customSearchFn"
																(change)="changeUser(rowData, rowData[col.field], col.field)"
																placeholder="Select Existing User"
																>
					
																<!-- <ng-option [value]="{'USER_ID':null}">test</ng-option> -->
																<ng-template ng-label-tmp let-item="item">
																	<span *ngIf="item.FULL_NAME" style="color: black;">{{
																		item.FULL_NAME + ', ' +
																		'('+item.USER_EMAIL+')'}}</span>
																	<span
																		*ngIf="!item.FULL_NAME">{{ '(' + item.USER_EMAIL + ')'}}</span>
																</ng-template>
																<ng-template ng-option-tmp let-item="item"
																	let-search="searchTerm" let-index="index" >
																	<span *ngIf="item.FULL_NAME" style="color: black;">{{
																		item.FULL_NAME + ', ' +
																		'(' + item.USER_EMAIL + ')'}}</span>
																	<span
																		*ngIf="!item.FULL_NAME" style="color: black;">{{'(' + item.USER_EMAIL + ')'}}</span>
																</ng-template>
															</ng-select>
															<ng-select *ngIf="rowData[col.field][0]"
																id="writer reviewer dropdown"style="margin:4px; color: grey" class="col-md-7 p-1 rptInfo"
																[clearable]="false" [items]="allusersList"
																notFoundText="Not Found" bindLabel="USER_EMAIL"
																[(ngModel)]="rowData[col.field][0]"
																[ngModelOptions]="{standalone: true}"
																[searchFn]="customSearchFn"
																(change)="changeUser(rowData, rowData[col.field], col.field)"
																>
																<!-- <ng-option [value]="{'USER_ID':null}">test</ng-option> -->
																<ng-template ng-label-tmp let-item="item">
																	<span *ngIf="item.FULL_NAME" style="color: black;">{{
																		item.FULL_NAME + ', ' +
																		'(' + item.USER_EMAIL + ')'}}</span>
																	<span
																		*ngIf="!item.FULL_NAME">{{item.USER_EMAIL}}</span>
																</ng-template>
																<ng-template ng-option-tmp let-item="item"
																	let-search="searchTerm" let-index="index" >
																	<span *ngIf="item.FULL_NAME" style="color: black;">{{
																		item.FULL_NAME + ', ' +
																		'(' + item.USER_EMAIL + ')'}}</span>
																	<span
																		*ngIf="!item.FULL_NAME" style="color: black;">{{'(' + item.USER_EMAIL + ')'}}</span>
																</ng-template>
															</ng-select>
					
															<button class="btn btn-sm pt-0 pb-0 pl-1 pr-1 col-md-1"
																style="margin-left: 5px; padding: 3px; font-size: 11px; margin:4px"
																title="Remove User"><i
																	class="far fa-trash-alt erisGreen"
																	(click)="rowData[col.field][0]={'USER_ID':null}; changeUser(rowData, rowData[col.field], col.field)"></i>
															</button>
															<hr style="color: white; width: 100%; background-color: white;">
																<!---->
															<div>
																<label style="margin-top:10px"
																class="col-md-10 inputLabel">Invite New Users
																&nbsp;
																
																<span style="float: right">External:
																	<input type="checkbox" [(ngModel)]="userExternal" (change)="changeRole()" [ngModelOptions]="{standalone: true}"></span></label>
					
															
					
																<label style="margin-top:10px"
																class="col-md-3 inputLabel">First Name:<span style="color:red"> * </span>
																&nbsp;</label>
					
																<input [(ngModel)]="firstname"
																	[ngModelOptions]="{standalone: true}"
																	style="background:#E6E6E6; margin:4px" type="text"
																	class="col-md-7 invuser p-1 rptInfo"/>
						
																	<label style="margin-top:10px"
																	class="col-md-3 inputLabel">Last Name:<span style="color:red"> * </span>
																	&nbsp;</label>
						
																<input [(ngModel)]="lastname"
																	[ngModelOptions]="{standalone: true}"
																	style="background:#E6E6E6; margin:4px" type="text"
																	class="col-md-7 invuser p-1 rptInfo"/>
						<!---->
																<label style="margin-top:10px"
																	class="col-md-3 inputLabel">Email:<span style="color:red"> * </span>
																	&nbsp;</label>
						
																<input [(ngModel)]="userToAdd"
																	[ngModelOptions]="{standalone: true}"
																	style="background:#E6E6E6; margin:4px" type="text"
																	class="col-md-7 invuser p-1 rptInfo" placeholder="Enter Email to Invite User"/>
															
																<!--button type="button"
																	title="Invite User"
																	class="btn btn-sm pt-0 pb-0 pl-1 pr-1 col-md-1"
																	(click)="inviteUser2(rowData, col.field); op1.hide()"
																	style="margin-left: 5px; padding: 3px; font-size: 11px; margin:4px">
																	<i class="fas fa-user-plus erisGreen"></i></button-->
						
																<!-- <button *ngIf="i==10" type="button" class="btn btn-sm pt-0 pb-0 pl-1 pr-1 col-md-1"
																			(click)="inviteUser2(rowData, col.field); op1.hide()"
																			style="margin-left: 5px; padding: 3px; font-size: 11px; margin:4px"> <i class="fas fa-user-plus erisGreen"></i></button> -->
																<!-- </div> -->
					
																<label style="margin-top:10px"
																class="col-md-3 inputLabel">User Role:<span style="color:red"> * </span></label>
																<select style="margin:4px;" class="col-md-7 p-1 rptInfo" [(ngModel)]="role"
																[ngModelOptions]="{standalone: true}" >
																  <option [value]="type.ROLE_ID" *ngFor="let type of roles">
																	{{type.ROLE_NAME}} </option>
																</select>
					
																<label class="col-md-10 inputLabel">
																	<button (click)="inviteUser3(rowData, col.field, op1, $event); " [disabled]="inviteUserLoading||!assignUserPermission"
																	title="Invite User" class="btn btn-default btn-outline-dark"
																	style="color: white; border-color: white; margin-top: 10px;" >Invite User</button>
																	<i *ngIf="inviteUserLoading" class="pi pi-spin pi-spinner" style="font-size: 1.2rem; margin-left: 10px; color: #C2D63F;"></i>
																	<span *ngIf="inviteUserErrorMessage" style="margin-left:30px;color: red"> {{inviteUserErrorMessage}}</span>
																</label>
																
																<button title="Close" class="btn btn-outline-dark btn-sm pt-0 pb-0 pl-1 pr-1 ml-1" 
																	style="float: right; color: black; background-color: #C2D63F; border-color:black; margin: 10px;" 
																	(click)='op1.hide()'>
																	Close
																</button>

															</div>
												
														</div>
													</ng-container>
												</ng-template>
											</p-overlayPanel>
					
										</span>
										<span *ngIf="rowData.size!=0 &&rowData.REPORT_CATEGORY && col.field==='ASSIGNED_USERS'">
											<!-- <a  [class.assignedUser]="rowData[col.field].length>1"
												*ngIf="rowData[col.field] && rowData[col.field][0] && rowData[col.field][0].LAST_NAME && rowData[col.field][1] && rowData[col.field][1].LAST_NAME"
												(click)="op1.toggle($event); getCompanyRoles(); getAllReportUsers(-1, -1, ''); clearInvite1(rowData, rowData[col.field]); "
												style="cursor: pointer; text-decoration: underline;">
												{{rowData[col.field][0].FIRST_NAME
												+ " " + rowData[col.field][0].LAST_NAME}}
												{{rowData[col.field][1].FIRST_NAME
													+ " " + rowData[col.field][1].LAST_NAME}}
											</a>
											<a  [class.assignedUser]="rowData[col.field].length>1"
												*ngIf="rowData[col.field] && rowData[col.field][0] && !rowData[col.field][0].LAST_NAME && rowData[col.field][1] && !rowData[col.field][1].LAST_NAME"
												(click)="op1.toggle($event); getCompanyRoles(); getAllReportUsers(-1, -1, ''); clearInvite1(rowData, rowData[col.field]); "
												style="cursor: pointer; text-decoration: underline; word-break:break-all">
												{{rowData[col.field][0].USER_EMAIL}}
												{{rowData[col.field][1].USER_EMAIL}}
											</a> -->

											<!-- If there are assigned users: -->
											<div style="position:relative">
												<a  [class.assignedUser]="rowData[col.field].length>1"
													*ngIf="rowData[col.field] && rowData[col.field][0] && rowData[col.field][0].LAST_NAME"
													(click)="op1.toggle($event); getCompanyRoles(); getAllReportUsers(-1, -1, ''); clearInvite1(rowData, rowData[col.field]); "
													[title]="rowData[col.field][0].FIRST_NAME+ ' ' + rowData[col.field][0].LAST_NAME"
													style="cursor: pointer; text-decoration: underline; overflow-wrap: break-word;">
													{{rowData[col.field][0].FIRST_NAME
													+ " " + rowData[col.field][0].LAST_NAME}}
												</a>
												<a  [class.assignedUser]="rowData[col.field].length>1"
													*ngIf="rowData[col.field] && rowData[col.field][0] && !rowData[col.field][0].LAST_NAME"
													(click)="op1.toggle($event); getCompanyRoles(); getAllReportUsers(-1, -1, ''); clearInvite1(rowData, rowData[col.field]); "
													[title]="rowData[col.field][0].USER_EMAIL"
													style="cursor: pointer; text-decoration: underline; word-break:break-all">
													{{rowData[col.field][0].USER_EMAIL}}
												</a>
												
												<!-- If there is more than 1 assigned user: -->
												<div *ngIf="rowData[col.field].length>1">
													<a style="position:absolute;right:0;top:-5px; cursor: pointer; font-size: 16px;"
														(click)="assignedUsersop.toggle($event);"
														title="View Assigned Users">
														<i class="pi pi-angle-down" style="margin: 5px;"></i>
													</a>
												</div>
												<p-overlayPanel #assignedUsersop [appendTo]="'body'" [dismissable]="true" [showCloseIcon]="true">
													<ng-template pTemplate>
														<div style="padding:4px; height:400px; overflow:auto; width:400px">
															<ng-container *ngFor="let item of rowData[col.field];">
																<span *ngIf="item.FIRST_NAME!==undefined">{{item.FIRST_NAME}} </span>
																<span *ngIf="item.LAST_NAME!==undefined">{{item.LAST_NAME}} </span>
																<span *ngIf="item.USER_EMAIL!==undefined">({{item.USER_EMAIL}})</span>
																<br>
															</ng-container>
														</div>
													</ng-template>
												</p-overlayPanel>
											</div>

											<!-- If there are no assigned users: -->
											<a [class.assignedUser]="rowData[col.field]?.length>1"
												*ngIf="!rowData[col.field] || !(rowData[col.field]&&rowData[col.field][0])"
												(click)="op1.toggle($event); checkAssignUserPermission(rowData.REPORT_ID); getCompanyRoles(); clearInvite1(rowData, rowData[col.field]); getAllReportUsers(-1, -1, '');"
												title="Add User"
												style="cursor: pointer; margin-left:5px;">
												<i class="icon-AddUser fa-2x" style="color: rgb(201 218 251)"></i></a>
											<p-overlayPanel #op1 [style]="{'max-width':'580px'}" [dismissable]="false" [appendTo]="'body'" (onShow)="getCompanyRoles(); clearInvite()">
												<ng-template pTemplate>
													<ng-container>
														<!-- <div>
															{{rowData.ASSESSOR_TITLE[0]}}
														</div> -->
														<div class="row">
															<div *ngFor="let user of rowData.ASSIGNED_USERS" class="col-md-12">
																<label class="tag"> <i class="fas fa-times iconBtn erisGreen" style="margin-left:5px" (click)='removeAssignedUser(rowData, user)'></i> {{user.FULL_NAME? user.FULL_NAME:user.USER_EMAIL}}</label>
															</div>
															<label style="margin-top:10px"
																class="col-md-3 inputLabel">Add New User: </label>
					
																<!-- <select class="col-md-6 p-1 rptInfo" style="margin:4px; color: grey;" [(ngModel)]="rowData['USER_TO_ADD']">
																	<option></option>
																	<option *ngFor="let item of allusersList" [ngValue]='item'>
																	{{item.FULL_NAME}} ({{item.USER_EMAIL}})
																
																	</option>
																</select> -->
																<ng-select
																	id="writer reviewer dropdown"style="margin:4px; color: grey" class="col-md-7 p-1 rptInfo"
																	[clearable]="false" 
																	[items]="allusersList"
																	notFoundText="Not Found" bindLabel="USER_EMAIL"
																	[(ngModel)]="rowData['USER_TO_ADD']"
																	[ngModelOptions]="{standalone: true}"
																	>
																	<!-- placeholder="Select Existing User" -->
																	<!-- <ng-option [value]="{'USER_ID':null}">test</ng-option> -->
																	<ng-template ng-label-tmp let-item="item">
																		<span *ngIf="item.FULL_NAME" style="color: black;">{{
																			item.FULL_NAME + ', ' +
																			'('+item.USER_EMAIL+')'}}</span>
																		<span
																			*ngIf="!item.FULL_NAME">{{ '(' + item.USER_EMAIL + ')'}}</span>
																	</ng-template>
																	<ng-template ng-option-tmp let-item="item">
																		<span *ngIf="item.FULL_NAME" style="color: black;">{{
																			item.FULL_NAME + ', ' +
																			'(' + item.USER_EMAIL + ')'}}</span>
																		<span
																			*ngIf="!item.FULL_NAME" style="color: black;">{{'(' + item.USER_EMAIL + ')'}}</span>
																	</ng-template>
																</ng-select>
																
																<button *ngIf="!rowData['USER_TO_ADD']" class="btn btn-sm pt-0 pb-0 pl-1 pr-1 col-md-1 btn-outline-light"
																style="margin-left: 5px; padding: 3px; margin:4px">
																Add 
																</button>
																<button *ngIf="rowData['USER_TO_ADD']" class="btn btn-sm pt-0 pb-0 pl-1 pr-1 col-md-1 btn-outline-light"
																style="margin-left: 5px; padding: 3px; margin:4px" (click)="addAssignedUser(rowData, rowData['USER_TO_ADD']);"
																title="Add User">Add
																</button>
						
																<hr style="color: white; width: 100%; background-color: white;">
						
																<!--label style="margin-top:10px"
																	class="col-md-4 inputLabel">Invite New User:
																	&nbsp;</label>
						
																<input [(ngModel)]="userToAdd"
																	[ngModelOptions]="{standalone: true}"
																	style="background:#E6E6E6; margin:4px" type="text"
																	class="col-md-6 invuser p-1 rptInfo" placeholder="Enter Email to Invite User"/>
						
																<button type="button"
																	title="Invite User"
																	class="btn btn-sm pt-0 pb-0 pl-1 pr-1 col-md-1"
																	(click)="inviteUser2(rowData, col.field);"
																	style="margin-left: 5px; padding: 3px; font-size: 11px; margin:4px">
																	<i class="fas fa-user-plus erisGreen"></i></button>
															
																
																	<label style="margin-top:10px"
																	class="col-md-4 inputLabel">User Role:</label>
																	<select style="margin:4px;" class="col-md-6 p-1 rptInfo" [(ngModel)]="role"
																	[ngModelOptions]="{standalone: true}" >
																	<option [value]="type.ROLE_ID" *ngFor="let type of roles">
																		{{type.ROLE_NAME}} </option>
														
																	</select-->
													
																<label style="margin-top:10px"
																class="col-md-10 inputLabel">Invite New Users
																&nbsp;<span style="float: right">External:
																	<input type="checkbox" [(ngModel)]="userExternal" (change)="changeRole()" [ngModelOptions]="{standalone: true}"></span></label>
					
															
					
																<label style="margin-top:10px"
																class="col-md-3 inputLabel">First Name:<span style="color:red"> * </span>
																&nbsp;</label>
						
																<input [(ngModel)]="firstname"
																	[ngModelOptions]="{standalone: true}"
																	style="background:#E6E6E6; margin:4px" type="text"
																	class="col-md-7 invuser p-1 rptInfo"/>
						
																	<label style="margin-top:10px"
																	class="col-md-3 inputLabel">Last Name:<span style="color:red"> * </span>
																	&nbsp;</label>
						
																<input [(ngModel)]="lastname"
																	[ngModelOptions]="{standalone: true}"
																	style="background:#E6E6E6; margin:4px" type="text"
																	class="col-md-7 invuser p-1 rptInfo"/>

																<label style="margin-top:10px"
																	class="col-md-3 inputLabel">Email:<span style="color:red"> * </span>
																	&nbsp;</label>
						
																<input [(ngModel)]="userToAdd"
																	[ngModelOptions]="{standalone: true}"
																	style="background:#E6E6E6; margin:4px" type="text"
																	class="col-md-7 invuser p-1 rptInfo" placeholder="Enter Email to Invite User"/>
						
																	<label style="margin-top:10px"
																	class="col-md-3 inputLabel">User Role:<span style="color:red"> * </span></label>
																	<select style="margin:4px;" class="col-md-7 p-1 rptInfo" [(ngModel)]="role"
																	[ngModelOptions]="{standalone: true}" >
																  <option [value]="type.ROLE_ID" *ngFor="let type of roles">
																	{{type.ROLE_NAME}} </option>
													  
																</select>
					
																<label class="col-md-10 inputLabel">
																	<button (click)="inviteUser3(rowData, col.field, op1, $event); " [disabled]="inviteUserLoading||!assignUserPermission" title="Invite User"
																		class="btn btn-default btn-outline-dark" style="color: white; border-color: white; margin-top: 10px;" >Invite User</button>
																	<i *ngIf="inviteUserLoading" class="pi pi-spin pi-spinner" style="font-size: 1.2rem; margin-left: 10px; color: #C2D63F;"></i>
																	<span *ngIf="inviteUserErrorMessage" style="margin-left:30px;color: red"> {{inviteUserErrorMessage}}</span>
																</label>
																
																<button title="Close" class="btn btn-outline-dark btn-sm pt-0 pb-0 pl-1 pr-1 ml-1" 
																	style="float: right; color: black; background-color: #C2D63F; border-color:black; margin: 10px;" 
																	(click)='op1.hide()'>
																	Close
																</button>

														</div>
													</ng-container>
												</ng-template>
											</p-overlayPanel>
					
										</span>
					
										<span *ngIf="rowData.size!=0 && col.field==='ORDER_REPORTS'">
											<ng-container>
												<ng-container *ngIf="rowData.ORDER_NUM!=''">
													<div>
														<div style=" white-space: nowrap;
														overflow: hidden;
														text-overflow: ellipsis;
														 cursor: pointer; font-size: 12px; margin-top:3px; color:rgb(195,212,47)"  *ngIf="rowData.ORDER_REPORTS?.length>0"
														 [title]="rowData.ORDER_NUM">
															<a style="color:rgb(195,212,47)"
																(click)="op2.toggle($event);">
																{{rowData.ORDER_NUM}}
															</a>
														</div>
														<div style="  white-space: nowrap;
														overflow: hidden;
														text-overflow: ellipsis; margin-top:3px;" *ngIf="rowData.ORDER_REPORTS?.length==0"
														[title]="rowData.ORDER_NUM">
										
																{{rowData.ORDER_NUM}}
														
														</div>
														<!-- <div #test class="col-sm-auto">
															<a style="cursor: pointer; font-size: 16px;"
																(click)="op2.toggle($event);">
																<i class="pi pi-angle-down" style="margin: 5px;"></i>
															</a>
														</div> -->
														<p-overlayPanel #op2 [styleClass]="'fixedoverlay'"
															[appendTo]="'body'" [dismissable]="true">
															<ng-template pTemplate>
																<ng-container *ngFor="let item of rowData[col.field]">
																	<a style="font-size:12px; color:rgb(195,212,47)"
																		[href]="item.REPORT_URL"
																		target=_blank>{{item.REPORT_NAME}}</a><br>
																</ng-container>
															</ng-template>
														</p-overlayPanel>
													</div>
					
												</ng-container>
												<ng-container *ngIf="rowData.ORDER_NUM==''">
					
												<span *ngIf="userInfo.ERIS_CUSTOMER_ID">
												<a class="btn btn-sm pt-0 pb-0 pl-1 pr-1 ml-1"
														(click)="op1.toggle($event);consoleLog(userInfo);checkErisData()"
														title="Add/Change Order Number">
														<i class="erisIcon erisGreen"></i>
													</a>
												</span>
												<span *ngIf="!userInfo.ERIS_CUSTOMER_ID">
													<a class="btn btn-sm pt-0 pb-0 pl-1 pr-1 ml-1"
															(click)="op2.toggle($event);consoleLog(userInfo)"
															title="Add/Change Order Number">
															<i class="erisIcon erisGreen"></i>
														</a>
													</span>
												</ng-container>
					
												<p-overlayPanel #op1 [appendTo]="'body'" [style]="{'z-index':'9999999999999999', 'min-width':'400px', 'max-width':'700px'}" [dismissable]="false" [showCloseIcon]="false">
													<ng-template pTemplate>
														<!-- <span *ngFor="let history of rowData.RW_REPORT_HISTORY">
															<a class="erisGreen" [title]="history.CHANGE_REASON_DESC"> {{history.DATE_UPDATED}} -- {{history.UPDATED_BY}}</a>
															<br>
														</span> -->
														<!--table  class="table2" style="width:90%; border: 1px solid black;  border-collapse: collapse;">
															<thead>
																<tr style="color:rgb(195,212,47); font-size:12px">
											
																<th class="table2">Edited By</th>
																<th class="table2">Edit Date</th>
																</tr>
															</thead>
															<tbody>
																<ng-container *ngFor="let history of rowData.RW_REPORT_HISTORY; let i=index">
																<tr style="color:rgb(195,212,47); font-size:12px">
																<td class="table2">{{history.UPDATED_BY}}</td>
																<td class="table2">{{history.DATE_UPDATED}}</td>
																
																</tr>
																</ng-container>
															</tbody>
															</table-->
															<p-table #pt2 styleClass="p-datatable-sm" [value]="erisData" [columns]="erisColsDashboard" [scrollable]="true"
															scrollHeight="30vh"			[globalFilterFields]="erisCols2">
															<!--ng-template pTemplate="caption">
													
																<div class="table-header">
																	&nbsp;
																	<i *ngIf="erisDataLoading" class="pi pi-spin pi-spinner" style="font-size: 1.2rem; margin-left: 10px; color: #C2D63F;"></i>
										
																<span style="float: right;">
																	<i class="pi pi-search" style="margin:4px 4px 0 0"></i>
																	<input type="text" pInputText size="50" placeholder="Search This Page"
																		(input)="pt2.filterGlobal($event.target.value, 'contains')" style="width:auto" style="background-color: rgb(28 36 51); border:0px">
																</span>
																</div>
															</ng-template-->
															<ng-template pTemplate="header" let-columns let-i>
													
																<tr style="font-size:12px">
																<th *ngFor="let col of columns|slice:0:6" [ngStyle]="{'width': col.width}" [pSortableColumn]="col.field" >
																	<span>{{col.header}}</span>
																	<span *ngIf="col.field!='CHECKBOX'"><p-sortIcon  [field]="col.field"></p-sortIcon></span>
																</th>
																
																</tr>
										
																<tr>
																<th *ngFor="let col of columns|slice:0:6" style="padding:2px;border: 2px solid rgb(9 17 33); background-color: rgb(28 36 51)">
																<span *ngIf="col.field!='CHECKBOX'">
																<input  pInputText type="text"
																	(input)="pt2.filter($event.target.value, col.searchfield, col.filterMatchMode);consoleLog($event.target.value);consoleLog(col.searchfield);consoleLog(col.filterMatchMode)"
																	style="margin:0 2px; font-size:12px; width:98%; background-color: rgb(9 17 33); border: 0px">
																</span>
																</th>
																	</tr>
															</ng-template>
															<ng-template pTemplate="body" let-user let-j="rowIndex" let-columns="columns">
																<tr style="font-size:12px;">
																<td  style="padding:4px; font-size:12px; border: solid 2px rgb(9 17 33); background-color: rgb(28 36 51); border-collapse: collapse;"*ngFor="let col of columns let i = index" [ngStyle]="{'width': col.width}">
																	<!--span *ngIf="col.field!='ADDRESS1'&&col.field!='ORDER_NUM'&&col.field!='CHECKBOX'"
																	>{{user[col.field]}}{{j}}
																	</span-->
																	<span *ngIf="col.field!='ADDRESS1'&&col.field!='ORDER_NUM'&&col.field!='CHECKBOX'"
																	>{{user[col.field]}}
																	</span>
																	<span *ngIf="col.field=='ADDRESS1'"
																	>{{user[col.field]}}, {{user.CITY}}
																</span>
																<span *ngIf="col.field=='ORDER_NUM'" style="color:rgb(228, 238, 138)">{{user[col.field]}}</span>
																<span *ngIf="col.field=='CHECKBOX'">                        <input
																	type="checkbox"
																	id="erisDataCheckBox{{j}}"
																	(change)="erisDataChange(user, j)"
																	/></span>
																</td>
																</tr>
															</ng-template>
															</p-table>
															<button title="Close" class="btn btn-outline-dark btn-sm pt-0 pb-0 pl-1 pr-1 ml-1" 
																	style="float: right; color: black; background-color: #C2D63F; border-color:black; margin-bottom: 10px; margin-top: 10px" 
																	(click)='op1.hide()'>Close</button>
															<button title="Add Order" class="btn btn-outline-dark btn-sm pt-0 pb-0 pl-1 pr-1 ml-1" 
																	style="float: right; color: black; background-color: #C2D63F; border-color:black; margin-bottom: 10px; margin-top: 10px" 
																	(click)='addOrder1(rowData);op1.hide()'>Add ERIS Data</button>
															<i *ngIf="erisDataLoading" class="pi pi-spin pi-spinner" 
																	style="float:right; font-size: 1.2rem; margin-left: 10px; margin-bottom: 10px; margin-top: 10px; color: #C2D63F;"></i>
													</ng-template>
												</p-overlayPanel>
												<p-overlayPanel #op2 [appendTo]="'body'" [style]="{'z-index':'9999999999999999', 'max-width':'500px'}" [dismissable]="false" [showCloseIcon]="false">
													<ng-template pTemplate>
														<div class="col-md-12">
															<label class=col-md-4 style="font-weight:normal;margin-top: 10px;">
															Username:
															</label><input class="col-md-5" style="padding:0px; background-color: rgb(28 36 51)" type="text" [(ngModel)]="ERIS_USERNAME">
														</div>
														<div class="col-md-12">
					
															<label style="font-weight:normal" class=col-md-4>
															Password:
															</label>
															<input class="col-md-5" type="password" style="padding:0px; background-color: rgb(28 36 51);" [(ngModel)]="ERIS_PASSWORD">
															<button class="btn btn-outline-dark btn-sm pt-0 pb-0 pl-1 pr-1 ml-1" style="float: right; color: black; background-color: #C2D63F; border-color:black; margin-bottom: 10px; margin-top: 10px"(click)="verifyEris($event, op2);">Verify ERIS Account</button>
															<button title="Close" class="btn btn-outline-dark btn-sm pt-0 pb-0 pl-1 pr-1 ml-1" style="float: right; color: black; background-color: #C2D63F; border-color:black; margin-bottom: 10px; margin-top: 10px" (click)='op2.hide()'>Close</button>
															<!--span>
																<i *ngIf="verifyErisLoading" class="pi pi-spin pi-spinner" style="font-size: 1.2rem; margin-left: 10px; color: #C2D63F; float: right"></i>
															</span-->
					
														</div>
														<div class="col-md-12" *ngIf="incorrect" style="color:red">
															Incorrect ERIS Login Information
														</div>
					
													</ng-template>
												</p-overlayPanel>
													<!--p-overlayPanel [styleClass]="'fixedoverlay'" #op1 
														[appendTo]="'body'">
														<ng-template pTemplate>
															<input style="min-width:150px" class="tableInput"
																[(ngModel)]="rowData.ORDER_NUM" type='text'>
															<button type="button"
																class="btn btn-outline-dark btn-sm pt-0 pb-0 pl-1 pr-1 ml-1"
																title="Add Order" (click)='addOrder(rowData,$event)'><i
																	class="fas fa-check erisIconColor"></i></button>
					
														</ng-template>
													</p-overlayPanel-->
												<ng-container
													*ngIf="rowData.ORDER_NUM==''">

													<!-- <a href="http://testorder.erisinfo.com" target=_blank
														class="btn btn-outline-dark btn-sm pt-0 pb-0 pl-1 pr-1 ml-1 erisGreen"
														title="Order ERIS Data"><span
															style="font-weight:bold;">E</span></a> -->
													<a [href]="erisOrderURL" target=_blank
															class="btn btn-outline-dark btn-sm pt-0 pb-0 pl-1 pr-1 ml-1 erisGreen"
															title="Order ERIS Data"><span
																style="font-weight:bold;">E</span></a>
												</ng-container>
					
											</ng-container>
										</span>
									</span>
								
								</td>
							</tr>
						</ng-template>
					</p-table>

				</div>
				
				<div id="Portfolio" class="tab-pane fade"><br>
					<div class="row" style="margin:15px">
						<div class="col-md-12">
							<!--span style="float: right;">
						

						
								<i class="pi pi-search" style="margin:4px 4px 0 0;color: white"></i>
								<input type="text" class="mr-1" pInputText size="50" placeholder="Find" [(ngModel)]="searchWord"
									(input)="tt2.filterGlobal($event.target.value, 'contains')" style="width:auto; background-color: rgb(28 36 51); border: 0px">
									<input type="text" class="mr-1" pInputText size="50" placeholder="Replace" [(ngModel)]="replaceWord"
									 style="margin-left: 5px; width:auto; background-color: rgb(28 36 51); border: 0px">
									 <a class="btn btn-outline-dark btn-sm pt-1 pb-1 pl-2 pr-2 ml-4"  style="color:white" (click)="searchAndReplace()">Replace</a>
									
							</span-->
							</div>
					</div>
					
					<!--p-treeTable #tt2 [value]="portfolioTreeData" [columns]="portfolioCols" [paginator]="true" [rows]="10" [autoLayout]='false' (onSort)="setExcel2($event)" (onFilter)="setExcel2($event)" [scrollable]="true"
					[rowHover]='true'> 
					<ng-template pTemplate="caption">
						<div class="table-header">
							<span >

						
							Portfolio:&nbsp;<select [(ngModel)]="selectedPortfolio" (change)="getProjectforPortfolio()" style="background-color: rgb(28 36 51); color: white; border: 0px">
								<option  *ngFor="let portfolio of portfolioList; let i=index" [ngValue]='portfolio.PORTFOLIO_ID'>
		
									{{portfolio.PORTFOLIO_NAME}}
									
								</option>
							</select>
						</span>
						<a href="javascript:void(0)" class="btn btn-outline-dark btn-sm pt-1 pb-1 pl-2 pr-2 ml-4" 
						style="color:white" title="Export to Excel" (click)="exportExcel2()">
	
						<span> Export to Excel</span>
					</a>
						</div>
					</ng-template>

					<ng-template pTemplate="header" let-columns let-rowNode>
						<tr [ttRow]="rowNode">
							<th [ngStyle]="{'width': '180px'}" style="padding:1px; font-size:12px; border: 2px solid rgb(9 17 33); background-color: rgb(28 36 51)">
								<a style="cursor: pointer; font-size: 16px;" (click)="expandAllPortfolios()"
									title="Expand/Collapse All">
									<i *ngIf="!isExpanded" class="pi pi-plus"></i>
									<i *ngIf="isExpanded" class="pi pi-minus"></i>
								</a>
							</th>
							<th *ngFor="let col of columns | slice:1:17; let i=index"
								[ttSortableColumn]="col.searchfield" [ngStyle]="{'width': col.width}"
								style="padding:1px; font-size:12px" style="padding:1px; font-size:12px; border: 2px solid rgb(9 17 33)" ttResizableColumn>
								
								{{col.header}}
								<p-treeTableSortIcon *ngIf="i!=5&&i!=6&&i!=7"[field]="col.field"></p-treeTableSortIcon>

							</th>
						</tr>
						<tr>
							<th style="padding:1px; font-size:12px; border: 2px solid rgb(9 17 33); background-color: rgb(28 36 51)"></th>
							<th *ngFor="let col of columns | slice:1:17; let i=index" style="padding:1px; font-size:12px; border: 2px solid rgb(9 17 33); background-color: rgb(28 36 51)">
								<input *ngIf="i!=3 && i!=11" pInputText type="text"
									(input)="tt2.filter($event.target.value, col.searchfield, col.filterMatchMode)"
									style="margin:0 2px; font-size:12px; width:98%; background-color: rgb(9 17 33); border: 0px">
								
									(input)="tt2.filter($event.target.value, 'flat', 'address')"
									style="margin:0 2px; font-size:12px; width:98%; background-color: rgb(9 17 33); border: 0px">
							
								<input *ngIf="i==11" pInputText type="text"
									(input)="tt2.filter($event.target.value, 'flat', 'transaction')"
									style="margin:0 2px; font-size:12px; width:98%; background-color: rgb(9 17 33); border: 0px">
							</th>
						</tr>
					</ng-template>
					<ng-template pTemplate="body" let-rowNode let-rowData="rowData" let-columns="columns">
						<tr style="font-size:12px; line-height:1.3"
							[ngStyle]="{'background': rowData.highlight? '#4c4c4c' :'#323232'}">

							<td *ngFor="let col of columns | slice:0:17; let i = index"
							style="padding:4px; font-size:12px; border: 2px solid rgb(9 17 33); order-width: 0px 4px 4px 4px; background-color: rgb(28 36 51)"  [ngStyle]="{'width': col.width}"> 
							
								<span *ngIf="!rowData.project && i==0 && rowData.size!=0">
									
									<button style="background: transparent; border: none;  background-repeat:no-repeat;" *ngIf="rowData.REVIEWER_PROGRESS>=180" title="Click to View" (click)="op1.toggle($event); getWriterReviewerStatus(rowData)">
										<i class="pieblue tenblue" [style]="{'background-image':'linear-gradient(0deg, transparent 50%, rgb(195,212,47) 50%), linear-gradient('+ (360-(rowData.REVIEWER_PROGRESS*3.6))
										 +'deg, rgb(195,212,47) 50%, transparent 50%)'}"
				
										></i>
									</button>
									<button style="background: transparent; border: none;  background-repeat:no-repeat;" *ngIf="rowData.REVIEWER_PROGRESS && rowData.REVIEWER_PROGRESS<180" title="Click to View" (click)="op1.toggle($event); getWriterReviewerStatus(rowData)">
										
										<i class="pieblue tenblue " [style]="{'background-image':'linear-gradient('+ (360-(rowData.REVIEWER_PROGRESS*3.6))+'deg, transparent 50%, white 50%), linear-gradient(180deg, rgb(195,212,47) 50%, transparent 50%)'}"
				
										></i>
									</button>
									<button style="background: transparent; border: none;  background-repeat:no-repeat;" *ngIf="!rowData.REVIEWER_PROGRESS" title="Click to View" (click)="op1.toggle($event); getWriterReviewerStatus(rowData)">
										<i class="pieblue  tenblue "  [style]="{'background-image':'linear-gradient(0deg, transparent 50%, white 50%), linear-gradient(180deg, white 50%, transparent 50%)'}"
										></i>
									</button>
									<p-overlayPanel #op1 [appendTo]="'body'">
										<ng-template pTemplate>
												<a *ngIf="rowData.REVIEWER_PROGRESS" href="javascript:void(0)"
													style="font-size:.8em;"
													>Reviewer Progress: {{rowData.REVIEWER_PROGRESS}}%</a>
												<a *ngIf="!rowData.REVIEWER_PROGRESS" href="javascript:void(0)"
													style="font-size:.8em;"
													>Reviewer Progress: 0%</a>
												<br>
										</ng-template>
									</p-overlayPanel>

									<button style="background: transparent; border: none;  background-repeat:no-repeat;" *ngIf="rowData.PERCENT_COMPLETE>=180" title="Click to View" (click)="op2.toggle($event); getWriterReviewerStatus(rowData)">
										<i class="pie ten" [style]="{'background-image':'linear-gradient(0deg, transparent 50%, green 50%), linear-gradient('+ (360-(rowData.PERCENT_COMPLETE*3.6))
										 +'deg, green 50%, transparent 50%)'}"
				
										></i>
									</button>
									<button style="background: transparent; border: none;  background-repeat:no-repeat;" *ngIf="rowData.PERCENT_COMPLETE && rowData.PERCENT_COMPLETE<180" title="Click to View" (click)="op2.toggle($event); getWriterReviewerStatus(rowData)">
										
										<i class="pie ten" [style]="{'background-image':'linear-gradient('+ (360-(rowData.PERCENT_COMPLETE*3.6))+'deg, transparent 50%, white 50%), linear-gradient(180deg, green 50%, transparent 50%)'}"
				
										></i>
									</button>
								
									<button style="background: transparent; border: none;  background-repeat:no-repeat;" *ngIf="!rowData.PERCENT_COMPLETE" title="Click to View" (click)="op2.toggle($event); getWriterReviewerStatus(rowData)">
										<i class="pie ten"  [style]="{'background-image':'linear-gradient(0deg, transparent 50%, white 50%), linear-gradient(180deg, white 50%, transparent 50%)'}"
										></i>
									</button>
									<p-overlayPanel #op2 [appendTo]="'body'" >
										<ng-template pTemplate>
											<a *ngIf="rowData.PERCENT_COMPLETE" href="javascript:void(0)"
												style="font-size:.8em;"
												>Writing Progress: {{rowData.PERCENT_COMPLETE}}%</a>
											<a *ngIf="!rowData.PERCENT_COMPLETE" href="javascript:void(0)"
												style="font-size:.8em;"
												>Writing Progress: 0%</a>
											<br>
										</ng-template>
									</p-overlayPanel>
									

									<a  title="Share Report by Email" *ngIf="rowData.size!=0 && rowData.REPORT_URL" style="cursor:pointer; float:right" class="m-1" (click)="op5.toggle($event)">

										<i style="font-size:15px"  class=" erisGreen fas fa-envelope"></i>
									</a>
									<p-overlayPanel #op5 [appendTo]="'body'">

										<ng-template pTemplate> 

											Email: <br>
											<input class="rptInfo" type='text' [(ngModel)]="shareEmail"> 	
											<a  title="Send to Email" style="cursor:pointer;" class="m-1" (click)="op5.hide();shareByEmail(rowData.REPORT_ID);">

												<i style="font-size:15px"  class="erisGreen fas fa-paper-plane"></i>
											</a>
											
										</ng-template> 
									
									</p-overlayPanel>
								</span>
						
								<span *ngIf="rowData.size!=0 && !rowData.project && col.field=='DATE_UPDATED'">
									<a (click)="getHistory(rowData); op1.toggle($event)"  style="cursor:pointer; color:rgb(195,212,47)"> {{rowData[col.field]}}</a>
									<p-overlayPanel #op1 [appendTo]="'body'" 		[style]="{'z-index':'9999999999999999', 'min-width':'300px'}">

										<ng-template pTemplate>
										
											<table  class="table2" style="width:90%; border: 1px solid black;  border-collapse: collapse;">
												<thead>
												  <tr style="color:rgb(195,212,47); font-size:12px">
								
												  <th class="table2">Edited By</th>
												  <th class="table2">Edit Date</th>
												  </tr>
												</thead>
												<tbody>
												  <ng-container *ngFor="let history of rowData.RW_REPORT_HISTORY; let i=index">
													<tr style="color:rgb(195,212,47); font-size:12px">
													<td class="table2">{{history.UPDATED_BY}}</td>
													<td class="table2">{{history.DATE_UPDATED}}</td>
													
													</tr>
												  </ng-container>
												</tbody>
												</table>
										</ng-template>
									</p-overlayPanel>
								</span>
								<span class="line-clamp1" *ngIf="(rowData.project) && i==0">
									<p-treeTableToggler [rowNode]="rowNode" style="width:10px; height:10px">
									</p-treeTableToggler> {{rowData[col.field]}}&nbsp; ({{rowData.size}})
								</span>
							
								<span *ngIf="!(rowData.project)">
									<span class="line-clamp2" *ngIf="i==3"> {{rowData["PROPERTY_NAME"]}}</span>
									
									<div style="position:relative;" *ngIf="i==2" #reportInfo>
								
										<span *ngIf="rowData.size!=0"> 
											<a *ngIf="rowData.TEMPLATE && rowData.TEMPLATE[0] "class="line-clamp"
												style="color:#C2D63F; margin-right:19px; max-width:calc(100% - 18px);"
												target="_blank" [title]="rowData[col.field]"
												[attr.href]="'/report/' + rowData.PROJECT_ID +'/' + rowData.REPORT_ID">
												{{rowData[col.field]}} <br> &nbsp;
											</a>
											<span 	style="margin-right:19px; max-width:calc(100% - 18px);" *ngIf="!rowData.TEMPLATE || !rowData.TEMPLATE[0]"> 
												{{rowData[col.field]}} 
											</span>
											<a *ngIf="rowData[col.field]==''">
												&nbsp;
											</a>
										</span>
										<span *ngIf="rowData.size!=0">
										
											<a *ngIf="rowData.REPORT_URL" [href]="rowData.REPORT_URL"
												target="_blank"
												style="font-size:12px; position:absolute;right:-1px;top:-3px; cursor: pointer;"
												title="PDF"><i class="far fa-file-pdf"
													style="margin:5px"></i> </a>
											<a *ngIf="rowData.REPORT_URL"
												style="position:absolute;right:0;top:12px; cursor: pointer; font-size: 16px; ; color: rgb(201 218 251)"
												(click)="op1.toggle($event);" title="More Tools">
												<i class="pi pi-angle-down"
													tyle="margin-left:5px; margin-right:4px;"></i>
											</a>
											<a *ngIf="!rowData.REPORT_URL"
												style="position:absolute;right:0;top:6px; cursor: pointer; font-size: 16px; ; color: rgb(201 218 251)"
												(click)="op1.toggle($event);" title="More Tools">
												<i class="pi pi-angle-down"
													tyle="margin-left:5px; margin-right:4px;"></i>
											</a>
																	
										</span>
										<p-overlayPanel #op3 [dismissable]="true" appendTo="reportInfo"
											[style]="{'z-index':'9999999999999999','width':'300px'} "
											[showCloseIcon]="true">

											<ng-template pTemplate>
												<ng-container>
												
													Email: <br>
													<input class="rptInfo" type='text' style="width:80%" [(ngModel)]="shareEmail"> 	
													<a  title="Send to Email" style="cursor:pointer;" class="m-1" (click)="shareByEmail(rowData.REPORT_ID);op1.toggle($event)">
	
														<i style="font-size:15px"  class="erisGreen fas fa-paper-plane"></i>
													</a>
													<a  style="cursor:pointer;" (click)="copy(rowData)"
													class="m-1"
													title="Copy Link"><i
														class="fas fa-link erisGreen"></i> </a>

												</ng-container>

											</ng-template>
										</p-overlayPanel>
										<p-overlayPanel #op1 [appendTo]="'body'">

											<ng-template pTemplate>
												<button *ngIf="rowData.size!=0" 
												data-toggle="modal"
												data-target="#deleteReportModal"
												style="color: rgb(201 218 251)"
													class="btn btn-outline-dark btn-sm pt-0 pb-0 pl-1 pr-1 ml-1"
													title="Delete Report"><i class="far fa-trash-alt"
														(click)="reportToDelete= rowData"></i> </button>

											
											</ng-template>
										</p-overlayPanel>
										<p-overlayPanel #op2 [appendTo]="'body'">

											<ng-template pTemplate>
												<input class="rptInfo" type="text" [(ngModel)]="rowData[col.field]"
												style="width: 250px;" maxlength="240">
												<button (click)="changeReportTitle(rowData); op2.hide()"
												class="btn m-0 uploadBtn">Save</button>


											</ng-template>
										</p-overlayPanel>

									</div>
									<span *ngIf="(i==8 || i==6 ||i==7) && rowData.size!=0"
										style="position:relative">
										<a *ngIf="rowData[col.field]==null"
											style=" cursor: pointer;z-index:1;position: absolute; top:0; left:5px; pointer-events: none;">
											<i class="fas fa-calendar-plus erisGreen"></i></a>
										
										<p-calendar 
										#op [appendTo]="'body'"
											[(ngModel)]="rowData[col.field]" dateFormat="M dd, yy"
											styleClass="calendarInput2" inputStyleClass="calendarInput2"
											[inputStyle]="{'padding':'2px','color': rowData[col.field+'_RED']? 'rgb(255 89 89)': '#ccc'}"
											(onSelect)="changeDate(rowData, rowData[col.field], col.field)">
										</p-calendar>
									</span>
									<span *ngIf="(i==1)">

										<ng-container>
											<div>
												<div style="position:relative;">
													<span class="line-clamp ">
														
														<a class=" mr-1"
															style="cursor: pointer; margin-right:19px; max-width:calc(80% - 20px); text-overflow: ellipsis; display: inline-block; color:#C2D63F"
															data-toggle="modal" (click)="editProject(rowData, rowNode, false); show('collapse1');
														hide('inner-collapse1'); hide('inner-collapse2'); hide('inner-collapse3');" data-target="#reportsModal"
															[title]="'Project Num: '+ rowData.PROJECT_NUMBER"
															href="javascript:void(0)">{{rowData.PROJECT_NUMBER}} <br> &nbsp;</a>
													</span>
												
													

													<a href="javascript:void(0)"
														style="font-size:12px; position:absolute;right:0;top:-5px; cursor: pointer;"
														title="Add/Edit Reports" data-toggle="modal"
														data-target="#reportsModal"
														(click)="editProject(rowData, rowNode, true); show('collapse5');">
														<i style="margin:7px; color: rgb(201 218 251)"
															class="fas fa-file-medical"></i> </a>

													<a style="position:absolute;right:0;top:12px; cursor: pointer; font-size: 16px;"
														(click)="op1.toggle($event);" title="More Tools">
														<i class="pi pi-angle-down"
															style="margin-left:5px; margin-right:4px;"></i>
													</a>
												</div>
											
											</div>
										</ng-container>

										<p-overlayPanel #op1 [appendTo]="'body'">

											<ng-template pTemplate>
												<button
												data-toggle="modal"
												data-target="#deleteModal"
													class="btn btn-outline-dark btn-sm pt-0 pb-0 pl-1 pr-1 ml-1"
													style="color: rgb(201 218 251)"
													title="Delete Project"
													(click)="projectToDelete=rowData.PROJECT_ID;"><i
														class="far fa-trash-alt"></i>
											</button>

											</ng-template>
										</p-overlayPanel>
									</span>
									
									<span *ngIf="i==13 &&!rowData.project && rowData.size!=0">

										<ng-container>
											<div style="position:relative">
												<div style="max-width:calc(100% - 20px);">
													{{rowData.STATUS}}
												</div>
											
												<div>
													<a style="position:absolute;right:0;top:-5px; cursor: pointer; font-size: 16px;"
														(click)="op1.toggle($event);" title="Edit Status">
														<i class="pi pi-angle-down" style="margin: 5px;"></i>
													</a>
												</div>
												<p-overlayPanel #op1 [appendTo]="'body'">
													<ng-template pTemplate>
														<ng-container *ngFor="let item of statusList2">
															<a href="javascript:void(0)"
																style="font-size:.8em; color: #C2D63F;"
																(click)="op1.hide(); rowData.STATUS=item.STATUS; changeStatus1(rowData.REPORT_ID,item.STATUS)">{{item.STATUS}}</a>
															<br>
														</ng-container>
													</ng-template>
												</p-overlayPanel>
											</div>
										</ng-container>
									</span>
									<span *ngIf="(i==5)  && rowData.size!=0">

										<div *ngIf="!rowData.TEMPLATE || !rowData.TEMPLATE[0]"
											style="position:relative">

											<div>
												<a style="position:absolute;right:2px;top:-8px; cursor: pointer; font-size: 16px;"
													(click)="op1.toggle($event);findType(rowData);"
													title="Add Template">
													<i class="fas fa-plus erisGreen" style="margin: 4px;"></i>
												</a>
												<p-overlayPanel #op1 [appendTo]="'tt'">
													<ng-template pTemplate>
														<label class="col-md-4 inputLabel">Template
															Identifier:</label>
														<select class="col-md-7 p-1 rptInfo" style="margin:4px;"
															[(ngModel)]="catToChange.selectedSubCat"
															[ngModelOptions]="{standalone: true}"
															(change)="setByTypeId(catToChange); setDisplaySections(7);">
															<option></option>
															<option
																*ngFor="let subCat of catToChange.subCategories;"
																[ngValue]="subCat">
																{{subCat.subCategory}}</option>
														</select>

														<label class="col-md-4 inputLabel">Template:</label>
														<select class="col-md-7 p-1 rptInfo" style="margin:4px;"
															[(ngModel)]="catToChange.selectedTemplate"
															[ngModelOptions]="{standalone: true}"
															(change)="changeTemplate(rowData)">
															<option></option>
															<option
																*ngFor="let template of catToChange.typeIdTemplates;"
																[ngValue]="template">
																{{template.TEMPLATE_TITLE}}</option>
														</select>

													</ng-template>
												</p-overlayPanel>

											</div>
										</div>
										<ng-container *ngIf="rowData.TEMPLATE && rowData.TEMPLATE[0]">
											<div style="position:relative">

												
												<div style="max-width:calc(100% - 18px);" class="line-clamp">
												
													<a style="color:rgb(195,212,47)" [href]="'template/'+rowData.TEMPLATE[0].TEMPLATE_ID" target=_blank
												
													title="Edit">{{rowData.TEMPLATE[0].TEMPLATE_TITLE}}</a>
												</div>
												<div>


													<a style="position:absolute;right:0;top:-5px; cursor: pointer; font-size: 16px;"
														(click)="tableTemplates=[]; getTemplate(rowData.TEMPLATE[0].TEMPLATE_TYPE_ID); op1.toggle($event);"
														title="Choose Template">
														<i class="pi pi-angle-down" style="margin: 5px;"></i>
													</a>
												</div>

												<p-overlayPanel #op1 [appendTo]="'body'">
													<ng-template pTemplate>
														<ng-container *ngFor="let item of tableTemplates">
															<a href="javascript:void(0)"
																style="font-size:.8em; color: #C2D63F;"
																(click)="rowData.TEMPLATE[0].TEMPLATE_TITLE=item.TEMPLATE_TITLE; updateTemplate(item, rowData); op1.hide()">{{item.TEMPLATE_TITLE}}</a>
															<br>

														</ng-container>
													</ng-template>
												</p-overlayPanel>
												
											</div>
										</ng-container>
									</span>
									
									<span *ngIf="(i==4) && rowData.FULL_ADDRESS ">
										<a [title]="rowData.FULL_ADDRESS" class="link-light line-clamp"
											style="cursor:pointer; text-decoration: underline;"
											(click)="op.toggle($event); getCords(rowData)">
											<i class= "fas fa-map-marker-alt" style="float:right; margin:3px; color: rgb(201 218 251)"></i>
											{{rowData.FULL_ADDRESS}}
									
										</a>
										
										<p-overlayPanel #op [appendTo]="'body'" [dismissable]="true"
												[style]="{width: '550px', height: '550px'}">
												<span style="color:rgb(195,212,47)">
													{{rowData.FULL_ADDRESS}}
													<a *ngIf="!noLocation" style="color: red; display: inline-block;">
														(Address not valid)
													</a><br>
													<span *ngIf="rowData.PARCEL_ID">
														Parcel ID: {{rowData.PARCEL_ID}}
													</span>
													
												</span>
												<agm-map id="test" class="googleMap2" controlSize=24 [latitude]="rowData.LATITUDE"
                              						[longitude]="rowData.LONGITUDE" [zoom]="zoomV" [disableDefaultUI]="false" [zoomControl]="false" [disableDoubleClickZoom]='true'>
                              						<agm-marker *ngIf="noLocation" [latitude]="rowData.LATITUDE" 
													  [longitude]="rowData.LONGITUDE">
														<agm-info-window>
															<strong>{{rowData.FULL_ADDRESS}}</strong>
														</agm-info-window>

													</agm-marker>
												</agm-map>


											</p-overlayPanel>
									</span>
									<span *ngIf="(i==12) ">
										<span *ngIf='rowData[col.field][0]'>
											<a 
											class="line-clamp"
													style="margin-right:19px; max-width:calc(100% - 5px); text-overflow: ellipsis; display: inline-block;"
											[title]="rowData[col.field][0].TRANSACTION_TYPE">
												{{rowData[col.field][0].TRANSACTION_TYPE}}<br>
											</a>
										</span>
										<span *ngIf='rowData[col.field][0]'>
											<a 
											class="line-clamp"
													style="margin-right:19px; max-width:calc(100% - 5px); text-overflow: ellipsis; display: inline-block;"
											[title]="rowData[col.field][0].PROTOCOL">
												{{rowData[col.field][0].PROTOCOL}} <br>
											</a>
										</span>
									</span>
									<span *ngIf="(i==9 || i==10)  && rowData.size!=0">
										<a *ngIf="rowData[col.field] && rowData[col.field][0] && rowData[col.field][0].LAST_NAME "
											(click)="op1.toggle($event);"
											style="cursor: pointer; text-decoration: underline;">
											{{rowData[col.field][0].FIRST_NAME
											+ " " + rowData[col.field][0].LAST_NAME}}
										</a>
										<a *ngIf="rowData[col.field] && rowData[col.field][0] && !rowData[col.field][0].LAST_NAME"
											(click)="op1.toggle($event);"
											style="cursor: pointer; word-break:break-all">
											{{rowData[col.field][0].USER_EMAIL}}
										</a>
										<a *ngIf="!rowData[col.field] || !rowData[col.field][0]"
											(click)="op1.toggle($event); getCompanyRoles(); clearInvite1(rowData, rowData[col.field]); getAllReportUsers(-1, -1, '')"
											title="Add User"
											style="cursor: pointer; margin-left:5px;"><i
											class="icon-AddUser fa-2x" style="color: rgb(201 218 251)"></i></a>
										<p-overlayPanel #op1 [style]="{'max-width':'480px'}" [appendTo]="'body'">
											<ng-template pTemplate>
												<ng-container>
													
													<div class="row">
														
														<label *ngIf="i==9" style="margin-top:10px"
															class="col-md-3 inputLabel">
															Writer Title:</label>
														<ng-select  
															*ngIf="i==9 && !rowData.ASSESSOR_TITLE[0]"
															[compareWith]="compareFn" 
															class="col-md-7 p-1 rptInfo" 
															style="margin:4px; color: grey"
															(change)="changeTitle(true, rowData)"
															[(ngModel)]="rowData.ASSESSOR_TITLE[0]"
															[ngModelOptions]="{standalone: true}"
															placeholder="Select Title"
															>
															<ng-option 
															*ngFor="let title of assessortitles;">
															<span style="color: black;">
																{{title.TITLE}}
															</span>	
														</ng-option>
														</ng-select>
														<ng-select  
															*ngIf="i==9 && rowData.ASSESSOR_TITLE[0]"
															[compareWith]="compareFn" 
															class="col-md-7 p-1 rptInfo" 
															style="margin:4px;"
															(change)="changeTitle(true, rowData)"
															[(ngModel)]="rowData.ASSESSOR_TITLE[0]"
															[ngModelOptions]="{standalone: true}"
															>
															<ng-option 
															*ngFor="let title of assessortitles;">
															<span style="color: black;">
																{{title.TITLE}}
															</span>	
														</ng-option>
														</ng-select>
														
														<label *ngIf="i==10" style="margin-top:10px"
															class="col-md-3 inputLabel">
															Reviewer Title:</label>
														
														<ng-select  
															*ngIf="i==10 && !rowData.REVIEWER_TITLE[0]"
															[compareWith]="compareFn" 
															class="col-md-7 p-1 rptInfo" 
															style="margin:4px; color: grey"
															(change)="changeTitle(true, rowData)"
															[(ngModel)]="rowData.REVIEWER_TITLE[0]"
															[ngModelOptions]="{standalone: true}"
															placeholder="Select Title"
															>
															<ng-option 
															*ngFor="let title of reviewertitles;">
															<span style="color: black;">
																{{title.TITLE}}
															</span>	
														</ng-option>
														</ng-select>
														<ng-select  
															*ngIf="i==10 && rowData.REVIEWER_TITLE[0]"
															[compareWith]="compareFn" 
															class="col-md-7 p-1 rptInfo" 
															style="margin:4px;"
															(change)="changeTitle(true, rowData)"
															[(ngModel)]="rowData.REVIEWER_TITLE[0]"
															[ngModelOptions]="{standalone: true}"
															>
															<ng-option 
															*ngFor="let title of reviewertitles;">
															<span style="color: black;">
																{{title.TITLE}}
															</span>	
														</ng-option>
														</ng-select>
														

														<label *ngIf="i!=11" style="margin-top:10px"
															class="col-md-3 inputLabel">{{col.header}}: </label>
														<label *ngIf="i==11" style="margin-top:10px"
															class="col-md-3 inputLabel">User: </label>
															<ng-select *ngIf="!rowData[col.field][0]"
															id="writer reviewer dropdown"style="margin:4px; color: grey" class="col-md-7 p-1 rptInfo"
															[clearable]="false" [items]="allusersList"
															notFoundText="Not Found" bindLabel="USER_EMAIL"
															[(ngModel)]="rowData[col.field][0]"
															[ngModelOptions]="{standalone: true}"
															[searchFn]="customSearchFn"
															(change)="changeUser(rowData, rowData[col.field], col.field)"
															placeholder="Select Existing User"
															>
															
															<ng-template ng-label-tmp let-item="item">
																<span *ngIf="item.FULL_NAME" style="color: black;">{{
																	
																	item.FULL_NAME + ', ' +
																	'(' + item.USER_EMAIL + ')'}}</span>
																<span
																	*ngIf="!item.FULL_NAME">{{item.USER_EMAIL}}</span>
															</ng-template>
															<ng-template ng-option-tmp let-item="item"
																let-search="searchTerm" let-index="index" >
																<span *ngIf="item.FULL_NAME" style="color: black;">{{
																	
																	item.FULL_NAME + ', ' +
																	'(' + item.USER_EMAIL + ')'}}</span>
																<span
																	*ngIf="!item.FULL_NAME" style="color: black;">{{'(' + item.USER_EMAIL + ')'}}</span>
															</ng-template>
														</ng-select>
														<ng-select *ngIf="rowData[col.field][0]"
															id="writer reviewer dropdown"style="margin:4px; color: grey" class="col-md-7 p-1 rptInfo"
															[clearable]="false" [items]="allusersList"
															notFoundText="Not Found" bindLabel="USER_EMAIL"
															[(ngModel)]="rowData[col.field][0]"
															[ngModelOptions]="{standalone: true}"
															[searchFn]="customSearchFn"
															(change)="changeUser(rowData, rowData[col.field], col.field)"
															>
															
															<ng-template ng-label-tmp let-item="item">
																<span *ngIf="item.FULL_NAME" style="color: black;">{{
																	
																	item.FULL_NAME + ', ' +
																	'(' + item.USER_EMAIL + ')'}}</span>
																<span
																	*ngIf="!item.FULL_NAME">{{item.USER_EMAIL}}</span>
															</ng-template>
															<ng-template ng-option-tmp let-item="item"
																let-search="searchTerm" let-index="index" >
																<span *ngIf="item.FULL_NAME" style="color: black;">{{
																	
																	item.FULL_NAME + ', ' +
																	'(' + item.USER_EMAIL + ')'}}</span>
																<span
																	*ngIf="!item.FULL_NAME" style="color: black;">{{'(' + item.USER_EMAIL + ')'}}</span>
															</ng-template>
														</ng-select> 

														<button class="btn btn-sm pt-0 pb-0 pl-1 pr-1 col-md-1"
															style="margin-left: 5px; padding: 3px; font-size: 11px; margin:4px; color: rgb(201 218 251)"
															title="Remove User"><i
																class="far fa-trash-alt"
																(click)="rowData[col.field][0]={'USER_ID':null}; changeUser(rowData, rowData[col.field], col.field)"></i>
														</button>
														<hr style="color: white; width: 100%; background-color: white;">
														<label style="margin-top:10px"
															class="col-md-3 inputLabel">Email:
															&nbsp;</label>

														<input [(ngModel)]="userToAdd"
															[ngModelOptions]="{standalone: true}"
															style="background:#E6E6E6; margin:4px" type="text"
															class="col-md-7 invuser p-1 rptInfo" placeholder="Enter Email to Invite User"/>

														<button type="button"
															title="Invite User"
															class="btn btn-sm pt-0 pb-0 pl-1 pr-1 col-md-1"
															(click)="inviteUser2(rowData, col.field); op1.hide()"
															style="margin-left: 5px; padding: 3px; font-size: 11px; margin:4px">
															<i class="fas fa-user-plus erisGreen"></i></button>
													
														
															<label style="margin-top:10px"
															class="col-md-3 inputLabel">User Role:</label>
															<select style="margin:4px;" class="col-md-7 p-1 rptInfo" [(ngModel)]="role"
															[ngModelOptions]="{standalone: true}" >
															  <option [value]="type.ROLE_ID" *ngFor="let type of roles">
																{{type.ROLE_NAME}} </option>
												  
															</select>
											
											
														  
													</div>
												</ng-container>
											</ng-template>
										</p-overlayPanel>

									</span>
									<span *ngIf="(i==11)  && rowData.size!=0">
										<a  [class.assignedUser]="rowData[col.field].length>1"  *ngIf="rowData[col.field] && rowData[col.field][0] && rowData[col.field][0].LAST_NAME "
											(click)="op1.toggle($event);"
											style="cursor: pointer; text-decoration: underline;">
											{{rowData[col.field][0].FIRST_NAME
											+ " " + rowData[col.field][0].LAST_NAME}}
										</a>
										<a  [class.assignedUser]="rowData[col.field].length>1" *ngIf="rowData[col.field] && rowData[col.field][0] && !rowData[col.field][0].LAST_NAME"
											(click)="op1.toggle($event);"
											style="cursor: pointer; text-decoration: underline; word-break:break-all">
											{{rowData[col.field][0].USER_EMAIL}}
										</a>
										<a [class.assignedUser]="rowData[col.field].length>1"  *ngIf="!rowData[col.field] || !rowData[col.field][0]"
											(click)="op1.toggle($event); getCompanyRoles(); clearInvite1(rowData, rowData[col.field]); getAllReportUsers(-1, -1, '')"
											title="Add User"
											style="cursor: pointer; margin-left:5px;"><i
											class="icon-AddUser fa-2x" style="color: rgb(201 218 251)"></i></a>
										<p-overlayPanel #op1 [style]="{'max-width':'480px'}" [appendTo]="'body'">
											<ng-template pTemplate>
												<ng-container>
													
													<div class="row">

														<div *ngFor="let user of rowData.ASSIGNED_USERS" class="col-md-12">

														
															<label class="tag"> <i class="fas fa-times iconBtn erisGreen" style="margin-left:5px" (click)='removeAssignedUser(rowData, user)'></i> {{user.FULL_NAME? user.FULL_NAME:user.USER_EMAIL}}</label>
														</div>
														<label *ngIf="i==11" style="margin-top:10px"
															class="col-md-3 inputLabel">User: </label>
													
														<ng-select *ngIf="!rowData[col.field][0]"
																id="writer reviewer dropdown"style="margin:4px; color: grey" class="col-md-7 p-1 rptInfo"
																[clearable]="false" [items]="allusersList"
																notFoundText="Not Found" bindLabel="USER_EMAIL"
																[(ngModel)]="rowData[col.field][0]"
																[ngModelOptions]="{standalone: true}"
																[searchFn]="customSearchFn"
																(change)="changeUser(rowData, rowData[col.field], col.field)"
																placeholder="Select Existing User"
																>
																
																<ng-template ng-label-tmp let-item="item">
																	<span *ngIf="item.FULL_NAME" style="color: black;">{{
																		item.FULL_NAME + ', ' +
																		'(' + item.USER_EMAIL + ')'}}</span>
																	<span
																		*ngIf="!item.FULL_NAME">{{item.USER_EMAIL}}</span>
																</ng-template>
																<ng-template ng-option-tmp let-item="item"
																	let-search="searchTerm" let-index="index" >
																	<span *ngIf="item.FULL_NAME" style="color: black;">{{
																		item.FULL_NAME + ', ' +
																		'(' + item.USER_EMAIL + ')'}}</span>
																	<span
																		*ngIf="!item.FIRST_NAME" style="color: black;">{{'(' + item.USER_EMAIL + ')'}}</span>
																</ng-template>
															</ng-select>
															<ng-select *ngIf="rowData[col.field][0]"
																id="writer reviewer dropdown"style="margin:4px; color: grey" class="col-md-7 p-1 rptInfo"
																[clearable]="false" [items]="allusersList"
																notFoundText="Not Found" bindLabel="USER_EMAIL"
																[(ngModel)]="rowData[col.field][0]"
																[ngModelOptions]="{standalone: true}"
																[searchFn]="customSearchFn"
																(change)="changeUser(rowData, rowData[col.field], col.field)"
																>
																
																<ng-template ng-label-tmp let-item="item">
																	<span *ngIf="item.FULL_NAME" style="color: black;">{{
																		item.FULL_NAME + ', ' +
																		'(' + item.USER_EMAIL + ')'}}</span>
																	<span
																		*ngIf="!item.FULL_NAME">{{item.USER_EMAIL}}</span>
																</ng-template>
																<ng-template ng-option-tmp let-item="item"
																	let-search="searchTerm" let-index="index" >
																	<span *ngIf="item.FULL_NAME" style="color: black;">{{
																		item.FULL_NAME + ', ' +
																		'(' + item.USER_EMAIL + ')'}}</span>
																	<span
																		*ngIf="!item.FULL_NAME" style="color: black;">{{'(' + item.USER_EMAIL + ')'}}</span>
																</ng-template>
															</ng-select>

														
														<button class="btn btn-sm pt-0 pb-0 pl-1 pr-1 col-md-1"
														style="margin-left: 5px; padding: 3px; font-size: 11px; margin:4px"
														title="Add User"><i
															class="fas fa-plus erisGreen"
															(click)="addAssignedUser(rowData, rowData['USER_TO_ADD']); getCompanyRoles(); clearInvite()"></i>
														</button>
														<label style="margin-top:10px"
															class="col-md-3 inputLabel">Email:
															&nbsp;</label>

														<input [(ngModel)]="userToAdd"
															[ngModelOptions]="{standalone: true}"
															style="background:#E6E6E6; margin:4px" type="text"
															class="col-md-7 invuser p-1 rptInfo" placeholder="Enter Email to Invite User" />

														<button type="button"
															title="Invite User"
															class="btn btn-sm pt-0 pb-0 pl-1 pr-1 col-md-1"
															(click)="inviteUser2(rowData, col.field);"
															style="margin-left: 5px; padding: 3px; font-size: 11px; margin:4px">
															<i class="fas fa-user-plus erisGreen"></i></button>
													
														
															<label style="margin-top:10px"
															class="col-md-3 inputLabel">User Role:</label>
															<select style="margin:4px;" class="col-md-7 p-1 rptInfo" [(ngModel)]="role"
															[ngModelOptions]="{standalone: true}" >
															  <option [value]="type.ROLE_ID" *ngFor="let type of roles">
																{{type.ROLE_NAME}} </option>
												  
															</select>
											
											
														  
													</div>
												</ng-container>
											</ng-template>
										</p-overlayPanel>

									</span>

									<span *ngIf="(i==14)  && rowData.size!=0">
										<ng-container>
											<ng-container *ngIf="rowData.ORDER_NUM!=''">
												<div>
													<div style=" white-space: nowrap;
													overflow: hidden;
													text-overflow: ellipsis;
													 cursor: pointer; font-size: 12px; margin-top:3px; color:rgb(195,212,47)"  *ngIf="rowData.ORDER_REPORTS?.length>0">
														<a 
															(click)="op2.toggle($event);">
															{{rowData.ORDER_NUM}}
														</a>
													</div>
													<div style="  white-space: nowrap;
													overflow: hidden;
													text-overflow: ellipsis; margin-top:3px;" *ngIf="rowData.ORDER_REPORTS?.length==0">
									
															{{rowData.ORDER_NUM}}
													
													</div>
													
													<p-overlayPanel #op2 [styleClass]="'fixedoverlay'"
														[appendTo]="'body'" [dismissable]="true">
														<ng-template pTemplate>
															<ng-container *ngFor="let item of rowData[col.field]">
																<a style="font-size:12px; color:rgb(195,212,47)"
																	[href]="item.REPORT_URL"
																	target=_blank>{{item.REPORT_NAME}}</a><br>
															</ng-container>
														</ng-template>
													</p-overlayPanel>
												</div>

											</ng-container>
											<a class="btn btn-sm pt-0 pb-0 pl-1 pr-1 ml-1"
													(click)="op1.toggle($event);"
													title="Add/Change Order Number">
													<i class="erisIcon erisGreen"></i>
												</a>
												<p-overlayPanel [styleClass]="'fixedoverlay'" #op1
													[appendTo]="'body'">
													<ng-template pTemplate>
														<input style="min-width:150px" class="tableInput"
															[(ngModel)]="rowData.ORDER_NUM" type='text'>
														<button type="button"
															class="btn btn-outline-dark btn-sm pt-0 pb-0 pl-1 pr-1 ml-1"
															title="Add Order" (click)='addOrder(rowData,$event)'><i
																class="fas fa-check erisGreen"></i></button>

													</ng-template>
												</p-overlayPanel>
											<ng-container
												*ngIf="rowData.ORDER_NUM==''">


												
												

												<a href="http://testorder.erisinfo.com" target=_blank
													class="btn btn-outline-dark btn-sm pt-0 pb-0 pl-1 pr-1 ml-1 erisGreen"
													title="Order ERIS Data"><span
														style="font-weight:bold;">E</span></a>
											</ng-container>

										</ng-container>
									</span>
								</span>

								<span *ngIf="i==0 && rowData.SOW" style="float:right; margin-right:10px; ">
									<a style="color:rgb(195,212,47)" target="_blank" [href]="rowData.SOW">SOW</a>

								</span>

							</td>
							
						</tr>
					</ng-template>
				</p-treeTable-->	
				<span *ngIf='loading7' class="redLabel" style="margin-left: 20px;font-size: 10pt;"> Portfolio Generation in Progress - Please Do Not Close This Browser Window or Exit Out of Scriva Until Completed. </span>
				<a *ngIf='loading7' (click)='op113.toggle($event)' href='javascript:void(0)' class="btn btn-dark btn-sm ml-3 pt-0 pb-0 pl-2 pr-2" style="background-color: rgb(9 17 33);"
									title="View Current Delivery Staus progress">
									<i class="fas fa-info"></i>
								</a>								
								<p-overlayPanel #op113 [appendTo]="'body'" [dismissable]="true"  [showCloseIcon]="true" [style]="{width: '520px'}">
									<ng-template pTemplate>
										<h6>Delivery Status</h6>
										<div style="width: 500px; color:#C2D63F;font-size:.8em; max-height:600px; overflow:auto">
											<ng-container *ngFor="let rpt of deliverResults; let i=index; trackBy:trackByFuntion">
												<a *ngIf="rpt.status=='Y'" style='color:white' target=_blank [href]="rpt.url">{{rpt.reportInfo}}</a>
												<a *ngIf="rpt.status=='N'" style='color:white' href='javascript:void(0)'>{{rpt.reportInfo}}</a>
												<a href='javascript:void(0)' *ngIf="rpt.status=='N'" [title]="rpt.url" class="redLabel"><i class="fas fa-times"></i><i class="fas fa-info-circle" ></i></a>
												<a href='javascript:void(0)' *ngIf="rpt.status=='Y'" title="Done!" style="color:green"><i class="fas fa-check"></i></a>
												<br>
											</ng-container> 	
										</div>
									</ng-template>
								</p-overlayPanel>
				<!-- <p-table #portfolioTable [value]="portfolioDataV2" [columns]="portfolioCols" [scrollable]="true" scrollHeight="68vh" scrollDirection="both" (sortFunction)="tableSort($event)" [customSort]="true"> -->
				<p-table #portfolioTable [value]="portfolioDataV2" [columns]="selectedColumns" [scrollable]="true" [scrollHeight]="rowHeight" scrollDirection="both" (onFilter)="onFilterPortfolio($event)" [tableStyle]="{'min-height': '200px'}">

					<ng-template pTemplate="caption">
						<div class="table-header">
							<span style="font-size: 12px"> {{numPortfolioReports}} Reports</span>
							<i *ngIf="loading" class="pi pi-spin pi-spinner" style="font-size: 1.2rem; margin-left: 10px; color: #C2D63F;"></i>
							<span style="font-size: 12px">
								&nbsp;&nbsp;Portfolio:&nbsp;
								<select class="pt-1 pb-1 pr-2" [(ngModel)]="selectedPortfolio" (change)="getProjectforPortfolioV2()"
									style="background-color: rgb(28 36 51); color: white; border: 0px">
									<option *ngFor="let portfolio of portfolioList; let i=index" [ngValue]='portfolio.PORTFOLIO_ID'>
										{{portfolio.PORTFOLIO_NAME}}
									</option>
								</select>
							</span>
							<a href="javascript:void(0)" class="btn btn-outline-dark btn-sm pt-1 pb-1 pl-2 pr-2 ml-4"
								title="Start New Project"  style=" background-color:rgb(195,212,47);"
								data-toggle="modal" data-target="#reportsModal" (click)="addRpt('PORTFOLIO'); show('collapse1');
								hide('inner-collapse1'); hide('inner-collapse2');hide('inner-collapse3'); tabFrom('PORTFOLIO');resetOriginalData();
								newReportPermission = false; checkNewReportPermission();">
								<!-- <span
									style="font-weight:bold; color:rgb(195,212,47)">P</span> -->
								<span style="color: black; font-size: 12px"> Start New Project</span>
							</a>

							<!--<a href="javascript:void(0)" class="btn btn-outline-dark btn-sm pt-1 pb-1 pl-2 pr-2 ml-4"
								title="Upload Batch Projects" data-toggle="modal" data-target="#import"
								(click)="resetUpload('PORTFOLIO');uploadBatchProjectsPermission=false;checkUploadBatchProjectsPermission();">
								<span style="font-size: 12px">Upload Batch Projects</span>
							</a>-->
							<a href="javascript:void(0)" class="btn btn-outline-dark btn-sm pt-1 pb-1 pl-2 pr-2 ml-4 mr-0" 
								style="color:white" title="Export to Excel" (click)="exportExcel3('P')">
								<span style="font-size: 12px"> Export to Excel</span>
							</a>
							<a href="javascript:void(0)" class="btn btn-outline-dark btn-sm pt-1 pb-1 pl-2 pr-2 ml-0"
								(click)="proOnly.toggle($event)">
								<i class="pi pi-angle-down" style="position:relative;top:2px"></i>
							</a>
							<p-overlayPanel #proOnly [appendTo]="'body'"
								[dismissable]="true" [showCloseIcon]="false">
								<ng-template pTemplate>
									<a href="javascript:void(0)" class="btn btn-outline-dark btn-sm pt-1 pb-1 pl-2 pr-2" (click)="exportExcel3('P','Y');proOnly.hide() "> Export to Project Only Excel</a>
								</ng-template>
							</p-overlayPanel>
							<!--<input type="checkbox" [(ngModel)]="proOnly2"><label class="tLabel ml-1" style="vertical-align: middle;line-height: 20px;">Project Only</label>
						-->	
							<a href="javascript:void(0)" class="btn btn-outline-dark btn-sm pt-1 pb-1 pl-2 pr-2 ml-4"
								(click)="checkPortfolioPermission(); opContentMenu.toggle($event);editName=false;">
								<span>Portfolio Tools</span>
								<i class="pi pi-angle-down" style="position:relative;top:2px;margin-left:5px;"></i>
							</a>
							<p-overlayPanel #opContentMenu [appendTo]="'body'"
								[dismissable]="true" [showCloseIcon]="false">
								<ng-template pTemplate>
									<ng-container *ngIf="portfolioPermission">
									<a href="javascript:void(0)" (click)="checkcopyPermission(); getProjectRpts(); intiCopy(); copyShow=true;opContentMenu.hide()">Copy Across Portfolio</a><br>
									<a href="javascript:void(0)" (click)="checkcomparisonPermission(); comparisonTable();opContentMenu.hide() ">Comparison Table</a><br>
									<a href="javascript:void(0)" (click)="checkupdatePNamerPermission();editName=!editName">Update Portfolio Name</a><br>
								<ng-container *ngIf="editName">
									<input type="text" [value]='portfolioDisplayName' maxlength="50" style="width:160px; padding:0 4px; border:1px solid #ccc">
									<i *ngIf='updatePNamerPermission' class="fas fa-check iconBtn" (click)="editPName($event)"></i><br>
								</ng-container>
								<a href="javascript:void(0)" (click)="checkchangeStatusPermission(); getProjectRpts(); getStatus(-1); statusShow=true;opContentMenu.hide();initStatus()">Change Status</a><br>
								<a href="javascript:void(0)" (click)="summaryTable();opContentMenu.hide() ">Create/download summary reports</a><br>
								<a href="javascript:void(0)" [ngClass]="{'disable':noPrint}" (click)="portfolioDeliverable();opContentMenu.hide() ">Portfolio Deliverable</a><br>
							</ng-container>
							</ng-template>
							</p-overlayPanel>

							<p-multiSelect styleClass="pt-1 pb-1 pl-2 ml-4" [style]="{minWidth: '100px', maxWidth: '100px'}"
									[options]="selectedDisplayCols" [(ngModel)]="selectedColumns" optionLabel="header"
									placeholder="Choose Columns" selectedItemsLabel="{0} columns selected"  (onChange)="$event?.originalEvent?.originalEvent?.stopPropagation();">
							</p-multiSelect>
								<button class="btn btn-dark btn-sm ml-1" style="background-color: rgb(9 17 33);"
									(click)="saveSelectedColumns();" title="Save as Default Columns Display">
									<i class="fa fa-save"></i></button>
								<a *ngIf='profolipZipUrl.length>0' [href]='profolipZipUrl' class="btn btn-dark btn-sm ml-1" style="background-color: rgb(9 17 33);"
									title="Download delivery zip file">
									<i class="far fa-file-archive"></i>
								</a>
								<a *ngIf='profolipZipUrl.length>0' href='javascript:void(0)' class="btn btn-dark btn-sm ml-1" style="background-color: rgb(9 17 33);"
									title="Show Portfolio Deliver Information" (click)="getPortfolioRptList(); op20.toggle($event)">
									<i class="fas fa-info"></i>
								</a>
								<p-overlayPanel #op20 [appendTo]="'body'" [dismissable]="true"  [showCloseIcon]="true" [style]="{width: '520px'}">
									<ng-template pTemplate>
										<h6>Portfolio Delivery Information<span *ngIf="loading8" class="fa fa-spinner fa-spin ml-2" style="font-size:16px;color:rgb(195,212,47); display:inline-block;"></span>
										</h6>
										<div style="width: 500px; color:#C2D63F;font-size:.8em; max-height:600px; overflow:auto">
											<ng-container *ngFor="let rpt of protfolioInfo; let i=index; trackBy:trackByFuntion">
												<a *ngIf="rpt.status=='Y'" style='color:white' target=_blank [href]="rpt.url">{{rpt.reportInfo}}</a>
												<a *ngIf="rpt.status=='N'" style='color:white' href='javascript:void(0)'>{{rpt.reportInfo}}</a>
												<a href='javascript:void(0)' *ngIf="rpt.status=='N'" [title]="rpt.url" class="redLabel"><i class="fas fa-times"></i><i class="fas fa-info-circle" ></i></a>
												<a href='javascript:void(0)' *ngIf="rpt.status=='Y'" title="Done!" style="color:green"><i class="fas fa-check"></i></a>
												<br>
											</ng-container> 	
										</div>
									</ng-template>
								</p-overlayPanel>
								<a *ngIf='profolipZipUrl.length>0' href='javascript:void(0)' class="btn btn-dark btn-sm ml-1" style="background-color: rgb(9 17 33);"
									title="Share delivery zip file"(click)='shareRpt(selectedPortfolio)'>
									<i class="far fa-envelope"></i>
								</a>
								
									
						</div>
					</ng-template>
					<ng-template pTemplate="header" let-columns>

						<!-- Portfolio Tab Headers: -->
						<th *ngFor="let col of columns"
							[ngStyle]="{'width': col.width,
										'background-color': col.field==='REPORT_TITLE'? 'rgb(195,212,47)' : null,
										'color': col.field==='REPORT_TITLE'? 'black' : 'white'}"
							style="padding:1px; font-size:12px; border: 2px solid rgb(9 17 33);" 
							[pSortableColumn]="col.sortfield"> 
							{{col.header}}
							<p-sortIcon *ngIf="col.field !== 'GROUP_LABEL'" [field]="col.searchfield"></p-sortIcon>
						</th>

						<!-- Portfolio Tab Column Search Bars: -->
						<tr>
							<th *ngFor="let col of columns" style="padding:2px;border: 2px solid rgb(9 17 33); background-color: rgb(28 36 51)">
								<input 
									*ngIf="col.field !== 'GROUP_LABEL' &&
										   col.field !== 'FULL_ADDRESS' &&
										   col.field !== 'ASSESSOR_DATE' &&
										   col.field !== 'REPORT_RECEIVED_DATE_DATE' &&
										   col.field !== 'REVIEWER_DATE' &&
										   col.field !== 'REPORT_DATE' &&
										   col.field !== 'ASSIGNED_USERS' &&
										   col.field !== 'TRANSACTION_TYPE'"
									pInputText type="text"
									(input)="portfolioTable.filter($event.target.value, col.searchfield, col.filterMatchMode)"
									style="margin:0 2px; font-size:12px; width:98%; background-color: rgb(9 17 33); border: 0px">
								<input *ngIf="col.field === 'FULL_ADDRESS'" pInputText type="text"
									(input)="portfolioTable.filter($event.target.value, 'flat', 'address')"
									style="margin:0 2px; font-size:12px; width:98%; background-color: rgb(9 17 33); border: 0px">
								<input *ngIf="col.field === 'ASSIGNED_USERS'" pInputText type="text"
									(input)="portfolioTable.filter($event.target.value, 'flat', 'additional_users')"
									style="margin:0 2px; font-size:12px; width:98%; background-color: rgb(9 17 33); border: 0px">
								<input *ngIf="col.field === 'TRANSACTION_TYPE'" pInputText type="text"
									(input)="portfolioTable.filter($event.target.value, 'flat', 'transaction')"
									style="margin:0 2px; font-size:12px; width:98%; background-color: rgb(9 17 33); border: 0px">
							</th>
						</tr>
					</ng-template>

					<!-- Portfolio Tab Table Data: -->
					<ng-template pTemplate="body" let-rowData let-columns="columns">
						<tr style="font-size:12px; line-height:1.3">
							
							<td *ngFor="let col of columns; trackBy: trackByFuntion" [ngStyle]="{'width': col.width}" style="padding:4px; font-size:12px; border: solid 2px rgb(9 17 33); background-color: rgb(28 36 51)" (click)="consoleLog(rowData)"> <!--flag-->
								<!--span (click)="consoleLog(rowData)">{{col.header}}{{i}}</span-->
								
								<span *ngIf="rowData.size!=0 && !rowData.project && col.field==='GROUP_LABEL'">
									<div class="row mb-1">
										<div style="width:20%;margin-right:5px;">
											<span class="col-md-12 m-0" style="font-size:.8em;">W</span><br>
											<span class="col-md-12 m-0" style="font-size:.8em">R</span>
										</div>
										<div style="width:60%">
											<div class="progress" [title]="rowData.PERCENT_COMPLETE" style="height:6px;margin-top:4px;background-color:#999">
												<div class="progress-bar" [ngStyle]="{'width': rowData.PERCENT_COMPLETE}" style="background:rgb(195,212,47)">
												</div>
											</div>
											<div style="height:10px"></div>
											<div class="progress" [title]="rowData.REVIEWER_PROGRESS" style="height:6px;background-color:#999">
												<div class="progress-bar" [ngStyle]="{'width': rowData.REVIEWER_PROGRESS}" style="background:rgb(195,212,47)">
												</div>
											</div>
										</div>
									</div>
									
									<!-- Tools menu: -->
									<a *ngIf="rowData.CONSULTANT!='Y'" class="erisIconColor"
										style="cursor: pointer; "
										(click)="toolsOpPortfolio.toggle($event);" title="Tools">
										Tools
										<i class="pi pi-angle-down" style="position:relative;top:2px;cursor:pointer;font-size:16px;margin-left:5px;"></i>
									</a>
									<a *ngIf="rowData.CONSULTANT=='Y'" class="erisIconColor"
										style="cursor: default; text-decoration:none; opacity:0.5; " title="Tools">
										Tools
									</a>
									<p-overlayPanel #toolsOpPortfolio [appendTo]="'body'">
										<div>
											<a *ngIf="rowData.size!=0" title="Project Documents"  style="cursor:pointer;" class="m-1" data-toggle="modal" data-target="#fileModal"
												(click)='uploadType="FILE"; currentRowData=rowData; getAllBk(rowData.PROJECT_ID, rowData.REPORT_ID)'>
												<i class="fas fa-file-upload erisIconColor"></i>
												Project Documents
											</a>
										</div>
										<div>
											<a  title="Share Report by Email" *ngIf="rowData.REPORT_ID" [ngClass]="{'disable':noPrint}" style="cursor:pointer;" class="m-1"
												(click)="resetEmailForm();showEmail(rowData.REPORT_ID)"><!--op6.toggle($event);-->
												<i class="fas fa-envelope erisIconColor"></i>
												Share Report
											</a>
											<i class="fas fa-info-circle erisIconColor" *ngIf='noPrint&&rowData.REPORT_ID&&rowData.REPORT_ID!=emailId' style="color:#F78181" title="Other report sharing in progress!"></i>
											<div *ngIf="rowData.REPORT_ID==emailId">Email:
												<input class="rptInfo" type='text' [(ngModel)]="shareEmail" >
												<a  title="Send to Email" style="cursor:pointer;" class="m-1" (click)="shareByEmail(rowData.REPORT_ID);">
													<i *ngIf="!noPrint"  style="font-size:15px; pointer-events: none;"  class="erisIconColor fas fa-paper-plane"></i>														
												</a>
												<i *ngIf="noPrint" class="pi pi-spin pi-spinner" style="font-size: 1.2rem; margin-left: 10px; color: #C2D63F;"></i>
											</div> 
										</div>
										
										<!-- <p-overlayPanel #op5 [style]="{'width':'480px'}" [appendTo]="'body'"> -->
										<p-overlayPanel #op6 [appendTo]="'body'" [dismissable]="false"  [showCloseIcon]="true">
											<ng-template pTemplate>
												Email: <br>
												<input class="rptInfo" type='text' [(ngModel)]="shareEmail" > 	
												<a  title="Send to Email" style="cursor:pointer;" class="m-1" (click)="shareByEmail(rowData.REPORT_ID)">
													<i *ngIf="!noPrint"   style="font-size:15px"  class="erisIconColor fas fa-paper-plane"></i>
												</a>
												<i *ngIf="noPrint" class="pi pi-spin pi-spinner" style="font-size: 1.2rem; margin-left: 10px; color: #C2D63F;"></i> 
											</ng-template> 
										</p-overlayPanel>

										<div>
											<a (click)="op13.toggle($event);getProM();checkAssignUserPermission(rowData.REPORT_ID);"
												title="Project Manager" style="cursor: pointer;" class="m-1">
												<i class="fas fa-user erisIconColor"></i>
												Project Manager
											</a>
										</div>
										<p-overlayPanel #op13 [style]="{'width':'480px'}" [dismissable]="false" [showCloseIcon]="true" [appendTo]="'body'">
												<ng-template pTemplate>
													<ng-container>
														<div class="row">
														<label style="margin-top:10px" class="col-md-4 inputLabel">Project Manager</label>
															<ng-select *ngIf="!rowData.PROJECT_MANAGER[0]"															
																[clearable]="false"
																[items]="pmList"
																notFoundText="Not Found"
																class="col-md-7 p-1 rptInfo" 
																style="margin:4px; color: grey"
																[(ngModel)]="rowData.PROJECT_MANAGER[0]"
																[ngModelOptions]="{standalone: true}"
																placeholder="Select User"
																[searchFn]="customSearchFn"															
																>
																<ng-template ng-label-tmp
																	let-item="item">
																	<span *ngIf="item.FULL_NAME" style="color: black;">
																		{{item.FULL_NAME + ' ' +'(' + item.USER_EMAIL + ')'}}
																	</span>
																	<span *ngIf="!item.FULL_NAME && item.USER_EMAIL" style="color: black;">
																		{{item.USER_EMAIL}}
																	</span>
																	<!-- for blank option: -->
																	<span *ngIf="!item.FULL_NAME && !item.USER_EMAIL" style="color: black;">
																		&nbsp;
																	</span>
																</ng-template>
																<ng-template ng-option-tmp
																	let-item="item"
																	let-search="searchTerm"
																	let-index="index">
																	<span *ngIf="item.FULL_NAME" style="color: black;">
																		{{item.FULL_NAME + ' ' +'(' + item.USER_EMAIL + ')'}}
																	</span>
																	<span *ngIf="!item.FULL_NAME && item.USER_EMAIL" style="color: black;">
																		{{item.USER_EMAIL}}
																	</span>
																	<!-- for blank option: -->
																	<span *ngIf="!item.FULL_NAME && !item.USER_EMAIL" style="color: black;">
																		&nbsp;
																	</span>
																</ng-template>
															</ng-select>
															<ng-select	*ngIf="rowData.PROJECT_MANAGER[0]"															
																[clearable]="false"
																[items]="pmList"
																notFoundText="Not Found"
																class="col-md-7 p-1 rptInfo" 
																style="margin:4px; color: grey"
																[(ngModel)]="rowData.PROJECT_MANAGER[0]"
																[ngModelOptions]="{standalone: true}"
																[searchFn]="customSearchFn"
																>
																<ng-template ng-label-tmp
																	let-item="item">
																	<span *ngIf="item.FULL_NAME" style="color: black;">
																		{{item.FULL_NAME + ' ' +'(' + item.USER_EMAIL + ')'}}
																	</span>
																	<span *ngIf="!item.FULL_NAME && item.USER_EMAIL" style="color: black;">
																		{{item.USER_EMAIL}}
																	</span>
																	<!-- for blank option: -->
																	<span *ngIf="!item.FULL_NAME && !item.USER_EMAIL" style="color: black;">
																		&nbsp;
																	</span>
																</ng-template>
																<ng-template ng-option-tmp
																	let-item="item"
																	let-search="searchTerm"
																	let-index="index">
																	<span *ngIf="item.FULL_NAME" style="color: black;">
																		{{item.FULL_NAME + ' ' +'(' + item.USER_EMAIL + ')'}}
																	</span>
																	<span *ngIf="!item.FULL_NAME && item.USER_EMAIL" style="color: black;">
																		{{item.USER_EMAIL}}
																	</span>
																	<!-- for blank option: -->
																	<span *ngIf="!item.FULL_NAME && !item.USER_EMAIL" style="color: black;">
																		&nbsp;
																	</span>
																</ng-template>
															</ng-select>															
																<button class="btn btn-sm pt-0 pb-0 pl-1 pr-1"
																style="padding: 3px; font-size: 11px;"
																title="Update Project Manager"
																[disabled]="!assignUserPermission">
																<i class="fas fa-check erisIconColor" (click)="updatePM(rowData);op13.hide();"></i>
															</button>															
														</div>	
													</ng-container>
												</ng-template>
											</p-overlayPanel>
									</p-overlayPanel>

									<!-- this is for uploading files to project documents: -->
									<input id="{{rowData.REPORT_ID}}" type="file" style="display: none;"  multiple (change)="uploadImage(rowData);"
										accept='.png,.PNG,.jpg,.JPG, .jpeg,.JPEG'/>
									<input  id="{{rowData.REPORT_ID}}x"  type="file" style="display: none;" multiple (change)="uploadFile2(rowData)"
									accept=".jpg,.png,.jpeg,.xlsx,.csv,.txt,.docx,.doc, .pdf, .ppt,.pptx,.kml,.dwg">

								</span>

								<span *ngIf="rowData.size!=0 && !rowData.project && col.field=='DATE_UPDATED'">
									<a class="erisIconColor" (click)="getHistory(rowData); op1.toggle($event)"  style="cursor:pointer;"
										[title]="rowData[col.field]">
										{{rowData[col.field]}}</a>
									<p-overlayPanel #op1 [appendTo]="'body'" 		[style]="{'z-index':'9999999999999999', 'min-width':'300px'}">

										<ng-template pTemplate>
											<!-- <span *ngFor="let history of rowData.RW_REPORT_HISTORY">
												<a class="erisGreen" [title]="history.CHANGE_REASON_DESC"> {{history.DATE_UPDATED}} -- {{history.UPDATED_BY}}</a>
												<br>
											</span> -->
											<div style="padding:4px; height:300px; overflow:auto">
											<table  class="table2" style="width:90%; border: 1px solid black;  border-collapse: collapse;">
												<thead>
												  <tr style="color:rgb(195,212,47); font-size:12px">
								
												  <th class="table2">Edited By</th>
												  <th class="table2">Edit Date</th>
												  </tr>
												</thead>
												<tbody>
												  <ng-container *ngFor="let history of rowData.RW_REPORT_HISTORY; let i=index; trackBy: trackByFuntion">
													<tr style="color:white; font-size: 12px">
													<td class="table2">{{history.UPDATED_BY}}</td>
													<td class="table2">{{history.DATE_UPDATED}}</td>
													
													</tr>
												  </ng-container>
												</tbody>
												</table>
												</div>
										</ng-template>
									</p-overlayPanel>
								</span>

								<span *ngIf="rowData.size!=0 && !rowData.project && col.field=='DATE_CREATED'"
									[title]="rowData[col.field]">
									<a (click)="consoleLog(rowData)"> 
										{{rowData[col.field]}}	
									</a>									
								</span>

								<span *ngIf="rowData.size!=0 && !rowData.project && col.field=='CONSULTANT_LOCATION'"
									[title]="rowData[col.field].LOCATION_NAME">
									{{rowData[col.field].LOCATION_NAME}}										
								</span>

								<!-- Has been removed: -->
								<span *ngIf="rowData.size!=0 && !rowData.project && col.field=='REPORT_COMPANY_NAME'">
									{{rowData[col.field]}}										
								</span>
								<span *ngIf="rowData.size!=0 && !rowData.project && col.field=='CLIENT_COMPANY_NAME'">
									{{rowData[col.field]}}
								</span>
								<span *ngIf="!(rowData.project)">
									<span class="line-clamp2" *ngIf="col.field==='PROPERTY_NAME'" [title]="rowData.PROPERTY_NAME">
										{{rowData["PROPERTY_NAME"]}}
									</span>
									<div style="position:relative;" *ngIf="col.field==='REPORT_TITLE'" #reportInfo>
								
										<span *ngIf="rowData.size!=0"> 
											<a *ngIf="rowData.TEMPLATE && rowData.TEMPLATE[0] && rowData.REPORT_URL"class="line-clamp"
												style="color:#C2D63F; margin-right:19px; max-width:calc(100% - 18px);"
												target="_blank" [title]="rowData[col.field]"
												[attr.href]="'/report/' + rowData.PROJECT_ID +'/' + rowData.REPORT_ID">
												{{rowData[col.field]}} <br> &nbsp;
											</a>
											<a *ngIf="rowData.TEMPLATE && rowData.TEMPLATE[0] && !(rowData.REPORT_URL)"class="line-clamp"
												style="color:#C2D63F; max-width:100%;"
												target="_blank" [title]="rowData[col.field]"
												[attr.href]="'/report/' + rowData.PROJECT_ID +'/' + rowData.REPORT_ID">
												{{rowData[col.field]}} <br> &nbsp;
											</a>
											<span style="margin-right:19px; max-width:calc(100% - 18px);" *ngIf="!rowData.TEMPLATE || !rowData.TEMPLATE[0]"> 
												{{rowData[col.field]}} 
											</span>
											<a *ngIf="rowData[col.field]==''">
												&nbsp;
											</a>
										</span>
										<span *ngIf="rowData.size!=0">
											<!-- <a style="font-size:12px; position:absolute;right:18px;top:-2px; cursor: pointer;"
											(click)="op2.toggle($event);" title="Edit Name">
											<i class="fas fa-pen erisGreen" style="margin: 5px;"></i>
										</a> *ngIf="rowData.REPORT_URL!=''"-->
											<a *ngIf="rowData.REPORT_URL" [href]="rowData.REPORT_URL"
												target="_blank"
												style="font-size:12px; position:absolute;right:-1px;top:-3px; cursor: pointer;"
												title="PDF"><i class="far fa-file-pdf"
													style="margin:5px; color: rgb(201 218 251)"></i> </a>
											<!--a *ngIf="rowData.REPORT_URL"
												style="position:absolute;right:0;top:12px; cursor: pointer; font-size: 16px;"
												(click)="op1.toggle($event);" title="More Tools">
												<i class="pi pi-angle-down"
													tyle="margin-left:5px; margin-right:4px; ; color: rgb(201 218 251)"></i>
											</a>
											<a *ngIf="!rowData.REPORT_URL"
												style="position:absolute;right:0;top:6px; cursor: pointer; font-size: 16px;"
												(click)="op1.toggle($event);" title="More Tools">
												<i class="pi pi-angle-down"
													tyle="margin-left:5px; margin-right:4px; ; color: rgb(201 218 251)"></i>
											</a-->

											
											<!-- <a href="javascript:void(0)" style="font-size:12px; position:absolute;right:0;top:-5px; cursor: pointer;"
												
											title="Add/Edit Reports" data-toggle="modal"
											data-target="#reportsModal"
											(click)="editProject(rowData, rowNode, true); show('collapse5');">
											<i 
												style="margin:7px" class="fas fa-file-medical erisGreen"></i> </a>

												<a style="position:absolute;right:0;top:12px; cursor: pointer; font-size: 16px;"
												(click)="op1.toggle($event);" title="More Tools">
												<i class="pi pi-angle-down" style="margin-left:5px; margin-right:4px;"></i>
											</a>										 -->
										</span>
										<p-overlayPanel #op3 [dismissable]="true" appendTo="reportInfo"
											[style]="{'z-index':'9999999999999999','width':'300px'} "
											[showCloseIcon]="true">

											<ng-template pTemplate>
												<ng-container>
													<!-- <div class="row">
														<label style="margin-top:10px"
															class="col-md-2 inputLabel">Email: </label>
														<input placeholder="Email"
															style="background:#E6E6E6; margin:4px" type="text"
															class="col-md-6 invuser p-1 rptInfo">
														<div class="col-md-auto" style="margin-top:5px">
															<a class="btn btn-outline-dark btn-sm pt-0 pb-0 pl-1 pr-1 ml-1"
																title="Send link"> <i
																	class="erisGreen fas fa-paper-plane"></i> </a>
															<a (click)="copy(rowData)"
																class="btn btn-outline-dark btn-sm pt-0 pb-0 pl-1 pr-1 ml-1"
																title="Copy Link"><i
																	class="fas fa-link erisGreen"></i> </a>
														</div>
													</div> -->
													Email: <br>
													<input class="rptInfo" type='text' style="width:80%" [(ngModel)]="shareEmail"> 	
													<a  title="Send to Email" style="cursor:pointer;" class="m-1" (click)="shareByEmail(rowData.REPORT_ID);op1.toggle($event)">
	
														<i style="font-size:15px ; color: rgb(201 218 251)"  class="fas fa-paper-plane"></i>
													</a>
													<a  style="cursor:pointer;" (click)="copy(rowData)"
													class="m-1"
													title="Copy Link"><i style="color: rgb(201 218 251)"
														class="fas fa-link"></i> </a>

												</ng-container>

											</ng-template>
										</p-overlayPanel>
										<p-overlayPanel #op1 [appendTo]="'body'">

											<ng-template pTemplate>
												<button *ngIf="rowData.size!=0" 
												data-toggle="modal"
												data-target="#deleteReportModal"
												style="color: rgb(201 218 251)"
													class="btn btn-outline-dark btn-sm pt-0 pb-0 pl-1 pr-1 ml-1"
													title="Delete Report"><i class="far fa-trash-alt"
														(click)="reportToDelete= rowData;tabFrom('PORTOFLIO')"></i> </button>

												<!-- <a ref="javascript:void(0)"
													class="btn btn-outline-dark btn-sm pt-0 pb-0 pl-1 pr-1 ml-1"
													(click)="op2.toggle($event);" title="Edit Name">
													<i class="fas fa-pen erisGreen"></i>
												</a>

												<a *ngIf="rowData.REPORT_URL"
													(click)="op1.hide(); op3.toggle($event);"
													class="btn btn-outline-dark btn-sm pt-0 pb-0 pl-1 pr-1 ml-1"
													title="Share"><i class="far fa-share-square erisGreen"></i> </a> -->
											</ng-template>
										</p-overlayPanel>
										<p-overlayPanel #op2 [appendTo]="'body'">

											<ng-template pTemplate>
												<input class="rptInfo" type="text" [(ngModel)]="rowData[col.field]" 
												style="width: 250px;">
												<button (click)="changeReportTitle(rowData); op2.hide()"
												class="btn m-0 uploadBtn">Save</button>


											</ng-template>
										</p-overlayPanel>

									</div>
									<span *ngIf="(col.field === 'ASSESSOR_DATE' ||
												col.field === 'REPORT_RECEIVED_DATE_DATE' ||
												col.field === 'REVIEWER_DATE' ||
												col.field === 'REPORT_DATE')
												&& rowData.size!=0 && rowData.REPORT_CATEGORY"
									style="position:relative">
										<span *ngIf="rowData.CONSULTANT != 'Y'">
											<a *ngIf="(rowData.ASSESSOR_DUE_DATE==null || rowData.ASSESSOR_DUE_DATE=='') && col.field === 'ASSESSOR_DATE'"
												style=" cursor: pointer;z-index:1;position: absolute; top:0; left:5px; pointer-events: none; color: rgb(201 218 251)">
												<i class="fas fa-calendar-plus"></i></a>
											<a *ngIf="(rowData.REPORT_RECEIVED_DATE==null || rowData.REPORT_RECEIVED_DATE=='') && col.field === 'REPORT_RECEIVED_DATE_DATE'"
												style=" cursor: pointer;z-index:1;position: absolute; top:0; left:5px; pointer-events: none; color: rgb(201 218 251)">
												<i class="fas fa-calendar-plus"></i></a>
											<a *ngIf="(rowData.REVIEWER_DUE_DATE==null || rowData.REVIEWER_DUE_DATE=='') && col.field === 'REVIEWER_DATE'"
												style=" cursor: pointer;z-index:1;position: absolute; top:0; left:5px; pointer-events: none; color: rgb(201 218 251)">
												<i class="fas fa-calendar-plus "></i></a>
											<a *ngIf="(rowData.REPORT_DUE_DATE==null || rowData.REPORT_DUE_DATE=='') && col.field === 'REPORT_DATE'"
												style=" cursor: pointer;z-index:1;position: absolute; top:0; left:5px; pointer-events: none; color: rgb(201 218 251)">
												<i class="fas fa-calendar-plus "></i></a>
										</span>
										<!--
											<p-overlayPanel #op1 [style]="{'max-width':'130px'}" [appendTo]="'body'">
												<ng-template pTemplate>
													
													<p-calendar placeholder="dd-M-y" [(ngModel)]="rowData[col.field]" dateFormat="dd-M-y"op1.toggle($event);
											styleClass="calendarInput2" inputStyleClass="calendarInput2"
											(onSelect)="changeDate(rowData, rowData[col.field], col.field)" [showIcon]="true">
										</p-calendar>
													</ng-template>
											</p-overlayPanel>-->
										<p-calendar *ngIf="col.field === 'ASSESSOR_DATE'"
										#op [appendTo]="'body'"
											[(ngModel)]="rowData.ASSESSOR_DUE_DATE" dateFormat="M dd, yy" 
											[title]="rowData.ASSESSOR_DUE_DATE"
											styleClass="calendarInput2" inputStyleClass="calendarInput2"
											[inputStyle]="{'padding':'2px','color': rowData[col.field+'_RED']? 'rgb(255 89 89)': '#ccc'}"
											[readonlyInput]="true"
											[showOnFocus]="rowData.CONSULTANT != 'Y'"
											showButtonBar="true"
											(onSelect)="changeDate(rowData, rowData.ASSESSOR_DUE_DATE, col.field, col.sortfield)"
											(onClearClick)="changeDate(rowData, rowData.ASSESSOR_DUE_DATE, col.field, col.sortfield)">
										</p-calendar>
										<!------------------------------->
										<p-calendar *ngIf="col.field === 'REPORT_RECEIVED_DATE_DATE'"
										#op [appendTo]="'body'"
											[(ngModel)]="rowData.REPORT_RECEIVED_DATE" dateFormat="M dd, yy" 
											[title]="rowData.REPORT_RECEIVED_DATE"
											styleClass="calendarInput2" inputStyleClass="calendarInput2"
											[inputStyle]="{'padding':'2px','color': rowData[col.field+'_WHITE']? 'rgb(255 89 89)': '#ccc'}"
											[readonlyInput]="true"
											[showOnFocus]="rowData.CONSULTANT != 'Y'"
											showButtonBar="true"
											(onSelect)="changeDate(rowData, rowData.REPORT_RECEIVED_DATE, col.field, col.sortfield)"
											(onClearClick)="changeDate(rowData, rowData.REPORT_RECEIVED_DATE, col.field, col.sortfield)">
										</p-calendar>
										<!------------------------------->
										<p-calendar *ngIf="col.field === 'REVIEWER_DATE'"
										#op [appendTo]="'body'"
											[(ngModel)]="rowData.REVIEWER_DUE_DATE" dateFormat="M dd, yy" 
											[title]="rowData.REVIEWER_DUE_DATE"
											styleClass="calendarInput2" inputStyleClass="calendarInput2"
											[inputStyle]="{'padding':'2px','color': rowData[col.field+'_RED']? 'rgb(255 89 89)': '#ccc'}"
											[readonlyInput]="true"
											[showOnFocus]="rowData.CONSULTANT != 'Y'"
											showButtonBar="true"
											(onSelect)="changeDate(rowData, rowData.REVIEWER_DUE_DATE, col.field, col.sortfield)"
											(onClearClick)="changeDate(rowData, rowData.REVIEWER_DUE_DATE, col.field, col.sortfield)">
										</p-calendar>
										<p-calendar *ngIf="col.field === 'REPORT_DATE'"
										#op [appendTo]="'body'"
											[(ngModel)]="rowData.REPORT_DUE_DATE" dateFormat="M dd, yy" 
											[title]="rowData.REPORT_DUE_DATE"
											styleClass="calendarInput2" inputStyleClass="calendarInput2"
											[inputStyle]="{'padding':'2px','color': rowData[col.field+'_RED']? 'rgb(255 89 89)': '#ccc'}"
											[readonlyInput]="true"
											[showOnFocus]="rowData.CONSULTANT != 'Y'"
											showButtonBar="true"
											(onSelect)="changeDate(rowData, rowData.REPORT_DUE_DATE, col.field, col.sortfield)"
											(onClearClick)="changeDate(rowData, rowData.REPORT_DUE_DATE, col.field, col.sortfield)">
										</p-calendar>
									</span>
									<span *ngIf="col.field === 'PROJECT_NUMBER'">
										<ng-container>
											<div>
												<div style="position:relative;">
													<span class="line-clamp ">
														<a *ngIf="rowData.PRIVATE_FLAG == 'Y'" class="mr-1" style="cursor:pointer"
															target="_blank"
															(click)="editProject(rowData, '', false); show('collapse1'); hide('inner-collapse1'); hide('inner-collapse2'); hide('inner-collapse3');tabFrom('PORTFOLIO');checkEditProjectPermission(rowData.PROJECT_ID)"
															data-toggle="modal"
															data-target="#reportsModal"
															[title]="rowData.PROJECT_NUMBER"
															href="javascript:void(0)">
															<i class="erisIconColor fas fa-lock"></i>
														</a>
														<!--a  class="mr-1" style="cursor:pointer" (click)="selectedPortfolio=rowData.PORTFOLIO[0].PORTFOLIO_ID; getProjectforPortfolio(); setTabs()"[title]=rowData.PORTFOLIO[0].PORTFOLIO_NAME *ngIf="rowData.PORTFOLIO.length!=0" >
															<i class="erisIconColor fas fa-folder"></i>
														</a-->
														<!-- original colour of vv: erisGreen color: rgb(195,212,47) just to keep for now -->
														<!-- now it is:
																.erisIconColor{
																color: rgb(201 218 251)
															} -->
															<!--  margin-right:19px;max-width:calc(80% - 20px); -->
														<a class="erisIconColor mr-1"
														target="_blank"
															style="cursor: pointer; text-overflow: ellipsis; display: inline-block;"
															data-toggle="modal" (click)="editProject(rowData, '', false); show('collapse1'); 
														hide('inner-collapse1'); hide('inner-collapse2'); hide('inner-collapse3');tabFrom('PORTFOLIO');checkEditProjectPermission(rowData.PROJECT_ID)" data-target="#reportsModal"
															[title]="rowData.PROJECT_NUMBER"
															href="javascript:void(0)">{{rowData.PROJECT_NUMBER}}</a>
													</span>
												
													
<!--flag-->
													<!--a href="javascript:void(0)"
														style="font-size:12px; position:absolute;right:0;top:-5px; cursor: pointer;"
														title="Add/Edit Reports" data-toggle="modal"
														data-target="#reportsModal"
														(click)="editProject(rowData, '', false); show('collapse1');tabFrom('PORTFOLIO');getReports2()">
														<i style="margin:4px; color: rgb(201 218 251)" 
															class="fas fa-edit"></i> </a>

													<a style="position:absolute;right:0;top:12px; cursor: pointer; font-size: 16px; ; color: rgb(201 218 251)"
														(click)="op1.toggle($event);" title="More Tools">
														<i class="pi pi-angle-down"
															style="margin-left:5px; margin-right:4px;"></i>
													</a-->
												</div>
												<!-- <div class="col-sm-2">
													<a href="javascript:void(0)"
														class="btn btn-outline-dark btn-sm pt-0 pb-0 pl-1 pr-1 ml-1"
														title="Edit Project" data-toggle="modal"
														data-target="#reportsModal"
														(click)="editProject(rowData, rowNode, true);">
														<i 
															class="fas fa-file-medical erisGreen"></i> </a>

													<a style="cursor: pointer; font-size: 16px;"
														(click)="op1.toggle($event);" title="Edit Project">
														<i class="pi pi-angle-down" style="margin-left:5px; margin-right:5px;"></i>
													</a>
												</div> -->
											</div>
										</ng-container>
<!--flag-->
										<p-overlayPanel #op1 [appendTo]="'body'">

											<ng-template pTemplate>
												<button
												data-toggle="modal"
												data-target="#deleteModal"
													class="btn btn-outline-dark btn-sm pt-0 pb-0 pl-1 pr-1 ml-1"
													title="Delete Project"
													style="color: rgb(201 218 251)"
													(click)="projectToDelete=rowData.PROJECT_ID;tabFrom('PORTFOLIO')"><i
														class="far fa-trash-alt"></i>
											</button>

											</ng-template>
										</p-overlayPanel>
									</span>
									<span *ngIf="rowData.size!=0 && !rowData.project && col.field === 'STATUS'">

										<ng-container>
											<div style="position:relative">
												<div style="max-width:calc(100% - 20px);" [title]="rowData.STATUS">
													{{rowData.STATUS}}
												</div>
												<!-- <div class="col-sm-6" *ngIf="rowData.STATUS=='Writing in Process'" >  
											Writing
										</div>
										<div class="col-sm-7" *ngIf="rowData.STATUS=='In Senior Review'">
											Senior Review
										</div> -->
												<div>
													<a style="position:absolute;right:0;top:-5px; cursor: pointer; font-size: 16px;"
														(click)="getStatus(rowData.REPORT_ID);op1.toggle($event);" title="Edit Status">
														<i class="pi pi-angle-down" style="margin: 5px;"></i>
													</a>
												</div>
												<p-overlayPanel #op1 [appendTo]="'body'">
													<ng-template pTemplate>
														<ng-container *ngFor="let item of statusList2; trackBy: trackByFuntion">
															<a href="javascript:void(0)"
																style="font-size:.8em; color: #C2D63F;"
																(click)="op1.hide(); changeStatus1(rowData,item.STATUS)">{{item.STATUS}}</a>
															<br>
														</ng-container>
													</ng-template>
												</p-overlayPanel>
											</div>
										</ng-container>
									</span>
									<span *ngIf="rowData.size!=0 && !rowData.project && col.field==='REPORT_GROUP'">
										<ng-container>
											<div style="position:relative">
												<div style="max-width:calc(100% - 20px);" [title]="rowData?.REPORT_GROUP?.GROUP_NAME || ''">
													{{rowData?.REPORT_GROUP?.GROUP_NAME || ''}}
												</div>
												<div>
													<a style="position:absolute;right:0;top:-5px; cursor: pointer; font-size: 16px;"
														(click)="toggleUserGroups($event, op1)" title="Edit Group">
														<i class="pi pi-angle-down" style="margin: 5px;"></i>
													</a>
												</div>
												<p-overlayPanel #op1 [appendTo]="'body'">
													<ng-template pTemplate>
														<div style="max-height: 400px; overflow-y: auto;">
															<ng-container *ngIf="userGroups.length > 0; else noGroups">
																<ng-container *ngFor="let group of userGroups; trackBy: trackByFuntion">
																	<a href="javascript:void(0)"
																		style="font-size:.8em; color: #C2D63F;"
																		(click)="op1.hide(); updateReportGroup(rowData,group)">
																		{{group.GROUP_NAME}}
																	</a>
																	<br>
																</ng-container>
															</ng-container>
															<ng-template #noGroups>
																<p style="font-size:.8em; color: #C2D63F;">No Groups Found</p>
															</ng-template>
														</div>
													</ng-template>
												</p-overlayPanel>
											</div>
										</ng-container>
									</span>
									<span *ngIf="rowData.FULL_ADDRESS && col.field === 'FULL_ADDRESS'">
										<a [title]="rowData.FULL_ADDRESS" class="link-light line-clamp"
											style="cursor:pointer; text-decoration: underline;"
											(click)="op.toggle($event);getCords(rowData)">
											<!-- <i class= "fas fa-map-marker-alt" style="float:right; margin:3px; color: rgb(201 218 251)"></i> -->
											{{rowData.FULL_ADDRESS}}
									
										</a>
										<p-overlayPanel #op [appendTo]="'body'" [dismissable]="true" (onHide)="onHide()"
											[style]="{width: '550px', height: '550px'}">
											<span style="color:rgb(195,212,47)">
												{{rowData.FULL_ADDRESS}}
												<a *ngIf="!noLocation" style="color: red; display: inline-block;">
													(Address not valid)
												</a><br>
												<span *ngIf="rowData.PARCEL_ID">
													Parcel ID: {{rowData.PARCEL_ID}}
												</span>
												
											</span>
											<!--<agm-map id="test" class="googleMap2" controlSize=24 [latitude]="rowData.LATITUDE"
												  [longitude]="rowData.LONGITUDE" [zoom]="zoomV" [disableDefaultUI]="false" [zoomControl]="false" [disableDoubleClickZoom]='true'>
												  <agm-marker *ngIf="noLocation" [latitude]="rowData.LATITUDE" 
												  [longitude]="rowData.LONGITUDE">
													<agm-info-window>
														<strong>{{rowData.FULL_ADDRESS}}</strong>
													</agm-info-window>

												</agm-marker>
											</agm-map>-->
											<div id="googleMap2" class="googleMap2"></div>

										</p-overlayPanel>
									</span>
									<span *ngIf="rowData.size!=0 && rowData.REPORT_CATEGORY && col.field === 'TEMPLATE_ID'">
										<div *ngIf="!rowData.TEMPLATE || !rowData.TEMPLATE[0] "
											style="position:relative">

											<div>
												<a style="position:absolute;right:2px;top:-8px; cursor: pointer; font-size: 16px;"
													(click)="op1.toggle($event);findType(rowData);"
													title="Add Template">
													<i class="fas fa-plus erisIconColor" style="margin: 4px;"></i>
												</a>
												<p-overlayPanel #op1 [appendTo]="'body'">
													<ng-template pTemplate>
														<label class="col-md-4 inputLabel">Template
															Identifier:</label>
														<select class="col-md-7 p-1 rptInfo" style="margin:4px;"
															[(ngModel)]="catToChange.selectedSubCat"
															[ngModelOptions]="{standalone: true}"
															(change)="setByTypeId(catToChange);">
															<option></option>
															<option
																*ngFor="let subCat of catToChange.subCategories;"
																[ngValue]="subCat">
																{{subCat.subCategory}}</option>
														</select>

														<label class="col-md-4 inputLabel">Template: </label>
														<select class="col-md-7 p-1 rptInfo" style="margin:4px;"
															[(ngModel)]="catToChange.selectedTemplate"
															[ngModelOptions]="{standalone: true}"
															(change)="changeTemplate(rowData)">
															<option></option>
															<option
																*ngFor="let template of catToChange.typeIdTemplates;"
																[ngValue]="template">
																{{template.TEMPLATE_TITLE}}</option>
														</select>

													</ng-template>
												</p-overlayPanel>

											</div>
										</div>
										<ng-container *ngIf="rowData.TEMPLATE && rowData.TEMPLATE[0]">
											<div  style="position:relative">

												<!-- <div class="row"> -->
												<!-- <div class="col-md-6"> -->
												<div style="max-width:calc(100% - 18px);" class="line-clamp">													
													<a class="erisIconColor" [href]="'template/'+rowData.TEMPLATE[0].TEMPLATE_ID" target=_blank	title="{{rowData.TEMPLATE[0].TEMPLATE_TITLE}}">
													{{rowData.TEMPLATE[0].TEMPLATE_TITLE}}
													</a>													
												</div>
												<ng-container *ngIf="rowData.TEMPLATE[0].TEMPLATE_VERSION_NO">
													<span style="font-size: 7pt;">({{rowData.TEMPLATE[0].TEMPLATE_VERSION_NO}})</span>
												</ng-container>
												<!--<div>
													<a style="position:absolute;right:0;top:-5px; cursor: pointer; font-size: 16px;"
														(click)="tableTemplates=[]; getTemplate(rowData.TEMPLATE[0].TEMPLATE_TYPE_ID); findType1(rowData);op11.toggle($event);"
														title="Choose Template">
														<i class="pi pi-angle-down" style="margin: 5px;"></i>
													</a>
												</div>
												<p-overlayPanel #op11 [appendTo]="'body'" [dismissable]="false" [showCloseIcon]="true">
													<ng-template pTemplate>
														<div style="padding:4px; height:400px; overflow:auto; width:400px">
														<ng-container *ngFor="let item of tableTemplates; trackBy:trackByFuntion">
														
															<a href="javascript:void(0)"
																style="font-size:.8em; color: #C2D63F;"
																(click)="updateTemplate(item, rowData); op11.hide()">
																{{item.TEMPLATE_TITLE}}</a>
															<br>

														</ng-container>
														</div>
													</ng-template>
												</p-overlayPanel>-->
												<!-- </div> -->
												<!-- <div class="col-md-12">
												<div class="dropdown" style="display:inline; margin-left:4px">
													<button type="button"
														class="btn btn-success dropdown-toggle btn-sm p-0 m-0"
														style="width:16px; height:16px" data-toggle="dropdown"
														(click)="tableTemplates=[]; getTemplate(rowData.TEMPLATE[0].TEMPLATE_ID)"></button>
													<div class="dropdown-menu">
														<ng-container *ngFor="let item of tableTemplates">
															<a class="dropdown-item m-0 p-1"
																href="javascript:void(0)"
																(click)="updateTemplate(item, rowData);"
																style="font-size:.9em; color:black; font-family:'Times New Roman', Times, serif;">{{item.TEMPLATE_TITLE}}</a>

														</ng-container>
													</div>
												</div>
											</div> -->
												<!-- </div> -->
											</div>
										</ng-container>
									</span>
									<span *ngIf="rowData.size!=0 && col.field === 'TRANSACTION_TYPE'"
										style="position:relative">
										<span *ngIf='rowData[col.field]&&rowData[col.field][0]'
										[title]="rowData[col.field][0].TRANSACTION_TYPE"
										style="overflow-wrap:break-word;">
										{{rowData[col.field][0].TRANSACTION_TYPE}} 
											<!--<a 
											class="line-clamp"
												style="margin-right:19px; max-width:calc(100% - 5px); text-overflow: ellipsis; display: inline-block;"
											[title]="rowData[col.field][0].TRANSACTION_TYPE">
											<br>	{{rowData[col.field][0].TRANSACTION_TYPE}} 
											</a>-->
										</span><br>
										<span *ngIf='rowData["PROTOCOL"]&&rowData["PROTOCOL"][0]'
										[title]="rowData['PROTOCOL'][0]?.PROTOCOL"
										style="overflow-wrap:break-word;">
										{{rowData['PROTOCOL'][0]?.PROTOCOL}} 
											<!--<a 
											class="line-clamp"
												style="margin-right:19px; max-width:calc(100% - 5px); text-overflow: ellipsis; display: inline-block;"
											[title]="rowData['PROTOCOL'][0]?.PROTOCOL">
											<br>	{{rowData['PROTOCOL'][0]?.PROTOCOL}} 
											</a>-->
										</span>
									</span>
									<span *ngIf="rowData.size!=0 && rowData.REPORT_CATEGORY && (col.field === 'ASSESSOR' || col.field === 'REVIEWER')">
										<a *ngIf="rowData[col.field] && rowData[col.field][0] && rowData[col.field][0].LAST_NAME"
											(click)="op1.toggle($event); checkAssignUserPermission(rowData.REPORT_ID); getCompanyRoles(); getAllReportUsers(-1, -1, ''); clearInvite1(rowData, rowData[col.field]);"
											[title]="rowData[col.field][0].FIRST_NAME+ ' ' + rowData[col.field][0].LAST_NAME"
											style="cursor: pointer; text-decoration: underline; overflow-wrap: break-word;">
											{{rowData[col.field][0].FIRST_NAME
											+ " " + rowData[col.field][0].LAST_NAME}}
										</a>
										<a *ngIf="rowData[col.field] && rowData[col.field][0] && !rowData[col.field][0].LAST_NAME"
											(click)="op1.toggle($event); checkAssignUserPermission(rowData.REPORT_ID); getCompanyRoles(); getAllReportUsers(-1, -1, ''); clearInvite1(rowData, rowData[col.field]);"
											[title]="rowData[col.field][0].USER_EMAIL"
											style="cursor: pointer; text-decoration: underline; word-break:break-all">
											{{rowData[col.field][0].USER_EMAIL}}
										</a>
										<a *ngIf="!rowData[col.field] || !rowData[col.field][0]"
											(click)="op1.toggle($event); checkAssignUserPermission(rowData.REPORT_ID); getCompanyRoles(); getAllReportUsers(-1, -1, ''); clearInvite1(rowData, rowData[col.field]);"
											title="Add User"
											style="cursor: pointer; margin-left:5px;"><i
											class="icon-AddUser fa-2x" style="color: rgb(201 218 251)"></i></a>
										<p-overlayPanel #op1 [style]="{'max-width':'580px'}" [appendTo]="'body'">
											<ng-template pTemplate>
												<ng-container>
													<div class="row">
														<label style="margin-top:10px"
															class="col-md-3 inputLabel">{{col.header}}: </label>
														<ng-select *ngIf="!rowData[col.field][0]"
															id="writer reviewer dropdown"style="margin:4px; color: grey" class="col-md-7 p-1 rptInfo"
															[clearable]="false" [items]="allusersList"
															notFoundText="Not Found" bindLabel="USER_EMAIL"
															[(ngModel)]="rowData[col.field][0]"
															[ngModelOptions]="{standalone: true}"
															[searchFn]="customSearchFn"
															(change)="changeUser(rowData, rowData[col.field], col.field)"
															placeholder="Select Existing User"
															>
															<!-- <ng-option [value]="{'USER_ID':null}">test</ng-option> -->
															<ng-template ng-label-tmp let-item="item">
																<span *ngIf="item.FULL_NAME" style="color: black;">{{
																	item.FULL_NAME + ', ' +
																	'('+item.USER_EMAIL+')'}}</span>
																<span
																	*ngIf="!item.FULL_NAME">{{ '(' + item.USER_EMAIL + ')'}}</span>
															</ng-template>
															<ng-template ng-option-tmp let-item="item"
																let-search="searchTerm" let-index="index" >
																<span *ngIf="item.FULL_NAME" style="color: black;">{{
																	item.FULL_NAME + ', ' +
																	'(' + item.USER_EMAIL + ')'}}</span>
																<span
																	*ngIf="!item.FULL_NAME" style="color: black;">{{'(' + item.USER_EMAIL + ')'}}</span>
															</ng-template>
														</ng-select>
														<ng-select *ngIf="rowData[col.field][0]"
															id="writer reviewer dropdown"style="margin:4px; color: grey" class="col-md-7 p-1 rptInfo"
															[clearable]="false" [items]="allusersList"
															notFoundText="Not Found" bindLabel="USER_EMAIL"
															[(ngModel)]="rowData[col.field][0]"
															[ngModelOptions]="{standalone: true}"
															[searchFn]="customSearchFn"
															(change)="changeUser(rowData, rowData[col.field], col.field)"
															>
															<ng-template ng-label-tmp let-item="item">
																<span *ngIf="item.FULL_NAME" style="color: black;">{{
																	item.FULL_NAME + ', ' +
																	'(' + item.USER_EMAIL + ')'}}</span>
																<span
																	*ngIf="!item.FULL_NAME">{{item.USER_EMAIL}}</span>
															</ng-template>
															<ng-template ng-option-tmp let-item="item"
																let-search="searchTerm" let-index="index" >
																<span *ngIf="item.FULL_NAME" style="color: black;">{{
																	item.FULL_NAME + ', ' +
																	'(' + item.USER_EMAIL + ')'}}</span>
																<span
																	*ngIf="!item.FULL_NAME" style="color: black;">{{'(' + item.USER_EMAIL + ')'}}</span>
															</ng-template>
														</ng-select>

														<button class="btn btn-sm pt-0 pb-0 pl-1 pr-1 col-md-1"
															style="margin-left: 5px; padding: 3px; font-size: 11px; margin:4px"
															title="Remove User"><i
																class="far fa-trash-alt erisGreen"
																(click)="rowData[col.field][0]={'USER_ID':null}; changeUser(rowData, rowData[col.field], col.field)"></i>
														</button>
														<hr style="color: white; width: 100%; background-color: white;">
														<div>
															<label style="margin-top:10px"
															class="col-md-10 inputLabel">Invite New Users
															&nbsp;
															
															<span style="float: right">External:
																<input type="checkbox" [(ngModel)]="userExternal" (change)="changeRole()" [ngModelOptions]="{standalone: true}"></span></label>

														

															<label style="margin-top:10px"
															class="col-md-3 inputLabel">First Name:<span style="color:red"> * </span>
															&nbsp;</label>

															<input [(ngModel)]="firstname"
																[ngModelOptions]="{standalone: true}"
																style="background:#E6E6E6; margin:4px" type="text"
																class="col-md-7 invuser p-1 rptInfo"/>

																<label style="margin-top:10px"
																class="col-md-3 inputLabel">Last Name:<span style="color:red"> * </span>
																&nbsp;</label>

															<input [(ngModel)]="lastname"
																[ngModelOptions]="{standalone: true}"
																style="background:#E6E6E6; margin:4px" type="text"
																class="col-md-7 invuser p-1 rptInfo"/>
															<label style="margin-top:10px"
																class="col-md-3 inputLabel">Email:<span style="color:red"> * </span>
																&nbsp;</label>

															<input [(ngModel)]="userToAdd"
																[ngModelOptions]="{standalone: true}"
																style="background:#E6E6E6; margin:4px" type="text"
																class="col-md-7 invuser p-1 rptInfo" placeholder="Enter Email to Invite User"/>
														
															<!--button type="button"
																title="Invite User"
																class="btn btn-sm pt-0 pb-0 pl-1 pr-1 col-md-1"
																(click)="inviteUser2(rowData, col.field); op1.hide()"
																style="margin-left: 5px; padding: 3px; font-size: 11px; margin:4px">
																<i class="fas fa-user-plus erisGreen"></i></button-->

															<!-- <button *ngIf="i==10" type="button" class="btn btn-sm pt-0 pb-0 pl-1 pr-1 col-md-1"
																		(click)="inviteUser2(rowData, col.field); op1.hide()"
																		style="margin-left: 5px; padding: 3px; font-size: 11px; margin:4px"> <i class="fas fa-user-plus erisGreen"></i></button> -->
															<!-- </div> -->

																<label style="margin-top:10px"
																class="col-md-3 inputLabel">User Role:<span style="color:red"> * </span></label>
																<select style="margin:4px;" class="col-md-7 p-1 rptInfo" [(ngModel)]="role"
																[ngModelOptions]="{standalone: true}" >
																<option [value]="type.ROLE_ID" *ngFor="let type of roles">
																	{{type.ROLE_NAME}} </option>
													
																</select>

																<label class="col-md-10 inputLabel">
																	<button (click)="inviteUser3(rowData, col.field, op1, $event); "
																	[disabled]="inviteUserLoading||!assignUserPermission" title="Invite User" class="btn btn-default btn-outline-dark"
																	style="color: white; border-color: white; margin-top: 10px;">
																		Invite User
																	</button>
																<i *ngIf="inviteUserLoading" class="pi pi-spin pi-spinner" style="font-size: 1.2rem; margin-left: 10px; color: #C2D63F;"></i>
																<span *ngIf="inviteUserErrorMessage" style="margin-left:30px;color: red"> {{inviteUserErrorMessage}} </span></label>
															
																<button title="Close" class="btn btn-outline-dark btn-sm pt-0 pb-0 pl-1 pr-1 ml-1" 
																	style="float: right; color: black; background-color: #C2D63F; border-color:black; margin: 10px;" 
																	(click)='op1.hide()'>
																	Close
																</button>
															
															</div>
											
													</div>
												</ng-container>
											</ng-template>
										</p-overlayPanel>

									</span>
									<span *ngIf="rowData.size!=0 && rowData.REPORT_CATEGORY && col.field === 'ASSIGNED_USERS'">
										<!-- <a  [class.assignedUser]="rowData[col.field].length>1"  *ngIf="rowData[col.field] && rowData[col.field][0] && rowData[col.field][0].LAST_NAME && rowData[col.field][1] && rowData[col.field][1].LAST_NAME"
											(click)="op1.toggle($event); getCompanyRoles(); getAllReportUsers(-1, -1, ''); clearInvite1(rowData, rowData[col.field]); "
											style="cursor: pointer; text-decoration: underline;">
											{{rowData[col.field][0].FIRST_NAME
											+ " " + rowData[col.field][0].LAST_NAME}}
											{{rowData[col.field][1].FIRST_NAME
												+ " " + rowData[col.field][1].LAST_NAME}}
										</a>
										<a  [class.assignedUser]="rowData[col.field].length>1" *ngIf="rowData[col.field] && rowData[col.field][0] && !rowData[col.field][0].LAST_NAME && rowData[col.field][1] && !rowData[col.field][1].LAST_NAME"
											(click)="op1.toggle($event); getCompanyRoles(); getAllReportUsers(-1, -1, ''); clearInvite1(rowData, rowData[col.field]); "
											style="cursor: pointer; text-decoration: underline; word-break:break-all">
											{{rowData[col.field][0].USER_EMAIL}}
											{{rowData[col.field][1].USER_EMAIL}}

										</a> -->

										<!-- If there are assigned users: -->
										<div style="position:relative">
											<a  [class.assignedUser]="rowData[col.field].length>1"
												*ngIf="rowData[col.field] && rowData[col.field][0] && rowData[col.field][0].LAST_NAME"
												(click)="op1.toggle($event); getCompanyRoles(); getAllReportUsers(-1, -1, ''); clearInvite1(rowData, rowData[col.field]); "
												[title]="rowData[col.field][0].FIRST_NAME+ ' ' + rowData[col.field][0].LAST_NAME"
												style="cursor: pointer; text-decoration: underline; overflow-wrap: break-word;">
												{{rowData[col.field][0].FIRST_NAME
												+ " " + rowData[col.field][0].LAST_NAME}}
											</a>
											<a  [class.assignedUser]="rowData[col.field].length>1"
												*ngIf="rowData[col.field] && rowData[col.field][0] && !rowData[col.field][0].LAST_NAME"
												(click)="op1.toggle($event); getCompanyRoles(); getAllReportUsers(-1, -1, ''); clearInvite1(rowData, rowData[col.field]); "
												[title]="rowData[col.field][0].USER_EMAIL"
												style="cursor: pointer; text-decoration: underline; word-break:break-all">
												{{rowData[col.field][0].USER_EMAIL}}
											</a>
											
											<!-- If there is more than 1 assigned user: -->
											<div *ngIf="rowData[col.field].length>1">
												<a style="position:absolute;right:0;top:-5px; cursor: pointer; font-size: 16px;"
													(click)="assignedUsersop.toggle($event);"
													title="View Assigned Users">
													<i class="pi pi-angle-down" style="margin: 5px;"></i>
												</a>
											</div>
											<p-overlayPanel #assignedUsersop [appendTo]="'body'" [dismissable]="true" [showCloseIcon]="true">
												<ng-template pTemplate>
													<div style="padding:4px; height:400px; overflow:auto; width:400px">
														<ng-container *ngFor="let item of rowData[col.field];">
															<span *ngIf="item.FIRST_NAME!==undefined">{{item.FIRST_NAME}} </span>
															<span *ngIf="item.LAST_NAME!==undefined">{{item.LAST_NAME}} </span>
															<span *ngIf="item.USER_EMAIL!==undefined">({{item.USER_EMAIL}})</span>
															<br>
														</ng-container>
													</div>
												</ng-template>
											</p-overlayPanel>
										</div>

										<!-- If there are no assigned users: -->
										<a [class.assignedUser]="rowData[col.field]?.length>1"  *ngIf="!rowData[col.field] || !(rowData[col.field]&&rowData[col.field][0])"
											(click)="op1.toggle($event); checkAssignUserPermission(rowData.REPORT_ID); getCompanyRoles(); clearInvite1(rowData, rowData[col.field]); getAllReportUsers(-1, -1, '');"
											title="Add User"
											style="cursor: pointer; margin-left:5px;"><i
											class="icon-AddUser fa-2x" style="color: rgb(201 218 251)"></i></a>
										<p-overlayPanel #op1 [style]="{'max-width':'580px'}" [dismissable]="false" [appendTo]="'body'" (onShow)="getCompanyRoles(); clearInvite()">
											<ng-template pTemplate>
												<ng-container>
													<div class="row">

														<div *ngFor="let user of rowData.ASSIGNED_USERS" class="col-md-12">
															<label class="tag"> <i class="fas fa-times iconBtn erisGreen" style="margin-left:5px" (click)='removeAssignedUser(rowData, user)'></i> {{user.FULL_NAME? user.FULL_NAME:user.USER_EMAIL}}</label>
														</div>

														<label style="margin-top:10px"
														class="col-md-3 inputLabel">Add New User: </label>
														<ng-select
															id="writer reviewer dropdown"style="margin:4px; color: grey" class="col-md-7 p-1 rptInfo"
															[clearable]="false" 
															[items]="allusersList"
															notFoundText="Not Found" bindLabel="USER_EMAIL"
															[(ngModel)]="rowData['USER_TO_ADD']"
															[ngModelOptions]="{standalone: true}"
															>
															<!-- placeholder="Select Existing User" -->
															<!-- <ng-option [value]="{'USER_ID':null}">test</ng-option> -->
															<ng-template ng-label-tmp let-item="item">
																<span *ngIf="item.FULL_NAME" style="color: black;">{{
																	item.FULL_NAME + ', ' +
																	'('+item.USER_EMAIL+')'}}</span>
																<span
																	*ngIf="!item.FULL_NAME">{{ '(' + item.USER_EMAIL + ')'}}</span>
															</ng-template>
															<ng-template ng-option-tmp let-item="item">
																<span *ngIf="item.FULL_NAME" style="color: black;">{{
																	item.FULL_NAME + ', ' +
																	'(' + item.USER_EMAIL + ')'}}</span>
																<span
																	*ngIf="!item.FULL_NAME" style="color: black;">{{'(' + item.USER_EMAIL + ')'}}</span>
															</ng-template>
														</ng-select>
															
														<button *ngIf="!rowData['USER_TO_ADD']" class="btn btn-sm pt-0 pb-0 pl-1 pr-1 col-md-1 btn-outline-light"
														style="margin-left: 5px; padding: 3px; margin:4px">
														Add
														</button>
														<button *ngIf="rowData['USER_TO_ADD']" class="btn btn-sm pt-0 pb-0 pl-1 pr-1 col-md-1 btn-outline-light"
														style="margin-left: 5px; padding: 3px; margin:4px" (click)="addAssignedUser(rowData, rowData['USER_TO_ADD']);"
														title="Add User">Add
														</button>

														<hr style="color: white; width: 100%; background-color: white;">

														<!--label style="margin-top:10px"
															class="col-md-4 inputLabel">Invite New User:
															&nbsp;</label>

														<input [(ngModel)]="userToAdd"
															[ngModelOptions]="{standalone: true}"
															style="background:#E6E6E6; margin:4px" type="text"
															class="col-md-6 invuser p-1 rptInfo" placeholder="Enter Email to Invite User"/>

														<button type="button"
															title="Invite User"
															class="btn btn-sm pt-0 pb-0 pl-1 pr-1 col-md-1"
															(click)="inviteUser2(rowData, col.field);"
															style="margin-left: 5px; padding: 3px; font-size: 11px; margin:4px">
															<i class="fas fa-user-plus erisGreen"></i></button>
													
														
															<label style="margin-top:10px"
															class="col-md-4 inputLabel">User Role:</label>
															<select style="margin:4px;" class="col-md-6 p-1 rptInfo" [(ngModel)]="role"
															[ngModelOptions]="{standalone: true}" >
															  <option [value]="type.ROLE_ID" *ngFor="let type of roles">
																{{type.ROLE_NAME}} </option>
												  
															</select-->
											
															<label style="margin-top:10px"
															class="col-md-10 inputLabel">Invite New Users
															&nbsp;<span style="float: right">External:
																<input type="checkbox" [(ngModel)]="userExternal" (change)="changeRole()" [ngModelOptions]="{standalone: true}"></span></label>

															<label style="margin-top:10px"
															class="col-md-3 inputLabel">First Name:<span style="color:red"> * </span>
															&nbsp;</label>

														<input [(ngModel)]="firstname"
															[ngModelOptions]="{standalone: true}"
															style="background:#E6E6E6; margin:4px" type="text"
															class="col-md-7 invuser p-1 rptInfo"/>

															<label style="margin-top:10px"
															class="col-md-3 inputLabel">Last Name:<span style="color:red"> * </span>
															&nbsp;</label>

														<input [(ngModel)]="lastname"
															[ngModelOptions]="{standalone: true}"
															style="background:#E6E6E6; margin:4px" type="text"
															class="col-md-7 invuser p-1 rptInfo"/>
														<label style="margin-top:10px"
															class="col-md-3 inputLabel">Email:<span style="color:red"> * </span>
															&nbsp;</label>

														<input [(ngModel)]="userToAdd"
															[ngModelOptions]="{standalone: true}"
															style="background:#E6E6E6; margin:4px" type="text"
															class="col-md-7 invuser p-1 rptInfo" placeholder="Enter Email to Invite User"/>

															<label style="margin-top:10px"
															class="col-md-3 inputLabel">User Role:<span style="color:red"> * </span></label>
															<select style="margin:4px;" class="col-md-7 p-1 rptInfo" [(ngModel)]="role"
															[ngModelOptions]="{standalone: true}" >
															  <option [value]="type.ROLE_ID" *ngFor="let type of roles">
																{{type.ROLE_NAME}} </option>
												  
															</select>

															<label class="col-md-10 inputLabel">
																<button (click)="inviteUser3(rowData, col.field, op1, $event); "
																	[disabled]="inviteUserLoading||!assignUserPermission" title="Invite User"
																	class="btn btn-default btn-outline-dark" style="color: white; border-color: white; margin-top: 10px;" >
																	Invite User
																</button>
																<i *ngIf="inviteUserLoading" class="pi pi-spin pi-spinner" style="font-size: 1.2rem; margin-left: 10px; color: #C2D63F;"></i>
																<span *ngIf="inviteUserErrorMessage" style="margin-left:30px;color: red"> {{inviteUserErrorMessage}} </span></label>
																
															<button title="Close" class="btn btn-outline-dark btn-sm pt-0 pb-0 pl-1 pr-1 ml-1" 
																style="float: right; color: black; background-color: #C2D63F; border-color:black; margin: 10px;" 
																(click)='op1.hide()'>
																Close
															</button>
														  
													</div>
												</ng-container>
											</ng-template>
										</p-overlayPanel>

									</span>

									<span *ngIf="rowData.size!=0 && col.field === 'ORDER_REPORTS'">
										<ng-container>
											<ng-container *ngIf="rowData.ORDER_NUM!=''">
												<div>
													<div style=" white-space: nowrap;
													overflow: hidden;
													text-overflow: ellipsis;
													 cursor: pointer; font-size: 12px; margin-top:3px; color:rgb(195,212,47)"  *ngIf="rowData.ORDER_REPORTS?.length>0"
													 [title]="rowData.ORDER_NUM">
														<a 
															(click)="op2.toggle($event);">
															{{rowData.ORDER_NUM}}
														</a>
													</div>
													<div style="  white-space: nowrap;
													overflow: hidden;
													text-overflow: ellipsis; margin-top:3px;" *ngIf="rowData.ORDER_REPORTS?.length==0"
													[title]="rowData.ORDER_NUM">
									
															{{rowData.ORDER_NUM}}
													
													</div>
													<!-- <div #test class="col-sm-auto">
														<a style="cursor: pointer; font-size: 16px;"
															(click)="op2.toggle($event);">
															<i class="pi pi-angle-down" style="margin: 5px;"></i>
														</a>
													</div> -->
													<p-overlayPanel #op2 [styleClass]="'fixedoverlay'"
														[appendTo]="'body'" [dismissable]="true">
														<ng-template pTemplate>
															<ng-container *ngFor="let item of rowData[col.field]">
																<a style="font-size:12px; color:rgb(195,212,47)"
																	[href]="item.REPORT_URL"
																	target=_blank>{{item.REPORT_NAME}}</a><br>
															</ng-container>
														</ng-template>
													</p-overlayPanel>
												</div>

											</ng-container>
											<ng-container *ngIf="rowData.ORDER_NUM==''">

											<span *ngIf="userInfo.ERIS_CUSTOMER_ID">
											<a class="btn btn-sm pt-0 pb-0 pl-1 pr-1 ml-1"
													(click)="op1.toggle($event);consoleLog(userInfo);checkErisData()"
													title="Add/Change Order Number">
													<i class="erisIcon erisGreen"></i>
												</a>
											</span>
											<span *ngIf="!userInfo.ERIS_CUSTOMER_ID">
												<a class="btn btn-sm pt-0 pb-0 pl-1 pr-1 ml-1"
														(click)="op2.toggle($event);consoleLog(userInfo)"
														title="Add/Change Order Number">
														<i class="erisIcon erisGreen"></i>
													</a>
												</span>
											</ng-container>											

											<p-overlayPanel #op1 [appendTo]="'body'" [style]="{'z-index':'9999999999999999', 'min-width':'400px', 'max-width':'700px'}" [dismissable]="false" [showCloseIcon]="false">
												<ng-template pTemplate>
													<!-- <span *ngFor="let history of rowData.RW_REPORT_HISTORY">
														<a class="erisGreen" [title]="history.CHANGE_REASON_DESC"> {{history.DATE_UPDATED}} -- {{history.UPDATED_BY}}</a>
														<br>
													</span> -->
													<!--table  class="table2" style="width:90%; border: 1px solid black;  border-collapse: collapse;">
														<thead>
															<tr style="color:rgb(195,212,47); font-size:12px">
										
															<th class="table2">Edited By</th>
															<th class="table2">Edit Date</th>
															</tr>
														</thead>
														<tbody>
															<ng-container *ngFor="let history of rowData.RW_REPORT_HISTORY; let i=index">
															<tr style="color:rgb(195,212,47); font-size:12px">
															<td class="table2">{{history.UPDATED_BY}}</td>
															<td class="table2">{{history.DATE_UPDATED}}</td>
															
															</tr>
															</ng-container>
														</tbody>
														</table-->
														<p-table #pt2 styleClass="p-datatable-sm" [value]="erisData" [columns]="erisColsDashboard" [scrollable]="true"
														scrollHeight="30vh"			[globalFilterFields]="erisCols2">
														<!--ng-template pTemplate="caption">
												
															<div class="table-header">
																&nbsp;
																<i *ngIf="erisDataLoading" class="pi pi-spin pi-spinner" style="font-size: 1.2rem; margin-left: 10px; color: #C2D63F;"></i>
									
															<span style="float: right;">
																<i class="pi pi-search" style="margin:4px 4px 0 0"></i>
																<input type="text" pInputText size="50" placeholder="Search This Page"
																	(input)="pt2.filterGlobal($event.target.value, 'contains')" style="width:auto" style="background-color: rgb(28 36 51); border:0px">
															</span>
\
															</div>
														</ng-template-->
														<ng-template pTemplate="header" let-columns let-i>
												
															<tr style="font-size:12px">
															<th *ngFor="let col of columns|slice:0:6" [ngStyle]="{'width': col.width}" [pSortableColumn]="col.field" >
																<span>{{col.header}}</span>
																<span *ngIf="col.field!='CHECKBOX'"><p-sortIcon  [field]="col.field"></p-sortIcon></span>
															</th>
															
															</tr>
									
															<tr>
															<th *ngFor="let col of columns|slice:0:6" style="padding:2px;border: 2px solid rgb(9 17 33); background-color: rgb(28 36 51)">
															<span *ngIf="col.field!='CHECKBOX'">
															<input  pInputText type="text"
																(input)="pt2.filter($event.target.value, col.searchfield, col.filterMatchMode);consoleLog($event.target.value);consoleLog(col.searchfield);consoleLog(col.filterMatchMode)"
																style="margin:0 2px; font-size:12px; width:98%; background-color: rgb(9 17 33); border: 0px">
															</span>
															</th>
																</tr>
														</ng-template>
														<ng-template pTemplate="body" let-user let-j="rowIndex" let-columns="columns">
															<tr style="font-size:12px;">
															<td  style="padding:4px; font-size:12px; border: 2px solid rgb(9 17 33); background-color: rgb(28 36 51); border-collapse: collapse;"*ngFor="let col of columns let i = index" [ngStyle]="{'width': col.width}">
																<!--span *ngIf="col.field!='ADDRESS1'&&col.field!='ORDER_NUM'&&col.field!='CHECKBOX'"
																>{{user[col.field]}}{{j}}
																</span-->
																<span *ngIf="col.field!='ADDRESS1'&&col.field!='ORDER_NUM'&&col.field!='CHECKBOX'"
																>{{user[col.field]}}
																</span>
																<span *ngIf="col.field=='ADDRESS1'"
																>{{user[col.field]}}, {{user.CITY}}
															</span>
															<span *ngIf="col.field=='ORDER_NUM'" style="color:rgb(228, 238, 138)">{{user[col.field]}}</span>
															<span *ngIf="col.field=='CHECKBOX'">                        <input
																type="checkbox"
																id="erisDataCheckBox{{j}}"
																(change)="erisDataChange(user, j)"
																/></span>
															</td>
															</tr>
														</ng-template>
														</p-table>
														
														<button title="Close" class="btn btn-outline-dark btn-sm pt-0 pb-0 pl-1 pr-1 ml-1" 
																style="float: right; color: black; background-color: #C2D63F; border-color:black; margin-bottom: 10px; margin-top: 10px" 
																(click)='op1.hide()'>Close</button>
														<button title="Add Order" class="btn btn-outline-dark btn-sm pt-0 pb-0 pl-1 pr-1 ml-1" 
																style="float: right; color: black; background-color: #C2D63F; border-color:black; margin-bottom: 10px; margin-top: 10px"
																(click)='addOrder1(rowData);op1.hide()'>Add ERIS Data</button>
														<i *ngIf="erisDataLoading" class="pi pi-spin pi-spinner" 
																style="float:right; font-size: 1.2rem; margin-left: 10px; margin-bottom: 10px; margin-top: 10px; color: #C2D63F;"></i>
												
												</ng-template>
												
												
											</p-overlayPanel>
											<p-overlayPanel #op2 [appendTo]="'body'" [style]="{'z-index':'9999999999999999', 'max-width':'500px'}" [dismissable]="false" [showCloseIcon]="false">
												<ng-template pTemplate>
													<div class="col-md-12">
														<label class=col-md-4 style="font-weight:normal;margin-top: 10px;">
														Username:
														</label><input class="col-md-5" style="padding:0px; background-color: rgb(28 36 51)" type="text" [(ngModel)]="ERIS_USERNAME">
													</div>
													<div class="col-md-12">

														<label style="font-weight:normal" class=col-md-4>
														Password:
														</label>
														<input class="col-md-5" type="password" style="padding:0px; background-color: rgb(28 36 51);" [(ngModel)]="ERIS_PASSWORD">
														<button class="btn btn-outline-dark btn-sm pt-0 pb-0 pl-1 pr-1 ml-1" style="float: right; color: black; background-color: #C2D63F; border-color:black; margin-bottom: 10px; margin-top: 10px"(click)="verifyEris($event, op2);">Verify ERIS Account</button>
														<button title="Close" class="btn btn-outline-dark btn-sm pt-0 pb-0 pl-1 pr-1 ml-1" style="float: right; color: black; background-color: #C2D63F; border-color:black; margin-bottom: 10px; margin-top: 10px" (click)='op2.hide()'>Close</button>
														<!--span>
															<i *ngIf="verifyErisLoading" class="pi pi-spin pi-spinner" style="font-size: 1.2rem; margin-left: 10px; color: #C2D63F; float: right"></i>
														</span-->

													</div>
													<div class="col-md-12" *ngIf="incorrect" style="color:red">
														Incorrect ERIS Login Information
													</div>

												</ng-template>
											</p-overlayPanel>
												<!--p-overlayPanel [styleClass]="'fixedoverlay'" #op1 
													[appendTo]="'body'">
													<ng-template pTemplate>
														<input style="min-width:150px" class="tableInput"
															[(ngModel)]="rowData.ORDER_NUM" type='text'>
														<button type="button"
															class="btn btn-outline-dark btn-sm pt-0 pb-0 pl-1 pr-1 ml-1"
															title="Add Order" (click)='addOrder(rowData,$event)'><i
																class="fas fa-check erisIconColor"></i></button>

													</ng-template>
												</p-overlayPanel-->
											<ng-container
												*ngIf="rowData.ORDER_NUM==''">
												
												<!-- <a href="http://testorder.erisinfo.com" target=_blank
													class="btn btn-outline-dark btn-sm pt-0 pb-0 pl-1 pr-1 ml-1 erisGreen"
													title="Order ERIS Data"><span
														style="font-weight:bold;">E</span></a> -->

												<a [href]="erisOrderURL" target=_blank
														class="btn btn-outline-dark btn-sm pt-0 pb-0 pl-1 pr-1 ml-1 erisGreen"
														title="Order ERIS Data"><span
															style="font-weight:bold;">E</span></a>
											</ng-container>

										</ng-container>
									</span>
								</span>
							</td>
						</tr>
					</ng-template>
				</p-table>
				</div>
			</div>
			<app-panel [header]="'Profile Management'" [opened]="showLogo" [align]="'right'" [fixed]="[-10, 54]"
				(didClosed)="showLogo = null">
				
				<ng-container name="body">
					
					<app-logo *ngIf="userInfo" class="w-100 h-100" [logoInfo]="logoInfo" [userInfo]='userInfo'
						(editReport)="onEditReport($event)" (logOut)='logOut()'></app-logo>
				</ng-container>
			</app-panel>
		</div>
	</section>
	<div style="visibility:hidden">
		<app-pdfdata [content]='sharecontents' [appe]="shareappendices" [rptInfo]="sharereportInfo" [front]="sharefrontpages" [pop]='sharePOP'
		  [pdfgroup]="sharepdfs" [slot]="allRptSlots" [rdata]="r" [toPrint]="sharepdfType" [size]="sharelpagesize" (spinToggle)="pdfSpin($event)" (errorInfo)="showErrMsg($event)" (okmsg)="endPdf($event)" (delivermsg)="deliverInfo($event)"></app-pdfdata>
	  </div>	
</div>

	<!-- FOOTER: -->
	<app-footer></app-footer>

	<div id="replaceModal" class="modal fade" tabindex="-1" role="dialog" aria-labelledby="..." aria-hidden="true">
		<div class="modal-dialog modal-md modal-dialog-centered ">
			<div class="modal-content">
				<!-- Modal Header -->
				<div class="modal-header">
					<h6 id="" class="modal-title">Search & Replace Portfolio</h6>
					<button type="button" class="close" data-dismiss="modal">&times;</button>
				</div>

				<!-- Modal body -->
				<div class="modal-body">
					<div class="commentinput" style="font-size:12px">
						<label class="col-md-4" style="font-weight:bold">Original Word : </label>
						<input class="col-md-7" type="text" style="margin:10px; " />
						<br>
						<label class="col-md-4" style="font-weight:bold">Replace Word: </label>
						<input class="col-md-7" type="text" style="margin:10px;" />
						<br>
						<label class="col-md-4" style="font-weight:bold">Field : </label>
						<input class="col-md-7" type="text" style="margin:10px;" />
						<br>
						<button class="col-md-11 btn btn-outline-success btn-sm btn-block m-3 p-1"
							(click)="searchPortfolio($event)">Replace</button>
					</div>

				</div>
			</div>
		</div>
	</div>
	<div class="modal fade" id="deleteModal" tabindex="-1" role="dialog"
	aria-labelledby="exampleModalLabel" aria-hidden="true">
		<div class="modal-dialog modal-dialog-centered " role="document">
			<div class="modal-content">
				<div class="modal-header">
					<h5 class="modal-title" id="exampleModalLabel">Are you sure you want to
						delete the project?</h5>
					<button type="button" (click)="dismissConfirm2($event);" class="close"
						aria-label="Close">
						<span aria-hidden="true">&times;</span>
					</button>
				</div>
				<div class="modal-body ">
					<button type="button" class="btn btn-secondary"
						(click)="dismissConfirm2($event);">Go Back</button>
					<button style="float:right" type="button" class="btn btn-primary"
						(click)="dismissConfirm2($event); deleteProjectModal();">Delete</button>
				</div>
			</div>
		</div>
	</div>
	<div class="modal fade" id="deleteReportModal" tabindex="-1" role="dialog"
	aria-labelledby="exampleModalLabel" aria-hidden="true">
		<div class="modal-dialog modal-dialog-centered " role="document">
			<div class="modal-content">
				<div class="modal-header">
					<h5 class="modal-title" id="exampleModalLabel">Are you sure you want to
						delete the report?</h5>
					<button type="button" (click)="dismissConfirm3($event);" class="close"
						aria-label="Close">
						<span aria-hidden="true">&times;</span>
					</button>
				</div>
				<div class="modal-body ">
					<button type="button" class="btn btn-secondary"
						(click)="dismissConfirm3($event);">Go Back</button>
					<button style="float:right" type="button" class="btn btn-primary"
						(click)="dismissConfirm3($event); deleteRpt(reportToDelete);">Delete</button>
				</div>
			</div>
		</div>
	</div>

	<!-- Add or Edit Project/Report Window: -->
	<div #reportsModal id="reportsModal" class="modal fade" tabindex="-1" role="dialog" data-keyboard="false" data-backdrop="false">
		<div class="modal-dialog modal-dialog-centered" style="max-width:90%">
			<div class="modal-content" style="background-color:#cDcDcD">
				<!-- Modal Header -->
				<div class="modal-header">
					<h6 *ngIf="save" id="" class="modal-title">Start New Project</h6>
					<h6 *ngIf="!save" id="" class="modal-title">Add/Edit Project</h6>
					<!-- <button type="button" class="close" data-dismiss="modal">&times;</button> -->
					<button type="button" class="close" data-toggle="modal" data-target="#closeReportsModal">&times;</button>

					<div class="modal fade" id="closeReportsModal" role="dialog"
						aria-labelledby="exampleModalLabel" >
						<div class="modal-dialog modal-dialog-centered " role="document">
							<div class="modal-content">
								<div class="modal-header">
									<h5 class="modal-title">Do you want to save before exiting?</h5>
									<button type="button" (click)="dismissCloseModal($event, false);" class="close"
										aria-label="Close">
										<span >&times;</span>
									</button>
								</div>
								<div class="modal-body">
									<button style="float:right" type="button" class="btn btn-secondary"
										(click)="dismissCloseModal($event, true);">Cancel</button>
									<button type="button" class="btn btn-primary"
										(click)="newReportValid=false;newReport2();dismissCloseModal($event, false);"
										[disabled]="!newReportValid || (save && !newReportPermission) || (!save && !editProjectPermission)">Save</button>
								</div>
							</div>
						</div>
					</div>
				</div>

				<!-- Modal body -->
				<div class="modal-body scrollmodal">
					<div class="col-md-12 text-center m-0 p-0">
						<a href="javascript:void(0)" type='button' title="Expand/Collapse"
							class="collapsible2 pl-0 pr-3 pt-0 pb-0 m-0" (click)='proToggle($event)'></a>
					</div>
					<div class="row accordion" id="accordionExample" >
						<form  class="reportContainer col-md-6" style="font-size:12px; width:100%" [formGroup]="form">
							<div class="container">
								<div class="card">
									<div class="card-header p-2">
										<a class="card-link" data-toggle="collapse" href="#collapse1"
											(click)="rotate($event)">
											<span class="card-title"><b>Project Info</b></span><a type="button"
												class="collapsible1 active"
												style="float:right;background-color:#bbbbbb;">
												<!-- need class.active here -->
											</a>
										</a>

										<div class="float-md-right mr-5">
											<span style="margin-right:10px;">
												<a class="card-title card-link"> Private Project: ({{curProject.PRIVATE_FLAG? 'On': 'Off'}})</a>
											</span>
											<mat-slide-toggle [checked]="curProject.PRIVATE_FLAG" (click)="$event.preventDefault(); toggleProjectPrivateFlag()">
											</mat-slide-toggle>
										</div>
									</div>
									<div id="collapse1" class="collapse show" data-parent="#accordionExample">
										<div class="card-body">
											<div class="row">
												<div class="col-md-6">
													<label class="col-md-12 inputLabel m-0 p-0">Project Number:</label>
													<input class="rptInfo col-md-12" type="text"
														placeholder="Project Number" [(ngModel)]="curProject.PROJECT_NUMBER"
														[ngModelOptions]="{standalone: true}"
														(change)="setDisplaySections(1); show4(curProject.PROJECT_NUMBER)">
												</div>
												<div class="col-md-6">
													<label class="col-md-12 inputLabel m-0 p-0">Property Name:</label>
													<input class="rptInfo col-md-12" type="text"
														placeholder="Property Name" [(ngModel)]="curProject.PROJECT_NAME"
														[ngModelOptions]="{standalone: true}"
														(change)="setDisplaySections(1);">
												</div>
											</div>
											<br>
											<div class="row">
												<!-- <div class="col-md-6">
													<label class=" inputLabel m-0 p-0">Eris Order
														Number:</label>
													<br>
													<input type="text" class=" rptInfo" placeholder="Eris Order Number"
														[(ngModel)]="curProject.erisOrder"
														[ngModelOptions]="{standalone: true}"
														
														(change)="setDisplaySections(1);">
														
														<div style="float:right">
												
													<a class="btn btn-dark btn-sm pt-0 mt-1 pb-0 pl-2 pr-2"
														title="Order Eris Data" href="http://testorder.erisinfo.com"
														target=_blank>E</a>
														</div>
												</div> -->
												<div class="col-md-4">
													<label class=" inputLabel m-0 p-0">ERIS Order
														Number:</label>
													<br>
													<!-- <input type="text" class="rptInfo  col-md-12"
														placeholder="ERIS Order Number"
														[(ngModel)]="curProject.erisOrder"
														[ngModelOptions]="{standalone: true}"
														(change)="setDisplaySections(1);"> -->
													<select class="rptInfo  col-md-12"
														[ngModelOptions]="{standalone: true}"
														[(ngModel)]="curProject.erisOrder" 
														(change)="setDisplaySections(1);"
														(click)="checkErisData()">
														<option [ngValue]="" [selected]="curProject.erisOrder === ''"></option>
														<option *ngFor="let order of erisData"
															[ngValue]='order.ORDER_NUM'
															[selected]="curProject.erisOrder === order.ORDER_NUM">
															{{order.ORDER_NUM}}
														</option>
													</select>
												</div>
												<div class="col-md-2">
													<div style="float:right">
														<br>
														<!-- <a class="btn btn-dark btn-sm pt-0 mt-1 pb-0 pl-2 pr-2"
															title="Order ERIS Data" href="http://testorder.erisinfo.com"
															target=_blank>E</a> -->
														<a class="btn btn-dark btn-sm pt-0 mt-1 pb-0 pl-2 pr-2"
															title="Order ERIS Data" [href]="erisOrderURL"
															target=_blank>E</a>
													</div>
												</div>
												<!-- <div class="col-md-4">
													<p class="col-md-12"></p>
													<a class="btn btn-dark btn-sm pt-0 mt-1 pb-0 pl-2 pr-2"
														title="Order Eris Data" href="http://testorder.erisinfo.com"
														target=_blank>E</a>
												</div> -->
												<div class="col-md-6">
													<label class="inputLabel m-0 p-0">Portfolio Name:</label>
													<br>
													<!-- <input type="text" class="rptInfo  col-md-12"
													placeholder=""
													[(ngModel)]="newReportPortfolio"
													[ngModelOptions]="{standalone: true}"
													(change)="setDisplaySections(1);"> -->
													<select *ngIf="selectExisting" class="rptInfo  col-md-6" [ngModelOptions]="{standalone: true}" [(ngModel)]="curProject.PORTFOLIO_ID" 
														(change)="display(curProject.PORTFOLIO_ID)" (click)="getAllPortfolios1()">
														<option [ngValue]="null" disabled selected>Select from Existing</option>
														<option [ngValue]="null"></option>
														<option  *ngFor="let portfolio of portfolioList; let i=index" [ngValue]='portfolio.PORTFOLIO_ID'>
								
															{{portfolio.PORTFOLIO_NAME}}
															
														</option>
													</select>
													<input *ngIf="!selectExisting" type="text" class="rptInfo col-md-6"
														placeholder="New Portfolio Name"
														[(ngModel)]="newReportPortfolio "
														[ngModelOptions]="{standalone: true}"
														(change)="setDisplaySections(1);">

													<a class="btn btn-dark btn-sm pt-0 pb-0 pl-2 pr-2 offset-md-1 col-md-5"
													(click)="togglePortfolio()">{{selectExisting? 'Create Portfolio' : 'Select Portfolio'}}</a>
												<!-- <br>
												<a 	(click)="saveAnswers=false;"class="btn btn-dark btn-sm pt-0 mt-1 pb-0 pl-2 pr-2" data-toggle="modal" data-target="#PCA" >PCA</a> -->
												<!-- <p class="col-md-12"></p>
												<a class="btn btn-dark btn-sm pt-0 mt-1 pb-0 pl-2 pr-2"
													title="Order Eris Data" href="http://testorder.erisinfo.com"
													target=_blank>E</a> -->
												</div>
											</div>
											<br>
											<label class="col-md-12 inputLabel m-0 p-0">Project Property:</label>
											<div class="row">
												<div class="col-md-6">
													<input type="text" autocomplete="chrome-off"
														class="rptInfo col-md-12" placeholder="Address 1"
														[(ngModel)]="street1" (change)="setDisplaySections(1);"
														[ngModelOptions]="{standalone: true}">
												</div>
												<div class="col-md-6">
													<input type="text" autocomplete="chrome-off"
														class="rptInfo col-md-12" placeholder="Address 2"
														[(ngModel)]="street2" [ngModelOptions]="{standalone: true}"
														(change)="setDisplaySections(1);">
												</div>
											</div>
											<br>
											<div class="row">
												<div class="col-md-4">
													<input type="text" autocomplete="chrome-off"
														class="rptInfo  col-md-12" placeholder="City" [(ngModel)]="city"
														[ngModelOptions]="{standalone: true}"
														(change)="setDisplaySections(1);">
												</div>
												<div class="col-md-2">
													<input type="text" autocomplete="chrome-off"
														class="rptInfo  col-md-12" placeholder="State/Prov"
														[(ngModel)]="state" [ngModelOptions]="{standalone: true}"
														(change)="setDisplaySections(1);">
												</div>
												<div class="col-md-3">
													<input type="text" autocomplete="chrome-off"
														class="rptInfo  col-md-12" placeholder="Zip/Postal"
														[(ngModel)]="postCode" [ngModelOptions]="{standalone: true}"
														(change)="setDisplaySections(1);">
												</div>
												<div class="col-md-2">
													<input type="text" autocomplete="chrome-off"
														class="rptInfo  col-md-12" placeholder="Country"
														[(ngModel)]="country" [ngModelOptions]="{standalone: true}"
														(change)="setDisplaySections(1);">
												</div>
												<div class="col-md-1">
													<div style="float:right">
														<a href="javascript:void(0)" title="Locate"
															class="btn btn-dark btn-sm pt-0 pb-0 pl-1 pr-1"
															(click)='locate();'><i
																class="fas fa-search-location"></i></a>
														<span id="spinner1" class="fa fa-spinner fa-spin"
															style="font-size:24px; display:none"></span>
													</div>
												</div>
											</div>
											<br>
											<div class="row">
												<div class="col-md-4">
													<input type="text" class="rptInfo col-md-12" placeholder="Latitude"
														[(ngModel)]="lat" (change)="setDisplaySections(1);"
														[ngModelOptions]="{standalone: true}">
												</div>
												<div class="col-md-4">
													<input type="text" class="rptInfo col-md-12" placeholder="Longitude"
														[(ngModel)]="lng" (change)="setDisplaySections(1);"
														[ngModelOptions]="{standalone: true}">
												</div>
											</div>
										</div>
										<div class="container">
											<div class="card">
												<div class="card-header p-2">
													<a class="collapsed card-link" data-toggle="collapse"
														href="#inner-collapse3" (click)="rotate($event)">
														<span class="card-title">Property Specifics</span><a type="button" class="collapsible1"
															style="float:right;background-color:#bbbbbb"></a>
													</a>
												</div>
												<div id="inner-collapse3" class="collapse">
													<div class="card-body">
														<div class="row">
															<div *ngFor="let question of questionsInCard; let k=index" class="col-md-6">
																<!-- {{questionHeaders[k]}} : <input *ngIf="question!='PARCELS_CONTIGUOUS' && question!='YEARS_CONSTRUCTED'&& question!='YEARS_SUBSTANTIAL_RENOVATION'" (keypress)="numberOnly($event)" type="number"  [ngModelOptions]="{standalone: true}" [(ngModel)]="answers[question]" class="form-control validate rptInfo no-spinner"> -->
																{{questionHeaders[k]}} : <input  *ngIf="question!='PROPERTY_TYPE'" maxlength="100" type="text"  [ngModelOptions]="{standalone: true}" [(ngModel)]="answers[question]" class="form-control validate rptInfo no-spinner">
																<br *ngIf="question=='PROPERTY_TYPE'"  ><input type="text" maxlength="100" *ngIf="question=='PROPERTY_TYPE'" [ngModelOptions]="{standalone: true}" [(ngModel)]="answers[question]" class="validate rptInfo no-spinner" style="width:80%"><select class="rptInfo" style="width:30px" *ngIf="question=='PROPERTY_TYPE'" [ngModelOptions]="{standalone: true}"  [(ngModel)]="answers[question]">
																	<option *ngFor="let type of propertyTypes" [value]="type.PROPERTY_TYPE">{{type.PROPERTY_TYPE}}</option>
																	
																  </select>
															</div>
										
																
																	<div class=col-md-12>
																		Additional Property Specific Criteria: <br>
																		<textarea class="rptInfo col-md-12" [(ngModel)]="answers['ADDITIONAL_PROPERTY_INFORMATION']" [ngModelOptions]="{standalone: true}"></textarea>
																	</div>
														</div>
													</div>
												</div>
											</div>
										</div>
										<div class="container">
											<div class="card">
												<div class="card-header p-2">
													<a class="collapsed card-link" data-toggle="collapse"
														href="#inner-collapse1" (click)="rotate($event)">
														<span class="card-title">Additional Property /Location
															Info</span><a type="button" class="collapsible1"
															style="float:right;background-color:#bbbbbb"></a>
													</a>
												</div>
												<div id="inner-collapse1" class="collapse">
													<div class="card-body">
														<div class="row">
															<div class="col-md-4">
																<label class="col-md-12 inputLabel m-0 p-0">Property
																	County:</label>
																<input autocomplete="chrome-off"
																	class="rptInfo col-md-12" type="text"
																	placeholder="Property County"
																	[(ngModel)]="curProject.PROPERTY_COUNTY"
																	[ngModelOptions]="{standalone: true}"
																	(change)="setDisplaySections(2);">
															</div>
															<div class="col-md-4">
																<label class="col-md-12 inputLabel m-0 p-0">Flood Zone
																	(FEMA):</label>
																<input class="rptInfo col-md-12" type="text"
																	placeholder="Flood Zone"
																	[(ngModel)]="curProject.FLOOD_ZONE"
																	[ngModelOptions]="{standalone: true}"
																	(change)="setDisplaySections(2);">
															</div>
															<div class="col-md-4">
																<label class="inputLabel m-0 p-0">Parcel ID:</label>
																<br>
																<input type="text" class="rptInfo  col-md-12"
																	placeholder=""
																	[(ngModel)]="parcelID"
																	[ngModelOptions]="{standalone: true}"
																	(change)="setDisplaySections(2);">
															</div>
														</div>
														<br>
														<div class="row">
															<div class="col-md-4">
																<label class="col-md-12 inputLabel m-0 p-0">MSA (Metro
																	Statistisic Area):</label>
																<input type="text" class="col-md-12 rptInfo"
																	placeholder="MSA" [(ngModel)]="curProject.MSA"
																	[ngModelOptions]="{standalone: true}"
																	(change)="setDisplaySections(2);">
															</div>
															<div class="col-md-4">
																<label class="col-md-12 inputLabel m-0 p-0">Peak Ground
																	Acceleration(PGA):</label>
																<input type="text" class="col-md-12 rptInfo"
																	placeholder="PGA" [(ngModel)]="curProject.PGA"
																	[ngModelOptions]="{standalone: true}"
																	(change)="setDisplaySections(2);">
															</div>
															<div class="col-md-4">
																<label class="col-md-12 inputLabel m-0 p-0">Zoning
																	Designation:</label>
																<input type="text" class="col-md-12 rptInfo"
																	placeholder="Zoning" [(ngModel)]="curProject.ZONING"
																	[ngModelOptions]="{standalone: true}"
																	(change)="setDisplaySections(2);">
															</div>
														</div>
													</div>
												</div>
											</div>
										</div>
										<div class="container">
											<div class="card">
												<div class="card-header p-2">
													<a class="collapsed card-link" data-toggle="collapse"
														href="#inner-collapse2" (click)="rotate($event)">
														<span class="card-title">Additional Info</span><a type="button"
															class="collapsible1"
															style="float:right;background-color:#bbbbbb"></a>
													</a>
												</div>
												<div id="inner-collapse2" class="collapse">
													<div class="card-body">
														<div class="row">
															<div class="col-md-4">
																<label class="col-md-12 inputLabel m-0 p-0">Transaction
																	type: </label>
																<select class="col-md-12 rptInfo"
																	[(ngModel)]="curRptPara.TRANSACTION_TYPE"
																	[ngModelOptions]="{standalone: true}"
																	(change)="setDisplaySections(3);">
																	<option></option>
																	<ng-container
																		*ngFor="let t of transactions; let i=index">
																		<option [value]="i"
																			[selected]='i===curRptPara.TRANSACTION_TYPE'>
																			{{t.CODE_VALUE}}</option>
																	</ng-container>
																</select>
															</div>
															<div class="col-md-4">
																<label class="col-md-12 inputLabel m-0 p-0">Protocol:
																</label>
																<select class="col-md-12 rptInfo"
																	[(ngModel)]="curRptPara.PROTOCOLS"
																	[ngModelOptions]="{standalone: true}"
																	(change)="setDisplaySections(3);">
																	<option></option>
																	<ng-container
																		*ngFor="let protocol of protocols; let i=index">
																		<option [value]="i"
																			[selected]='i===curRptPara.PROTOCOLS'>
																			{{protocol.CODE_VALUE}}</option>
																	</ng-container>
																</select>
															</div>
															<div class="col-md-4 p-0">
																<label class="col-md-12 inputLabel m-0 p-0">Scope of
																	Work: </label>
																<!--<input #rptFile class="col-md-9 rptInfo mr-1" type="file"  style="display:none" (change)="getName()"/>
								<label class="col-md-9 rptInfo mr-1" (click)='selectFile()'>{{curRptPara.name}}</label>
								<button type="button" class="btn btn-outline-dark btn-sm mb-1" [disabled]="curRptPara.name=='Choose File'"(click)='uploadFile()'><i class="fas fa-file-upload"></i></button>-->
																<div class="input-group col-md-12">
																	<input #rptFile class="col-md-9 rptInfo mr-1"
																		type="file" style="display:none"
																		(change)="getName(); setDisplaySections(3);" accept=".jpg,.png,.jpeg,.xlsx,.csv,.txt,.docx,.doc, .pdf, .ppt,.pptx,.kml,.dwg"/>
																	<label class="form-control "
																		style="margin-left:0; height:24px; padding:4px; font-size:.9em; color:#000;border-color:#999"
																		(click)='selectFile()'
																		aria-label="Recipient's username"
																		aria-describedby="basic-addon2">{{curRptPara.name}}</label>
																	<div class="input-group-append">
																		<button
																			class="btn btn-dark btn-sm pt-0 pb-0 pl-2 pr-2"
																			type="button"
																			[disabled]="curRptPara.name=='Choose File'"
																			(click)='uploadFile()' ><i
																				class="fas fa-file-upload"></i></button>
																	</div>
																	<span id="spinner" class="fa fa-spinner fa-spin"
																		style="font-size:20px; display:none"></span>
																	<span id="inputWarn" class="fas fa-exclamation"
																		style="margin-left:4px;font-size:16px; display:none; color:red"></span>
																	<span id="inputSuccess" class="fas fa-check"
																		style="margin-left:4px;font-size:16px; display:none; color:green"></span>
																</div>
															</div>
														</div>
													</div>
												</div>

											</div>
										</div>
										<div class="container">
											<div class="card">
												<div class="card-header p-2">
													<a class="collapsed card-link" data-toggle="collapse"
														href="#inner-collapse6" (click)="rotate($event)">
														<span class="card-title">Project Cost</span><a type="button"
															class="collapsible1"
															style="float:right;background-color:#bbbbbb"></a>
													</a>
												</div>
												<div id="inner-collapse6" class="collapse">
													<div class="card-body">
														<div class="row">
															<div class="col-md-4">
																<label class="col-md-12 inputLabel m-0 p-0">Project Cost: 																	
																</label>
																<input autocomplete="chrome-off"
																	class="rptInfo col-md-12" type="text"
																	placeholder="Project Cost"
																	[(ngModel)]="curProject.CHARGE_AMOUNT"
																	[ngModelOptions]="{standalone: true}"
																	(change)="setDisplaySections(9);">
															</div>
															<div class="col-md-4">
																<label class="col-md-12 inputLabel m-0 p-0">Project Expense:
																</label>
																<input autocomplete="chrome-off"
																	class="rptInfo col-md-12" type="text"
																	placeholder="Project Expense"
																	[(ngModel)]="curProject.EXPENSE_AMOUNT"
																	[ngModelOptions]="{standalone: true}"
																	(change)="setDisplaySections(9);">
															</div>
															<div class="col-md-4">
																<label class="col-md-12 inputLabel m-0 p-0">Project Total: 
																</label>
																<input autocomplete="chrome-off"
																	class="rptInfo col-md-12" type="text"
																	placeholder="Project Total"
																	[(ngModel)]="curProject.TOTAL_AMOUNT"
																	[ngModelOptions]="{standalone: true}"
																	(change)="setDisplaySections(9);">
															</div>
														</div>
													</div>
												</div>

											</div>
										</div>

									</div>


									<div class="card">
										<div class="card-header p-2">
											<a class="collapsed card-link" data-toggle="collapse" href="#collapse2"
												(click)="rotate($event)">
												<span class="card-title"><b>Project Dates</b></span><a type="button"
													class="collapsible1"
													style="float:right;background-color:#bbbbbb"></a>
											</a>
										</div>
										<div id="collapse2" class="collapse" data-parent="#accordionExample">
											<div class="card-body">
												<div class="row">
													<i> IMPORTANT MESSAGE: Dates entered here are for initial project set-up only and will be reflected across all report types in the project. Any changes in dates for individual reports or the project as a whole should be made on the dashboard once a project has been created.</i>
													<div class="col-md-5">
														<label class="col-md-12 inputLabel m-0 p-0">Inspection
															Date:</label>
														<p-calendar 

														dateFormat="M dd, yy" class="col-md-12"
															styleClass="calendarInput" inputStyleClass="calendarInput"
															[(ngModel)]="date1" [ngModelOptions]="{standalone: true}"
															(onSelect)="setDisplaySections(4);date1Text=getFormattedDate(date1)"></p-calendar>
													</div>
													<div class="col-md-5">
														<label class="col-md-12 inputLabel m-0 p-0">Writer Due
															Date:</label>
														<p-calendar 

														dateFormat="M dd, yy" class="col-md-12"
															styleClass="calendarInput" inputStyleClass="calendarInput"
															[(ngModel)]="date3" [ngModelOptions]="{standalone: true}"
															(onSelect)="setDisplaySections(4);date3Text=getFormattedDate(date3)"></p-calendar>
													</div>		
													
												</div>
												<br>
												<div class="row">
													<!--<div class="col-md-4">
						<label  class="col-md-12 inputLabel m-0 p-0">Inspection Time:</label>
						<p-calendar class="col-md-12" styleClass="calendarInput" inputStyleClass="calendarInput" [timeOnly]="true" [(ngModel)]="date4" (onSelect)="setDisplaySections(4);"></p-calendar>
						</div>-->					<div class="col-md-5">
														<label class="col-md-12 inputLabel m-0 p-0">Reviewer Due
															Date:</label>
														<p-calendar 
														
														dateFormat="M dd, yy" class="col-md-12"
															styleClass="calendarInput" inputStyleClass="calendarInput"
															[(ngModel)]="date2" [ngModelOptions]="{standalone: true}"
															(onSelect)="setDisplaySections(4);date2Text=getFormattedDate(date1)"></p-calendar>
													</div>
													<div class="col-md-5">
														<label class="col-md-12 inputLabel m-0 p-0">Report Due
															Date:</label>
														<p-calendar 
														
														dateFormat="M dd, yy" class="col-md-12"
															styleClass="calendarInput" inputStyleClass="calendarInput"
															[(ngModel)]="date5" [ngModelOptions]="{standalone: true}"
															(onSelect)="setDisplaySections(4);date5Text=getFormattedDate(date5)" ></p-calendar>
													</div>
													<!--<div class="col-md-4">
														<label class="col-md-12 inputLabel m-0 p-0">Revised Due
															Date:</label>
														<p-calendar 
														
														dateFormat="M dd, yy" class="col-md-12"
															styleClass="calendarInput" inputStyleClass="calendarInput"
															[(ngModel)]="date6" [ngModelOptions]="{standalone: true}"
															(onSelect)="setDisplaySections(4);date6Text=getFormattedDate(date6)"></p-calendar>
													</div>
													<div class="col-md-4">
														<label class="col-md-12 inputLabel m-0 p-0">Project Turn
															Time:</label>
														<input style="margin-left: 1rem !important;" dateFormat="M dd, yy"
															type="text" class="col-md-12 rptInfo"
															placeholder="Specify Time" [(ngModel)]="date7"
															[ngModelOptions]="{standalone: true}"
															(change)="setDisplaySections(4);">
													</div>-->
												</div>
												<!-- <br>
												<div class="row"> -->
												<!-- <div class="col-md-12">
														<label class="col-md-12 inputLabel m-0 p-0">Project Turn
															Time:</label>
														<input dateFormat="dd-M-y" type="text" class="col-md-12 rptInfo"
															placeholder="Specify Time" [(ngModel)]="date7" [ngModelOptions]="{standalone: true}"
															(change)="setDisplaySections(4);">
													</div> -->
												<!-- </div> -->
											</div>
										</div>
									</div>

									<div class="card">
										<div class="card-header p-2">
											<a class="collapsed card-link" data-toggle="collapse" href="#collapse3"
												(click)="rotate($event)">
												<span class="card-title"><b>Site Contact Info</b></span><a type="button"
													class="collapsible1"
													style="float:right;background-color:#bbbbbb"></a>
											</a>
										</div>
										<div id="collapse3" class="collapse" data-parent="#accordionExample">
											<div class="card-body">
												<div class="row">
													<div class="col-md-6">
														<label class="col-md-12 inputLabel p-0">Site Contact
															Name:</label>
														<input class="rptInfo col-md-10" type="text" placeholder="Name"
															[(ngModel)]="curProject.SITE_CONTACT_NAME"
															[ngModelOptions]="{standalone: true}"
															(change)="setDisplaySections(5);">

													</div>
													<div class="col-md-6">
														<label class="col-md-12 inputLabel p-0">Site Contact
															Title:</label>
														<input class="rptInfo col-md-10" type="text"
															placeholder="Title"
															[(ngModel)]="curProject.SITE_CONTACT_RELATIONSHIP"
															[ngModelOptions]="{standalone: true}"
															(change)="setDisplaySections(5);">

													</div>
													<div class="col-md-6">
														<label class="col-md-12 inputLabel p-0">Site Contact
															Phone: 
															
															<!-- remove phone number check..
															<span
																*ngIf="!form.controls.siteContactPhone.pristine && !form.controls.siteContactPhone.valid"
																style="margin:0px; line-height:1; font-size:10px;color:#ab4841">
																Invalid Phone Number </span> -->
															
															</label>

														<!-- <input class="rptInfo col-md-10" type="text" placeholder="Phone"
															[(ngModel)]="curProject.SITE_CONTACT_PHONE" [ngModelOptions]="{standalone: true}"
															(change)="setDisplaySections(5);"> -->
														<!-- [class.invalid]="!form.controls.siteContactPhone.pristine && !form.controls.siteContactPhone.valid" -->
														<input type="text"
															formControlName="siteContactPhone" placeholder="Phone"
															class="form-control rptInfo col-md-10"
															(change)="setDisplaySections(5);">

													</div>
													<div class="col-md-6">
														<label class="col-md-12 inputLabel  p-0">Site Contact
															Email: 
															
															<!-- remove email check......
															<span
																*ngIf="!form.controls.siteemailAddress.pristine && !form.controls.siteemailAddress.valid"
																style="margin:0px; line-height:1; font-size:10px;color:#ab4841">
																Invalid Email Address</span> -->
															
															</label>
														<!-- <input  class="rptInfo col-md-10"  type="text" placeholder="Email" [(ngModel)]="curProject.SITE_CONTACT_EMAIL" (change)="setDisplaySections(5);"> -->
														<!-- [class.invalid]="!form.controls.siteemailAddress.pristine && !form.controls.siteemailAddress.valid" -->
														<input type="email"
															formControlName="siteemailAddress" placeholder="Email"
															class="form-control rptInfo col-md-10"
															(change)="setDisplaySections(5);">
													</div>

													<div class="col-md-6 mt-3">
														<label class="col-md-12 inputLabel  p-0">Additional Site Contact
															Name:</label>
														<input class="rptInfo col-md-10" type="text" placeholder="Name"
															[(ngModel)]="curProject.ADD_SITE_CONTACT_NAME"
															[ngModelOptions]="{standalone: true}"
															(change)="setDisplaySections(5);">


													</div>
													<div class="col-md-6 mt-3">
														<label class="col-md-12 inputLabel  p-0">Additional Site Contact
															Title:</label>
														<input class="rptInfo col-md-10" type="text"
															placeholder="Title"
															[(ngModel)]="curProject.ADD_SITE_CONTACT_RELATIONSHIP"
															[ngModelOptions]="{standalone: true}"
															(change)="setDisplaySections(5);">

													</div>
													<div class="col-md-6 mt-3">
														<label class="col-md-12 inputLabel  p-0">Additional Site Contact
															Phone: 
															
															<!-- remove phone number check..
															<span
																*ngIf="!form.controls.additionalsiteContactPhone.pristine && !form.controls.additionalsiteContactPhone.valid"
																style="margin:0px; line-height:1; font-size:10px;color:#ab4841">
																Invalid Phone Number </span> -->
															
															</label>

														<!-- <input class="rptInfo col-md-10" type="text" placeholder="Phone"
															[(ngModel)]="curProject.ADD_SITE_CONTACT_PHONE" [ngModelOptions]="{standalone: true}"
															(change)="setDisplaySections(5);"> -->
														<!-- [class.invalid]="!form.controls.additionalsiteContactPhone.pristine && !form.controls.additionalsiteContactPhone.valid" -->
														<input type="text"
															formControlName="additionalsiteContactPhone"
															placeholder="Phone" class="form-control rptInfo col-md-10"
															(change)="setDisplaySections(5);">

													</div>
													<div class="col-md-6 mt-3">
														<label class="col-md-12 inputLabel p-0">Additional Site Contact
															Email:
															
															<!-- remove email check......
															<span
																*ngIf="!form.controls.additionalsiteemailAddress.pristine && !form.controls.additionalsiteemailAddress.valid"
																style="margin:0px; line-height:1; font-size:10px;color:#ab4841">
																Invalid Email Address</span> -->
															
															</label>
														<!-- <input class="rptInfo col-md-10" type="text" placeholder="Email"
															[(ngModel)]="curProject.ADD_SITE_CONTACT_EMAIL" [ngModelOptions]="{standalone: true}"
															(change)="setDisplaySections(5);"> -->
														<!-- [class.invalid]="!form.controls.additionalsiteemailAddress.pristine && !form.controls.additionalsiteemailAddress.valid" -->
														<input type="email"
															formControlName="additionalsiteemailAddress"
															placeholder="Email" class="form-control rptInfo col-md-10"
															(change)="setDisplaySections(5);">
													</div>
													<div class="col-md-12 mt-3">
														<label class="col-md-12 inputLabel  p-0">Site Inspection
															Instructions:</label>
														<textarea class="rptInfo col-md-12" row='4'
															placeholder="Site Inspection Instructions"
															[(ngModel)]="curProject.SITE_INSPECTION_INSTRUCTIONS"
															[ngModelOptions]="{standalone: true}"
															(change)="setDisplaySections(5);">
						</textarea>
													</div>
												</div>
											</div>
										</div>
									</div>
									<div class="card">
										<div class="card-header p-2">
											<a class="card-link" data-toggle="collapse" href="#collapse4"
												(click)="rotate($event)">
												<span class="card-title"><b>Client Info</b></span><a type="button"
													class="collapsible1"
													style="float:right;background-color:#bbbbbb"></a>
											</a>
										</div>
										<div id="collapse4" class="collapse" data-parent="#accordionExample">
											<div class="card-body">
												<div class="row">

													<i>The "New/Edit Client" section only allows you to add a client to this project – it does not save it to your Client Address book. You should add them to the Client Address book in the Company Module for future use.</i>

													<div class="col-md-12">
														<label class="col-md-12 inputLabel m-0 p-0">Client: </label>
														<div class="container">
															<div class="row">

							
															<ng-select class="col-md-9 rptInfo" [clearable]="false"
																[items]="clientAddressBook" notFoundText="Not Found"
																bindLabel="CLIENT_COMPANY_NAME"
																[(ngModel)]="curSelectClient"
																[ngModelOptions]="{standalone: true}"
																(open)="getAllClientInfo(userId)"
																(change)="updateClientID(); fillClient(curSelectClient); setDisplaySections(6);"
																[searchFn]="customSearchFn2">

																<ng-template ng-label-tmp let-item="item">
																	<span *ngIf="item.CLIENT_COMPANY_NAME">{{item.CLIENT_COMPANY_NAME}}</span>
																	<span *ngIf="item.CLIENT_FULL_ADDRESS"> ({{item.CLIENT_CONTACT_NAME}} - {{item.CLIENT_FULL_ADDRESS}})</span>
																		
																</ng-template>
																<ng-template ng-option-tmp let-item="item"
																	let-search="searchTerm" let-index="index">
																	<span *ngIf="item.CLIENT_COMPANY_NAME">{{item.CLIENT_COMPANY_NAME}}</span>
																	<span *ngIf="item.CLIENT_FULL_ADDRESS"> ({{item.CLIENT_CONTACT_NAME}} - {{item.CLIENT_FULL_ADDRESS}})</span>
																	<span *ngIf="!item.CLIENT_COMPANY_NAME && !item.CLIENT_FULL_ADDRESS">&nbsp;</span>
																</ng-template>
															</ng-select>
															<!-- <a class="btn btn-dark btn-sm pt-0 pb-0 ml-2 pl-2 pr-2" (click)="newEditClient=true; show('inner-collapse4')">{{curSelectClient && curSelectClient.CLIENT_ID? 'Edit' :'Add' }} Client</a> -->
															<i class="far fa-edit" style="margin-left: 10px; font-size: 25px" (click)="newEditClient=true; show('inner-collapse4')"></i>
														</div>
														</div>
														<label class="col-md-12 inputLabel m-0 p-0">c/o Client: </label>
														<div class="container">
															<div class="row">

													
								
															<ng-select class="col-md-9 rptInfo" [clearable]="false"
																[items]="clientAddressBook" notFoundText="Not Found"
																bindLabel="CLIENT_COMPANY_NAME"
																[(ngModel)]="curCoSelectClient"
																[ngModelOptions]="{standalone: true}"
																(open)="getAllClientInfo(userId)"
																(change)="updateCoClientID(); fillCoClient(curCoSelectClient); setDisplaySections(6);"
																[searchFn]="customSearchFn2">
															
																<ng-template ng-label-tmp let-item="item">
																	<span *ngIf="item.CLIENT_COMPANY_NAME">{{item.CLIENT_COMPANY_NAME}}</span>
																	<span *ngIf="item.CLIENT_FULL_ADDRESS"> ({{item.CLIENT_CONTACT_NAME}} - {{item.CLIENT_FULL_ADDRESS}})</span>
																</ng-template>
																<ng-template ng-option-tmp let-item="item"
																	let-search="searchTerm" let-index="index">
																	<span *ngIf="item.CLIENT_COMPANY_NAME">{{item.CLIENT_COMPANY_NAME}}</span>
																	<span *ngIf="item.CLIENT_FULL_ADDRESS"> ({{item.CLIENT_CONTACT_NAME}} - {{item.CLIENT_FULL_ADDRESS}})</span>
																	<span *ngIf="!item.CLIENT_COMPANY_NAME && !item.CLIENT_FULL_ADDRESS">&nbsp;</span>
																</ng-template>
															</ng-select>
															<!-- <a class="btn btn-dark btn-sm pt-0 pb-0 ml-2 pl-2 pr-2" (click)="newEditCoClient=true; show('inner-collapse5')">{{curCoSelectClient && curCoSelectClient.CLIENT_ID? 'Edit' :'Add' }} Co Client</a> -->
															<i class="far fa-edit" style="margin-left: 10px; font-size: 25px" (click)="newEditCoClient=true; show('inner-collapse5')"></i>

														</div>
														</div>
														<!-- <label class='inputLabel'>Client Information:</label>
														<div class="md-form">
															<label  class='inputLabel'>Client Name: <span style="color:red" *ngIf="(!form.controls.companyName.pristine && !form.controls.companyName.valid)|| !form.value.companyName"> *</span></label>
															<input (change)="setDisplaySections(6);" [class.invalid]="!form.controls.companyName.pristine && !form.controls.companyName.valid"
															  formControlName="companyName" id="defaultForm-pass" class="form-control validate rptInfo">
														  </div>
											
														  <div class="md-form">
															<label class='inputLabel'>Contact Name:</label>
															<input class="form-control validate rptInfo" [(ngModel)]="contactName"
															  [ngModelOptions]="{standalone: true}">
											
														  </div>
														  <div class="md-form">
															
															  <label  class='inputLabel'>Client Address:</label>
															  <div class="container">
																<div class="row">
																  <input (change)="setDisplaySections(6);" class="form-control validate rptInfo col-md-12 mb-3" [(ngModel)]="clientAddress"
																  placeholder="Address1" [ngModelOptions]="{standalone: true}">
																<input (change)="setDisplaySections(6);" class="form-control validate rptInfo col-md-12 mb-3" [(ngModel)]="clientAddress2"
																  placeholder="Address2" [ngModelOptions]="{standalone: true}">
																<input (change)="setDisplaySections(6);" class="form-control validate rptInfo col-md-5" [(ngModel)]="clientCity" placeholder="City"
																  [ngModelOptions]="{standalone: true}">
																<input (change)="setDisplaySections(6);" class="form-control validate rptInfo offset-md-2 col-md-5 mb-3" [(ngModel)]="clientState"
																  placeholder="State/Province" [ngModelOptions]="{standalone: true}">
																<input (change)="setDisplaySections(6);" class="form-control validate rptInfo col-md-5" [(ngModel)]="clientZip"
																  placeholder="Zip/Postal" [ngModelOptions]="{standalone: true}">
																<input (change)="setDisplaySections(6);" class="form-control validate rptInfo offset-md-2 col-md-5 mb-3" [(ngModel)]="clientCounty"
																  placeholder="County" [ngModelOptions]="{standalone: true}">
																</div>
											
															  </div>
															   
														  </div>
														  <div class="md-form">
															<label  class='inputLabel'>Phone (Number Only): <span style="color:red" *ngIf="!form.controls.clientPhone.pristine && !form.controls.clientPhone.valid"> *</span></label>
															<input (change)="setDisplaySections(6);" (keypress)="numberOnly($event)" type="number" placeholder="Number Only" [class.invalid]="!form.controls.clientPhone.pristine && !form.controls.clientPhone.valid"
															  formControlName="clientPhone" id="defaultForm-pass" class="form-control validate rptInfo no-spinner">
														  </div>
														  <div class="md-form">
															<label class='inputLabel' >Email: <span style="color:red" *ngIf="!form.controls.clientEmail.pristine && !form.controls.clientEmail.valid"> *</span></label> 
															<input (change)="setDisplaySections(6);" [class.invalid]="!form.controls.clientEmail.pristine && !form.controls.clientEmail.valid"
															  formControlName="clientEmail" id="defaultForm-pass" class="form-control validate rptInfo"
															  (change)="show(form.value.clientEmail)">
											
														  </div> -->
													</div>
												</div>
												<div class="row">
													<div class="col-md-12 mt-3">
														<label class="col-md-12 inputLabel  p-0">Client Provided
															Information:</label>
														<textarea class="rptInfo col-md-12" row='4'
															placeholder="Client Provided Information"
															[(ngModel)]="curProject.CLIENT_PROVIDED_INFORMATION"
															[ngModelOptions]="{standalone: true}"
															(change)="setDisplaySections(6);">
														</textarea>
													</div>
												</div>
											</div>
											<div class="container">
												<div class="card">
													<div class="card-header p-2">
														<a class="collapsed card-link" data-toggle="collapse"
															href="#inner-collapse4" (click)="rotate($event)">
															<span class="card-title">Edit Client</span><a type="button" class="collapsible1"
																style="float:right;background-color:#bbbbbb"></a>
														</a>
													</div>
													<div id="inner-collapse4" class="collapse">
														<div class="card-body">
															<div class="row">
																<div class="col-md-12">
																<!-- <label class='inputLabel'>Client Information:</label> -->
																<div class="md-form">
																	<label  class='inputLabel'>Client Name: <span style="color:red" *ngIf="(!form.controls.companyName.pristine && !form.controls.companyName.valid)|| !form.value.companyName"> *</span></label>
																	<input (change)="setDisplaySections(6);" [class.invalid]="!form.controls.companyName.pristine && !form.controls.companyName.valid"
																	  formControlName="companyName" id="defaultForm-pass" class="form-control validate rptInfo">
																  </div>
													
																  <div class="md-form">
																	<label class='inputLabel'>Contact Name:</label>
																	<input class="form-control validate rptInfo" [(ngModel)]="contactName"
																	  [ngModelOptions]="{standalone: true}">
													
																  </div>
																  <div class="md-form">
																	<label class='inputLabel'>Contact Title:</label>
																	<input class="form-control validate rptInfo" [(ngModel)]="contactTitle"
																	  [ngModelOptions]="{standalone: true}">
													
																  </div>
																  <div class="md-form">
																	
																	  <label  class='inputLabel'>Client Address:</label>
																	  <div class="container">
																		<div class="row">
																			<div class="col-md-6 p-1"> 
																				<input (change)="setDisplaySections(6);" class="form-control validate rptInfo  mb-3" [(ngModel)]="clientAddress"
																				placeholder="Address1" [ngModelOptions]="{standalone: true}">
																			</div>
																			<div class="col-md-6 p-1"> 
																				<input (change)="setDisplaySections(6);" class="form-control validate rptInfo  mb-3" [(ngModel)]="clientAddress2"
																		  placeholder="Address2" [ngModelOptions]="{standalone: true}">
																			</div>
																			<div class="col-md-3 p-1"> 
																				<input (change)="setDisplaySections(6);" class="form-control validate rptInfo" [(ngModel)]="clientCity" placeholder="City"
																				[ngModelOptions]="{standalone: true}">
																			</div>
																			<div class="col-md-3 p-1"> 
																				<input (change)="setDisplaySections(6);" class="form-control validate rptInfo  mb-3" [(ngModel)]="clientState"
																		  placeholder="State/Province" [ngModelOptions]="{standalone: true}">
																			</div>
																			<div class="col-md-3 p-1"> 
																					
																		<input (change)="setDisplaySections(6);" class="form-control validate rptInfo " [(ngModel)]="clientZip"
																		placeholder="Zip/Postal" [ngModelOptions]="{standalone: true}">
																			</div>
																			
																			<div class="col-md-3 p-1"> 
																				<input (change)="setDisplaySections(6);" class="form-control validate rptInfo mb-3" [(ngModel)]="clientCountry"
																		  placeholder="Country" [ngModelOptions]="{standalone: true}">
																		</div>
													
																			</div>
																	  </div>
																  </div>
																  <div class="md-form">
																	<label  class='inputLabel'>Phone: 
																	<!-- <label  class='inputLabel'>Phone (Number Only):  -->
																		<!-- remove phone number check...
																		<span style="color:red" *ngIf="!form.controls.clientPhone.pristine && !form.controls.clientPhone.valid"> *</span> -->
																	</label>
																	<!-- mask="(000) 000-0000"  placeholder="Number Only" [class.invalid]="!form.controls.clientPhone.pristine && !form.controls.clientPhone.valid" -->
																	<input (change)="setDisplaySections(6);" 
																	  formControlName="clientPhone" id="defaultForm-pass" class="form-control validate rptInfo no-spinner">
																  </div>
																  <div class="md-form">
																	<label class='inputLabel' >Email: <span style="color:red" *ngIf="!form.controls.clientEmail.pristine && !form.controls.clientEmail.valid"> *</span></label> 
																	<input (change)="setDisplaySections(6);" [class.invalid]="!form.controls.clientEmail.pristine && !form.controls.clientEmail.valid"
																	  formControlName="clientEmail" id="defaultForm-pass" class="form-control validate rptInfo"
																	  (change)="show(form.value.clientEmail)">
													
																  </div>
															</div>
														</div>
														</div>
													</div>
												</div>
											</div>
											<div class="container" >
												<div class="card">
													<div class="card-header p-2">
														<a class="collapsed card-link" data-toggle="collapse"
															href="#inner-collapse5" (click)="rotate($event)">
															<span class="card-title">Edit Co Client</span><a type="button" class="collapsible1"
																style="float:right;background-color:#bbbbbb"></a>
														</a>
													</div>
													<div id="inner-collapse5" class="collapse">
														<div class="card-body">
															<div class="row">
																<div class="col-md-12">
																<!-- <label class='inputLabel'>Client Information:</label> -->
																<div class="md-form">
																	<label  class='inputLabel'>Client Name: <span style="color:red" *ngIf="(!form.controls.cocompanyName.pristine && !form.controls.cocompanyName.valid)|| !form.value.cocompanyName"> *</span></label>
																	<input (change)="setDisplaySections(6);" [class.invalid]="!form.controls.cocompanyName.pristine && !form.controls.cocompanyName.valid"
																	  formControlName="cocompanyName" id="defaultForm-pass" class="form-control validate rptInfo">
																  </div>
													
																  <div class="md-form">
																	<label class='inputLabel'>Contact Name:</label>
																	<input class="form-control validate rptInfo" [(ngModel)]="cocontactName"
																	  [ngModelOptions]="{standalone: true}">
													
																  </div>
																  <div class="md-form">
																	<label class='inputLabel'>Contact Title:</label>
																	<input class="form-control validate rptInfo" [(ngModel)]="cocontactTitle"
																	  [ngModelOptions]="{standalone: true}">
													
																  </div>
																  <div class="md-form">
																	
																	  <label  class='inputLabel'>Client Address:</label>
																	  <div class="container">
																		<div class="row">
																			<div class="col-md-6 p-1"> 
																				<input (change)="setDisplaySections(6);" class="form-control validate rptInfo  mb-3" [(ngModel)]="coclientAddress"
																				placeholder="Address1" [ngModelOptions]="{standalone: true}">
																			</div>
																			<div class="col-md-6 p-1"> 
																				<input (change)="setDisplaySections(6);" class="form-control validate rptInfo  mb-3" [(ngModel)]="coclientAddress2"
																		  placeholder="Address2" [ngModelOptions]="{standalone: true}">
																			</div>
																			<div class="col-md-3 p-1"> 
																				<input (change)="setDisplaySections(6);" class="form-control validate rptInfo" [(ngModel)]="coclientCity" placeholder="City"
																				[ngModelOptions]="{standalone: true}">
																			</div>
																			<div class="col-md-3 p-1"> 
																				<input (change)="setDisplaySections(6);" class="form-control validate rptInfo  mb-3" [(ngModel)]="coclientState"
																		  placeholder="State/Province" [ngModelOptions]="{standalone: true}">
																			</div>
																			<div class="col-md-3 p-1"> 
																					
																		<input (change)="setDisplaySections(6);" class="form-control validate rptInfo " [(ngModel)]="coclientZip"
																		placeholder="Zip/Postal" [ngModelOptions]="{standalone: true}">
																			</div>
																			<div class="col-md-3 p-1"> 
																				<input (change)="setDisplaySections(6);" class="form-control validate rptInfo mb-3" [(ngModel)]="coclientCountry"
																		  placeholder="Country" [ngModelOptions]="{standalone: true}">
																		</div>
													
																			</div>
															
																	
																		
																	
																	
																		
																	  </div>
																	   
																  </div>
																  <div class="md-form">
																	<!-- <label  class='inputLabel'>Phone (Number Only): -->
																	<label  class='inputLabel'>Phone:
																		<!-- remove phone number check:
																		<span style="color:red" *ngIf="!form.controls.coclientPhone.pristine && !form.controls.coclientPhone.valid"> *</span> -->
																	</label>
																	<!-- mask="(000) 000-0000"  placeholder="Number Only" [class.invalid]="!form.controls.coclientPhone.pristine && !form.controls.coclientPhone.valid" -->
																	<input (change)="setDisplaySections(6);"
																	  formControlName="coclientPhone" id="defaultForm-pass" class="form-control validate rptInfo no-spinner">
																  </div>
																  <div class="md-form">
																	<label class='inputLabel' >Email: <span style="color:red" *ngIf="!form.controls.coclientEmail.pristine && !form.controls.coclientEmail.valid"> *</span></label> 
																	<input (change)="setDisplaySections(6);" [class.invalid]="!form.controls.coclientEmail.pristine && !form.controls.coclientEmail.valid"
																	  formControlName="coclientEmail" id="defaultForm-pass" class="form-control validate rptInfo"
																	  (change)="show(form.value.coclientEmail)">
													
																  </div>
															</div>
														</div>
														</div>
													</div>
												</div>
											</div>
										</div>
									</div>
									<!----->
									<div class="card">
										<div class="card-header p-2">
											<a class="card-link" data-toggle="collapse" href="#collapse6"
												(click)="rotate($event)">
												<span class="card-title"><b>Company Office</b></span>
												<a type="button"
													class="collapsible1"
													style="float:right;background-color:#bbbbbb"></a>
											</a>
										</div>
										<div id="collapse6" class="collapse" data-parent="#accordionExample">
											<div class="card-body">

												<div class="col-md-12">
													<label class="col-md-12 inputLabel m-0 p-0">Company Name </label>
													<div class="container">
														<div class="row">

						
														<ng-select class="col-md-9 rptInfo" [clearable]="false"
															[items]="consultantNames" notFoundText="Not Found"
															bindLabel="LOCATION_NAME"
															[(ngModel)]="curSelectConsultant"
															[ngModelOptions]="{standalone: true}"
															[searchFn]="customSearchFn2"
															(change)="setDisplaySections(8)">

															<ng-template ng-label-tmp let-item="item">
																<span *ngIf="item.FULL_ADDRESS">{{item.LOCATION_NAME}} ({{item.FULL_ADDRESS}})</span>
																<span *ngIf="!item.FULL_ADDRESS">{{item.LOCATION_NAME}}</span>

															</ng-template>
															<ng-template ng-option-tmp let-item="item"
																let-search="searchTerm" let-index="index">
																<span *ngIf="item.FULL_ADDRESS">{{item.LOCATION_NAME}} ({{item.FULL_ADDRESS}})</span>
																<span *ngIf="!item.FULL_ADDRESS">{{item.LOCATION_NAME}}</span>
																	
															</ng-template>
														</ng-select>
														<i class="far fa-trash-alt" style="margin-left: 10px; font-size: 25px" (click)="resetcurSelectConsultant()"></i>													

														<!--a class="btn btn-dark btn-sm pt-0 pb-0 ml-2 pl-2 pr-2" (click)="newEditClient=true; show('inner-collapse4')">{{curSelectClient && curSelectClient.CLIENT_ID? 'Edit' :'Add New' }} Location</a-->
														</div>
													</div>
												</div>
												<div class="col-md-12">
													<label class="col-md-12 inputLabel m-0 p-0">PO Number</label>
													<input type="text" class="rptInfo col-md-12"
														[(ngModel)]="curProject.PO_NUMBER"
														[ngModelOptions]="{standalone: true}">
												</div>
											</div>
													
										</div>
									</div>
									<!----->
									<div class="card">
										<div class="card-header p-2">
											<a class="card-link" data-toggle="collapse" href="#collapse5"
												(click)="rotate($event); getReports(); consoleLog(allTypeRpt)">
												<span class="card-title"><b>Add Report(s)</b></span><a type="button"
													class="collapsible1"
													style="float:right;background-color:#bbbbbb"></a>
											</a>
										</div>
										<div id="collapse5" class="collapse" data-parent="#accordionExample">
											<div class="card-body" style="padding:0">
												
												<button class="btn btn-gray3 ml-4 mb-2 mt-2" data-toggle="modal" data-target="#reportModal" style="font-size:.8em;"
													(click)="companyGroupIndicator ? getUserGroups() : null; getProM(); consoleLog1(allTypeRpt)">
													Select Template(s) / Client Deliverable(s)
												</button>																							
								<div *ngIf="displaySections[6] && allTypeRpt" style="height:600px; overflow-y:auto; overflow-x:hidden; margin:0">
									<div class="row">
										<ng-container *ngFor="let report of allTypeRpt, let i= index">
											<div class="col-md-5" *ngIf="report.selected" style="margin:10px 0 10px 30px; padding:10px 16px; background-color:#D8D8D8; border: solid 1px #ffffff; border-radius: 4px;">

												<label *ngIf="report.selectedSubCat"
													class="inputLabel">{{report.selectedSubCat.subCategory}}</label>
													<a *ngIf='save' class="collapsed card-link ml-1" (click)="deleteTRpt(i)">
														<i class="far fa-trash-alt"></i>													
													</a>
													<br>
												<label class="inputLabel">Template:&nbsp; </label>
												<label *ngIf="report.selectedTemplate != null;" style="color: black; font-size: 11px"
													class="displayContentLabel">{{report.selectedTemplate.TEMPLATE_TITLE}}</label><br>

												<ng-container *ngIf="companyGroupIndicator">
													<label class="inputLabel">Group:&nbsp; </label>
													<label *ngIf="report.selectedGroup" style="color: black; font-size: 11px"
														class="displayContentLabel">{{report.selectedGroup.GROUP_NAME}}</label><br>
												</ng-container>

												<label class="inputLabel">Writer:&nbsp; </label><label
													class="displayContentLabel"><span style="color: black; font-size: 11px"
														*ngIf="!report.userList.assessor.FULL_NAME">{{report.userList.assessor.USER_EMAIL}}
													</span>
													<span style="color: black; font-size: 11px"
														*ngIf="report.userList.assessor.FULL_NAME">{{report.userList.assessor.FULL_NAME}} </span>

												</label><br>
												<!--label class="inputLabel">Writer Title:&nbsp; </label><label
													class="displayContentLabel"><span style="color: black; font-size: 11px"
														*ngIf="report.userList.assessortitle">{{report.userList.assessortitle.TITLE}}
													</span>


												</label><br-->
												<label class="inputLabel">Reviewer:&nbsp; </label><label
													class="displayContentLabel"><span style="color: black; font-size: 11px"
														*ngIf="!report.userList.reviewer.FULL_NAME">{{report.userList.reviewer.USER_EMAIL}}
													</span>
													<span style="color: black; font-size: 11px"
														*ngIf="report.userList.reviewer.FULL_NAME">{{report.userList.reviewer.FULL_NAME}} </span></label><br>
														<!--label class="inputLabel">Reviewer Title:&nbsp; </label><label
													class="displayContentLabel"><span style="color: black; font-size: 11px"
														*ngIf="report.userList.reviewertitle">{{report.userList.reviewertitle.TITLE}}
													</span>
												</label><br-->
												<label class="inputLabel">User:&nbsp; </label><label
													class="displayContentLabel"><span
														*ngIf="!report.userList.assigned_user.FULL_NAME">{{report.userList.assigned_user.USER_EMAIL}}
													</span>
													<span style="color: black; font-size: 11px"
														*ngIf="report.userList.assigned_user.FULL_NAME">{{report.userList.assigned_user.FULL_NAME}}
													</span></label><br>
												
													<label class="inputLabel">Project Manager:&nbsp; </label><label
													class="displayContentLabel"><span style="color: black; font-size: 11px"
														*ngIf="report.userList.pm">{{report.userList.pm.FULL_NAME}}
													</span>
												</label>												
											</div> 

											<!--<div class="col-md-5" *ngIf="report.selected &&i%2==1"
												style="background-color:#D8D8D8; line-height:1">

												<label *ngIf="report.selectedSubCat"
													class="inputLabel">{{report.selectedSubCat.subCategory}}</label>
													<a  *ngIf='save' class="collapsed card-link ml-1" (click)="deleteTRpt(i)">
														<i class="far fa-trash-alt"></i>													
												</a>
													<br>
												<label class="inputLabel">Template:&nbsp; </label>
												<label *ngIf="report.selectedTemplate != null;"
													class="displayContentLabel">{{report.selectedTemplate.TEMPLATE_TITLE}}</label><br>

												<label class="inputLabel">Writer:&nbsp; </label><label
													class="displayContentLabel"><span
														*ngIf="!report.userList.assessor.FIRST_NAME">{{report.userList.assessor.USER_EMAIL}}
													</span>
													<span
														*ngIf="report.userList.assessor.FIRST_NAME">{{report.userList.assessor.FIRST_NAME
														+ ' ' +report.userList.assessor.FULL_NAME}} </span>

												</label><br>
												<label class="inputLabel">Writer Title:&nbsp; </label><label
													class="displayContentLabel"><span
														*ngIf="report.userList.assessortitle">{{report.userList.assessortitle.TITLE}}
													</span>


												</label><br>
												<label class="inputLabel">Reviewer:&nbsp; </label><label
													class="displayContentLabel"><span
														*ngIf="!report.userList.reviewer.FIRST_NAME">{{report.userList.reviewer.USER_EMAIL}}
													</span>
													<span
														*ngIf="report.userList.reviewer.FIRST_NAME">{{report.userList.reviewer.FIRST_NAME
														+ ' ' +report.userList.reviewer.FULL_NAME}} </span></label><br>
												<label class="inputLabel">User:&nbsp; </label><label
													class="displayContentLabel"><span
														*ngIf="!report.userList.assigned_user.FIRST_NAME">{{report.userList.assigned_user.USER_EMAIL}}
													</span>
													<span
														*ngIf="report.userList.assigned_user.FIRST_NAME">{{report.userList.assigned_user.FIRST_NAME
														+ ' ' +report.userList.assigned_user.FULL_NAME}}
													</span></label><br>
												<label class="inputLabel">Reviewer Title:&nbsp; </label><label
													class="displayContentLabel"><span
														*ngIf="report.userList.reviewertitle">{{report.userList.reviewertitle.TITLE}}
													</span>
												</label><br>
												<label class="inputLabel">Project Manager:&nbsp; </label><label
													class="displayContentLabel"><span
														*ngIf="report.userList.pm">{{report.userList.pm.FULL_NAME}}
													</span>
												</label><br>												<br>
											</div>
											<div class="col-md-1" *ngIf="i==1 ||i==0 &&curTempCategories.length==1">
												<a class="collapsed card-link" (click)="show('collapse5') ">
													<i class="far fa-edit">
													</i>
												</a>
											</div>-->
										</ng-container>
										
									</div>

								</div>
															<!--<ng-container
																*ngFor="let cat of curTempCategories; let i = index">
																<div class="col-md-11" style="min-width: 400px;">
																	<label class="inputLabel">{{cat.category}}</label>
																	<a href="javascript:void(0)" style="padding:0;" class="btn btn-sm"
																			(click)="curTypeIndex=i; selectType(i, $event, this.curTempCategories); setSubCat(cat);setDisplaySections(7); clearInvite2(cat.userList) "><i class="fas fa-angle-down" style="color:#333"></i></a>
																		
																	<div class="mb-2 pt-2"
																		[style.display]="curTypeIndex==i?'block':'none'"
																		style="border:solid 1px white;">
																		<label class="col-md-4 inputLabel">Template
																			Identifier:</label>
																		<select class="col-md-7 p-1 rptInfo"
																			style="margin:4px;"
																			[(ngModel)]="cat.selectedSubCat"
																			[ngModelOptions]="{standalone: true}"
																			(change)="setByTypeId(cat); setDisplaySections(7);">
																			
																			<option
																				*ngFor="let subCat of cat.subCategories;"
																				[ngValue]="subCat">
																				{{subCat.subCategory}}</option>
																		</select>
																		
																			<label
																			class="col-md-4 inputLabel">Template:</label>
																		<select class="col-md-7 p-1 rptInfo"
																			style="margin:4px;"
																			[(ngModel)]="cat.selectedTemplate"
																			[ngModelOptions]="{standalone: true}"
																			(change)="setDisplaySections(7);">
																			<option></option>
																			<option
																				*ngFor="let template of cat.typeIdTemplates;"
																				[ngValue]="template">
																				{{template.TEMPLATE_TITLE}}</option>
																		</select>
																	<div class="container">
																			<div class="row">
																				<label class="col-md-4 inputLabel"
																					style="margin-top:10px">Writer:</label>
																				<div class='col-md-7'
																					style="padding:0px">
																					<ng-select
																						*ngIf="!cat.userList.assessor"
																						class="col-md-8 p-1 rptInfo"
																						[clearable]="false"
																						style="margin:4px;color: grey; display:inline-block; "
																						[items]="usersList"
																						notFoundText="Not Found"
																						bindLabel="USER_EMAIL"
																						[(ngModel)]="cat.userList.assessor"
																						[ngModelOptions]="{standalone: true}"
																						[searchFn]="customSearchFn"
																						placeholder="Select Writer">
																					<ng-template ng-label-tmp
																							let-item="item">
																							<span style="color: black;"
																								*ngIf="item.FIRST_NAME">{{
																								item.FIRST_NAME + ', ' +
																								item.FULL_NAME + ', ' +
																								'(' + item.USER_EMAIL + ')'}}</span>
																							<span style="color: black;"
																								*ngIf="!item.FIRST_NAME">{{item.USER_EMAIL}}</span>
																						</ng-template>
																						<ng-template ng-option-tmp
																							let-item="item"
																							let-search="searchTerm"
																							let-index="index">
																							<span style="color: black;"
																								*ngIf="item.FIRST_NAME">{{
																								item.FIRST_NAME + ', ' +
																								item.FULL_NAME + ', ' +
																								'(' + item.USER_EMAIL + ')'}}</span>
																							<span style="color: black;"
																								*ngIf="!item.FIRST_NAME">{{item.USER_EMAIL}}</span>
																						</ng-template>
																					</ng-select>
																					<ng-select
																						*ngIf="cat.userList.assessor"
																						class="col-md-8 p-1 rptInfo"
																						[clearable]="false"
																						style="margin:4px;color: grey; display:inline-block; "
																						[items]="usersList"
																						notFoundText="Not Found"
																						bindLabel="USER_EMAIL"
																						[(ngModel)]="cat.userList.assessor"
																						[ngModelOptions]="{standalone: true}"
																						[searchFn]="customSearchFn">
																					
																						<ng-template ng-label-tmp
																							let-item="item">
																							<span style="color: black;"
																								*ngIf="item.FIRST_NAME">{{
																								item.FIRST_NAME + ', ' +
																								item.FULL_NAME + ', ' +
																								'(' + item.USER_EMAIL + ')'}}</span>
																							<span style="color: black;"
																								*ngIf="!item.FIRST_NAME">{{item.USER_EMAIL}}</span>
																						</ng-template>
																						<ng-template ng-option-tmp
																							let-item="item"
																							let-search="searchTerm"
																							let-index="index">
																							<span style="color: black;"
																								*ngIf="item.FIRST_NAME">{{
																								item.FIRST_NAME + ', ' +
																								item.FULL_NAME + ', ' +
																								'(' + item.USER_EMAIL + ')'}}</span>
																							<span style="color: black;"
																								*ngIf="!item.FIRST_NAME">{{item.USER_EMAIL}}</span>
																						</ng-template>
																					</ng-select>
																					<a style="margin-bottom:10px; margin-left:2px; margin-top:0.4rem"
																						href="javascript:void(0)"
																						title="Invite"
																						class="btn btn-dark btn-sm pt-0 pb-0 pl-1 pr-1 col-md-auto float-right"
																						(click)='invite3.toggle($event); getCompanyRoles(); clearInvite()'><i
																							class="fas fa-user-plus"></i></a>
																				</div>
																			</div>
																		</div>


																		<p-overlayPanel #invite3 [dismissable]="true"
																			[appendTo]="reportsModal"
																			[style]="{'z-index':'99999'}"
																			showCloseIcon="true">
																			<ng-template pTemplate>
																				<div style="display:inline-block">

																					<div class="Info"
																						style="float: left;">
																						<label>Writer Email:
																							&nbsp;</label>
																					</div>
																					<input
																						class="placeholder"
																						[(ngModel)]="userToAdd"
																						[ngModelOptions]="{standalone: true}"
																						style="background:grey; color: black"
																						type="text" placeholder="Enter email to invite user"/>
																					<div style="float: right;">
																						<button type="button"
																						class="btn m-0 uploadBtn"
																							(click)="inviteUser(i, 'assessor'); invite3.hide()"
																							style="margin-left: 5px; padding: 3px; font-size: 11px;">Invite</button>
																					</div>
																				</div>
																				<br>
																				<br>
																				<div style="display: inline-block;">
																				<div class="Info" style="float: left;">
																						<label>Role: &nbsp;</label>
																					</div>
																				<div style="float: right; width: 45%;">
																					<select class="rptInfo"
																						[(ngModel)]="role"
																						style="background:grey"
																						[ngModelOptions]="{standalone: true}" >
																  						<option [value]="type.ROLE_ID" *ngFor="let type of roles">
																							{{type.ROLE_NAME}} </option>
																					</select>
																				</div>
																				
																				</div>
																			</ng-template>
																		</p-overlayPanel>
																	<div class="container">
																			<div class="row">
																				<label class="col-md-4 inputLabel"
																				style="margin-top:10px" >Writer Title:</label>
																				<div class="col-md-7" style="padding: 0px;">
																				<ng-select 
																					*ngIf = "!cat.userList.assessortitle"
																					[compareWith]="compareFn" 
																					class="col-md-12 p-1 rptInfo" 
																					style="margin:4px; color: grey"
																					(change)="setDisplaySections(7);"
																					[(ngModel)]="cat.userList.assessortitle"
																					[ngModelOptions]="{standalone: true}"
																					placeholder="Select Writer Title">
																				<ng-option [value]="title"
																					*ngFor="let title of assessortitles;">
																					<span style="color: black;">
																						{{title.TITLE}}
																					</span>	
																				</ng-option>
																				</ng-select>
																				<ng-select 
																					*ngIf = "cat.userList.assessortitle"
																					[compareWith]="compareFn" 
																					class="col-md-12 p-1 rptInfo" 
																					style="margin:4px;"
																					(change)="setDisplaySections(7);"
																					[(ngModel)]="cat.userList.assessortitle"
																					[ngModelOptions]="{standalone: true}"
																					>
																				<ng-option  [value]="title"
																					*ngFor="let title of assessortitles;">
																					<span style="color: black;">
																						{{title.TITLE}}
																					</span>	
																				</ng-option>
																				</ng-select>
																				</div>
																			</div>
																		</div>
															<div class="container">
																			<div class="row">
																				<label class="col-md-4 inputLabel"
																					style="margin-top:5px">Reviewer:</label>
																				<div class='col-md-7'
																					style="padding:0px">
																					<ng-select
																						*ngIf="!cat.userList.reviewer"
																						class="col-md-8 p-1 rptInfo"
																						[clearable]="false"
																						style="margin:4px;color: grey; display:inline-block; "
																						[items]="usersList"
																						notFoundText="Not Found"
																						bindLabel="USER_EMAIL"
																						[(ngModel)]="cat.userList.reviewer"
																						[ngModelOptions]="{standalone: true}"
																						[searchFn]="customSearchFn"
																						placeholder="Select Reviewer">
																						<ng-template ng-label-tmp
																							let-item="item">
																							<span style="color: black;"
																								*ngIf="item.FIRST_NAME">{{
																								item.FIRST_NAME + ', ' +
																								item.FULL_NAME + ', ' +
																								'(' + item.USER_EMAIL + ')'}}</span>
																							<span style="color: black;"
																								*ngIf="!item.FIRST_NAME">{{item.USER_EMAIL}}</span>
																						</ng-template>
																						<ng-template ng-option-tmp
																							let-item="item"
																							let-search="searchTerm"
																							let-index="index">
																							<span style="color: black;"
																								*ngIf="item.FIRST_NAME">{{
																								item.FIRST_NAME + ', ' +
																								item.FULL_NAME + ', ' +
																								'(' + item.USER_EMAIL + ')'}}</span>
																							<span style="color: black;"
																								*ngIf="!item.FIRST_NAME">{{item.USER_EMAIL}}</span>
																						</ng-template>
																					</ng-select>
																					<ng-select
																						*ngIf="cat.userList.reviewer"
																						class="col-md-8 p-1 rptInfo"
																						[clearable]="false"
																						style="margin:4px;color: grey; display:inline-block; "
																						[items]="usersList"
																						notFoundText="Not Found"
																						bindLabel="USER_EMAIL"
																						[(ngModel)]="cat.userList.reviewer"
																						[ngModelOptions]="{standalone: true}"
																						[searchFn]="customSearchFn">
																						<ng-template ng-label-tmp
																							let-item="item">
																							<span style="color: black;"
																								*ngIf="item.FIRST_NAME">{{
																								item.FIRST_NAME + ', ' +
																								item.FULL_NAME + ', ' +
																								'(' + item.USER_EMAIL + ')'}}</span>
																							<span style="color: black;"
																								*ngIf="!item.FIRST_NAME">{{item.USER_EMAIL}}</span>
																						</ng-template>
																						<ng-template ng-option-tmp
																							let-item="item"
																							let-search="searchTerm"
																							let-index="index">
																							<span style="color: black;"
																								*ngIf="item.FIRST_NAME">{{
																								item.FIRST_NAME + ', ' +
																								item.FULL_NAME + ', ' +
																								'(' + item.USER_EMAIL + ')'}}</span>
																							<span style="color: black;"
																								*ngIf="!item.FIRST_NAME">{{item.USER_EMAIL}}</span>
																						</ng-template>
																					</ng-select>
																					<a style="margin-bottom:10px; margin-left:2px; margin-top:0.4rem"
																						href="javascript:void(0)"
																						title="Invite"
																						class="btn btn-dark btn-sm pt-0 pb-0 pl-1 pr-1 col-md-auto float-right"
																						(click)='invite2.toggle($event); getCompanyRoles(); clearInvite()'><i
																							class="fas fa-user-plus"></i></a>
																				</div>
																			</div>
																		</div>
																		<p-overlayPanel #invite2 [dismissable]="true"
																			[appendTo]="reportsModal"
																			[style]="{'z-index':'99999'}"
																			showCloseIcon="true">
																			<ng-template pTemplate>
																				<div style="display:inline-block">

																					<div class="Info"
																						style="float: left;">
																						<label>Reviewer Email:
																							&nbsp;</label>
																					</div>
																					<input 
																						class="rptInfo"
																						[(ngModel)]="userToAdd"
																						[ngModelOptions]="{standalone: true}"
																						style="background:grey; color: black"
																						type="text" placeholder="Enter email to invite user"/>
																					<div style="float: right;">
																						<button type="button"
																						class="btn m-0 uploadBtn"
																							(click)="inviteUser(i, 'reviewer'); invite2.hide()"
																							style="margin-left: 5px; padding: 3px; font-size: 11px;">Invite</button>
																					</div>
																				</div>
																				<br>
																				<br>
																				<div style="display: inline-block;">
																				<div class="Info" style="float: left;">
																						<label>Role: &nbsp;</label>
																					</div>
																				<div style="float: right; width: 35%;">
																					<select class="rptInfo" 
																						[(ngModel)]="role"
																						style="background:grey"
																						[ngModelOptions]="{standalone: true}" >
																  						<option [value]="type.ROLE_ID" *ngFor="let type of roles">
																							{{type.ROLE_NAME}} </option>
																					</select>
																				</div>
																				
																				</div>
																				
																				</ng-template>
																		</p-overlayPanel>
																		<div class="container">
																			<div class="row">
																				<label class="col-md-4 inputLabel"
																				style="margin-top:10px" >Reviewer Title:</label>
																				<div class="col-md-7" style="padding: 0px;">
																				<ng-select 
																					*ngIf = "!cat.userList.reviewertitle"
																					[compareWith]="compareFn" 
																					class="col-md-12 p-1 rptInfo" 
																					style="margin:4px; color: grey"
																					(change)="setDisplaySections(7);"
																					[(ngModel)]="cat.userList.reviewertitle"
																					[ngModelOptions]="{standalone: true}"
																					placeholder="Select Reviewer Title">
																				<ng-option   [value]="title"
																					*ngFor="let title of reviewertitles;">
																					<span style="color: black;">
																						{{title.TITLE}}
																					</span>	
																				</ng-option>
																				</ng-select>
																				<ng-select 
																					*ngIf = "cat.userList.reviewertitle"
																					[compareWith]="compareFn" 
																					class="col-md-12 p-1 rptInfo" 
																					style="margin:4px;"
																					(change)="setDisplaySections(7);"
																					[(ngModel)]="cat.userList.reviewertitle"
																					[ngModelOptions]="{standalone: true}"
																					>
																				<ng-option  [value]="title"
																					*ngFor="let title of reviewertitles;">
																					<span style="color: black;">
																						{{title.TITLE}}
																					</span>	
																				</ng-option>
																				</ng-select>
																				</div>
																			</div>
																		</div>
																	<div class="container">
																			<div class="row">
																				<label class="col-md-4 inputLabel"
																					style="margin-top:5px">Users:</label>
																				<div class='col-md-7'
																					style="padding:0px">
																					<ng-select
																						*ngIf="!cat.userList.assigned_user"
																						class="col-md-8 p-1 rptInfo"
																						[clearable]="false"
																						style="margin:4px;color: grey; display:inline-block;"
																						[items]="usersList"
																						notFoundText="Not Found"
																						bindLabel="USER_EMAIL"
																						[(ngModel)]="cat.userList.assigned_user"
																						[ngModelOptions]="{standalone: true}"
																						[searchFn]="customSearchFn"
																						placeholder="Select User">
																						<ng-template ng-label-tmp
																							let-item="item">
																							<span style="color: black;"
																								*ngIf="item.FIRST_NAME">{{
																								item.FIRST_NAME + ', ' +
																								item.FULL_NAME + ', ' +
																								'(' + item.USER_EMAIL + ')'}}</span>
																							<span style="color: black;"
																								*ngIf="!item.FIRST_NAME">{{item.USER_EMAIL}}</span>
																						</ng-template>
																						<ng-template ng-option-tmp
																							let-item="item"
																							let-search="searchTerm"
																							let-index="index">
																							<span style="color: black;"
																								*ngIf="item.FIRST_NAME">{{
																								item.FIRST_NAME + ', ' +
																								item.FULL_NAME + ', ' +
																								'(' + item.USER_EMAIL + ')'}}</span>
																							<span style="color: black;"
																								*ngIf="!item.FIRST_NAME">{{item.USER_EMAIL}}</span>
																						</ng-template>
																					</ng-select>
																					<ng-select
																						*ngIf="cat.userList.assigned_user"
																						class="col-md-8 p-1 rptInfo"
																						[clearable]="false"
																						style="margin:4px;color: grey; display:inline-block;"
																						[items]="usersList"
																						notFoundText="Not Found"
																						bindLabel="USER_EMAIL"
																						[(ngModel)]="cat.userList.assigned_user"
																						[ngModelOptions]="{standalone: true}"
																						[searchFn]="customSearchFn"
																						>
																						<ng-template ng-label-tmp
																							let-item="item">
																							<span style="color: black;"
																								*ngIf="item.FIRST_NAME">{{
																								item.FIRST_NAME + ', ' +
																								item.FULL_NAME + ', ' +
																								item.USER_EMAIL}}</span>
																							<span style="color: black;"
																								*ngIf="!item.FIRST_NAME">{{item.USER_EMAIL}}</span>
																						</ng-template>
																						<ng-template ng-option-tmp
																							let-item="item"
																							let-search="searchTerm"
																							let-index="index">
																							<span style="color: black;"
																								*ngIf="item.FIRST_NAME">{{
																								item.FIRST_NAME + ', ' +
																								item.FULL_NAME + ', ' +
																								'(' + item.USER_EMAIL + ')'}}</span>
																							<span style="color: black;"
																								*ngIf="!item.FIRST_NAME">{{item.USER_EMAIL}}</span>
																						</ng-template>
																					</ng-select>
																					<a style="margin-bottom:10px; margin-left:2px; margin-top:0.4rem"
																						href="javascript:void(0)"
																						title="Invite"
																						class="btn btn-dark btn-sm pt-0 pb-0 pl-1 pr-1 col-md-auto float-right"
																						(click)='invite.toggle($event); getCompanyRoles(); clearInvite()'><i
																							class="fas fa-user-plus"></i></a>
																				</div>
																			</div>
																		</div>
																		<p-overlayPanel #invite [dismissable]="true"
																			[appendTo]="reportsModal" [style]="{'z-index':'99999'}"
																			showCloseIcon="true">
																			<ng-template pTemplate>
																				<div style="display:inline-block">

																					<div class="Info"
																						style="float: left;">
																						<label>User Email:
																							&nbsp;</label>
																					</div>
																					<input [(ngModel)]="userToAdd"
																						[ngModelOptions]="{standalone: true}"
																						style="background:grey; color: black"
																						type="text" placeholder="Enter email to invite user"/>
																					<div style="float: right;">
																						<button type="button"
																						class="btn m-0 uploadBtn"
																							(click)="inviteUser(i, 'assigned_user'); invite.hide()"
																							style="margin-left: 5px; padding: 3px; font-size: 11px;">Invite</button>
																					</div>
																				</div>
																				<br>
																				<br>
																				<div style="display: inline-block;">
																				<div class="Info" style="float: left;">
																						<label>Role: &nbsp;</label>
																					</div>
																				<div style="float: right; width: 50%;">
																					<select class="rptInfo"
																						[(ngModel)]="role"
																						style="background:grey"
																						[ngModelOptions]="{standalone: true}" >
																  						<option [value]="type.ROLE_ID" *ngFor="let type of roles">
																							{{type.ROLE_NAME}} </option>
																					</select>
																				</div>
																				
																				</div>
																			</ng-template>
																		</p-overlayPanel>
																		<div class="container">
																			<div class="row">
																				<label class="col-md-4 inputLabel"
																					style="margin-top:5px">Project Manager:</label>
																				<div class='col-md-7'
																					style="padding:0px">
																					<ng-select
																						class="col-md-12 p-1 rptInfo"
																						[clearable]="false"
																						style="margin:4px;color: grey; display:inline-block;"
																						[items]="pmList"
																						notFoundText="Not Found"
																						bindLabel="USER_EMAIL"
																						[(ngModel)]="cat.userList.pm"
																						[ngModelOptions]="{standalone: true}"
																						[searchFn]="customSearchFn"
																						placeholder="Select User"  (click)="getProM()">
																						
																						<ng-template ng-label-tmp
																							let-item="item">
																							<span style="color: black;"
																								*ngIf="item.FIRST_NAME">{{
																								item.FIRST_NAME + ', ' +
																								item.FULL_NAME + ', ' +
																								'(' + item.USER_EMAIL + ')'}}</span>
																							<span style="color: black;"
																								*ngIf="!item.FIRST_NAME">{{item.USER_EMAIL}}</span>
																						</ng-template>
																						<ng-template ng-option-tmp
																							let-item="item"
																							let-search="searchTerm"
																							let-index="index">
																							<span style="color: black;"
																								*ngIf="item.FIRST_NAME">{{
																								item.FIRST_NAME + ', ' +
																								item.FULL_NAME + ', ' +
																								'(' + item.USER_EMAIL + ')'}}</span>
																							<span style="color: black;"
																								*ngIf="!item.FIRST_NAME">{{item.USER_EMAIL}}</span>
																						</ng-template>
																					</ng-select>
																					</div>
																			</div>
																			
																		</div>
																		<div class="container">
																			<a href="javascript:void(0)" style="margin-bottom:10px; margin-left:2px; margin-top:0.4rem"
																			class="btn btn-dark btn-sm pt-0 pb-0 pl-1 pr-1" (click)="addSingleRpt(cat)">Add</a>
																			<span *ngIf="cat['toAdd']&&!(cat.selectedSubCat&&cat.selectedSubCat.typeId)" style="color:red">* Template Identifier is required.</span>
																			<span *ngIf="cat.selectedSubCat&&cat.selectedSubCat.typeId&&cat['added']" style="color:red">* Report already added.</span>																			
																		</div>
																	</div>
																</div>
															</ng-container>-->
														
											
											</div>
										</div>
									</div>
								</div>
							</div>

						</form>
						<div class="reportContainer col-md-6">
							<div id="mapContainer" class="mapInfo mt-2">

								<!--<input id="map-input" type="text" class="autocomplete"
									
									(keydown.enter)="$event.preventDefault()" placeholder="Input Address or Lat, Long"
									autocorrect="off" autocapitalize="off" spellcheck="off" type="text" #search>
								-->
								
								<!-- <input id="mapinput" class="autocomplete" ngx-google-places-autocomplete #placesRef="ngx-places"
									(onAddressChange)="AddressChange($event)" [options]='autoOptions'
									[(ngModel)]="address" (click)="appendMap()" /> -->
									<div class="mb-1">
										<span 
										style="margin-right:10px; font-size:12px"> <a class="card-title card-link"> Parcel Layer: ({{parcelOn? 'On': 'Off'}})</a> </span>
										<mat-slide-toggle [checked]="parcelOn" (change)="parcelToggle();">
										</mat-slide-toggle>
									</div>

									<input
										id="mapinput"
										class="controls autocomplete"
										type="text"
										[(ngModel)]="mapInputAddress"
										[ngModelOptions]="{standalone: true}"
										placeholder="Search Box"
								  	/>
								  
									<div #mapcanvas id="map-canvas"  class="googleMap"></div>
									
								<!-- <agm-map id="googleMap" class="googleMap" controlSize=24 [latitude]="lat" [longitude]="lng"
									[zoom]="zoom" [disableDefaultUI]="false" [zoomControl]="false"
									(mapClick)="mapClicked($event)" (mapReady)="onMapReady($event)">
									<agm-marker *ngFor="let m of markers; let i = index"
										(markerClick)="clickedMarker(m.label, i)" [latitude]="m.lat" [longitude]="m.lng"
										[label]="m.label" [markerDraggable]="m.draggable"
										(dragEnd)="markerDragEnd(m, $event)">

										<agm-info-window>
											<strong>InfoWindow content</strong>
										</agm-info-window>

									</agm-marker>
								</agm-map> -->
							</div>

							<div *ngIf="enabledDisplayInfo" id="summaryContainer" class="summaryInfo" style="margin:0">
								<!--<label class="inputLable"> Project Info</label>-->
								<div *ngIf="displaySections[0]" style="padding-top:8px"
									class="container displaysection">
									<div class="row">
										<div style="line-height:1" class="col-md-6">
											<label class="displayInputLabel">Project Number:&nbsp; </label><label
												class='displayContentLabel'>{{curProject.PROJECT_NUMBER}}</label><br>
											<label class="displayInputLabel">Property Name:&nbsp; </label><label
												class='displayContentLabel'>{{curProject.PROJECT_NAME}}</label><br>
											<label class="displayInputLabel">ERIS Order:&nbsp; </label><label
												class='displayContentLabel'>{{curProject.erisOrder}}</label><br>
												
										</div>
										<div style="line-height: 1;" class="col-md-5">
											<label style="line-height:1" class="displayInputLabel">Project Property:&nbsp;</label><br><label style="line-height: 1.5;"
												class='displayContentLabel'>{{street1}}<br> <span *ngIf="street2">
													{{street2}}<br></span>
												{{city? city +', ':'' }} {{ state? state +', ':'' }}
												{{ postCode? postCode +', ':'' }} {{ country? country +', ':'' }}</label><br>
												
										</div>
										<div class="col-md-1">
											<a class="collapsed card-link"
												(click)="show('collapse1'); hide('inner-collapse1'); hide('inner-collapse2'); hide('inner-collapse3');">
												<i class="far fa-edit">
												</i>
											</a>
										</div>
									</div>
								</div>
								<hr *ngIf="displaySections[1]" style="margin:0px">
								<div *ngIf="displaySections[1]" class="container displaysection">
									<div class="row">
										<div class="col-md-6" style="line-height:1">
											<label class="displayInputLabel">Property County:&nbsp;</label><label
												class='displayContentLabel'>{{curProject.PROPERTY_COUNTY}}</label><br>
											<label class="displayInputLabel">MSA:&nbsp; </label><label
												class='displayContentLabel'>{{curProject.MSA}}</label><br>
											<label class="displayInputLabel">Flood Zone:&nbsp;</label><label
												class='displayContentLabel'>{{curProject.FLOOD_ZONE}}</label><br>
										</div>
										<div class="col-md-5" style="line-height:1">
											<label class="displayInputLabel">PGA:&nbsp; </label><label
												class='displayContentLabel'>{{curProject.PGA}}</label><br>
											<label class="displayInputLabel">Zoning Des:&nbsp; </label><label
												class='displayContentLabel'>{{curProject.ZONING}}</label><br>
											<label class="displayInputLabel">Parcel ID:&nbsp; </label> 
												<label
												class='displayContentLabel'>{{parcelID}}</label><br>
										</div>
										<div class="col-md-1">
											<a class="collapsed card-link"
												(click)="show('collapse1');show('inner-collapse1'); hide('inner-collapse2');hide('inner-collapse3');" >
												<i class="far fa-edit">
												</i>
											</a>
										</div>
									</div>
								</div>
								<hr *ngIf="displaySections[2]" style="margin:0px">
								<div *ngIf="displaySections[2]" class="container displaysection">
									<div class="row" style="line-height:1">
										<div class="col-md-11">
											<label class="displayInputLabel">Transaction Type:&nbsp; </label><label
												class='displayContentLabel'>{{transactions[curRptPara.TRANSACTION_TYPE]?.CODE_VALUE}}</label><br>
											<label class="displayInputLabel">Protocol:&nbsp; </label><label
												class='displayContentLabel'>{{protocols[curRptPara.PROTOCOLS]?.CODE_VALUE}}</label><br>
											<label class="displayInputLabel">SOW:&nbsp; </label>
												<a
												*ngIf='curRptPara.SOW&&curRptPara.SOW.FILE_URL.length>0'
												class="displayInputLabel" [href]="curRptPara.SOW.FILE_URL" target=_blank
												style="color:black; margin-left:10px">
													<!-- {{curRptPara?.SOW.FILE_NAME}} -->
													<i class="far fa-eye"></i>
												</a>
											<a *ngIf='curRptPara.SOW&&curRptPara.SOW.FILE_URL.length>0' class="card-link ml-2"
												(click)="deleteSOW()">
												<i class="far fa-trash-alt"></i>
											</a>	
												<br>
										</div>
										<div class="col-md-1">
											<a class="collapsed card-link"
												(click)="show('collapse1');show('inner-collapse2');hide('inner-collapse1'); hide('inner-collapse3'); ">
												<i class="far fa-edit">
												</i>
											</a>
										</div>
									</div>
								</div>
								<hr *ngIf="displaySections[8]" style="margin:0px">
								<div *ngIf="displaySections[8]" class="container displaysection">
									<div class="row" style="line-height:1">
										<div class="col-md-6" style="line-height:1">
											<label class="displayInputLabel">Project Cost:&nbsp;</label><label
												class='displayContentLabel'>{{curProject.CHARGE_AMOUNT}}</label><br>
												<label class="displayInputLabel">Project Total:&nbsp; </label><label
												class='displayContentLabel'>{{curProject.TOTAL_AMOUNT}}</label>	
																						
										</div>
										<div class="col-md-5" style="line-height:1">
											<label class="displayInputLabel">Project Expense:&nbsp;</label><label
												class='displayContentLabel'>{{curProject.EXPENSE_AMOUNT}}</label>										
										</div>
										<div class="col-md-1">
											<a class="collapsed card-link"
												(click)="show('collapse1');show('inner-collapse6'); hide('inner-collapse2');hide('inner-collapse1'); hide('inner-collapse3'); ">
												<i class="far fa-edit">
												</i>
											</a>
										</div>
									</div>
								</div>
								<hr *ngIf="displaySections[3]" style="margin:0px">
								<div *ngIf="displaySections[3]" class="container displaysection">
									<div class="row" style="line-height:1">
										<div class="col-md-6">
											<label class="displayInputLabel">Inspection Date:&nbsp;</label><label
												class='displayContentLabel'>{{date1Text }}</label><br>
											<label class="displayInputLabel">Reviewer Due Date:&nbsp; </label><label
												class='displayContentLabel'>{{date2Text }}</label><br>
											<!--<label class="displayInputLabel">Project Turn Time:&nbsp; </label><label
												class='displayContentLabel'>{{date7}}</label><br>-->
										</div>
										<div class="col-md-5">
											<label class="displayInputLabel">Writer Due Date:&nbsp; </label><label
												class='displayContentLabel'>{{date3Text }}</label><br>
											<label class="displayInputLabel">Report Due Date:&nbsp; </label><label
												class='displayContentLabel'>{{date5Text }}</label><br>
											<!--<label class="displayInputLabel">Revised Due Date:&nbsp; </label><label
												class='displayContentLabel'>{{date6Text }}</label><br>-->
										</div>
										<div class="col-md-1">
											<a class="collapsed card-link" (click)="show('collapse2') ">
												<i class="far fa-edit">
												</i>
											</a>
										</div>
									</div>
								</div>
								<hr *ngIf="displaySections[4]" style="margin:0px">
								<div *ngIf="displaySections[4]" class="container displaysection">
									<div class="row">
										<div class="col-md-6">
											<label class="displayInputLabel">Site Contact:</label>
											<div class="col-md-12">
												<label class='displayContentLabel'>Contact
													Name:&nbsp;{{curProject.SITE_CONTACT_NAME}}<br>
													Contact Relationship:&nbsp;
													{{curProject.SITE_CONTACT_RELATIONSHIP}}<br>
													Contact Phone:&nbsp; {{form.value.siteContactPhone}}<br>
													Contact Email:&nbsp;{{form.value.siteemailAddress}}<br>
													Inspection Instructions:&nbsp;
													{{curProject.SITE_INSPECTION_INSTRUCTIONS}}</label><br>
											</div>
										</div>
										<div class="col-md-5">
											<label class="displayInputLabel">Additional Site Contact:</label>
											<div class="col-md-12">
												<label class='displayContentLabel'>Contact
													Name:&nbsp;{{curProject.ADD_SITE_CONTACT_NAME}}<br>
													Contact Relationship:&nbsp;
													{{curProject.ADD_SITE_CONTACT_RELATIONSHIP}}<br>
													Contact Phone:&nbsp; {{form.value.additionalsiteContactPhone}}<br>
													Contact Email:&nbsp;
													{{this.form.value.additionalsiteemailAddress}}</label><br>
											</div>
										</div>
										<div class="col-md-1">
											<a class="collapsed card-link" (click)="show('collapse3') ">
												<i class="far fa-edit">
												</i>
											</a>
										</div>
									</div>
								</div>
								<hr *ngIf="displaySections[5]" style="margin:0px">
								<div *ngIf="displaySections[5]" class="container displaysection">
									<div class="row">
										<div class="col-md-6" *ngIf="curSelectClient">
											<label class="displayInputLabel">Client:</label>
											<div *ngIf="!curSelectClient" class="col-md-12">
												<label class='displayContentLabel'>
													Company Name:&nbsp;
													{{companyName}}<br>
													Address:&nbsp;{{clientAddress}} + ", "+
													clientAddress2 + ", "+
													clientState
													}}<br>
													Contact Email:&nbsp;{{form.value.clientEmail}}<br>
													Contact Name:&nbsp;
													{{contactName}}</label><br>
											</div>
											<div *ngIf="curSelectClient" class="col-md-12">
												<label class='displayContentLabel'>
													Company Name:&nbsp;
													{{companyName}}<br>
													Address:&nbsp;{{curSelectClient.CLIENT_FULL_ADDRESS}}<br>
													Contact Email:&nbsp;{{curSelectClient.CLIENT_CONTACT_EMAIL}}<br>
													Contact Name:&nbsp;
													{{curSelectClient.CLIENT_CONTACT_NAME}}</label><br>
											</div>
										</div>
										<div class="col-md-6" *ngIf="!curSelectClient">
											<label class="displayInputLabel">Client:</label>
											<div class="col-md-12">
												<label class='displayContentLabel'>
													Company Name:&nbsp;
													<br>
													Address:&nbsp;<br>
													Contact Email:&nbsp;<br>
													Contact Name:&nbsp;
												</label><br>
											</div>
										</div>
										<div class="col-md-5">
											<span *ngIf="curCoSelectClient">
												<label class="displayInputLabel">c/o Client:</label>
												<div class="col-md-12">
													<label class='displayContentLabel'>
														Company Name:&nbsp;
														{{curCoSelectClient.CLIENT_COMPANY_NAME}}<br>
														Address:&nbsp;{{curCoSelectClient.CLIENT_FULL_ADDRESS}}<br>

														Contact
														Email:&nbsp;{{curCoSelectClient.CLIENT_CONTACT_EMAIL}}<br>
														Contact Name:&nbsp;
														{{curCoSelectClient.CLIENT_CONTACT_NAME}}</label><br>
												</div>
											</span>
											<span *ngIf="!curCoSelectClient">
												<label class="displayInputLabel">c/o Client:</label>
												<div class="col-md-12">
													<label class='displayContentLabel'>
														Company Name:&nbsp;
														<br>
														Address:&nbsp;<br>

														Contact
														Email:&nbsp;<br>
														Contact Name:&nbsp;
													</label><br>
												</div>
											</span>
										</div>
										<div class="col-md-1">
											<a class="collapsed card-link" (click)="show('collapse4') ">
												<i class="far fa-edit">
												</i>
											</a>
										</div>
<!--flagflag-->
									
								</div>
								
								</div>

								<hr *ngIf="displaySections[7]" style="margin:0px">

								<div *ngIf="displaySections[7]" class="container displaysection">
									<div class="row">
									<div class="col-md-11">
										<span *ngIf="curSelectConsultant">
											<label class="displayInputLabel"> Company Office: &nbsp;</label>
											<label *ngIf="curSelectConsultant.FULL_ADDRESS" class='displayContentLabel'>
												{{curSelectConsultant.LOCATION_NAME}} ({{curSelectConsultant.FULL_ADDRESS}})
											</label>

											<label *ngIf="!curSelectConsultant.FULL_ADDRESS" class='displayContentLabel'>
												{{curSelectConsultant.LOCATION_NAME}}
											</label>
										</span>
									</div>
									<div class="col-md-1">
										<a class="collapsed card-link" (click)="show('collapse6') ">
											<i class="far fa-edit">
											</i>
										</a>
									</div>


								</div>
							</div>
								<!-- <div *ngIf="displaySections[5]" class="container displaysection">
									<label *ngIf="curSelectClient != null"
										class="displayInputLabel">Client:&nbsp;</label>
									<div *ngIf="curSelectClient != null" class="row">
										<div class="col-md-12">
											<ng-container *ngFor="let item of curSelectClient | keyvalue">
												<label *ngIf="item.value != ''" class="col-md-6 displayContentLabel">
													{{item.key.replace('CLIENT_','')}}: {{item.value}}
												</label>
											</ng-container>
										</div>
									</div>

									<label *ngIf="curCoSelectClient != null" class="displayInputLabel">c/o
										Client:</label>
									<div *ngIf="curCoSelectClient != null" class="row">
										<div class="col-md-12">

										</div>
									</div>

									<div class="row">
										<div class="col-md-12">
											<label class='displayContentLabel'>Provided Information:
												{{curProject.CLIENT_PROVIDED_INFORMATION}}</label><br>
										</div>
									</div>
								</div> -->

								<!--<hr *ngIf="displaySections[6]" style="margin:0px">
								<div *ngIf="displaySections[6] && allTypeRpt && oneSelected()"
									class="container displaysection" style="padding:4px 16px;">
									<div class="row">
										<ng-container *ngFor="let report of allTypeRpt, let i= index">
											<div class="col-md-6" *ngIf="report.selected &&i%2==0"
												style="background-color:#D8D8D8; line-height:1">

												<label *ngIf="report.selectedSubCat"
													class="inputLabel">{{report.selectedSubCat.subCategory}}</label>
													<a *ngIf='save' class="collapsed card-link ml-1" (click)="deleteTRpt(i)">
													<i class="far fa-trash-alt"></i>													
												</a>
													<br>
												<label class="inputLabel">Template:&nbsp; </label>
												<label *ngIf="report.selectedTemplate != null;"
													class="displayContentLabel">{{report.selectedTemplate.TEMPLATE_TITLE}}</label><br>

												<label class="inputLabel">Writer:&nbsp; </label><label
													class="displayContentLabel"><span
														*ngIf="!report.userList.assessor.FIRST_NAME">{{report.userList.assessor.USER_EMAIL}}
													</span>
													<span
														*ngIf="report.userList.assessor.FIRST_NAME">{{report.userList.assessor.FIRST_NAME
														+ ' ' +report.userList.assessor.FULL_NAME}} </span>

												</label><br>
												<label class="inputLabel">Writer Title:&nbsp; </label><label
													class="displayContentLabel"><span
														*ngIf="report.userList.assessortitle">{{report.userList.assessortitle.TITLE}}
													</span>


												</label><br>
												<label class="inputLabel">Reviewer:&nbsp; </label><label
													class="displayContentLabel"><span
														*ngIf="!report.userList.reviewer.FIRST_NAME">{{report.userList.reviewer.USER_EMAIL}}
													</span>
													<span
														*ngIf="report.userList.reviewer.FIRST_NAME">{{report.userList.reviewer.FIRST_NAME
														+ ' ' +report.userList.reviewer.FULL_NAME}} </span></label><br>
												<label class="inputLabel">User:&nbsp; </label><label
													class="displayContentLabel"><span
														*ngIf="!report.userList.assigned_user.FIRST_NAME">{{report.userList.assigned_user.USER_EMAIL}}
													</span>
													<span
														*ngIf="report.userList.assigned_user.FIRST_NAME">{{report.userList.assigned_user.FIRST_NAME
														+ ' ' +report.userList.assigned_user.FULL_NAME}}
													</span></label><br>
												<label class="inputLabel">Reviewer Title:&nbsp; </label><label
													class="displayContentLabel"><span
														*ngIf="report.userList.reviewertitle">{{report.userList.reviewertitle.TITLE}}
													</span>
												</label><br>
													<label class="inputLabel">Project Manager:&nbsp; </label><label
													class="displayContentLabel"><span
														*ngIf="report.userList.pm">{{report.userList.pm.FULL_NAME}}
													</span>
												</label>												<br>
											</div>

											<div class="col-md-5" *ngIf="report.selected &&i%2==1"
												style="background-color:#D8D8D8; line-height:1">

												<label *ngIf="report.selectedSubCat"
													class="inputLabel">{{report.selectedSubCat.subCategory}}</label>
													<a  *ngIf='save' class="collapsed card-link ml-1" (click)="deleteTRpt(i)">
														<i class="far fa-trash-alt"></i>													
												</a>
													<br>
												<label class="inputLabel">Template:&nbsp; </label>
												<label *ngIf="report.selectedTemplate != null;"
													class="displayContentLabel">{{report.selectedTemplate.TEMPLATE_TITLE}}</label><br>

												<label class="inputLabel">Writer:&nbsp; </label><label
													class="displayContentLabel"><span
														*ngIf="!report.userList.assessor.FIRST_NAME">{{report.userList.assessor.USER_EMAIL}}
													</span>
													<span
														*ngIf="report.userList.assessor.FIRST_NAME">{{report.userList.assessor.FIRST_NAME
														+ ' ' +report.userList.assessor.FULL_NAME}} </span>

												</label><br>
												<label class="inputLabel">Writer Title:&nbsp; </label><label
													class="displayContentLabel"><span
														*ngIf="report.userList.assessortitle">{{report.userList.assessortitle.TITLE}}
													</span>


												</label><br>
												<label class="inputLabel">Reviewer:&nbsp; </label><label
													class="displayContentLabel"><span
														*ngIf="!report.userList.reviewer.FIRST_NAME">{{report.userList.reviewer.USER_EMAIL}}
													</span>
													<span
														*ngIf="report.userList.reviewer.FIRST_NAME">{{report.userList.reviewer.FIRST_NAME
														+ ' ' +report.userList.reviewer.FULL_NAME}} </span></label><br>
												<label class="inputLabel">User:&nbsp; </label><label
													class="displayContentLabel"><span
														*ngIf="!report.userList.assigned_user.FIRST_NAME">{{report.userList.assigned_user.USER_EMAIL}}
													</span>
													<span
														*ngIf="report.userList.assigned_user.FIRST_NAME">{{report.userList.assigned_user.FIRST_NAME
														+ ' ' +report.userList.assigned_user.FULL_NAME}}
													</span></label><br>
												<label class="inputLabel">Reviewer Title:&nbsp; </label><label
													class="displayContentLabel"><span
														*ngIf="report.userList.reviewertitle">{{report.userList.reviewertitle.TITLE}}
													</span>
												</label><br>
												<label class="inputLabel">Project Manager:&nbsp; </label><label
													class="displayContentLabel"><span
														*ngIf="report.userList.pm">{{report.userList.pm.FULL_NAME}}
													</span>
												</label><br>												<br>
											</div>
											<div class="col-md-1" *ngIf="i==1 ||i==0 &&curTempCategories.length==1">
												<a class="collapsed card-link" (click)="show('collapse5') ">
													<i class="far fa-edit">
													</i>
												</a>
											</div>
										</ng-container>
										
									</div>

								</div>-->
							</div>



						</div>
					</div>

				</div>
				<div class="modal-footer">

					<button class="btn btn-gray1 float-md-right ml-4  mr-4" (click)="newReportValid=false;newReport2();"
						[disabled]="!newReportValid || (save && !newReportPermission) || (!save && !editProjectPermission)">Save</button>
					<button class="btn btn-gray1 float-md-right ml-4  mr-4" data-toggle="modal"
						data-target="#confirmModal">Cancel</button>

					<div class="modal fade" id="confirmModal" tabindex="-1" role="dialog"
						aria-labelledby="exampleModalLabel" >
						<div class="modal-dialog modal-dialog-centered " role="document">
							<div class="modal-content">
								<div class="modal-header">
									<h5 class="modal-title" id="exampleModalLabel">Are you sure you want to cancel?</h5>
									<button type="button" (click)="dismissConfirm($event, false);" class="close"
										aria-label="Close">
										<span >&times;</span>
									</button>
								</div>
								<div class="modal-body ">
									<button type="button" class="btn btn-secondary"
										(click)="dismissConfirm($event, false);">Go Back</button>
									<button style="float:right" type="button" class="btn btn-primary"
										(click)="dismissConfirm($event, true);">{{save? 'Cancel':'Cancel'}} </button>
								</div>
							</div>
						</div>
					</div>

				</div>
			</div>
		</div>
	</div>
	<!-- <div id="PCA" class="modal fade" tabindex="-1" role="dialog" data-keyboard="false" data-backdrop="false">

		<div class="modal-dialog modal-dialog-centered" style="max-width:30%">
			<div class="modal-content" style="background-color:#cDcDcD">
			
				<div class="modal-header">
					<h6 class="modal-title">PCA Info</h6>
					<button type="button" class="close" data-dismiss="modal">&times;</button>
				</div>

			
				<div class="modal-body">
					<table style="margin-left:auto;   border: 1px solid white;
					border-collapse: collapse;
					margin-right:auto;">
						<tr *ngFor="let question of questions; let k=index" style="width:100%;  border: 1px solid white; margin:2px;
						border-collapse: collapse; ">
							<td style="  border: 1px solid white; padding:3px;
							border-collapse: collapse;">{{questionHeaders[k]}} :</td> 
							<td *ngIf="question!='PARCELS_CONTIGUOUS'"  style="  border: 1px solid white; padding:3px;
							border-collapse: collapse;"> <input (keypress)="numberOnly($event)" type="number" [(ngModel)]="answers[question]" class="form-control validate rptInfo no-spinner"> </td>
							<td *ngIf="question=='PARCELS_CONTIGUOUS'"  style="  border: 1px solid white; padding:3px;
							border-collapse: collapse;">
								<select class="rptInfo selectinput"  [(ngModel)]="answers[question]">
									<option value=""> </option>
									<option value="Yes">Yes</option>
									<option value="No">No</option>
								  </select>
							</td>
						</tr>
						
						</table>
					<div class="container-fluid">
						<div class=row>

						
							<div class=col-md-12>
								Additional Property Specific Criteria: <br>
								<textarea class="rptInfo col-md-12" [(ngModel)]="answers['ADDITIONAL_PROPERTY_INFORMATION']"></textarea>
							</div>
						</div>
						<button (click)="savePCA()" *ngIf="saveAnswers" class="btn btn-gray1 float-md-right m-4" data-dismiss="modal">Save</button>
						<button *ngIf="!saveAnswers" class="btn btn-gray1 float-md-right m-4" data-dismiss="modal">Save</button>
					</div>

				</div>
				</div>
				</div>
				 

	</div> -->
	<!-- Upload Batch Projects Modal -->
	<div #import id="import" class="modal fade" tabindex="-1" role="dialog" data-keyboard="false" data-backdrop="false">

		<div class="modal-dialog modal-dialog-centered" [style.max-width]="excelJson? '80%':'50%'">
			<div class="modal-content" style="background-color:#cDcDcD">
			
				<div class="modal-header">
					<h6 class="modal-title">Import Excel</h6>
					<button 
						class="btn btn-dark btn-sm pt-0 pb-0 pl-2 pr-2 ml-3"
						type="button"
						id="batchButton"
						href="javascript:void(0)"
						title="Help"
						#batchButton
					(click)='testFunction()'>Instructions to upload a Project or Portfolio</button>
					<button type="button" class="close" data-dismiss="modal">&times;</button>
				</div>

			
				<div class="modal-body">

					<!-- <span style="cursor:pointer" [style.color]="sheet==selectedSheet? 'yellow':'black'" (click)="resetSheet();selectedSheet=sheet; selectSheet()" *ngFor="let sheet of sheets">
						{{sheet}}
					</span> -->

					<!-- <div *ngIf="excelJson && (uploadBatchFrom=='ACTIVE' || portfolioDisplayName===null)" -->
					<div *ngIf="excelJson"
						class="justify-content-start text-left mb-1" style="margin-right: 20px; color:rgb(28 36 51)">
						<strong> Portfolio Name: </strong>
						<input class="rptInfo" type="text" [(ngModel)]="portfolioName">
						<select class="rptInfo" (change)="portfolioName=$event.target.value;" (click)="getAllPortfolios1()">
							<option [ngValue]="null" selected>Select from Existing</option>
							<!-- <option [ngValue]="null"></option> -->
							<option *ngFor="let portfolio of portfolioList" [ngValue]='null'>
								{{portfolio.PORTFOLIO_NAME}}
							</option>
						</select>
					</div>
					<!-- <div *ngIf="excelJson && (uploadBatchFrom=='PORTFOLIO' && portfolioDisplayName!==null)"
						class="justify-content-left text-left mb-1" style="margin-right: 20px; color:rgb(28 36 51)">
						<strong> Portfolio Name: </strong> 
						<span style="color:red">{{portfolioDisplayName}} </span>
					</div> -->

					<!-- <span *ngIf="excelJson">
					<button 
					class="btn btn-dark btn-sm pt-0 pb-0 pl-2 pr-2"
					type="button"
					id="batchButton"
					href="javascript:void(0)"
					title="Help"
					style="margin: left 0px;"
					#batchButton
					(click)='testFunction()'>Instructions to upload a Project or Portfolio</button>
					</span> -->
					<!--p-overlayPanel #batchHelp [dismissable]="true"
					for="batchButton"
					showCloseIcon="true"
					[appendTo]="'Modal'"
					[style]="{'z-index':'99999'}"
					>
					<ng-template pTemplate>
						<div style="color: red">How to use the Batch Project or Portfolio Upload:</div>
						<div>•Batch Project - Upload any number of individual projects that are not in a Portfolio (of any size). SCRIVA will read the project number/name and create a separate project for each location.</div>
						<div>•Portfolio - Upload a batch of projects within a portfolio. Enter the Portfolio Name in the Portfolio Name field at the top of the Import Excel window to link all the projects. Only upload one Portfolio of projects at a time.</div>
					</ng-template>
				</p-overlayPanel-->

					<p-table [value]="excelJson" [columns]="excelCols" [autoLayout]="true">
						<ng-template pTemplate="header" let-columns>
							<tr style="font-size:12px">
								<th style="padding: 1px; padding-left: 3px;" *ngFor="let col of columns" >
									
									<select style="color:white; background:#323232; max-width:100%" [(ngModel)]="col.changeHeader"
										(change)="changeCol();">
										<option *ngFor="let pre of presetCols" [value]='pre'>
											{{pre}}
										</option>
									</select>
								</th>
							</tr>
						</ng-template>
						<ng-template pTemplate="body" let-rowData let-columns="columns">
							<tr style="font-size:12px;">
								<td style="padding: 1px; padding-left: 3px;" *ngFor="let col of columns" >
									<span>
										{{rowData[col.header]}}
									</span>
		
								</td>
							</tr>
						</ng-template>
					</p-table>
					<div class="input-group col-md-12 justify-content-center text-center mt-1"  >
						<input [style.max-width]="excelJson? '50%':'80%'" #excelFile class="col-md-9 rptInfo mr-1"
							type="file" accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
							[(ngModel)]="sheet1"/>
						
						<div class="input-group-append">
							<button title="Upload File"
								class="btn btn-dark btn-sm pt-0 pb-0 pl-2 pr-2"
								type="button"
								
							
								(click)='uploadExcel()'><i
									class="fas fa-file-upload"></i></button>
							
						
						</div>
						<span id="spinner" class="fa fa-spinner fa-spin"
							style="font-size:20px; display:none"></span>
						<span id="inputWarn" class="fas fa-exclamation"
							style="margin-left:4px;font-size:16px; display:none; color:red"></span>
						<span id="inputSuccess" class="fas fa-check"
							style="margin-left:4px;font-size:16px; display:none; color:green"></span>
					</div>
					<div class="col-md-12 justify-content-center text-center mt-1">

						<button *ngIf="excelJson"
						class="btn btn-dark btn-sm pt-0 pb-0 pl-2 pr-2"
						type="button"
						[disabled]="!uploadBatchProjectsPermission"
						(click)='uploadBatchProjects()'>Create Batch Projects</button>
					</div>

					<div *ngIf="sheets.length!=0" class="mt-1 text-center justify-content-center">

						Choose Sheet:
						<select class="rptInfo" [(ngModel)]="selectedSheet" (change)="resetSheet();selectSheet()" >
							<option [value]="sheet" *ngFor="let sheet of sheets">
								{{sheet}} </option>
	
						</select>
					</div>
	
				</div>
			</div>
		</div>
	</div>

	<!-- Complete search modal: -->
	<div #keySearchModal id="keySearchModal" cdkDrag class="modal fade" tabindex="-1" role="dialog" data-keyboard="false" data-backdrop="false">
		<div class="modal-dialog modal-dialog-centered" [style.max-width]="keySearchReports? '80%':'50%'">
			<div class="modal-content">
			
				<div class="modal-header" style="background-color: #323232; color: rgb(222, 222, 222); border: 0px">
					<h6 class="modal-title">Search All Reports</h6>
					<input class="btn-sm pt-1 pb-1 pl-2 ml-4" type="text" pInputText size="50" placeholder="Search for All Reports"
						[(ngModel)]="keyInput" style="width:180px; background-color:rgb(28 36 51)" (mousedown)="$event.stopPropagation()">
					<button class="btn btn-dark btn-sm ml-2" style="background-color: rgb(9 17 33);"
						[style.background-color]="keywordSearchButtonColor"
						(click)="keySearch();" (mouseover)="hoverKeywordSearchButton()" (mouseleave)="leaveKeywordSearchButton()">
						Search</button>
					<i *ngIf="keySearchLoading" class="pi pi-spin pi-spinner" style="font-size: 1.2rem; margin-left: 10px; color: #C2D63F;"></i>

					<a href="javascript:void(0)" class="btn btn-dark btn-sm pt-1 pb-1 pl-2 pr-2 ml-4" 
						title="Export to Excel" (click)="exportKeySearchExcel()">
						<span>Export to Excel</span>
					</a>

					<button type="button" class="close" data-dismiss="modal" style="color: rgb(222, 222, 222);">&times;</button>
				</div>

				<div class="modal-body" style="background-color: #323232; color: rgb(222, 222, 222); padding: 0px">
					<p-table #pt2 styleClass="p-datatable-sm" [value]="keySearchReports" [columns]="keySearchCols"
						[scrollable]="true" scrollHeight="50vh">
						<ng-template pTemplate="header" let-columns let-i>
							<tr style="font-size:12px">
								<th *ngFor="let col of columns" [ngStyle]="{'width': col.width}" [pSortableColumn]="col.sortfield" >
									<span>{{col.header}}</span>
								</th>
							</tr>
						</ng-template>
						<ng-template pTemplate="body" let-rowData let-columns="columns">
							<tr style="font-size:12px;">
								<td style="padding: 1px; padding-left: 3px; border: 2px solid rgb(9 17 33); background-color: rgb(28 36 51)"
									*ngFor="let col of columns" [ngStyle]="{'width': col.width}">
									<span *ngIf="col.field=='PROJECT_NUMBER'">
										<span *ngIf="rowData.PRIVATE_FLAG == 'Y'" class="mr-1"
											[title]="rowData.PROJECT_NUMBER">
											<i class="erisIconColor fas fa-lock"></i>
										</span>
									</span>
									<span *ngIf="!col.field2&&!col.field3&&col.field!='ORDER_NUM'&&col.field!='FULL_ADDRESS'&&col.field!='REPORT_GROUP'">
										{{rowData[col.field]}}
									</span>
									<ng-container *ngIf="col.field=='FULL_ADDRESS'&&rowData.FULL_ADDRESS">
										<a [title]="rowData.FULL_ADDRESS" class="link-light line-clamp"
											style="cursor:pointer; text-decoration: underline;">
											{{rowData.FULL_ADDRESS}}
										</a>
									</ng-container>
									<ng-container *ngIf="!col.field2&&col.field=='ORDER_NUM'">
										{{rowData.ORDER_NUM}}
										<!-- <a (click)="op.toggle($event);">{{rowData.ORDER_NUM}}</a>
										<p-overlayPanel #op [styleClass]="'fixedoverlay'"
														[appendTo]="'body'" [dismissable]="true">
											<ng-template pTemplate>
												<ng-container *ngFor="let item of rowData.ORDER_REPORTS">
													<a style="font-size:12px; color:rgb(195,212,47)"
														[href]="item.REPORT_URL"
														target=_blank>{{item.REPORT_NAME}}</a><br>
												</ng-container>
											</ng-template>
										</p-overlayPanel> -->
									</ng-container>
									<span *ngIf="col.field2&&rowData[col.field]?.length>0">
										{{rowData[col.field][0][col.field2]}}
										<ng-container *ngIf="col.field=='TRANSACTION_TYPE'&&rowData.PROTOCOL[0]">
										{{rowData.PROTOCOL[0].PROTOCOL}}
										</ng-container>
									</span>
									<span *ngIf="col.field3&&col.field3=='REPORT'">
										<a style="color:rgb(195,212,47)" [href]="'complete-rpt/'+rowData.PROJECT_ID+'/'+rowData.REPORT_ID" target=_blank>{{rowData[col.field]}}</a>	
										</span>
									<span *ngIf="col.field3&&col.field3=='TEMPLATE'">
										<span *ngIf="rowData.TEMPLATE!=undefined && rowData.TEMPLATE[0]!=undefined">
										<a class="erisIconColor" [href]="'template/'+rowData.TEMPLATE[0].TEMPLATE_ID" target=_blank>{{rowData[col.field][0].TEMPLATE_TITLE}}</a>
										</span>								
									</span>
									<span *ngIf="this.companyGroupIndicator&&col.field=='REPORT_GROUP'">
										{{rowData[col.field] ? rowData[col.field].GROUP_NAME : ''}}
									</span>
								</td>
							</tr>
						</ng-template>
					</p-table>
				</div>

				<div class="modal-footer" style="background-color: #323232; color: rgb(222, 222, 222); border: 0px">
					<button title="Close" class="btn btn-outline-dark btn-sm pt-0 pb-0 pl-1 pr-1 ml-1" 
						style="float: right; color: black; background-color: #C2D63F; border-color:black; margin-bottom: 10px; margin-top: 10px" 
						data-dismiss="modal">Close</button>
				</div>

			</div>
		</div>
	</div>

	<div id="reportModal" #reportModal class="modal fade" tabindex="-1" role="dialog" data-keyboard="false" data-backdrop="false">
		<div class="modal-dialog modal-dialog-centered" style="max-width:40%; min-width:40%; overflow-y:scroll; position:absolute; right:10%">
			<div class="modal-content" style="background-color:#cDcDcD">
				
				<div class="modal-header">
					<h6 id="" class="modal-title">Add New Report</h6>
					<button type="button" class="close" data-dismiss="modal">&times;</button>
				</div>
			
				<div style="height:60vh; max-height: 700px" class="modal-body scrollmodal">
					<div class="reportContainer col-md-12" style="font-size:12px; width:100%">
						<ng-container *ngFor="let cat of curTempCategories; let i = index">
							<div class="col-md-11" style="min-width: 600px; width:100%">
								<label class="card-title"><b>{{cat.category}}</b></label>
								<a href="javascript:void(0)" style="padding:0;" class="btn btn-sm"
									(click)="setCurTypeIndex(i); selectType(i, $event, this.curTempCategories); setSubCat(cat);setDisplaySections(7); clearInvite2(cat.userList) ">
									<i class="fas fa-angle-down" style="color:#333"></i></a>
								
									<div class="mb-2 pt-2"  [style.display]="curTypeIndex==i?'block':'none'" style="border:solid 1px white;">
									<label class="col-md-3 insideCatLabel">Template Identifier:<span style="color:red">*</span></label>
									<select class="col-md-7 p-1 rptInfo" style="margin:4px;"
										[(ngModel)]="cat.selectedSubCat"
										[ngModelOptions]="{standalone: true}"
										(change)="setByTypeId(cat); setDisplaySections(7); consoleLog(allTypeRpt)">
										<option *ngFor="let subCat of cat.subCategories;" [ngValue]="subCat">
											{{subCat.subCategory}}
										</option>
									</select>
									<ng-container *ngIf="companyGroupIndicator">
										<label class="col-md-3 insideCatLabel">Group:<span style="color:red">*</span></label>
										<select class="col-md-7 p-1 rptInfo" style="margin:4px;"
											[(ngModel)]="cat.selectedGroup"
											[ngModelOptions]="{standalone: true}"
											(change)="setByTypeId(cat); setDisplaySections(7);">
											<option value=""></option>
											<ng-container *ngFor="let group of userGroups;">
												<option [ngValue]="group">
												  {{group.GROUP_NAME}}
												</option>
											  </ng-container>
										</select>
									</ng-container>
									<label class="col-md-3 insideCatLabel">Template:<span style="color:red">*</span></label>
									<select class="col-md-7 p-1 rptInfo" style="margin:4px;"
										[(ngModel)]="cat.selectedTemplate"
										[ngModelOptions]="{standalone: true}"
										(change)="setDisplaySections(7); consoleLog(allTypeRpt)">
										<option></option>
										<option	*ngFor="let template of cat.typeIdTemplates;" [ngValue]="template">
											{{template.TEMPLATE_TITLE}}
										</option>
									</select>
									
									

									<div class="container">
										<div class="row">
											<label class="col-md-3 insideCatLabel" style="margin-top:10px">Writer:</label>
											<div class='col-md-7' style="padding:0px">
												<ng-select
													*ngIf="!cat.userList.assessor"
													class="col-md-8 p-1 rptInfo"
													[clearable]="false"
													style="margin:4px;color: grey; display:inline-block; "
													[items]="usersList"
													notFoundText="Not Found"
													bindLabel="USER_EMAIL"
													[(ngModel)]="cat.userList.assessor"
													[ngModelOptions]="{standalone: true}"
													[searchFn]="customSearchFn"
													placeholder="Select Writer">
													<ng-template ng-label-tmp let-item="item">
														<span *ngIf="item.FULL_NAME" style="color: black;">
															{{item.FULL_NAME + ' ' +'(' + item.USER_EMAIL + ')'}}
														</span>
														<span *ngIf="!item.FULL_NAME && item.USER_EMAIL" style="color: black;">
															{{item.USER_EMAIL}}
														</span>
														<!-- for blank option: -->
														<span *ngIf="!item.FULL_NAME && !item.USER_EMAIL" style="color: black;">
															&nbsp;
														</span>
													</ng-template>
													<ng-template ng-option-tmp
														let-item="item"
														let-search="searchTerm"
														let-index="index">
														<span *ngIf="item.FULL_NAME" style="color: black;">
															{{item.FULL_NAME + ' ' +'(' + item.USER_EMAIL + ')'}}
														</span>
														<span *ngIf="!item.FULL_NAME && item.USER_EMAIL" style="color: black;">
															{{item.USER_EMAIL}}
														</span>
														<!-- for blank option: -->
														<span *ngIf="!item.FULL_NAME && !item.USER_EMAIL" style="color: black;">
															&nbsp;
														</span>
													</ng-template>
												</ng-select>
												<ng-select
													*ngIf="cat.userList.assessor"
													class="col-md-8 p-1 rptInfo"
													[clearable]="false"
													style="margin:4px;color: grey; display:inline-block; "
													[items]="usersList"
													notFoundText="Not Found"
													bindLabel="USER_EMAIL"
													[(ngModel)]="cat.userList.assessor"
													[ngModelOptions]="{standalone: true}"
													[searchFn]="customSearchFn">
													<ng-template ng-label-tmp let-item="item">
														<span *ngIf="item.FULL_NAME" style="color: black;">
															{{item.FULL_NAME + ' ' +'(' + item.USER_EMAIL + ')'}}
														</span>
														<span *ngIf="!item.FULL_NAME && item.USER_EMAIL" style="color: black;">
															{{item.USER_EMAIL}}
														</span>
														<!-- for blank option: -->
														<span *ngIf="!item.FULL_NAME && !item.USER_EMAIL" style="color: black;">
															&nbsp;
														</span>
													</ng-template>
													<ng-template ng-option-tmp
														let-item="item"
														let-search="searchTerm"
														let-index="index">
														<span *ngIf="item.FULL_NAME" style="color: black;">
															{{item.FULL_NAME + ' ' +'(' + item.USER_EMAIL + ')'}}
														</span>
														<span *ngIf="!item.FULL_NAME && item.USER_EMAIL" style="color: black;">
															{{item.USER_EMAIL}}
														</span>
														<!-- for blank option: -->
														<span *ngIf="!item.FULL_NAME && !item.USER_EMAIL" style="color: black;">
															&nbsp;
														</span>
													</ng-template>
												</ng-select>
												<a style="margin-bottom:10px; margin-left:2px; margin-top:0.4rem"
													href="javascript:void(0)"
													title="Invite"
													class="btn btn-dark btn-sm pt-0 pb-0 pl-1 pr-1 col-md-auto float-right"
													(click)='invite3.toggle($event); getCompanyRoles(); clearInvite()'><i
														class="fas fa-user-plus"></i></a>
											</div>
										</div>
									</div>
									<p-overlayPanel #invite3 [dismissable]="true"
										[appendTo]="reportModal"
										[style]="{'z-index':'99999'}"
										showCloseIcon="true"
										[style]="{'max-width':'600px'}">
										<ng-template pTemplate>
											<div style="display:inline-block">
												<div>
													<label style="margin-top:10px"
													class="col-md-10 inputLabel">Invite New Users
													&nbsp;<span style="float: right">External:
														<input type="checkbox" [(ngModel)]="userExternal" (change)="changeRole()" [ngModelOptions]="{standalone: true}"></span></label>
													<label style="margin-top:10px"
													class="col-md-3 inputLabel">First Name:<span style="color:red"> * </span>
													&nbsp;</label>

												<input [(ngModel)]="firstname"
													[ngModelOptions]="{standalone: true}"
													style="background:#E6E6E6; margin:4px" type="text"
													class="col-md-7 invuser p-1 rptInfo"/>

													<label style="margin-top:10px"
													class="col-md-3 inputLabel">Last Name:<span style="color:red"> * </span>
													&nbsp;</label>

												<input [(ngModel)]="lastname"
													[ngModelOptions]="{standalone: true}"
													style="background:#E6E6E6; margin:4px" type="text"
													class="col-md-7 invuser p-1 rptInfo"/>
												<label style="margin-top:10px"
													class="col-md-3 inputLabel">Email:<span style="color:red"> * </span>
													&nbsp;</label>

												<input [(ngModel)]="userToAdd"
													[ngModelOptions]="{standalone: true}"
													style="background:#E6E6E6; margin:4px" type="text"
													class="col-md-7 invuser p-1 rptInfo" placeholder="Enter Email to Invite User"/>
											
												<!--button type="button"
													title="Invite User"
													class="btn btn-sm pt-0 pb-0 pl-1 pr-1 col-md-1"
													(click)="inviteUser2(rowData, col.field); op1.hide()"
													style="margin-left: 5px; padding: 3px; font-size: 11px; margin:4px">
													<i class="fas fa-user-plus erisGreen"></i></button-->

												<!-- <button *ngIf="i==10" type="button" class="btn btn-sm pt-0 pb-0 pl-1 pr-1 col-md-1"
															(click)="inviteUser2(rowData, col.field); op1.hide()"
															style="margin-left: 5px; padding: 3px; font-size: 11px; margin:4px"> <i class="fas fa-user-plus erisGreen"></i></button> -->
												<!-- </div> -->

													<label style="margin-top:10px"
													class="col-md-3 inputLabel">User Role:<span style="color:red"> * </span></label>
													<select style="margin:4px;" class="col-md-7 p-1 rptInfo" [(ngModel)]="role"
													[ngModelOptions]="{standalone: true}" >
														<option [value]="type.ROLE_ID" *ngFor="let type of roles">
														{{type.ROLE_NAME}} </option>
													</select>

													<label class="col-md-10 inputLabel"><button 	(click)="inviteUser4(i, 'assessor', invite3, $event)" [disabled]="inviteUserLoading" title="Invite User" class="btn btn-default btn-outline-dark" style="color: white; border-color: white; margin-top: 10px;" >Invite User</button>
														<i *ngIf="inviteUserLoading" class="pi pi-spin pi-spinner" style="font-size: 1.2rem; margin-left: 10px; color: #C2D63F;"></i>
														<span></span><span *ngIf="inviteUserErrorMessage" style="margin-left:30px;color: red"> {{inviteUserErrorMessage}} </span></label>
													</div>
												<!--div class="Info"
													style="float: left;">
													<label>Writer Email:
														&nbsp;</label>
												</div>
												<input
													class="placeholder"
													[(ngModel)]="userToAdd"
													[ngModelOptions]="{standalone: true}"
													style="background:grey; color: black"
													type="text" placeholder="Enter email to invite user"/>
												<div style="float: right;">
													<button type="button"
													class="btn m-0 uploadBtn"
														(click)="inviteUser(i, 'assessor'); invite3.hide()"
														style="margin-left: 5px; padding: 3px; font-size: 11px;">Invite</button>
												</div>
											</div>
											<br>
											<br>
											<div style="display: inline-block;">
											<div class="Info" style="float: left;">
													<label>Role: &nbsp;</label>
												</div>
											<div style="float: right; width: 45%;">
												<select class="rptInfo"
													[(ngModel)]="role"
													style="background:grey"
													[ngModelOptions]="{standalone: true}" >
													<option [value]="type.ROLE_ID" *ngFor="let type of roles">
														{{type.ROLE_NAME}} </option>
												</select>
											</div-->
											
											</div>
										</ng-template>
									</p-overlayPanel>
																		
									<!-- <div class="container">
										<div class="row">
											<label class="col-md-3 insideCatLabel"
											style="margin-top:10px" >Writer Title:</label>
											<div class="col-md-7" style="padding: 0px;">
											<ng-select 
												*ngIf = "!cat.userList.assessortitle"
												[compareWith]="compareFn" 
												class="col-md-12 p-1 rptInfo" 
												style="margin:4px; color: grey"
												(change)="setDisplaySections(7);"
												[(ngModel)]="cat.userList.assessortitle"
												[ngModelOptions]="{standalone: true}"
												placeholder="Select Writer Title">
											<ng-option [value]="title"
												*ngFor="let title of assessortitles;">
												<span style="color: black;">
													{{title.TITLE}}
												</span>	
											</ng-option>
											</ng-select>
											<ng-select 
												*ngIf = "cat.userList.assessortitle"
												[compareWith]="compareFn" 
												class="col-md-12 p-1 rptInfo" 
												style="margin:4px;"
												(change)="setDisplaySections(7);"
												[(ngModel)]="cat.userList.assessortitle"
												[ngModelOptions]="{standalone: true}"
												>
											<ng-option  [value]="title"
												*ngFor="let title of assessortitles;">
												<span style="color: black;">
													{{title.TITLE}}
												</span>	
											</ng-option>
											</ng-select>
											</div>
										</div>
									</div> -->
									<div class="container">
										<div class="row">
											<label class="col-md-3 insideCatLabel"
												style="margin-top:5px">Reviewer:</label>
											<div class='col-md-7' style="padding:0px">
												<ng-select
													*ngIf="!cat.userList.reviewer"
													class="col-md-8 p-1 rptInfo"
													[clearable]="false"
													style="margin:4px;color: grey; display:inline-block; "
													[items]="usersList"
													notFoundText="Not Found"
													bindLabel="USER_EMAIL"
													[(ngModel)]="cat.userList.reviewer"
													[ngModelOptions]="{standalone: true}"
													[searchFn]="customSearchFn"
													placeholder="Select Reviewer">
													<ng-template ng-label-tmp
														let-item="item">
														<span *ngIf="item.FULL_NAME" style="color: black;">
															{{item.FULL_NAME + ' ' +'(' + item.USER_EMAIL + ')'}}
														</span>
														<span *ngIf="!item.FULL_NAME && item.USER_EMAIL" style="color: black;">
															{{item.USER_EMAIL}}
														</span>
														<!-- for blank option: -->
														<span *ngIf="!item.FULL_NAME && !item.USER_EMAIL" style="color: black;">
															&nbsp;
														</span>
													</ng-template>
													<ng-template ng-option-tmp
														let-item="item"
														let-search="searchTerm"
														let-index="index">
														<span *ngIf="item.FULL_NAME" style="color: black;">
															{{item.FULL_NAME + ' ' +'(' + item.USER_EMAIL + ')'}}
														</span>
														<span *ngIf="!item.FULL_NAME && item.USER_EMAIL" style="color: black;">
															{{item.USER_EMAIL}}
														</span>
														<!-- for blank option: -->
														<span *ngIf="!item.FULL_NAME && !item.USER_EMAIL" style="color: black;">
															&nbsp;
														</span>
													</ng-template>
												</ng-select>
												<ng-select
													*ngIf="cat.userList.reviewer"
													class="col-md-8 p-1 rptInfo"
													[clearable]="false"
													style="margin:4px;color: grey; display:inline-block; "
													[items]="usersList"
													notFoundText="Not Found"
													bindLabel="USER_EMAIL"
													[(ngModel)]="cat.userList.reviewer"
													[ngModelOptions]="{standalone: true}"
													[searchFn]="customSearchFn">
													<ng-template ng-label-tmp
														let-item="item">
														<span *ngIf="item.FULL_NAME" style="color: black;">
															{{item.FULL_NAME + ' ' +'(' + item.USER_EMAIL + ')'}}
														</span>
														<span *ngIf="!item.FULL_NAME && item.USER_EMAIL" style="color: black;">
															{{item.USER_EMAIL}}
														</span>
														<!-- for blank option: -->
														<span *ngIf="!item.FULL_NAME && !item.USER_EMAIL" style="color: black;">
															&nbsp;
														</span>
													</ng-template>
													<ng-template ng-option-tmp
														let-item="item"
														let-search="searchTerm"
														let-index="index">
														<span *ngIf="item.FULL_NAME" style="color: black;">
															{{item.FULL_NAME + ' ' +'(' + item.USER_EMAIL + ')'}}
														</span>
														<span *ngIf="!item.FULL_NAME && item.USER_EMAIL" style="color: black;">
															{{item.USER_EMAIL}}
														</span>
														<!-- for blank option: -->
														<span *ngIf="!item.FULL_NAME && !item.USER_EMAIL" style="color: black;">
															&nbsp;
														</span>
													</ng-template>
												</ng-select>
												<a style="margin-bottom:10px; margin-left:2px; margin-top:0.4rem"
													href="javascript:void(0)"
													title="Invite"
													class="btn btn-dark btn-sm pt-0 pb-0 pl-1 pr-1 col-md-auto float-right"
													(click)='invite2.toggle($event); getCompanyRoles(); clearInvite()'>
													<i
														class="fas fa-user-plus"></i></a>
											</div>
										</div>
									</div>
									<p-overlayPanel #invite2 [dismissable]="true"
										[appendTo]="reportModal"
										[style]="{'z-index':'99999'}"
										showCloseIcon="true"
										[style]="{'max-width':'600px'}">
										<ng-template pTemplate>
											<div style="display:inline-block">
												<div>
													<label style="margin-top:10px"
													class="col-md-10 inputLabel">Invite New Users
													&nbsp;<span style="float: right">External:
														<input type="checkbox" [(ngModel)]="userExternal" (change)="changeRole()" [ngModelOptions]="{standalone: true}"></span></label>

												

													<label style="margin-top:10px"
													class="col-md-3 inputLabel">First Name:<span style="color:red"> * </span>
													&nbsp;</label>

												<input [(ngModel)]="firstname"
													[ngModelOptions]="{standalone: true}"
													style="background:#E6E6E6; margin:4px" type="text"
													class="col-md-7 invuser p-1 rptInfo"/>

													<label style="margin-top:10px"
													class="col-md-3 inputLabel">Last Name:<span style="color:red"> * </span>
													&nbsp;</label>

												<input [(ngModel)]="lastname"
													[ngModelOptions]="{standalone: true}"
													style="background:#E6E6E6; margin:4px" type="text"
													class="col-md-7 invuser p-1 rptInfo"/>
												<label style="margin-top:10px"
													class="col-md-3 inputLabel">Email:<span style="color:red"> * </span>
													&nbsp;</label>

												<input [(ngModel)]="userToAdd"
													[ngModelOptions]="{standalone: true}"
													style="background:#E6E6E6; margin:4px" type="text"
													class="col-md-7 invuser p-1 rptInfo" placeholder="Enter Email to Invite User"/>
											
												<!--button type="button"
													title="Invite User"
													class="btn btn-sm pt-0 pb-0 pl-1 pr-1 col-md-1"
													(click)="inviteUser2(rowData, col.field); op1.hide()"
													style="margin-left: 5px; padding: 3px; font-size: 11px; margin:4px">
													<i class="fas fa-user-plus erisGreen"></i></button-->

												<!-- <button *ngIf="i==10" type="button" class="btn btn-sm pt-0 pb-0 pl-1 pr-1 col-md-1"
															(click)="inviteUser2(rowData, col.field); op1.hide()"
															style="margin-left: 5px; padding: 3px; font-size: 11px; margin:4px"> <i class="fas fa-user-plus erisGreen"></i></button> -->
												<!-- </div> -->

													<label style="margin-top:10px"
													class="col-md-3 inputLabel">User Role:<span style="color:red"> * </span></label>
													<select style="margin:4px;" class="col-md-7 p-1 rptInfo" [(ngModel)]="role"
													[ngModelOptions]="{standalone: true}" >
														<option [value]="type.ROLE_ID" *ngFor="let type of roles">
														{{type.ROLE_NAME}} </option>
											
													</select>

													<label class="col-md-10 inputLabel"><button 	(click)="inviteUser4(i, 'reviewer', invite2, $event)" [disabled]="inviteUserLoading" title="Invite User" class="btn btn-default btn-outline-dark" style="color: white; border-color: white; margin-top: 10px;" >Invite User</button>
														<i *ngIf="inviteUserLoading" class="pi pi-spin pi-spinner" style="font-size: 1.2rem; margin-left: 10px; color: #C2D63F;"></i>
														<span></span><span *ngIf="inviteUserErrorMessage" style="margin-left:30px;color: red"> {{inviteUserErrorMessage}} </span></label>
													</div>

												<!--div class="Info"
													style="float: left;">
													<label>Reviewer Email:
														&nbsp;</label>
												</div>
												<input 
													class="rptInfo"
													[(ngModel)]="userToAdd"
													[ngModelOptions]="{standalone: true}"
													style="background:grey; color: black"
													type="text" placeholder="Enter email to invite user"/>
												<div style="float: right;">
													<button type="button"
													class="btn m-0 uploadBtn"
														(click)="inviteUser(i, 'reviewer'); invite2.hide()"
														style="margin-left: 5px; padding: 3px; font-size: 11px;">Invite</button>
												</div>
											</div>
											<br>
											<br>
											<div style="display: inline-block;">
											<div class="Info" style="float: left;">
													<label>Role: &nbsp;</label>
												</div>
											<div style="float: right; width: 35%;">
												<select class="rptInfo" 
													[(ngModel)]="role"
													style="background:grey"
													[ngModelOptions]="{standalone: true}" >
													<option [value]="type.ROLE_ID" *ngFor="let type of roles">
														{{type.ROLE_NAME}} </option>
												</select>
											</div-->
											
											</div>
											
											</ng-template>
									</p-overlayPanel>
									<!--div class="container">
										<div class="row">
											<label class="col-md-3 insideCatLabel"
											style="margin-top:10px" >Reviewer Title:</label>
											<div class="col-md-7" style="padding: 0px;">
											<ng-select 
												*ngIf = "!cat.userList.reviewertitle"
												[compareWith]="compareFn" 
												class="col-md-12 p-1 rptInfo" 
												style="margin:4px; color: grey"
												(change)="setDisplaySections(7);"
												[(ngModel)]="cat.userList.reviewertitle"
												[ngModelOptions]="{standalone: true}"
												placeholder="Select Reviewer Title">
											<ng-option   [value]="title"
												*ngFor="let title of reviewertitles;">
												<span style="color: black;">
													{{title.TITLE}}
												</span>	
											</ng-option>
											</ng-select>
											<ng-select 
												*ngIf = "cat.userList.reviewertitle"
												[compareWith]="compareFn" 
												class="col-md-12 p-1 rptInfo" 
												style="margin:4px;"
												(change)="setDisplaySections(7);"
												[(ngModel)]="cat.userList.reviewertitle"
												[ngModelOptions]="{standalone: true}"
												>
											<ng-option  [value]="title"
												*ngFor="let title of reviewertitles;">
												<span style="color: black;">
													{{title.TITLE}}
												</span>	
											</ng-option>
											</ng-select>
											</div>
										</div>
									</div-->
									<div class="container">
										<div class="row">
											<label class="col-md-3 insideCatLabel"
												style="margin-top:5px">Users:</label>
											<div class='col-md-7'
												style="padding:0px">
												<ng-select
													(click)="consoleLog(usersList)"
													*ngIf="!cat.userList.assigned_user"
													class="col-md-8 p-1 rptInfo"
													[clearable]="false"
													style="margin:4px;color: grey; display:inline-block;"
													[items]="usersList"
													notFoundText="Not Found"
													bindLabel="USER_EMAIL"
													[(ngModel)]="cat.userList.assigned_user"
													[ngModelOptions]="{standalone: true}"
													[searchFn]="customSearchFn"
													placeholder="Select User">
													<ng-template ng-label-tmp
														let-item="item">
														<span *ngIf="item.FULL_NAME" style="color: black;">
															{{item.FULL_NAME + ' ' +'(' + item.USER_EMAIL + ')'}}
														</span>
														<span *ngIf="!item.FULL_NAME && item.USER_EMAIL" style="color: black;">
															{{item.USER_EMAIL}}
														</span>
														<!-- for blank option: -->
														<span *ngIf="!item.FULL_NAME && !item.USER_EMAIL" style="color: black;">
															&nbsp;
														</span>
													</ng-template>
													<ng-template ng-option-tmp
														let-item="item"
														let-search="searchTerm"
														let-index="index">
														<span *ngIf="item.FULL_NAME" style="color: black;">
															{{item.FULL_NAME + ' ' +'(' + item.USER_EMAIL + ')'}}
														</span>
														<span *ngIf="!item.FULL_NAME && item.USER_EMAIL" style="color: black;">
															{{item.USER_EMAIL}}
														</span>
														<!-- for blank option: -->
														<span *ngIf="!item.FULL_NAME && !item.USER_EMAIL" style="color: black;">
															&nbsp;
														</span>
													</ng-template>
												</ng-select>
												<ng-select
													*ngIf="cat.userList.assigned_user"
													class="col-md-8 p-1 rptInfo"
													[clearable]="false"
													style="margin:4px;color: grey; display:inline-block;"
													[items]="usersList"
													notFoundText="Not Found"
													bindLabel="USER_EMAIL"
													[(ngModel)]="cat.userList.assigned_user"
													[ngModelOptions]="{standalone: true}"
													[searchFn]="customSearchFn"
													>
													<ng-template ng-label-tmp
														let-item="item">
														<span *ngIf="item.FULL_NAME" style="color: black;">
															{{item.FULL_NAME + ' ' +'(' + item.USER_EMAIL + ')'}}
														</span>
														<span *ngIf="!item.FULL_NAME && item.USER_EMAIL" style="color: black;">
															{{item.USER_EMAIL}}
														</span>
														<!-- for blank option: -->
														<span *ngIf="!item.FULL_NAME && !item.USER_EMAIL" style="color: black;">
															&nbsp;
														</span>
													</ng-template>
													<ng-template ng-option-tmp
														let-item="item"
														let-search="searchTerm"
														let-index="index">
														<span *ngIf="item.FULL_NAME" style="color: black;">
															{{item.FULL_NAME + ' ' +'(' + item.USER_EMAIL + ')'}}
														</span>
														<span *ngIf="!item.FULL_NAME && item.USER_EMAIL" style="color: black;">
															{{item.USER_EMAIL}}
														</span>
														<!-- for blank option: -->
														<span *ngIf="!item.FULL_NAME && !item.USER_EMAIL" style="color: black;">
															&nbsp;
														</span>
													</ng-template>
												</ng-select>
												<a style="margin-bottom:10px; margin-left:2px; margin-top:0.4rem"
													href="javascript:void(0)"
													title="Invite"
													class="btn btn-dark btn-sm pt-0 pb-0 pl-1 pr-1 col-md-auto float-right"
													(click)='invite.toggle($event); getCompanyRoles(); clearInvite()'><i
														class="fas fa-user-plus"></i></a>
											</div>
										</div>
									</div>
									<p-overlayPanel #invite [dismissable]="true"
										[appendTo]="reportModal" [style]="{'z-index':'99999'}"
										showCloseIcon="true" [style]="{'max-width':'600px'}">
										<ng-template pTemplate>
											<div style="display:inline-block">
												<div>
													<label style="margin-top:10px"
													class="col-md-10 inputLabel">Invite New Users
													&nbsp;<span style="float: right">External:
														<input type="checkbox" [(ngModel)]="userExternal" (change)="changeRole()" [ngModelOptions]="{standalone: true}"></span></label>

												

													<label style="margin-top:10px"
													class="col-md-3 inputLabel">First Name:<span style="color:red"> * </span>
													&nbsp;</label>

												<input [(ngModel)]="firstname"
													[ngModelOptions]="{standalone: true}"
													style="background:#E6E6E6; margin:4px" type="text"
													class="col-md-7 invuser p-1 rptInfo"/>

													<label style="margin-top:10px"
													class="col-md-3 inputLabel">Last Name:<span style="color:red"> * </span>
													&nbsp;</label>

												<input [(ngModel)]="lastname"
													[ngModelOptions]="{standalone: true}"
													style="background:#E6E6E6; margin:4px" type="text"
													class="col-md-7 invuser p-1 rptInfo"/>
												<label style="margin-top:10px"
													class="col-md-3 inputLabel">Email:<span style="color:red"> * </span>
													&nbsp;</label>

												<input [(ngModel)]="userToAdd"
													[ngModelOptions]="{standalone: true}"
													style="background:#E6E6E6; margin:4px" type="text"
													class="col-md-7 invuser p-1 rptInfo" placeholder="Enter Email to Invite User"/>
											
												<!--button type="button"
													title="Invite User"
													class="btn btn-sm pt-0 pb-0 pl-1 pr-1 col-md-1"
													(click)="inviteUser2(rowData, col.field); op1.hide()"
													style="margin-left: 5px; padding: 3px; font-size: 11px; margin:4px">
													<i class="fas fa-user-plus erisGreen"></i></button-->

												<!-- <button *ngIf="i==10" type="button" class="btn btn-sm pt-0 pb-0 pl-1 pr-1 col-md-1"
															(click)="inviteUser2(rowData, col.field); op1.hide()"
															style="margin-left: 5px; padding: 3px; font-size: 11px; margin:4px"> <i class="fas fa-user-plus erisGreen"></i></button> -->
												<!-- </div> -->

													<label style="margin-top:10px"
													class="col-md-3 inputLabel">User Role:<span style="color:red"> * </span></label>
													<select style="margin:4px;" class="col-md-7 p-1 rptInfo" [(ngModel)]="role"
													[ngModelOptions]="{standalone: true}" >
														<option [value]="type.ROLE_ID" *ngFor="let type of roles">
														{{type.ROLE_NAME}} </option>
											
													</select>

													<label class="col-md-10 inputLabel"><button 	(click)="inviteUser4(i, 'assigned_user', invite, $event)" [disabled]="inviteUserLoading" title="Invite User" class="btn btn-default btn-outline-dark" style="color: white; border-color: white; margin-top: 10px;" >Invite User</button>
														<i *ngIf="inviteUserLoading" class="pi pi-spin pi-spinner" style="font-size: 1.2rem; margin-left: 10px; color: #C2D63F;"></i>

														<span></span><span *ngIf="inviteUserErrorMessage" style="margin-left:30px;color: red"> {{inviteUserErrorMessage}} </span></label>
													</div>
												<!--div class="Info"
													style="float: left;">
													<label>User Email:
														&nbsp;</label>
												</div>
												<input [(ngModel)]="userToAdd"
													[ngModelOptions]="{standalone: true}"
													style="background:grey; color: black"
													type="text" placeholder="Enter email to invite user"/>
												<div style="float: right;">
													<button type="button"
													class="btn m-0 uploadBtn"
														(click)="inviteUser(i, 'assigned_user'); invite.hide()"
														style="margin-left: 5px; padding: 3px; font-size: 11px;">Invite</button>
												</div>
											</div>
											<br>
											<br>
											<div style="display: inline-block;">
											<div class="Info" style="float: left;">
													<label>Role: &nbsp;</label>
												</div>
											<div style="float: right; width: 50%;">
												<select class="rptInfo"
													[(ngModel)]="role"
													style="background:grey"
													[ngModelOptions]="{standalone: true}" >
													<option [value]="type.ROLE_ID" *ngFor="let type of roles">
														{{type.ROLE_NAME}} </option>
												</select>
											</div-->
											
											</div>
										</ng-template>
									</p-overlayPanel>

									<div class="container">
										<div class="row">
											<label class="col-md-3 insideCatLabel"
												style="margin-top:5px">Project Manager:</label>
											<div class='col-md-7'
												style="padding:0px">
												<ng-select *ngIf="!cat.userList.pm"
													class="col-md-12 p-1 rptInfo"
													[clearable]="false"
													style="margin:4px;color: grey; display:inline-block;"
													[items]="pmList"
													notFoundText="Not Found"
													bindLabel="USER_EMAIL"
													[(ngModel)]="cat.userList.pm"
													[ngModelOptions]="{standalone: true}"
													[searchFn]="customSearchFn"
													placeholder="Select User"  (click)="getProM()">
													<ng-template ng-label-tmp
														let-item="item">
														<span *ngIf="item.FULL_NAME" style="color: black;">
															{{item.FULL_NAME + ' ' +'(' + item.USER_EMAIL + ')'}}
														</span>
														<span *ngIf="!item.FULL_NAME && item.USER_EMAIL" style="color: black;">
															{{item.USER_EMAIL}}
														</span>
														<!-- for blank option: -->
														<span *ngIf="!item.FULL_NAME && !item.USER_EMAIL" style="color: black;">
															&nbsp;
														</span>
													</ng-template>
													<ng-template ng-option-tmp
														let-item="item"
														let-search="searchTerm"
														let-index="index">
														<span *ngIf="item.FULL_NAME" style="color: black;">
															{{item.FULL_NAME + ' ' +'(' + item.USER_EMAIL + ')'}}
														</span>
														<span *ngIf="!item.FULL_NAME && item.USER_EMAIL" style="color: black;">
															{{item.USER_EMAIL}}
														</span>
														<!-- for blank option: -->
														<span *ngIf="!item.FULL_NAME && !item.USER_EMAIL" style="color: black;">
															&nbsp;
														</span>
													</ng-template>
												</ng-select>
												<ng-select *ngIf="cat.userList.pm"
													class="col-md-12 p-1 rptInfo"
													[clearable]="false"
													style="margin:4px;color: grey; display:inline-block;"
													[items]="pmList"
													notFoundText="Not Found"
													bindLabel="USER_EMAIL"
													[(ngModel)]="cat.userList.pm"
													[ngModelOptions]="{standalone: true}"
													[searchFn]="customSearchFn"
													(click)="getProM()">
													<ng-template ng-label-tmp
														let-item="item">
														<span *ngIf="item.FULL_NAME" style="color: black;">
															{{item.FULL_NAME + ' ' +'(' + item.USER_EMAIL + ')'}}
														</span>
														<span *ngIf="!item.FULL_NAME && item.USER_EMAIL" style="color: black;">
															{{item.USER_EMAIL}}
														</span>
														<!-- for blank option: -->
														<span *ngIf="!item.FULL_NAME && !item.USER_EMAIL" style="color: black;">
															&nbsp;
														</span>
													</ng-template>
													<ng-template ng-option-tmp
														let-item="item"
														let-search="searchTerm"
														let-index="index">
														<span *ngIf="item.FULL_NAME" style="color: black;">
															{{item.FULL_NAME + ' ' +'(' + item.USER_EMAIL + ')'}}
														</span>
														<span *ngIf="!item.FULL_NAME && item.USER_EMAIL" style="color: black;">
															{{item.USER_EMAIL}}
														</span>
														<!-- for blank option: -->
														<span *ngIf="!item.FULL_NAME && !item.USER_EMAIL" style="color: black;">
															&nbsp;
														</span>
													</ng-template>
												</ng-select>									
											</div>
										</div>
									</div>
									<div class="container">
										<a href="javascript:void(0)" style="margin-bottom:10px; margin-left:2px; margin-top:0.4rem"
										class="btn btn-dark btn-sm pt-0 pb-0 pl-1 pr-1" (click)="addSingleRpt(cat)">Add</a>
										<!--span *ngIf="cat['toAdd']&&!(cat.selectedSubCat&&cat.selectedSubCat.typeId)&&cat.selectedTemplate.TEMPLATE_TITLE==null" style="color:red">* Template Identifier is required.</span-->
										<span *ngIf="displayAddSingleRptErrorMessage" style="color:red">&nbsp;{{addSingleRptErrorMessage}}</span>

										<span *ngIf="cat.selectedSubCat&&cat.selectedSubCat.typeId&&cat['added']" style="color:red">* Report already added.</span>																			
									</div>
								</div>
							</div>
						</ng-container>					
					</div>
				</div>
			</div>
		</div>
	</div>
	<div id="fileModal" #fileModal class="modal fade" data-backdrop='false'>
		<div class="modal-dialog modal-lg modal-dialog-centered ">
		<div class="modal-content" style="background:#444; color:#ccc">
			<!-- Modal Header -->
			  <!--<div class="modal-header">
			  <h6 id="" class="modal-title">Project Documents</h6>
			<a href='javascript:void(0)' class="btn btn-outline-success btn-sm  pr-1 pl-1 pt-0 pb-0 ml-3" title="Insert Image" (click)='insertImage()'><i class="fas fa-check"></i></a>
				<button type="button" class="close" data-dismiss="modal">&times;</button>
			</div>-->
			
			<!-- Modal body -->
			<div class="modal-body">
			<button type="button" class="close" data-dismiss="modal">&times;</button>
			
				
				<div style="width:100%">
		<ul class="nav nav-tabs">
		<li class="nav-item">
			<a class="nav-link" [ngClass]="{'active':uploadType=='FILE'}" data-toggle="tab" href="#files">Project Documents</a>		
		</li>
		<!-- only show photos tab if it's a report: -->
		<li class="nav-item" *ngIf="showPhotosTab">
		  <a class="nav-link" [ngClass]="{'active':uploadType=='PHOTO'}" data-toggle="tab" href="#photos">Photo Gallery</a>
		</li>
		<!-- remove Company Images:
		<li class="nav-item">
		  <a class="nav-link" [ngClass]="{'active':uploadType=='IMAGE'||uploadType=='BKIMAGE'||uploadType=='LOGO'}" data-toggle="tab" href="#images" >Company Images </a>
		</li>	 -->
	  </ul>
	  <!-- Tab panes -->
	  <div class="tab-content">
		
			<div id="files" class="container tab-pane" [ngClass]="{'active':uploadType=='FILE','fade':uploadType!='FILE'}" style="width:100%; padding:0; max-height:600px; overflow:auto">
				<div class="row" style="width:98%">
					<div *ngIf="uploadTotal!==0&&uploadTotal!==100&&uploadType=='FILE'" class="progress-wrapper col-md-10" style="height:10px;margin:4px">
						<div class="progress">
							<div class="progress-bar progress-bar-striped" style="height:10px;" [ngStyle]="{'width': uploadTotal + '%'}">
								{{uploadFiles}} of {{uploadNo}}
							</div>
						</div>
					</div>
					<a href='javascript:void(0)' class="btn uploadBtn ml-auto m-1" [ngClass]="{'disabled':uploadTotal!==0&&uploadTotal!==100}" (click)='upload("FILE")'>Upload</a>
					<span *ngIf="loading" class="fa fa-spinner fa-spin float-right" style="font-size:16px;color:rgb(195,212,47)"></span>
				</div>			
				<p-table #dt [value]="uploadedFiles" [columns]="cols62">
					<ng-template pTemplate="caption">
						<i class="pi pi-search"></i>
						<input type="text" (input)="dt.filterGlobal($event.target.value, 'contains')" placeholder="Global Search" style="font-size:11px; padding:2px"/>
					</ng-template>
							<ng-template pTemplate="header"  let-columns>
								<tr>
									<th *ngFor="let col of columns" [pSortableColumn]="col.field" [ngStyle]="{'width': col.width}" style="padding:1px; font-size:11px">
										{{col.header}} <p-sortIcon field="code"></p-sortIcon>               
									</th>
								</tr>
							</ng-template>
							<ng-template pTemplate="body" let-rowData let-columns="columns">
								<tr>
									<td *ngFor="let col of columns" [ngStyle]="{'width': col.width}" style="padding:1px; font-size:11px; text-overflow:ellipsis; overflow:hidden;">
										<span *ngIf="col.field=='FILE_NAME'"><a [href]="rowData.FILE_URL" style="color: rgb(195,212,47)" target=_blank>{{rowData[col.field]}}</a></span>
										<span *ngIf="col.field!=='FILE_NAME' && col.field!='PROJECT_ID'">{{rowData[col.field]}}</span>	
										<span *ngIf="col.field=='PROJECT_ID'">
											{{currentRowData.PROJECT_NUMBER}}
										</span>		
										
										<!-- remove delete button: -->
										<!-- <i  *ngIf="col.field=='FILE_NAME'" class="brn btn-outline-light btn-small far fa-trash-alt float-right mt-1"  style="color:#C2D63F"(click)="deleteFile(rowData, 'FILE')"></i> -->
										
									</td>																	
								</tr>
							</ng-template>
						</p-table>					
					</div>					
					<div id="images" class="container tab-pane" [ngClass]="{'active':uploadType=='IMAGE'||uploadType=='BKIMAGE'||uploadType=='LOGO', 'fade':uploadType!='IMAGE'&&uploadType!='BKIMAGE'&&uploadType!='LOGO'}">
						<div style="color:#C2D63F; font-size:.9em; padding-left:10px">
							<label class="radio-inline mr-2">
								<input type="radio" name="uploadimage" [checked]="imgGroup=='other'" (change)="imgGroup='other'"> 
								Images 
							</label> 
							<label class="radio-inline ml-3">
								<input type="radio" name="uploadimage" [checked]="imgGroup=='bk'" (change)="imgGroup='bk'">
								Background Images
							</label> 
							<label class="radio-inline ml-3"> 
								<input type="radio" name="uploadimage" [checked]="imgGroup=='logo'" (change)="imgGroup='logo'">
								Logos
							</label>
						</div>
					<div *ngIf="imgGroup=='other'"  style="padding:0; max-height:600px;  overflow-y: auto;overflow-x: hidden;">
					<div class="row" style="width:98%">
					<div *ngIf="uploadTotal!==0&&uploadTotal!==100&&uploadType=='IMAGE'&&imgGroup=='other'" class="progress-wrapper col-md-10" style="height:10px;margin:4px">
						<div class="progress">
							<div class="progress-bar progress-bar-striped" style="height:10px;" [ngStyle]="{'width': uploadTotal + '%'}">
								{{uploadFiles}} of {{uploadNo}}
							</div>
						</div>
					</div>
					<a href='javascript:void(0)' class="btn uploadBtn ml-auto m-1" [ngClass]="{'disabled':uploadTotal!==0&&uploadTotal!==100}" (click)='upload("IMAGE")'>Upload</a>
					<span *ngIf="loading" class="fa fa-spinner fa-spin float-right" style="font-size:16px;color:rgb(195,212,47)"></span>
				</div>				
						<!--<ng-container *ngFor="let other of others">
							<img class="bkImage" style="display:inline-block; width:100px; height:100px; margin:10px" [src]="other.FILE_TN_URL">
						</ng-container>-->
						<ul class="widget-item-list">
							<li class="item" *ngFor="let other of others">
								<div class="img-wrapper">
									<img *ngIf="other.FILE_TN_URL" [src]="other.FILE_TN_URL" class="img img-fluid"/>
								</div>
								<div *ngIf="other.FILE_DESCRIPTION.length>0" class="title" title="Click to Edit Description"  (click)="op41.toggle($event)">{{other.FILE_DESCRIPTION.substring(0, 40)}}<span *ngIf="other.FILE_DESCRIPTION.length>40"> . . . </span></div>
								<div *ngIf="other.FILE_DESCRIPTION.length==0" class="title" title="Click to Edit Description"  (click)="op41.toggle($event)" style="color:rgb(195,212,47);">Click to Edit File Description</div>
								<hr class="line">
								<a href="javascript:void(0);" class="remove" (click)="op41.toggle($event)"><i class="erisGreen far fa-edit" style="font-size: 10px;"></i></a>
								<!-- remove delete button: -->
								<!-- <a href="javascript:void(0);" class="remove" (click)="deleteFile(other, 'IMAGE')"><i class="erisGreen far fa-trash-alt" style="font-size: 10px;"></i></a> -->
								<p-overlayPanel #op41 [appendTo]="fileModal" [dismissable]="true" [showCloseIcon]="true"  [autoZIndex]="false" [baseZIndex]="1000" [style]="{'width': '300px'}">
									<ng-template pTemplate>
										<div style="margin: 0; color:#C2D63F;max-height:400px; overflow:auto; font-size:.9em"> 
											<strong>File Description : </strong><br> 
											<textarea class="col-md-12" rows=6 maxlength="100" style="font-size:11px; z-index:1010">{{other.FILE_DESCRIPTION}}</textarea>
											<button class="btn m-0 uploadBtn float-right" (click)="updateFile(other, 'IMAGE', $event)">Update</button>
										</div>
									</ng-template>
								</p-overlayPanel>
							</li>
					 
					  
						</ul>
					</div>
					
					<div *ngIf="imgGroup=='bk'"  style="padding:0; max-height:600px;  overflow-y: auto;overflow-x: hidden;">
					<div class="row" style="width:98%">
					<div *ngIf="uploadTotal!==0&&uploadTotal!==100&&uploadType=='BKIMAGE'&&imgGroup=='bk'" class="progress-wrapper col-md-10" style="height:10px;margin:4px">
						<div class="progress">
							<div class="progress-bar progress-bar-striped" style="height:10px;" [ngStyle]="{'width': uploadTotal + '%'}">
								{{uploadFiles}} of {{uploadNo}}
							</div>
						</div>
					</div>
					<a href='javascript:void(0)' class="btn uploadBtn ml-auto m-1" [ngClass]="{'disabled':uploadTotal!==0&&uploadTotal!==100}" (click)='upload("BKIMAGE")'>Upload</a>
					<span *ngIf="loading" class="fa fa-spinner fa-spin float-right" style="font-size:16px;color:rgb(195,212,47)"></span>
				</div>				
						<!--<ng-container *ngFor="let bk of bks">
							<img class="bkImage" style="display:inline-block; width:100px; height:100px; margin:10px" [src]="bk.FILE_TN_URL">
						</ng-container>-->
						<ul class="widget-item-list">
							<li class="item" *ngFor="let bk of bks">
								<div class="img-wrapper">
									<img *ngIf="bk.FILE_TN_URL" [src]="bk.FILE_TN_URL" class="img img-fluid"/>
								</div>
								<div *ngIf="bk.FILE_DESCRIPTION.length>0" class="title" title="Click to Edit Description"  (click)="op42.toggle($event)">{{bk.FILE_DESCRIPTION.substring(0, 40)}}<span *ngIf="bk.FILE_DESCRIPTION.length>40"> . . . </span></div>
								<div *ngIf="bk.FILE_DESCRIPTION.length==0" class="title" title="Click to Edit Description"  (click)="op42.toggle($event)" style="color:rgb(195,212,47);">Click to Edit File Description</div>
								<hr class="line">
								<a href="javascript:void(0);" class="remove" (click)="op42.toggle($event)"><i class="far fa-edit" style="font-size: 10px;"></i></a>
								<!-- remove delete button: -->
								<!-- <a href="javascript:void(0);" class="remove" (click)="deleteFile(bk, 'BKIMAGE')"><i class="far fa-trash-alt" style="font-size: 10px;"></i></a> -->
								<p-overlayPanel #op42 [appendTo]="fileModal" [dismissable]="true" [showCloseIcon]="true"  [autoZIndex]="false" [baseZIndex]="1000" [style]="{'width': '300px'}">
									<ng-template pTemplate>
										<div style="margin: 0; color:#C2D63F;max-height:400px; overflow:auto; font-size:.9em"> 
											<strong>File Description : </strong><br> 
											<textarea class="col-md-12" rows=6 maxlength="100" style="font-size:11px; z-index:1010">{{bk.FILE_DESCRIPTION}}</textarea>
											<button class="btn m-0 uploadBtn float-right" (click)="updateFile(bk, 'BKIMAGE', $event)">Update</button>
										</div>
									</ng-template>
								</p-overlayPanel>
							</li>
					 
					  
						</ul>
					</div>
					
					<div *ngIf="imgGroup=='logo'"  style="padding:0; max-height:600px;  overflow-y: auto;overflow-x: hidden;">
						<div class="row" style="width:98%">
							<div *ngIf="uploadTotal!==0&&uploadTotal!==100&&uploadType=='LOGO'&&imgGroup=='logo'" class="progress-wrapper col-md-10" style="height:10px;margin:4px">
								<div class="progress">
									<div class="progress-bar progress-bar-striped" style="height:10px;" [ngStyle]="{'width': uploadTotal + '%'}">
										{{uploadFiles}} of {{uploadNo}}
									</div>
								</div>
							</div>
							<a href='javascript:void(0)' class="btn uploadBtn ml-auto m-1" [ngClass]="{'disabled':uploadTotal!==0&&uploadTotal!==100}" (click)='upload("LOGO")'>Upload</a>
							<span *ngIf="loading" class="fa fa-spinner fa-spin float-right" style="font-size:16px;color:rgb(195,212,47)"></span>
						</div>
				
						<!--<ng-container *ngFor="let logo of logos">
							<img class="bkImage" style="display:inline-block; width:100px; height:100px; margin:10px" [src]="logo.FILE_TN_URL">
						</ng-container>-->
						<ul class="widget-item-list">
							<li class="item" *ngFor="let logo of logos">
								<div class="img-wrapper">
									<img *ngIf="logo.FILE_TN_URL" [src]="logo.FILE_TN_URL" class="img img-fluid"/>
								</div>
								<div *ngIf="logo.FILE_DESCRIPTION.length>0" class="title" title="Click to Edit Description"  (click)="op43.toggle($event)">{{logo.FILE_DESCRIPTION.substring(0, 40)}}<span *ngIf="logo.FILE_DESCRIPTION.length>40"> . . . </span></div>
								<div *ngIf="logo.FILE_DESCRIPTION.length==0" class="title" title="Click to Edit Description"  (click)="op43.toggle($event)" style="color:rgb(195,212,47);">Click to Edit File Description</div>
								<hr class="line">
								<a href="javascript:void(0);" class="remove" (click)="op43.toggle($event)"><i class="far fa-edit" style="font-size: 10px;"></i></a>
								<!-- remove delete button: -->
								<!-- <a href="javascript:void(0);" class="remove" (click)="deleteFile(logo, 'LOGO')"><i class="far fa-trash-alt" style="font-size: 10px;"></i></a> -->
								<p-overlayPanel #op43 [appendTo]="fileModal" [dismissable]="true" [showCloseIcon]="true"  [autoZIndex]="false" [baseZIndex]="1000" [style]="{'width': '300px'}">
									<ng-template pTemplate>
										<div style="margin: 0; color:#C2D63F;max-height:400px; overflow:auto; font-size:.9em"> 
											<strong>File Description : </strong><br> 
											<textarea class="col-md-12" rows=6 maxlength="100" style="font-size:11px; z-index:1010">{{logo.FILE_DESCRIPTION}}</textarea>
											<button class="btn m-0 uploadBtn float-right" (click)="updateFile(logo, 'LOGO', $event)">Update</button>
										</div>
									</ng-template>
								</p-overlayPanel>
							</li>
					 
					  
						</ul>
						</div>
					</div>
					<div id="photos" class="container tab-pane" [ngClass]="{'active':uploadType=='PHOTO','fade':uploadType!='PHOTO' }"  style="width:100%; padding:0; margin:0; max-height:600px; overflow-y: auto;overflow-x: hidden;">
						<div class="row" style="width:98%">
							<div *ngIf="uploadTotal!==0&&uploadTotal!==100&&uploadType=='PHOTO'" class="progress-wrapper col-md-10" style="height:10px;margin:4px">
								<div class="progress">
									<div class="progress-bar progress-bar-striped" style="height:10px;" [ngStyle]="{'width': uploadTotal + '%'}">
										{{uploadFiles}} of {{uploadNo}}
									</div>
								</div>
							</div>
							<a href='javascript:void(0)' class="btn uploadBtn ml-auto m-1" [ngClass]="{'disabled':(uploadTotal!==0&&uploadTotal!==100)||!showPhotosTab}" (click)='upload("PHOTO")'>Upload</a>
							<span *ngIf="loading" class="fa fa-spinner fa-spin float-right" style="font-size:16px;color:rgb(195,212,47)"></span>
						</div>
						<ul class="widget-item-list">
							<li class="item" *ngFor="let photo of photos">
								<div class="img-wrapper">
									<img *ngIf="photo.FILE_TN_URL" [src]="photo.FILE_TN_URL" class="img img-fluid"/>
								</div>
								<div *ngIf="photo.FILE_DESCRIPTION.length>0" class="title" title="Click to Edit Description"  (click)="op44.toggle($event)">{{photo.FILE_DESCRIPTION.substring(0, 40)}}<span *ngIf="photo.FILE_DESCRIPTION.length>40"> . . . </span></div>
								<div *ngIf="photo.FILE_DESCRIPTION.length==0" class="title" title="Click to Edit Description"  (click)="op44.toggle($event)" style="color:rgb(195,212,47);">Click to Edit File Description</div>
								<hr class="line">
								<a href="javascript:void(0);" class="remove" (click)="op44.toggle($event)"><i class="far fa-edit" style="font-size: 10px;"></i></a>
								<!-- remove delete button: -->
								<!-- <a href="javascript:void(0);" class="remove" (click)="deleteFile(photo, 'PHOTO')"><i class="far fa-trash-alt" style="font-size: 10px;"></i></a> -->
								<p-overlayPanel #op44 [appendTo]="fileModal" [dismissable]="true" [showCloseIcon]="true"  [autoZIndex]="false" [baseZIndex]="1000" [style]="{'width': '300px'}">
									<ng-template pTemplate>
										<div style="margin: 0; color:#C2D63F;max-height:400px; overflow:auto; font-size:.9em"> 
											<strong>File Description : </strong><br> 
											<textarea class="col-md-12" rows=6 maxlength="100" style="font-size:11px; z-index:1010">{{photo.FILE_DESCRIPTION}}</textarea>
											<button class="btn m-0 uploadBtn float-right" (click)="updateFile(photo, 'PHOTO', $event)">Update</button>
										</div>
									</ng-template>
								</p-overlayPanel>	
							</li>
					 
					  
						</ul>
					</div>
			</div>
		
		</div>
		</div>
	</div>
		</div>	
</div>
<div *ngIf="updateShow" class="task-box1" style="width:80vw; top:20vh;  right:200px; max-height:70vh; z-index: 1000;" cdkDrag [cdkDragDisabled]="intext">
	<div style="margin:0 4px; padding:10px; color:#C2D63F; font-size:12px"> 
		<h6 style="font-weight:bold"><label style="width: 50%;">Comparison Table
		<span class="col-md-1" *ngIf="loading3" class="fa fa-spinner fa-spin" style="font-size:16px;color:rgb(195,212,47); display:inline-block;"></span>
			</label>
				  <i class="iconBtn far fa-times-circle ml-3" style="float:right; cursor:pointer" (click)="updateShow=false"></i>
		<button class="btn pcaBtn" (click)="op110.toggle($event)">Choose Reports from Portfolio </button>
		<label style="width: 30%;"></label>
	</h6>
			
		<hr class="line1 mb-1">
		<p-overlayPanel #op110 [appendTo]="'body'" [dismissable]="false"  [showCloseIcon]="true" [style]="{width: '620px'}">
			<ng-template pTemplate>
			<div style="width: 600px; margin:0; color:#C2D63F;font-size:.8em; max-height:600px; overflow:auto">
				<button class="btn uploadBtn" (click)="addCompareRpt($event)">Check All</button><br> 
				<ng-container *ngFor="let rpt of projectRpts; trackBy:trackByFuntion">
				<ng-container *ngIf="rpt.REPORT_ID>-1"> 
					<input type="checkbox" [checked]="compareRpts.indexOf(rpt.REPORT_ID)>-1" (change)="addCompareRpt($event, rpt)">
					<a class="ml-2" target=_blank [href]="'report/'+rpt.PROJECT_ID+'/'+rpt.REPORT_ID">{{rpt.REPORT_TITLE}}( {{rpt.PROJECT_NUMBER}} )--{{rpt.ADDRESS_LINE1+', '+rpt.CITY+' '+rpt.PROVSTATE+' '+rpt.POSTALZIP+' '+rpt.COUNTRY}}</a><br>
				</ng-container>	
			</ng-container> 									
			</div>
			<button class="btn uploadBtn" (click)="getCompareRpts(); op110.hide()">Get Comparison Table</button>
			<span *ngIf="loading2" class="fa fa-spinner fa-spin" style="font-size:16px;color:rgb(195,212,47); display:inline-block;"></span>
			</ng-template>
		</p-overlayPanel>
		<p class="noteLabel">For each Repeat Field to be updated:</p>
		<p class="savedLabel1 ml-2">Click the “<span  class="noteLabel">Choose Reports from Portfolio</span>” button in upper right corner of this window.</p>
		<p class="savedLabel1 ml-2">You may manually select the reports needed for comparison or the Check All button.</p>
		<p class="savedLabel1 ml-2">Click the “<span  class="noteLabel">Get Comparison Table</span>” button.</p>
		<p class="savedLabel1 ml-2">For any Repeat Field in a report, click the drop-down arrow and select the correct value or in the smaller window click “<span class="noteLabel">Update All Reports</span>”..</p>
		<p class="savedLabel1 ml-2">Values in <span class="redLabel">RED</span> font show the new value in the reports (no need to <span class="noteLabel">‘Save’</span>!).</p>
		<p class="redLabel ml-2"><span class="redLabel">IMPORTANT! </span>If there is an ACTIVE user in a report, the Repeat Fields content will not update into that report.</p>
		<div style="color:#C2D63F; max-height:50vh; max-width:100%; font-size:.9em"> 
			<div style="width:100%; max-height:34vh;overflow:auto; cursor:default" (mouseenter)='intext=true;' (mouseleave)='intext=false'>
			<table *ngIf="compareSlots.length>0" [ngStyle]="{'width': (compareRpts.length*160+160)+'px'}" style="color:white; border: 1px solid black;  border-collapse: collapse; background-color:rgb(28, 36, 51); margin-right:8px; margin-left:2px;">
				<thead style=" text-align:center; position: sticky; top: 20">
					<tr style="position: sticky; top: 0;background:rgb(28, 36, 51);">
						<th>Project Number</th>
						<ng-container *ngFor="let pro of compareProject; let i=index">
							<th style="width:160px">{{pro}}</th>
						</ng-container>
					</tr>
					<tr style="position: sticky; top: 18px;background:rgb(28, 36, 51);">
						<th>Report Title</th>
						<ng-container *ngFor="let rpt of compareTitles; let i=index">
							<th style="width:160px">{{rpt}}</th>
						</ng-container>
					</tr>
					<tr style="position: sticky; top: 50px;background:rgb(28, 36, 51);color:#C2D63F; height:20px">
						<th>Re-Fields Identifier</th>
						<ng-container *ngFor="let rpt of compareTitles; let i=index">
							<th>Re-Fields Value</th>
						</ng-container>							
					</tr>
				</thead>
				<tbody>
					<ng-container *ngFor="let item of compareSlots; let i=index">
						<tr  [ngStyle]="{'color':item['TYPE']!='ex'?'rgb(201 218 251)':'white'}">
							<td style="padding-left:2px">{{item.SLOT_KEY}}</td>
							<ng-container *ngFor="let rpt of item.REPORT_VALUE_LIST; let j=index"  style="padding-left:2px">
								<td><span>{{rpt.RF_CONTENT}}</span>
									<a *ngIf="rpt.RF_CONTENT!='Not Used'&&comparisonPermission" class="ml-1 mb-1" style="width:20px; float:right; cursor:pointer" (click)="selectAll=false; selectedCell=$event; op84.toggle($event);" title="Update Repeat Field"><i class="pi pi-angle-down" style="margin: 2px;pointer-events: none;"></i></a>
									<p-overlayPanel #op84 [appendTo]="'body'" [dismissable]="false" [showCloseIcon]="true" (hide)="selectedCell=null">
										<ng-template pTemplate>
											<div style="padding:4px; max-height:400px; overflow:auto; width:200px">
												<input type="checkbox" [(ngModel)]="selectAll">
												<a href="javascript:void(0)" class="savedLabel1 ml-1">Update All Reports</a><br>
												<!--<a href="javascript:void(0)" style="font-size:.8em; color: #C2D63F;">
													None
												</a><br>-->
												<ng-container *ngFor="let slot of item.REPORT_VALUE_LIST; let k=index; trackBy:trackByFuntion">
													<a *ngIf="slot.RF_CONTENT!='Not Used'" href="javascript:void(0)" class="selectItem" (click)="updaterpts($event, k, item, i,j)">
														<span *ngIf="slot.RF_CONTENT.length>0">{{slot.RF_CONTENT}}</span>
														<span *ngIf="slot.RF_CONTENT.length==0" style="font-style: italic;color:white">empty</span>
														<span class="fa fa-spinner fa-spin" style="font-size:16px;color:rgb(195,212,47); display:none;float:right"></span>													
													</a>
												</ng-container>
											</div>
										</ng-template>
									</p-overlayPanel>
									<!--<select *ngIf="rpt.RF_CONTENT!='Not Used'" style="width:20px; float:right" (change)="updaterpts($event, item, j)">
										<option></option>
										<ng-container *ngFor="let slot of item.REPORT_VALUE_LIST; let k=index">
										<option *ngIf="slot.RF_CONTENT!='Not Used'" [value]="k">
											{{slot.RF_CONTENT}}
										</option>
										</ng-container>
									</select>-->
									
			
									
								</td>													
							</ng-container>
						</tr>
					</ng-container>						
				</tbody>
			</table>				
			</div>				
		</div>
		<hr class="m-0 p-0">
		<!--<button *ngIf="!loading&&(updatedSlots.length>0||exSlots.length>0)" class="btn pcaBtn mb-2 float-md-right" (click)="updateSlots()">Update Selected Re-Fields</button>
		<span *ngIf="loading" class="fa fa-spinner fa-spin" style="font-size:16px;color:rgb(195,212,47); display:inline-block; float:right"></span>
	-->
	</div>					
</div>
<div *ngIf="statusShow" class="task-box1" style="width:60vw; top:20vh;  right:20vw; height:60vh;" cdkDrag [cdkDragDisabled]="intext">
	<div style="margin:0 4px; padding:10px; color:#C2D63F;"> 
		<label style="font-weight:bold">Change Report(s) Status</label>
		<a href="javascript:void(0)" class="float-sm-right m-1 iconBtn" pTooltip="Close" tooltipZIndex='auto' (click)="statusShow=false;"><i  titie='close' class="far fa-window-close" style="pointer-events:none"></i></a>
		<br>
		<div style="color:#C2D63F; overflow: auto; width:98%; height:50vh; font-size: .8em;margin: 10px 0;cursor:default" (mouseenter)='intext=true;' (mouseleave)='intext=false'>
		<table style="width:98%;  overflow:auto; color:white; border: 1px solid black;  border-collapse: collapse; background-color:rgb(28, 36, 51);">
			<thead style=" text-align:center; position: sticky; top: 0">
				<tr style="position: sticky; top: 0;background:rgb(28, 36, 51);">
					<th>Report Title</th>
					<th>Project Name</th>
					<th>Property Address</th>
					<th>Report Status</th>
					<th>Select</th>				
				</tr>				
			</thead>
			<tbody>
				<ng-container *ngFor="let rpt of projectRpts; let i=index">
					<tr>
						<td style="padding-left:2px">{{rpt.REPORT_TITLE}}</td>
						<td style="padding-left:2px">{{rpt.PROJECT_NUMBER}}</td>
						<td style="padding-left:2px">{{rpt.FULL_ADDRESS}}</td>
						<td style="padding-left:2px">{{rpt.STATUS}}</td>
						<td>
							<input type="checkbox" (change)="addSRpt($event, rpt.REPORT_ID)" [checked]="selectedSRpts.indexOf(rpt.REPORT_ID)>-1">
							<ng-container *ngIf="statusMsg[rpt.REPORT_ID]">
								<i class="fas fa-check erisGreen"></i>	
							</ng-container>
							<ng-container *ngIf="statussWarn[rpt.REPORT_ID]">
								<i class="fas fa-info-circle" [title]="statussWarn[rpt.REPORT_ID]" style="color: #F78181"></i>								
							</ng-container>
						</td>						
					</tr>
				</ng-container>						
			</tbody>
		</table>
	</div>
	<button type="button" class="btn btn-outline-light btn-sm m1-4 mt-1 mb-1 pt-0 pb-0 pl-1 pr-1" style="font-size:.8em;" (click)="selAll('Y')">Select All</button>
	<button type="button" class="btn btn-outline-light btn-sm mr-4 mt-1 mb-1 pt-0 pb-0 pl-1 pr-1" style="font-size:.8em;" (click)="selAll('N')">Unselect All</button>	
		<select>
			<option></option>
			<option *ngFor="let item of statusList2; trackBy: trackByFuntion" [value]="item.STATUS">
				{{item.STATUS}}
			</option>
		</select>
		<button type="button" [disabled]="!changeStatusPermission" class="btn btn-outline-light btn-sm ml-1 mt-1 mb-1 pt-0 pb-0 pl-1 pr-1" style="font-size:.8em;" (click)="changePStatus($event)">Change Status</button>
													
												
	</div>					
</div>
<div *ngIf="copyShow" class="task-box1" style="width:50vw; top:20vh;  right:20vw; height:64vh;" cdkDrag [cdkDragDisabled]="intext">
	<div style="margin:0 4px; padding:10px; color:#C2D63F;height:100%;"> 
		<h6 style="font-weight:bold">Copy Across Portfolio
			<a href="javascript:void(0)" class="float-sm-right m-1 iconBtn" pTooltip="Close" tooltipZIndex='auto' (click)="copyShow=false;"><i  titie='close' class="far fa-window-close" style="pointer-events:none"></i></a>
		</h6>
		<hr class="line1 mb-1">
		<label class="noteLabel">How to Import to your Current Portfolio Reports from a Base Report:</label><br>
		<label class="savedLabel1 ml-2">Access the list of reports via the drop-down under “<span  class="noteLabel">Choose Base Report</span>”.</label><br>
		<label class="savedLabel1 ml-2">Select the section(s) (in the Base report) that needs to be copied across your portfolio.</label><br>
		<label class="savedLabel1 ml-2">Click the “<span  class="noteLabel">Copy Across Portfolio</span>” button.</label><br>
		<label class="redLabel ml-2"><span class="redLabel">IMPORTANT! </span>If there is an active user in report, in any section you are copying, the content might overwrite whatever you just copied over.</label><br>
		
		<label class="noteLabel1">Choose Base Report : </label>
		<select (change)="getRptContent($event); getTemplateRpts($event)" style="font-size: .8em;width:100%">
			<option></option>
			<ng-container *ngFor="let rpt of projectRpts; trackBy: trackByFuntion">
				<option *ngIf="rpt.REPORT_ID>-1" [value]="rpt.REPORT_ID">
					{{rpt.REPORT_TITLE}} ( {{rpt.PROJECT_NUMBER}} ) -- {{rpt.PROPERTY_NAME}} ( {{rpt.ADDRESS_LINE1+', '+rpt.CITY+' '+rpt.PROVSTATE+' '+rpt.POSTALZIP+' '+rpt.COUNTRY}} )
				</option>
			</ng-container>
		</select><br>
		<!--<button class="btn pcaBtn float-md-right mr-4" (click)="op110.toggle($event)">Choose Target Reports</button>		
		<p-overlayPanel #op110 [appendTo]="'body'" [dismissable]="false"  [showCloseIcon]="true" [style]="{width: '320px'}">
			<ng-template pTemplate>
			<div style="width: 300px; margin:0; color:#C2D63F;font-size:.8em; max-height:600px; overflow:auto">
				<button class="btn uploadBtn" (click)="addTargetRpt($event)">Check All</button><br> 
				<ng-container *ngFor="let rpt of targetRpts; trackBy:trackByFuntion">
				<ng-container *ngIf="rpt.REPORT_ID>-1"> 
					<input type="checkbox" [checked]="selectedTarget.indexOf(rpt.REPORT_ID)>-1" (change)="addTargetRpt($event, rpt)">
					<a class="ml-2" target=_blank style="color:#C2D63F" [href]="'report/'+rpt.PROJECT_ID+'/'+rpt.REPORT_ID">{{rpt.REPORT_TITLE}}</a><br>
				</ng-container>	
			</ng-container> 									
			</div>

			</ng-template>
		</p-overlayPanel>-->
		<div class="row p-2 mb-2" style="height:calc(100% - 280px)">
		<div class="contentarea" style="width:65%" (mouseenter)='intext=true;' (mouseleave)='intext=false'>
			<div *ngFor="let doc of srcFront">
				<input class="contentChk" type="checkbox" (change)="addsec($event, doc.id)" [checked]="selectedId.indexOf(doc.id)>-1" [disabled]="otherTypes.indexOf(doc.TYPE)>-1">
				<label class="contentSeq">{{doc.SECTION_SEQUENCE}}</label>
				<label class="contentLabel">{{doc.SECTION_TITLE}}</label>
				<div *ngFor="let doc1 of doc.SUB_SECTIONS">
					<input class="contentChk" type="checkbox" [checked]="selectedId.indexOf(doc1.id)>-1" (change)="addsec($event, doc1.id)"  [disabled]="otherTypes.indexOf(doc1.TYPE)>-1||(doc1.data?.erisName?.length>0&&doc1.TYPE=='TABLE')">
					<label class="contentSeq">{{doc1.SECTION_SEQUENCE}}</label>
					<label class="contentLabel">{{doc1.SECTION_TITLE}}</label>					
				</div>
			</div>
			<div *ngFor="let doc of srcContents">
				<input class="contentChk" type="checkbox" (change)="addsec($event, doc.id)" [checked]="selectedId.indexOf(doc.id)>-1"  [disabled]="otherTypes.indexOf(doc.TYPE)>-1">
				<label class="contentSeq">{{doc.SECTION_SEQUENCE}}</label>
				<label class="contentLabel">{{doc.SECTION_TITLE}}</label>
				<div *ngFor="let doc1 of doc.SUB_SECTIONS">
					<input class="contentChk" type="checkbox" [checked]="selectedId.indexOf(doc1.id)>-1" (change)="addsec($event, doc1.id)"  [disabled]="otherTypes.indexOf(doc1.TYPE)>-1||(doc1.data?.erisName?.length>0&&doc1.TYPE=='TABLE')">
					<label class="contentSeq">{{doc1.SECTION_SEQUENCE}}</label>
					<label class="contentLabel">{{doc1.SECTION_TITLE}}</label>
					<div *ngFor="let doc2 of doc1.SUB_SECTIONS">
						<input class="contentChk" type="checkbox" [checked]="selectedId.indexOf(doc2.id)>-1" (change)="addsec($event, doc2.id)"  [disabled]="otherTypes.indexOf(doc2.TYPE)>-1||(doc2.data?.erisName?.length>0&&doc2.TYPE=='TABLE')">
						<label class="contentSeq">{{doc2.SECTION_SEQUENCE}}</label>
						<label class="contentLabel">{{doc2.SECTION_TITLE}}</label>
					</div>
				</div>
			</div>
		</div>
		<div class="contentarea"  style="width:33%; background-color: #4C4C4C;border:#C2D63F solid 1px; ">
			<button *ngIf='targetRpts.length>0' class="btn uploadBtn" (click)="addTargetRpt($event)">Check All</button><br>
			<div *ngFor="let rpt of targetRpts; trackBy:trackByFuntion">
				<ng-container *ngIf="rpt.REPORT_ID>-1"> 
					<input class="contentChk" type="checkbox" [checked]="selectedTarget.indexOf(rpt.REPORT_ID)>-1" (change)="addTargetRpt($event, rpt)">
					<a class="ml-2" target=_blank style="color:#C2D63F" [href]="'report/'+rpt.PROJECT_ID+'/'+rpt.REPORT_ID">{{rpt.REPORT_TITLE}}</a><label class="infolabel ml-2">( {{rpt.PROJECT_NUMBER}} )</label>
					<label class="infolabel" *ngIf="rpt.ADDRESS_LINE1.length>0">{{rpt.ADDRESS_LINE1+', '+rpt.CITY+' '+rpt.PROVSTATE+' '+rpt.POSTALZIP+' '+rpt.COUNTRY}}</label><br>
					<ng-container *ngIf="copyMsg">	
					<div *ngIf="copyMsg[rpt.REPORT_ID]?.length>0" style="color:white"> 
						<label>Copied:</label><br>
						<ng-container *ngFor="let msg of copyMsg[rpt.REPORT_ID]">
							<label>{{msg}}</label><br>
						</ng-container>

						
					</div>
					<div *ngIf="copyMsg[rpt.REPORT_ID]?.length==0" style="color:white"> 
						<label>No match section found. </label>						
					</div>
				</ng-container>
				<ng-container *ngIf="copyWarn">
					<div *ngIf="copyWarn[rpt.REPORT_ID]?.length>0" style="color: #F78181"> 
						<label>Error:</label><br>
						<ng-container *ngFor="let msg of copyWarn[rpt.REPORT_ID]">
							<label>{{msg}}</label><br>
						</ng-container>					
					</div>
				</ng-container>				
			</ng-container>		 
				
			</div>
		</div>
	</div>
		<button type="button" class="btn btn-outline-light btn-sm m1-4 mr-1 mt-1 mb-1 pt-0 pb-0 pl-1 pr-1" style="font-size:.8em;" (click)="addsec('Y')">Select All</button>
		<button type="button" class="btn btn-outline-light btn-sm mr-4 mt-1 mb-1 pt-0 pb-0 pl-1 pr-1" style="font-size:.8em;" (click)="addsec('N')">Unselect All</button>	
		<button type="button" [disabled]='!copyPermission' class="btn btn-outline-light btn-sm mr-4 mt-1 mb-1 pt-0 pb-0 pl-1 pr-1" style="font-size:.8em;" (click)="startCopy($event)">Copy Across Portfolio</button>
		<span *ngIf="loading4" class="fa fa-spinner fa-spin" style="font-size:16px;color:rgb(195,212,47); display:inline-block;"></span>											
												
	</div>					
</div>
<div *ngIf="summaryShow" #summaryPanel class="task-box1" style="width:80vw; top:20vh;  right:10vw; max-height:80vh" cdkDrag [cdkDragDisabled]="intext">
	<div style="margin:0 4px; padding:10px; color:#C2D63F; font-size:12px"> 
		<h6 style="font-weight:bold">Create/Download Summary Reports
			
		<span *ngIf="loading3" class="fa fa-spinner fa-spin" style="font-size:16px;color:rgb(195,212,47); display:inline-block;"></span>
		<span *ngIf='loading5' class="fa fa-spinner fa-spin" style="font-size:16px;color:rgb(195,212,47); display:inline-block;"></span>
		 <i class="iconBtn far fa-times-circle ml-3" style="float:right; cursor:pointer" (click)="summaryShow=false"></i></h6>
		 <hr class="line1 mb-1">
		<!--<button class="btn pcaBtn" (click)="op110.toggle($event)">Choose Reports from Portfolio </button>
		<p-overlayPanel #op110 [appendTo]="'body'" [dismissable]="false"  [showCloseIcon]="true" [style]="{width: '320px'}">
			<ng-template pTemplate>
			<div style="width: 300px; margin:0; color:#C2D63F;font-size:.8em; max-height:600px; overflow:auto">
				<button class="btn uploadBtn" (click)="addSummaryRpts($event)">Check All</button>
				<button class="btn uploadBtn" (click)="summaryRpts=[]">Uncheck All</button><br> 
				<ng-container *ngFor="let rpt of projectRpts; trackBy:trackByFuntion">
				<ng-container *ngIf="rpt.REPORT_ID>-1"> 
					<input type="checkbox" [checked]="summaryRpts.indexOf(rpt.REPORT_ID)>-1" (change)="addSummaryRpts($event, rpt)">
					<a class="ml-2" target=_blank [href]="'report/'+rpt.PROJECT_ID+'/'+rpt.REPORT_ID">{{rpt.REPORT_TITLE}}</a><br>
				</ng-container>	
			</ng-container> 									
			</div>
			<button class="btn uploadBtn" (click)="getCompareRpts('summary'); op110.hide()">Get Summary</button>
			<span *ngIf="loading2" class="fa fa-spinner fa-spin" style="font-size:16px;color:rgb(195,212,47); display:inline-block;"></span>
			</ng-template>
		</p-overlayPanel>
		<button class="btn pcaBtn ml-4" (click)="op111.toggle($event)">Choose RFs</button><br>
		<p-overlayPanel #op111 [appendTo]="'body'" [dismissable]="false"  [showCloseIcon]="true" [style]="{width: '320px'}">
			<ng-template pTemplate>
			<div style="width: 300px; margin:0; font-size:.8em; max-height:600px; overflow:auto">
				<button class="btn uploadBtn" (click)="addSummaryRFs($event)">Check All</button>
				<button class="btn uploadBtn" (click)="selectedRFs=[]">Uncheck All</button><br> 
				<ng-container *ngFor="let rf of summaryRFs; trackBy:trackByFuntion">
				<ng-container *ngIf="rf.SLOT_ID>-1"> 
					<input type="checkbox" [checked]="selectedRFs.indexOf(rf.SLOT_ID)>-1" (change)="addSummaryRFs($event, rf.SLOT_ID)">
					<label class="ml-2 infolabel" >{{rf.SLOT_KEY}}</label><br>
				</ng-container>	
			</ng-container> 									
			</div>
			<button class="btn uploadBtn" (click)="createSummaryRpt(); op111.hide()">Create/download summary reports</button>
			<span *ngIf="loading2" class="fa fa-spinner fa-spin" style="font-size:16px;color:rgb(195,212,47); display:inline-block;"></span>
			</ng-template>
		</p-overlayPanel>-->
		
		<div class="contentarea1" style="width:50%;" (mouseenter)='intext=true;' (mouseleave)='intext=false'>
			Choose Reports from Portfolio
			<button class="btn uploadBtn ml-3" (click)="addSummaryRpts($event)">Check All</button>
			<button class="btn uploadBtn" (click)="summaryRpts=[]">Uncheck All</button> 
			<div style="margin:0; height:85%; overflow:auto;border:#C2D63F solid 1px;">				
				<ng-container *ngFor="let rpt of projectRpts; trackBy:trackByFuntion">
				<ng-container *ngIf="rpt.REPORT_ID>-1"> 
					<input class="ml-1" type="checkbox" [checked]="summaryRpts.indexOf(rpt.REPORT_ID)>-1" (change)="addSummaryRpts($event, rpt)">
					<a class="ml-2"  style='color:white' target=_blank [href]="'report/'+rpt.PROJECT_ID+'/'+rpt.REPORT_ID">{{rpt.REPORT_TITLE}}( {{rpt.PROJECT_NUMBER}} - {{rpt.PROPERTY_NAME}} )--{{rpt.ADDRESS_LINE1+', '+rpt.CITY+' '+rpt.PROVSTATE+' '+rpt.POSTALZIP+' '+rpt.COUNTRY}}</a><br>
				</ng-container>	
			</ng-container> 									
			</div>
			
		</div>
		<div class="contentarea1"  style="width:24%;">
			Choose RFs
			<!--<button class="btn uploadBtn ml-3" (click)="addSummaryRFs($event)">Check All</button>
			<button class="btn uploadBtn" (click)="selectedRFs=[];selectedRFIds=[];">Uncheck All</button><br>-->
			
			<input type="text" pInputText size="20" placeholder="Filter" (input)="slotFilter($event.target.value)" (mouseenter)='intext=true' (mouseleave)='intext=false' style="width:auto; margin-left: 10px;">
			<i class="pi pi-search" style="margin:4px 4px 0 0"></i><br> 
			<div style="margin:0; height:85%; overflow:auto;border:#C2D63F solid 1px;">
				<ng-container *ngFor="let rf of allSlots; trackBy:trackByFuntion">
				<ng-container *ngIf="rf.SLOT_ID>-1&&(!filted||(filted&&filteredSlot.indexOf(rf.SLOT_ID)>-1))"> 
					<input  class="ml-1" type="checkbox" [checked]="selectedRFIds.indexOf(rf.SLOT_ID)>-1" (change)="addSummaryRFs($event, rf)">
					<label class="ml-2 infolabel" >{{rf.KEY}}</label><br>
				</ng-container>	
			</ng-container> 									
			</div>
			<input type="checkbox" [(ngModel)]="pcaInd"><label style="vertical-align: middle;line-height: 20px;">Include PCA Cost Columns</label>
		</div>
		<div class="contentarea1"  style="width:24%;">
			Chosen RFs
			<!--<button class="btn uploadBtn ml-3" (click)="addSummaryRFs($event)">Check All</button>
			<button class="btn uploadBtn" (click)="selectedRFs=[]">Uncheck All</button><br> 
			<div style="margin:0; height:85%; overflow:auto;border:#C2D63F solid 1px;">
				<ng-container *ngFor="let rf of allSlots; trackBy:trackByFuntion">
				<ng-container *ngIf="selectedRFs.indexOf(rf.SLOT_ID)>-1"> 
					<input  class="ml-1" type="checkbox" [checked]="selectedRFs.indexOf(rf.SLOT_ID)>-1" (change)="addSummaryRFs($event, rf.SLOT_ID)">
					<label class="ml-2 infolabel" >{{rf.KEY}}</label><br>
				</ng-container>	
			</ng-container> 									
			</div>-->
			<label style="margin-left: 10px;">Selected Profile</label>
			<select [(ngModel)]="curProfile" (change)="getSummaryProfile()" style="width:120px">
				<option value=-1>None</option>
				<option *ngFor="let rf of summaryProfiles; trackBy:trackByFuntion" [value]="rf.SUMMARY_ID">{{rf.SUMMARY_NAME}}</option>
			</select>					
			<div style="margin:0; height:85%; overflow:auto;border:#C2D63F solid 1px;">
			<div  cdkDropList class="example-list" (cdkDropListDropped)="dropFItem($event)">
				<ng-container *ngFor="let rf of selectedRFs; trackBy:trackByFuntion">
					<div class="example-box1" cdkDrag>{{rf.KEY}}
						<!--<input  class="ml-1" type="checkbox" [checked]="selectedRFs.indexOf(rf.SLOT_ID)>-1" (change)="addSummaryRFs($event, rf.SLOT_ID)">
						<label class="ml-2 infolabel" >{{rf.KEY}}</label>-->
						<button  style="color: rgb(201 218 251)" (click)="deleteRFs(rf.SLOT_ID)" class="btn btn-outline-dark btn-sm pt-0 pb-0 pl-1 pr-1 ml-1" title="Delete Repeat Field">
						<i class="far fa-trash-alt" style="pointer-events:none"></i> </button>
					</div>
				</ng-container>												
			</div>
		</div>
			<!--<button class="btn uploadBtn" (click)="getCompareRpts('summary');">Get Summary RFs</button>-->
			<button *ngIf="curProfile==-1" class="btn uploadBtn" (click)="saveSummaryProfile('new')">Save Summay Profile</button>
			<button *ngIf="curProfile>-1"class="btn uploadBtn" (click)="saveSummaryProfile()">Update Summay Profile</button>
			<span *ngIf="loading6" class="fa fa-spinner fa-spin" style="font-size:16px;color:rgb(195,212,47); display:inline-block;"></span>
			<button class="btn uploadBtn float-md-right" (click)="createSummaryRpt();">Create/download summary reports</button>
			<span *ngIf="loading5" class="fa fa-spinner fa-spin  float-md-right" style="font-size:16px;color:rgb(195,212,47); display:inline-block;"></span>
		</div>
		<!--<button class="btn pcaBtn mb-2 float-md-right" >Create/download summary reports</button>-->
		
	
	</div>					
</div>
<div *ngIf="deliverShow" class="task-box1" style="width:60vw; top:20vh;  right:20vw; max-height:70vh" cdkDrag [cdkDragDisabled]="intext">
	<div style="margin:0 4px; padding:10px; color:#C2D63F; font-size:12px"> 
		<h6 style="font-weight:bold">Choose which Reports to Deliver
		 <i class="iconBtn far fa-times-circle ml-3" style="float:right; cursor:pointer" (click)="deliverShow=false"></i></h6>
		 <hr class="line1 mb-1">
		<div #deliverPanel style="width:100%;margin: 10px;max-height:60vh; overflow: auto;" (mouseenter)='intext=true;' (mouseleave)='intext=false'>
			Choose Report from Portfolio
			<button class="btn uploadBtn ml-3" (click)="addDeliverRpts($event)">Check All</button>
			<button class="btn uploadBtn ml-1" (click)="deliverRpts=[]">Uncheck All</button>
			<button class="btn uploadBtn ml-3" (click)="addDeliverRpts($event, 'Phase I')">Check All Phase I Reports</button>			 
			<button class="btn uploadBtn ml-3" (click)="addDeliverRpts($event, 'PCA')">Check All PCA Reports</button>
			<button class="btn uploadBtn ml-3" (click)="checkedTmps=[]; op112.toggle($event)">Check off Specific Templates</button>
			<p-overlayPanel #op112 [appendTo]="'body'" [dismissable]="false"  [showCloseIcon]="true" [style]="{width: '420px'}" [baseZIndex]="1011">
				<ng-template pTemplate>
					<div style="width: 400px; color:#C2D63F;font-size:.8em; max-height:600px; overflow:auto">
						<ng-container *ngFor="let tmp of portfolioTmps; trackBy:trackByFuntion">
						<ng-container *ngIf="tmp.TEMPLATE_ID>-1"> 
							<input class="noDeliverTmps" type="checkbox" (change)="addToOffTmps($event, tmp.TEMPLATE_ID)">
							<a class="ml-2" target=_blank [href]="'template/'+tmp.TEMPLATE_ID">{{tmp.TEMPLATE_TITLE}}( {{tmp.TEMPLATE_VERSION_NO}} )--{{tmp.SUBCATEGORY_NAME}}</a><br>
						</ng-container>	
					</ng-container> 
					<button class="btn uploadBtn ml-3" (click)="addDeliverRpts($event, 'tmps')">Check off Specific Template(s) from Portfolio List</button>									
					</div>
				</ng-template>
			</p-overlayPanel>
			<div style="margin:0; border:#C2D63F solid 1px;">				
				<ng-container *ngFor="let rpt of projectRpts; trackBy:trackByFuntion">
				<ng-container *ngIf="rpt.REPORT_ID>-1"> 
					<input class="ml-1" type="checkbox" [checked]="deliverRpts.indexOf(rpt.REPORT_ID)>-1" (change)="addDeliverRpts($event, rpt)">
					<a class="ml-2"  style='color:white' target=_blank [href]="'report/'+rpt.PROJECT_ID+'/'+rpt.REPORT_ID">{{rpt.REPORT_TITLE}}( {{rpt.PROJECT_NUMBER}} - {{rpt.PROPERTY_NAME}} )--{{rpt.ADDRESS_LINE1+', '+rpt.CITY+' '+rpt.PROVSTATE+' '+rpt.POSTALZIP+' '+rpt.COUNTRY}}</a><br>
				</ng-container>	
			</ng-container>
			</div>
			
		</div>

		<button class="btn uploadBtn float-md-right m-2" (click)="deliverPortfolio();">Generate Reports and Deliver File</button>
		<span *ngIf="loading7" class="fa fa-spinner fa-spin  float-md-right" style="font-size:16px;color:rgb(195,212,47); display:inline-block;"></span>
		<span *ngIf="delliverWarn" class="float-md-right m-2" style="font-size:12px;color:#e27676;font-weight: bold;">Choose Report for Portfolio Generation! </span>	
		
	</div>					
</div>
<div *ngIf="copyProjShow" class="task-box1" style="width:60vw; top:20vh;  right:20vw; height:64vh;" cdkDrag [cdkDragDisabled]="intext">
	<div style="margin:0 4px; padding:10px; color:#C2D63F;height:100%;"> 
		<h6 style="font-weight:bold">Copy Project/Reports
			<a href="javascript:void(0)" class="float-sm-right m-1 iconBtn" pTooltip="Close" tooltipZIndex='auto' (click)="copyProjShow=false;"><i  titie='close' class="far fa-window-close" style="pointer-events:none"></i></a>
		</h6>
		<hr class="line1 mb-1">
		<label class="contentLabel">Search Projects:</label>
			<input class="ml-4 mr-2 mt-2" type="text" pInputText size="50" placeholder="Search Projects by Keyword"
				[(ngModel)]="projKey" style="width:280px; background-color:rgb(28 36 51)" (mousedown)="$event.stopPropagation()">
					<button class="btn btn-dark btn-sm ml-2 copybtn" (click)="searchProjectsByKey();">Search</button>
					<i *ngIf="searchProjLoading" class="pi pi-spin pi-spinner" style="font-size: 1.2rem; margin-left: 10px; color: #C2D63F;"></i>
					<label class="copyInfo">{{searchInfo}}</label>
		<div class="row p-1 mb-2 ml-0" style="height:calc(100% - 180px);">
			<label  class="contentLabel mb-0" style="width:60%">Select the Project to Copy</label>
			<label class="contentLabel mb-0" style="width:38%">Select Report(s)</label>
			<div class="contentarea" style="width:60%; margin-top: 0;" (mouseenter)='intext=true;' (mouseleave)='intext=false'>
				<div *ngFor="let doc of srcProjects">
					<label class="radio-inline ml-3"> 
						<input type="radio" name="srcproject" [checked]="selectedProjectId==doc.PROJECT_ID" (change)="getProjRpts(doc.PROJECT_ID)">
						<b>{{doc.PROJECT_NUMBER}} </b><span  *ngIf="doc.PROPERTY_NAME?.length > 0" style="color:#1D365E">( {{doc.PROPERTY_NAME}} ) </span><span *ngIf="doc.FULL_ADDRESS?.length > 0">-- {{doc.FULL_ADDRESS}}</span>
					</label>							
				</div>
			</div>
			<div class="contentarea"  style="width:38%;  margin-top:0;background-color: #4C4C4C;border:#C2D63F solid 1px; ">
				<button *ngIf='allRptsInProject.length>0' class="btn uploadBtn" (click)="allRptsToCopy(true)">Select All</button>
				<button *ngIf='allRptsInProject.length>0' class="btn uploadBtn ml-2" (click)="allRptsToCopy(false)">Unselect All</button>
				<br>
				<div *ngFor="let rpt of allRptsInProject; trackBy:trackByFuntion">
					<input class="contentChk" type="checkbox" [disabled]="rpt.COPY_REPORT_ALLOWED!=='Y'" (change)="addToCopyProj($event, rpt.REPORT_ID)" [checked]="checkedRptsToProject.indexOf(rpt.REPORT_ID)>-1">  
					<label class="rptlabel">{{rpt.REPORT_TITLE}}</label><label *ngIf="rpt.COPY_REPORT_ALLOWED!=='Y'" class="text-warning">&nbsp;( {{rpt.REPORT_MESSAGE}} )</label>					
				</div>
			</div>
		</div>
		<hr class="line1 mb-1">
		
		<button type="button" class="btn btn-outline-light copybtn float-md-right mt-2 mr-2" (click)="startCopyProj($event)">Copy</button>
		<span *ngIf="loading4" class="fa fa-spinner fa-spin float-md-right mt-2 mr-1" style="font-size:20px;color:rgb(195,212,47); display:inline-block;"></span>
		<span *ngIf="copyProWarn" class="ml-1" style="color: #F78181">{{copyProWarn}}</span>										
	</div>					
</div>
